// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/nucleo-outline.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/nucleo-outline.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/nucleo-outline.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/nucleo-outline.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

 =========================================================
 * Now UI Kit React - v1.5.2 based on Now UI Kit - v1.3.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit-react
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/now-ui-kit-react/blob/main/LICENSE.md)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*     brand Colors              */
/*      light colors         */
/* ========================================================================
 * bootstrap-switch - v3.3.2
 * http://www.bootstrap-switch.org
 * ========================================================================
 * Copyright 2012-2013 Mattia Larentis
 * http://www.apache.org/licenses/LICENSE-2.0
 */
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  margin-bottom: 10px;
  line-height: 8px;
  width: 59px !important;
  height: 22px;
  outline: none;
  z-index: 0;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  margin-right: 20px;
  background: rgba(44, 44, 44, 0.2);
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 22px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 12px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  line-height: 11px;
  width: 50% !important;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-brown,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-brown {
  color: #fff;
  background: #f96332;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-blue,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-blue {
  color: #fff;
  background: #2CA8FF;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-green,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-green {
  color: #fff;
  background: #18ce0f;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-orange,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-orange {
  background: #FFB236;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-red,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-red {
  color: #fff;
  background: #FF3636;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px !important;
  margin: 0px -11px;
  border-radius: 20px;
  position: absolute;
  float: left;
  top: 0;
  left: 50%;
  padding: 0;
  box-shadow: 0 1px 11px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label {
  background-color: rgba(23, 23, 23, 0.4);
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 27px !important;
  margin-left: -16px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 27px !important;
  margin-left: -11px;
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type=radio].form-control,
.bootstrap-switch input[type=checkbox].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -39px !important;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label:before {
  background-color: #FFFFFF;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-red ~ .bootstrap-switch-default {
  background-color: #FF3636;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-orange ~ .bootstrap-switch-default {
  background-color: #FFB236;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-green ~ .bootstrap-switch-default {
  background-color: #18ce0f;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-brown ~ .bootstrap-switch-default {
  background-color: #f96332;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-blue ~ .bootstrap-switch-default {
  background-color: #2CA8FF;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-red,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-brown,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-blue,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-orange,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-green {
  background-color: #E3E3E3;
}

.bootstrap-switch-off .bootstrap-switch-handle-on {
  opacity: 0;
}

.bootstrap-switch-on .bootstrap-switch-handle-off {
  opacity: 0;
}

/*! nouislider - 13.1.4 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform-origin: 0 0;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  position: absolute;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 1px;
}

.noUi-horizontal .noUi-handle {
  border-radius: 50%;
  background-color: #FFFFFF;
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-top: -7px;
  outline: none;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -15px;
  left: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #888888;
  border-radius: 3px;
  transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
  -webkit-transition: 300ms ease 0s;
  -moz-transition: 300ms ease 0s;
  -ms-transition: 300ms ease 0s;
  -o-transform: 300ms ease 0s;
  transition: 300ms ease 0s;
}

.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

/* Handle stripes;
 */
.noUi-handle:before,
.noUi-handle:after {
  display: none;
}

.noUi-handle:after {
  left: 17px;
}

.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}

.noUi-vertical .noUi-handle:after {
  top: 17px;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%, 0);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.slider.slider-neutral .noUi-connect, .slider.slider-neutral.noUi-connect {
  background-color: #FFFFFF;
}
.slider.slider-neutral.noUi-target {
  background-color: rgba(255, 255, 255, 0.3);
}
.slider.slider-neutral .noUi-handle {
  background-color: #FFFFFF;
}
.slider.slider-primary .noUi-connect, .slider.slider-primary.noUi-connect {
  background-color: #f96332;
}
.slider.slider-primary.noUi-target {
  background-color: rgba(249, 99, 50, 0.3);
}
.slider.slider-primary .noUi-handle {
  background-color: #f96332;
}
.slider.slider-info .noUi-connect, .slider.slider-info.noUi-connect {
  background-color: #2CA8FF;
}
.slider.slider-info.noUi-target {
  background-color: rgba(44, 168, 255, 0.3);
}
.slider.slider-info .noUi-handle {
  background-color: #2CA8FF;
}
.slider.slider-success .noUi-connect, .slider.slider-success.noUi-connect {
  background-color: #18ce0f;
}
.slider.slider-success.noUi-target {
  background-color: rgba(24, 206, 15, 0.3);
}
.slider.slider-success .noUi-handle {
  background-color: #18ce0f;
}
.slider.slider-warning .noUi-connect, .slider.slider-warning.noUi-connect {
  background-color: #FFB236;
}
.slider.slider-warning.noUi-target {
  background-color: rgba(255, 178, 54, 0.3);
}
.slider.slider-warning .noUi-handle {
  background-color: #FFB236;
}
.slider.slider-danger .noUi-connect, .slider.slider-danger.noUi-connect {
  background-color: #FF3636;
}
.slider.slider-danger.noUi-target {
  background-color: rgba(255, 54, 54, 0.3);
}
.slider.slider-danger .noUi-handle {
  background-color: #FF3636;
}

/*!
 * Datepicker for Bootstrap v1.7.0-dev (https://github.com/uxsolutions/bootstrap-datepicker)
 *
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */
.datepicker {
  padding: 8px 6px;
  border-radius: 4px;
  direction: ltr;
  transform: translate3d(0, -40px, 0);
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
  opacity: 0;
  filter: alpha(opacity=0);
  visibility: hidden;
  display: block;
  width: 254px;
  max-width: 254px;
}
.datepicker.dropdown-menu:before {
  display: none;
}
.datepicker.datepicker-primary {
  background-color: #f96332;
}
.datepicker.datepicker-primary th,
.datepicker.datepicker-primary .day div,
.datepicker.datepicker-primary table tr td span {
  color: #FFFFFF;
}
.datepicker.datepicker-primary:after {
  border-bottom-color: #f96332;
}
.datepicker.datepicker-primary.datepicker-orient-top:after {
  border-top-color: #f96332;
}
.datepicker.datepicker-primary .dow {
  color: rgba(255, 255, 255, 0.8);
}
.datepicker.datepicker-primary table tr td.old div,
.datepicker.datepicker-primary table tr td.new div,
.datepicker.datepicker-primary table tr td span.old,
.datepicker.datepicker-primary table tr td span.new {
  color: rgba(255, 255, 255, 0.4);
}
.datepicker.datepicker-primary table tr td span:hover,
.datepicker.datepicker-primary table tr td span.focused {
  background: rgba(255, 255, 255, 0.1);
}
.datepicker.datepicker-primary .datepicker-switch:hover,
.datepicker.datepicker-primary .prev:hover,
.datepicker.datepicker-primary .next:hover,
.datepicker.datepicker-primary tfoot tr th:hover {
  background: rgba(255, 255, 255, 0.2);
}
.datepicker.datepicker-primary table tr td.active div,
.datepicker.datepicker-primary table tr td.active:hover div,
.datepicker.datepicker-primary table tr td.active.disabled div,
.datepicker.datepicker-primary table tr td.active.disabled:hover div {
  background-color: #FFFFFF;
  color: #f96332;
}
.datepicker.datepicker-primary table tr td.day:hover div,
.datepicker.datepicker-primary table tr td.day.focused div {
  background: rgba(255, 255, 255, 0.2);
}
.datepicker.datepicker-primary table tr td.active:hover div,
.datepicker.datepicker-primary table tr td.active:hover:hover div,
.datepicker.datepicker-primary table tr td.active.disabled:hover div,
.datepicker.datepicker-primary table tr td.active.disabled:hover:hover div,
.datepicker.datepicker-primary table tr td.active:active div,
.datepicker.datepicker-primary table tr td.active:hover:active div,
.datepicker.datepicker-primary table tr td.active.disabled:active div,
.datepicker.datepicker-primary table tr td.active.disabled:hover:active div,
.datepicker.datepicker-primary table tr td.active.active div,
.datepicker.datepicker-primary table tr td.active:hover.active div,
.datepicker.datepicker-primary table tr td.active.disabled.active div,
.datepicker.datepicker-primary table tr td.active.disabled:hover.active div,
.datepicker.datepicker-primary table tr td.active.disabled div,
.datepicker.datepicker-primary table tr td.active:hover.disabled div,
.datepicker.datepicker-primary table tr td.active.disabled.disabled div,
.datepicker.datepicker-primary table tr td.active.disabled:hover.disabled div,
.datepicker.datepicker-primary table tr td.active[disabled] div,
.datepicker.datepicker-primary table tr td.active:hover[disabled] div,
.datepicker.datepicker-primary table tr td.active.disabled[disabled] div,
.datepicker.datepicker-primary table tr td.active.disabled:hover[disabled] div,
.datepicker.datepicker-primary table tr td span.active:hover,
.datepicker.datepicker-primary table tr td span.active:hover:hover,
.datepicker.datepicker-primary table tr td span.active.disabled:hover,
.datepicker.datepicker-primary table tr td span.active.disabled:hover:hover,
.datepicker.datepicker-primary table tr td span.active:active,
.datepicker.datepicker-primary table tr td span.active:hover:active,
.datepicker.datepicker-primary table tr td span.active.disabled:active,
.datepicker.datepicker-primary table tr td span.active.disabled:hover:active,
.datepicker.datepicker-primary table tr td span.active.active,
.datepicker.datepicker-primary table tr td span.active:hover.active,
.datepicker.datepicker-primary table tr td span.active.disabled.active,
.datepicker.datepicker-primary table tr td span.active.disabled:hover.active,
.datepicker.datepicker-primary table tr td span.active.disabled,
.datepicker.datepicker-primary table tr td span.active:hover.disabled,
.datepicker.datepicker-primary table tr td span.active.disabled.disabled,
.datepicker.datepicker-primary table tr td span.active.disabled:hover.disabled,
.datepicker.datepicker-primary table tr td span.active[disabled],
.datepicker.datepicker-primary table tr td span.active:hover[disabled],
.datepicker.datepicker-primary table tr td span.active.disabled[disabled],
.datepicker.datepicker-primary table tr td span.active.disabled:hover[disabled] {
  background-color: #FFFFFF;
}
.datepicker.datepicker-primary table tr td span.active:hover,
.datepicker.datepicker-primary table tr td span.active:hover:hover,
.datepicker.datepicker-primary table tr td span.active.disabled:hover,
.datepicker.datepicker-primary table tr td span.active.disabled:hover:hover,
.datepicker.datepicker-primary table tr td span.active:active,
.datepicker.datepicker-primary table tr td span.active:hover:active,
.datepicker.datepicker-primary table tr td span.active.disabled:active,
.datepicker.datepicker-primary table tr td span.active.disabled:hover:active,
.datepicker.datepicker-primary table tr td span.active.active,
.datepicker.datepicker-primary table tr td span.active:hover.active,
.datepicker.datepicker-primary table tr td span.active.disabled.active,
.datepicker.datepicker-primary table tr td span.active.disabled:hover.active,
.datepicker.datepicker-primary table tr td span.active.disabled,
.datepicker.datepicker-primary table tr td span.active:hover.disabled,
.datepicker.datepicker-primary table tr td span.active.disabled.disabled,
.datepicker.datepicker-primary table tr td span.active.disabled:hover.disabled,
.datepicker.datepicker-primary table tr td span.active[disabled],
.datepicker.datepicker-primary table tr td span.active:hover[disabled],
.datepicker.datepicker-primary table tr td span.active.disabled[disabled],
.datepicker.datepicker-primary table tr td span.active.disabled:hover[disabled] {
  color: #f96332;
}

.datepicker-inline {
  width: 220px;
}

.datepicker.datepicker-rtl {
  direction: rtl;
}

.datepicker.datepicker-rtl.dropdown-menu {
  left: auto;
}

.datepicker.datepicker-rtl table tr td span {
  float: right;
}

.datepicker-dropdown {
  top: 0;
  left: 0;
}

.datepicker-dropdown:before {
  content: "";
  display: inline-block;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-top: 0;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  position: absolute;
}

.datepicker-dropdown:after {
  content: "";
  display: inline-block;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  border-top: 0;
  position: absolute;
}

.datepicker-dropdown.datepicker-orient-left:before {
  left: 6px;
}

.datepicker-dropdown.datepicker-orient-left:after {
  left: 7px;
}

.datepicker-dropdown.datepicker-orient-right:before {
  right: 6px;
}

.datepicker-dropdown.datepicker-orient-right:after {
  right: 7px;
}

.datepicker-dropdown.datepicker-orient-bottom:before {
  top: -7px;
}

.datepicker-dropdown.datepicker-orient-bottom:after {
  top: -6px;
}

.datepicker-dropdown.datepicker-orient-top:before {
  bottom: -7px;
  border-bottom: 0;
  border-top: 7px solid transparent;
}

.datepicker-dropdown.datepicker-orient-top:after {
  bottom: -6px;
  border-bottom: 0;
  border-top: 6px solid #fff;
}

.datepicker table {
  margin: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  width: 241px;
  max-width: 241px;
}

.datepicker .day div,
.datepicker th {
  transition: all 300ms ease 0s;
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 2.2;
  border-radius: 50%;
  font-weight: 300;
  font-size: 14px;
  border: none;
  z-index: 1;
  position: relative;
  cursor: pointer;
}

.datepicker th {
  color: #f96332;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
  padding: 2px;
  text-align: center;
  cursor: pointer;
}

.table-striped .datepicker table tr td,
.table-striped .datepicker table tr th {
  background-color: transparent;
}

.datepicker table tr td.day:hover div,
.datepicker table tr td.day.focused div {
  background: #eee;
  cursor: pointer;
}

.datepicker table tr td.old,
.datepicker table tr td.new {
  color: #888888;
}

.datepicker table tr td.disabled,
.datepicker table tr td.disabled:hover {
  background: none;
  color: #888888;
  cursor: default;
}

.datepicker table tr td.highlighted {
  background: #d9edf7;
  border-radius: 0;
}

.datepicker table tr td.today,
.datepicker table tr td.today:hover,
.datepicker table tr td.today.disabled,
.datepicker table tr td.today.disabled:hover {
  background-color: #fde19a;
  background-image: linear-gradient(to bottom, #fdd49a, #fdf59a);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fdd49a", endColorstr="#fdf59a", GradientType=0);
  border-color: #fdf59a #fdf59a #fbed50;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
  color: #000;
}

.datepicker table tr td.today:hover,
.datepicker table tr td.today:hover:hover,
.datepicker table tr td.today.disabled:hover,
.datepicker table tr td.today.disabled:hover:hover,
.datepicker table tr td.today:active,
.datepicker table tr td.today:hover:active,
.datepicker table tr td.today.disabled:active,
.datepicker table tr td.today.disabled:hover:active,
.datepicker table tr td.today.active,
.datepicker table tr td.today:hover.active,
.datepicker table tr td.today.disabled.active,
.datepicker table tr td.today.disabled:hover.active,
.datepicker table tr td.today.disabled,
.datepicker table tr td.today:hover.disabled,
.datepicker table tr td.today.disabled.disabled,
.datepicker table tr td.today.disabled:hover.disabled,
.datepicker table tr td.today[disabled],
.datepicker table tr td.today:hover[disabled],
.datepicker table tr td.today.disabled[disabled],
.datepicker table tr td.today.disabled:hover[disabled] {
  background-color: #fdf59a;
}

.datepicker table tr td.today:active,
.datepicker table tr td.today:hover:active,
.datepicker table tr td.today.disabled:active,
.datepicker table tr td.today.disabled:hover:active,
.datepicker table tr td.today.active,
.datepicker table tr td.today:hover.active,
.datepicker table tr td.today.disabled.active,
.datepicker table tr td.today.disabled:hover.active {
  background-color: #fbf069 \\9 ;
}

.datepicker table tr td.today:hover:hover {
  color: #000;
}

.datepicker table tr td.today.active:hover {
  color: #fff;
}

.datepicker table tr td.range,
.datepicker table tr td.range:hover,
.datepicker table tr td.range.disabled,
.datepicker table tr td.range.disabled:hover {
  background: #eee;
  border-radius: 0;
}

.datepicker table tr td.range.today,
.datepicker table tr td.range.today:hover,
.datepicker table tr td.range.today.disabled,
.datepicker table tr td.range.today.disabled:hover {
  background-color: #f3d17a;
  background-image: linear-gradient(to bottom, #f3c17a, #f3e97a);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f3c17a", endColorstr="#f3e97a", GradientType=0);
  border-color: #f3e97a #f3e97a #edde34;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
  border-radius: 0;
}

.datepicker table tr td.range.today:hover,
.datepicker table tr td.range.today:hover:hover,
.datepicker table tr td.range.today.disabled:hover,
.datepicker table tr td.range.today.disabled:hover:hover,
.datepicker table tr td.range.today:active,
.datepicker table tr td.range.today:hover:active,
.datepicker table tr td.range.today.disabled:active,
.datepicker table tr td.range.today.disabled:hover:active,
.datepicker table tr td.range.today.active,
.datepicker table tr td.range.today:hover.active,
.datepicker table tr td.range.today.disabled.active,
.datepicker table tr td.range.today.disabled:hover.active,
.datepicker table tr td.range.today.disabled,
.datepicker table tr td.range.today:hover.disabled,
.datepicker table tr td.range.today.disabled.disabled,
.datepicker table tr td.range.today.disabled:hover.disabled,
.datepicker table tr td.range.today[disabled],
.datepicker table tr td.range.today:hover[disabled],
.datepicker table tr td.range.today.disabled[disabled],
.datepicker table tr td.range.today.disabled:hover[disabled] {
  background-color: #f3e97a;
}

.datepicker table tr td.range.today:active,
.datepicker table tr td.range.today:hover:active,
.datepicker table tr td.range.today.disabled:active,
.datepicker table tr td.range.today.disabled:hover:active,
.datepicker table tr td.range.today.active,
.datepicker table tr td.range.today:hover.active,
.datepicker table tr td.range.today.disabled.active,
.datepicker table tr td.range.today.disabled:hover.active {
  background-color: #efe24b \\9 ;
}

.datepicker table tr td.selected,
.datepicker table tr td.selected:hover,
.datepicker table tr td.selected.disabled,
.datepicker table tr td.selected.disabled:hover {
  background-color: #9e9e9e;
  background-image: linear-gradient(to bottom, #b3b3b3, #808080);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#b3b3b3", endColorstr="#808080", GradientType=0);
  border-color: #808080 #808080 #595959;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}

.datepicker table tr td.selected:hover,
.datepicker table tr td.selected:hover:hover,
.datepicker table tr td.selected.disabled:hover,
.datepicker table tr td.selected.disabled:hover:hover,
.datepicker table tr td.selected:active,
.datepicker table tr td.selected:hover:active,
.datepicker table tr td.selected.disabled:active,
.datepicker table tr td.selected.disabled:hover:active,
.datepicker table tr td.selected.active,
.datepicker table tr td.selected:hover.active,
.datepicker table tr td.selected.disabled.active,
.datepicker table tr td.selected.disabled:hover.active,
.datepicker table tr td.selected.disabled,
.datepicker table tr td.selected:hover.disabled,
.datepicker table tr td.selected.disabled.disabled,
.datepicker table tr td.selected.disabled:hover.disabled,
.datepicker table tr td.selected[disabled],
.datepicker table tr td.selected:hover[disabled],
.datepicker table tr td.selected.disabled[disabled],
.datepicker table tr td.selected.disabled:hover[disabled] {
  background-color: #808080;
}

.datepicker table tr td.selected:active,
.datepicker table tr td.selected:hover:active,
.datepicker table tr td.selected.disabled:active,
.datepicker table tr td.selected.disabled:hover:active,
.datepicker table tr td.selected.active,
.datepicker table tr td.selected:hover.active,
.datepicker table tr td.selected.disabled.active,
.datepicker table tr td.selected.disabled:hover.active {
  background-color: #666666 \\9 ;
}

.datepicker table tr td.active div,
.datepicker table tr td.active:hover div,
.datepicker table tr td.active.disabled div,
.datepicker table tr td.active.disabled:hover div {
  background-color: #f96332;
  color: #FFFFFF;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}

.datepicker table tr td.active:hover div,
.datepicker table tr td.active:hover:hover div,
.datepicker table tr td.active.disabled:hover div,
.datepicker table tr td.active.disabled:hover:hover div,
.datepicker table tr td.active:active div,
.datepicker table tr td.active:hover:active div,
.datepicker table tr td.active.disabled:active div,
.datepicker table tr td.active.disabled:hover:active div,
.datepicker table tr td.active.active div,
.datepicker table tr td.active:hover.active div,
.datepicker table tr td.active.disabled.active div,
.datepicker table tr td.active.disabled:hover.active div,
.datepicker table tr td.active.disabled div,
.datepicker table tr td.active:hover.disabled div,
.datepicker table tr td.active.disabled.disabled div,
.datepicker table tr td.active.disabled:hover.disabled div,
.datepicker table tr td.active[disabled] div,
.datepicker table tr td.active:hover[disabled] div,
.datepicker table tr td.active.disabled[disabled] div,
.datepicker table tr td.active.disabled:hover[disabled] div {
  background-color: #f96332;
}

.datepicker table tr td.active:active,
.datepicker table tr td.active:hover:active,
.datepicker table tr td.active.disabled:active,
.datepicker table tr td.active.disabled:hover:active,
.datepicker table tr td.active.active,
.datepicker table tr td.active:hover.active,
.datepicker table tr td.active.disabled.active,
.datepicker table tr td.active.disabled:hover.active {
  background-color: #003399 \\9 ;
}

.datepicker table tr td span {
  display: block;
  width: 41px;
  height: 41px;
  line-height: 41px;
  float: left;
  margin: 1%;
  font-size: 14px;
  cursor: pointer;
  border-radius: 50%;
}

.datepicker table tr td span:hover,
.datepicker table tr td span.focused {
  background: #eee;
}

.datepicker table tr td span.disabled,
.datepicker table tr td span.disabled:hover {
  background: none;
  color: #888888;
  cursor: default;
}

.datepicker table tr td span.active,
.datepicker table tr td span.active:hover,
.datepicker table tr td span.active.disabled,
.datepicker table tr td span.active.disabled:hover {
  color: #fff;
  background-color: #f96332;
}

.datepicker table tr td span.active:hover,
.datepicker table tr td span.active:hover:hover,
.datepicker table tr td span.active.disabled:hover,
.datepicker table tr td span.active.disabled:hover:hover,
.datepicker table tr td span.active:active,
.datepicker table tr td span.active:hover:active,
.datepicker table tr td span.active.disabled:active,
.datepicker table tr td span.active.disabled:hover:active,
.datepicker table tr td span.active.active,
.datepicker table tr td span.active:hover.active,
.datepicker table tr td span.active.disabled.active,
.datepicker table tr td span.active.disabled:hover.active,
.datepicker table tr td span.active.disabled,
.datepicker table tr td span.active:hover.disabled,
.datepicker table tr td span.active.disabled.disabled,
.datepicker table tr td span.active.disabled:hover.disabled,
.datepicker table tr td span.active[disabled],
.datepicker table tr td span.active:hover[disabled],
.datepicker table tr td span.active.disabled[disabled],
.datepicker table tr td span.active.disabled:hover[disabled] {
  background-color: #f96332;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}

.datepicker table tr td span.active:active,
.datepicker table tr td span.active:hover:active,
.datepicker table tr td span.active.disabled:active,
.datepicker table tr td span.active.disabled:hover:active,
.datepicker table tr td span.active.active,
.datepicker table tr td span.active:hover.active,
.datepicker table tr td span.active.disabled.active,
.datepicker table tr td span.active.disabled:hover.active {
  background-color: #003399 \\9 ;
}

.datepicker table tr td span.old,
.datepicker table tr td span.new {
  color: #888888;
}

.datepicker .datepicker-switch {
  width: auto;
  border-radius: 0.1875rem;
}

.datepicker .datepicker-switch,
.datepicker .prev,
.datepicker .next,
.datepicker tfoot tr th {
  cursor: pointer;
}

.datepicker .prev,
.datepicker .next {
  width: 35px;
  height: 35px;
}
.datepicker i {
  position: relative;
  top: 2px;
}
.datepicker .prev i {
  left: -1px;
}
.datepicker .next i {
  right: -1px;
}

.datepicker .datepicker-switch:hover,
.datepicker .prev:hover,
.datepicker .next:hover,
.datepicker tfoot tr th:hover {
  background: #eee;
}

.datepicker .prev.disabled,
.datepicker .next.disabled {
  visibility: hidden;
}

.datepicker .cw {
  font-size: 10px;
  width: 12px;
  padding: 0 2px 0 5px;
  vertical-align: middle;
}

.input-append.date .add-on,
.input-prepend.date .add-on {
  cursor: pointer;
}

.input-append.date .add-on i,
.input-prepend.date .add-on i {
  margin-top: 3px;
}

.input-daterange input {
  text-align: center;
}

.input-daterange input:first-child {
  border-radius: 3px 0 0 3px;
}

.input-daterange input:last-child {
  border-radius: 0 3px 3px 0;
}

.input-daterange .add-on {
  display: inline-block;
  width: auto;
  min-width: 16px;
  height: 18px;
  padding: 4px 5px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
  text-shadow: 0 1px 0 #fff;
  vertical-align: middle;
  background-color: #eee;
  border: 1px solid #ccc;
  margin-left: -5px;
  margin-right: -5px;
}

.table-condensed > tbody > tr > td, .table-condensed > tbody > tr > th, .table-condensed > tfoot > tr > td, .table-condensed > tfoot > tr > th, .table-condensed > thead > tr > td, .table-condensed > thead > tr > th {
  position: relative;
  z-index: -1;
}

.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  font-weight: 400;
  font-size: 0.8571em;
  line-height: 1.35em;
  margin: 10px 1px;
  border: none;
  border-radius: 0.1875rem;
  padding: 11px 22px;
  cursor: pointer;
  background-color: #888888;
  color: #FFFFFF;
}
.btn:hover, .btn:focus, .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active, .btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus, .btn:active:hover, .btn.active:hover, .show > .btn.dropdown-toggle, .show > .btn.dropdown-toggle:focus, .show > .btn.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn:not(:disabled):not(.disabled).active,
.navbar .navbar-nav > a.btn:not(:disabled):not(.disabled):active:focus,
.navbar .navbar-nav > a.btn:not(:disabled):not(.disabled).active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:hover,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:hover {
  background-color: #979797;
  color: #FFFFFF;
  box-shadow: none;
}
.btn:hover,
.navbar .navbar-nav > a.btn:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
  background-color: #888888;
  border-color: #888888;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
  color: #888888;
  border-color: #888888;
}
.btn.btn-simple:hover, .btn.btn-simple:focus, .btn.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-simple:active:hover, .btn.btn-simple.active:hover, .show > .btn.btn-simple.dropdown-toggle, .show > .btn.btn-simple.dropdown-toggle:focus, .show > .btn.btn-simple.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn.btn-simple:hover,
.navbar .navbar-nav > a.btn.btn-simple:focus,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled).active,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled):active:focus,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled).active:focus,
.navbar .navbar-nav > a.btn.btn-simple:active:hover,
.navbar .navbar-nav > a.btn.btn-simple.active:hover,
.show > .navbar .navbar-nav > a.btn.btn-simple.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.btn-simple.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #979797;
  border-color: #979797;
  box-shadow: none;
}
.btn.btn-link,
.navbar .navbar-nav > a.btn.btn-link {
  color: #888888;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:not(:disabled):not(.disabled):active, .btn.btn-link:not(:disabled):not(.disabled).active, .btn.btn-link:not(:disabled):not(.disabled):active:focus, .btn.btn-link:not(:disabled):not(.disabled).active:focus, .btn.btn-link:active:hover, .btn.btn-link.active:hover, .show > .btn.btn-link.dropdown-toggle, .show > .btn.btn-link.dropdown-toggle:focus, .show > .btn.btn-link.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn.btn-link:hover,
.navbar .navbar-nav > a.btn.btn-link:focus,
.navbar .navbar-nav > a.btn.btn-link:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-link:not(:disabled):not(.disabled).active,
.navbar .navbar-nav > a.btn.btn-link:not(:disabled):not(.disabled):active:focus,
.navbar .navbar-nav > a.btn.btn-link:not(:disabled):not(.disabled).active:focus,
.navbar .navbar-nav > a.btn.btn-link:active:hover,
.navbar .navbar-nav > a.btn.btn-link.active:hover,
.show > .navbar .navbar-nav > a.btn.btn-link.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.btn-link.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #979797;
  text-decoration: none;
  box-shadow: none;
}
.btn:hover, .btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
  height: 2.375rem;
  min-width: 2.375rem;
  width: 2.375rem;
  padding: 0;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
.btn.btn-icon[class*=btn-outline-],
.navbar .navbar-nav > a.btn.btn-icon[class*=btn-outline-] {
  padding: 0;
}
.btn.btn-icon.btn-sm,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm {
  height: 1.875rem;
  min-width: 1.875rem;
  width: 1.875rem;
}
.btn.btn-icon.btn-sm i.fab,
.btn.btn-icon.btn-sm i.now-ui-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm i.fab,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm i.now-ui-icons {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg {
  height: 3.6rem;
  min-width: 3.6rem;
  width: 3.6rem;
}
.btn.btn-icon.btn-lg i.now-ui-icons,
.btn.btn-icon.btn-lg i.fab,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg i.now-ui-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg i.fab {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) i.now-ui-icons, .btn.btn-icon:not(.btn-footer) i.fab,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) i.now-ui-icons,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) i.fab {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 23px;
}
.btn:not(.btn-icon) .now-ui-icons,
.navbar .navbar-nav > a.btn:not(.btn-icon) .now-ui-icons {
  position: relative;
  top: 1px;
}

.btn-primary {
  background-color: #f96332;
  color: #FFFFFF;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:active:hover, .btn-primary.active:hover, .show > .btn-primary.dropdown-toggle, .show > .btn-primary.dropdown-toggle:focus, .show > .btn-primary.dropdown-toggle:hover {
  background-color: #fa7a50;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-primary:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #f96332;
  border-color: #f96332;
}
.btn-primary.btn-simple {
  color: #f96332;
  border-color: #f96332;
}
.btn-primary.btn-simple:hover, .btn-primary.btn-simple:focus, .btn-primary.btn-simple:not(:disabled):not(.disabled):active, .btn-primary.btn-simple:not(:disabled):not(.disabled).active, .btn-primary.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-primary.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-primary.btn-simple:active:hover, .btn-primary.btn-simple.active:hover, .show > .btn-primary.btn-simple.dropdown-toggle, .show > .btn-primary.btn-simple.dropdown-toggle:focus, .show > .btn-primary.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #fa7a50;
  border-color: #fa7a50;
  box-shadow: none;
}
.btn-primary.btn-link {
  color: #f96332;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:not(:disabled):not(.disabled):active, .btn-primary.btn-link:not(:disabled):not(.disabled).active, .btn-primary.btn-link:not(:disabled):not(.disabled):active:focus, .btn-primary.btn-link:not(:disabled):not(.disabled).active:focus, .btn-primary.btn-link:active:hover, .btn-primary.btn-link.active:hover, .show > .btn-primary.btn-link.dropdown-toggle, .show > .btn-primary.btn-link.dropdown-toggle:focus, .show > .btn-primary.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #fa7a50;
  text-decoration: none;
  box-shadow: none;
}

.btn-success {
  background-color: #18ce0f;
  color: #FFFFFF;
}
.btn-success:hover, .btn-success:focus, .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .btn-success:active:hover, .btn-success.active:hover, .show > .btn-success.dropdown-toggle, .show > .btn-success.dropdown-toggle:focus, .show > .btn-success.dropdown-toggle:hover {
  background-color: #1beb11;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-success:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #18ce0f;
  border-color: #18ce0f;
}
.btn-success.btn-simple {
  color: #18ce0f;
  border-color: #18ce0f;
}
.btn-success.btn-simple:hover, .btn-success.btn-simple:focus, .btn-success.btn-simple:not(:disabled):not(.disabled):active, .btn-success.btn-simple:not(:disabled):not(.disabled).active, .btn-success.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-success.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-success.btn-simple:active:hover, .btn-success.btn-simple.active:hover, .show > .btn-success.btn-simple.dropdown-toggle, .show > .btn-success.btn-simple.dropdown-toggle:focus, .show > .btn-success.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #1beb11;
  border-color: #1beb11;
  box-shadow: none;
}
.btn-success.btn-link {
  color: #18ce0f;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:not(:disabled):not(.disabled):active, .btn-success.btn-link:not(:disabled):not(.disabled).active, .btn-success.btn-link:not(:disabled):not(.disabled):active:focus, .btn-success.btn-link:not(:disabled):not(.disabled).active:focus, .btn-success.btn-link:active:hover, .btn-success.btn-link.active:hover, .show > .btn-success.btn-link.dropdown-toggle, .show > .btn-success.btn-link.dropdown-toggle:focus, .show > .btn-success.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #1beb11;
  text-decoration: none;
  box-shadow: none;
}

.btn-info {
  background-color: #2CA8FF;
  color: #FFFFFF;
}
.btn-info:hover, .btn-info:focus, .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .btn-info:active:hover, .btn-info.active:hover, .show > .btn-info.dropdown-toggle, .show > .btn-info.dropdown-toggle:focus, .show > .btn-info.dropdown-toggle:hover {
  background-color: #4bb5ff;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-info:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #2CA8FF;
  border-color: #2CA8FF;
}
.btn-info.btn-simple {
  color: #2CA8FF;
  border-color: #2CA8FF;
}
.btn-info.btn-simple:hover, .btn-info.btn-simple:focus, .btn-info.btn-simple:not(:disabled):not(.disabled):active, .btn-info.btn-simple:not(:disabled):not(.disabled).active, .btn-info.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-info.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-info.btn-simple:active:hover, .btn-info.btn-simple.active:hover, .show > .btn-info.btn-simple.dropdown-toggle, .show > .btn-info.btn-simple.dropdown-toggle:focus, .show > .btn-info.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #4bb5ff;
  border-color: #4bb5ff;
  box-shadow: none;
}
.btn-info.btn-link {
  color: #2CA8FF;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:not(:disabled):not(.disabled):active, .btn-info.btn-link:not(:disabled):not(.disabled).active, .btn-info.btn-link:not(:disabled):not(.disabled):active:focus, .btn-info.btn-link:not(:disabled):not(.disabled).active:focus, .btn-info.btn-link:active:hover, .btn-info.btn-link.active:hover, .show > .btn-info.btn-link.dropdown-toggle, .show > .btn-info.btn-link.dropdown-toggle:focus, .show > .btn-info.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #4bb5ff;
  text-decoration: none;
  box-shadow: none;
}

.btn-warning {
  background-color: #FFB236;
  color: #FFFFFF;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .btn-warning:active:hover, .btn-warning.active:hover, .show > .btn-warning.dropdown-toggle, .show > .btn-warning.dropdown-toggle:focus, .show > .btn-warning.dropdown-toggle:hover {
  background-color: #ffbe55;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-warning:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #FFB236;
  border-color: #FFB236;
}
.btn-warning.btn-simple {
  color: #FFB236;
  border-color: #FFB236;
}
.btn-warning.btn-simple:hover, .btn-warning.btn-simple:focus, .btn-warning.btn-simple:not(:disabled):not(.disabled):active, .btn-warning.btn-simple:not(:disabled):not(.disabled).active, .btn-warning.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-warning.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-warning.btn-simple:active:hover, .btn-warning.btn-simple.active:hover, .show > .btn-warning.btn-simple.dropdown-toggle, .show > .btn-warning.btn-simple.dropdown-toggle:focus, .show > .btn-warning.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #ffbe55;
  border-color: #ffbe55;
  box-shadow: none;
}
.btn-warning.btn-link {
  color: #FFB236;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:not(:disabled):not(.disabled):active, .btn-warning.btn-link:not(:disabled):not(.disabled).active, .btn-warning.btn-link:not(:disabled):not(.disabled):active:focus, .btn-warning.btn-link:not(:disabled):not(.disabled).active:focus, .btn-warning.btn-link:active:hover, .btn-warning.btn-link.active:hover, .show > .btn-warning.btn-link.dropdown-toggle, .show > .btn-warning.btn-link.dropdown-toggle:focus, .show > .btn-warning.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #ffbe55;
  text-decoration: none;
  box-shadow: none;
}

.btn-danger {
  background-color: #FF3636;
  color: #FFFFFF;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .btn-danger:active:hover, .btn-danger.active:hover, .show > .btn-danger.dropdown-toggle, .show > .btn-danger.dropdown-toggle:focus, .show > .btn-danger.dropdown-toggle:hover {
  background-color: #ff5555;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-danger:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #FF3636;
  border-color: #FF3636;
}
.btn-danger.btn-simple {
  color: #FF3636;
  border-color: #FF3636;
}
.btn-danger.btn-simple:hover, .btn-danger.btn-simple:focus, .btn-danger.btn-simple:not(:disabled):not(.disabled):active, .btn-danger.btn-simple:not(:disabled):not(.disabled).active, .btn-danger.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-danger.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-danger.btn-simple:active:hover, .btn-danger.btn-simple.active:hover, .show > .btn-danger.btn-simple.dropdown-toggle, .show > .btn-danger.btn-simple.dropdown-toggle:focus, .show > .btn-danger.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #ff5555;
  border-color: #ff5555;
  box-shadow: none;
}
.btn-danger.btn-link {
  color: #FF3636;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:not(:disabled):not(.disabled):active, .btn-danger.btn-link:not(:disabled):not(.disabled).active, .btn-danger.btn-link:not(:disabled):not(.disabled):active:focus, .btn-danger.btn-link:not(:disabled):not(.disabled).active:focus, .btn-danger.btn-link:active:hover, .btn-danger.btn-link.active:hover, .show > .btn-danger.btn-link.dropdown-toggle, .show > .btn-danger.btn-link.dropdown-toggle:focus, .show > .btn-danger.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #ff5555;
  text-decoration: none;
  box-shadow: none;
}

.btn-neutral {
  background-color: #FFFFFF;
  color: #f96332;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .btn-neutral:active:hover, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #FFFFFF;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-neutral:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-danger {
  color: #FF3636;
}
.btn-neutral.btn-danger:hover, .btn-neutral.btn-danger:focus, .btn-neutral.btn-danger:active {
  color: #ff5555 !important;
}
.btn-neutral.btn-primary {
  color: #f96332;
}
.btn-neutral.btn-primary:hover, .btn-neutral.btn-primary:focus, .btn-neutral.btn-primary:active {
  color: #fa7a50 !important;
}
.btn-neutral.btn-info {
  color: #2CA8FF;
}
.btn-neutral.btn-info:hover, .btn-neutral.btn-info:focus, .btn-neutral.btn-info:active {
  color: #4bb5ff !important;
}
.btn-neutral.btn-warning {
  color: #FFB236;
}
.btn-neutral.btn-warning:hover, .btn-neutral.btn-warning:focus, .btn-neutral.btn-warning:active {
  color: #ffbe55 !important;
}
.btn-neutral.btn-success {
  color: #18ce0f;
}
.btn-neutral.btn-success:hover, .btn-neutral.btn-success:focus, .btn-neutral.btn-success:active {
  color: #1beb11 !important;
}
.btn-neutral.btn-default {
  color: #888888;
}
.btn-neutral.btn-default:hover, .btn-neutral.btn-default:focus, .btn-neutral.btn-default:active {
  color: #979797 !important;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .btn-neutral:active:hover, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #FFFFFF;
  color: #fa7a50;
  box-shadow: none;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #fa7a50 !important;
}
.btn-neutral:hover:not(.nav-link), .btn-neutral:focus:not(.nav-link) {
  box-shadow: none;
}
.btn-neutral.btn-simple {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-simple:hover, .btn-neutral.btn-simple:focus, .btn-neutral.btn-simple:not(:disabled):not(.disabled):active, .btn-neutral.btn-simple:not(:disabled):not(.disabled).active, .btn-neutral.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-neutral.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-neutral.btn-simple:active:hover, .btn-neutral.btn-simple.active:hover, .show > .btn-neutral.btn-simple.dropdown-toggle, .show > .btn-neutral.btn-simple.dropdown-toggle:focus, .show > .btn-neutral.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #FFFFFF;
  border-color: #FFFFFF;
  box-shadow: none;
}
.btn-neutral.btn-link {
  color: #FFFFFF;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:not(:disabled):not(.disabled):active, .btn-neutral.btn-link:not(:disabled):not(.disabled).active, .btn-neutral.btn-link:not(:disabled):not(.disabled):active:focus, .btn-neutral.btn-link:not(:disabled):not(.disabled).active:focus, .btn-neutral.btn-link:active:hover, .btn-neutral.btn-link.active:hover, .show > .btn-neutral.btn-link.dropdown-toggle, .show > .btn-neutral.btn-link.dropdown-toggle:focus, .show > .btn-neutral.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #FFFFFF;
  text-decoration: none;
  box-shadow: none;
}

.btn-outline-primary {
  color: #f96332;
  border-color: #f96332;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .btn-outline-primary:active:hover, .btn-outline-primary.active:hover, .show > .btn-outline-primary.dropdown-toggle, .show > .btn-outline-primary.dropdown-toggle:focus, .show > .btn-outline-primary.dropdown-toggle:hover {
  background-color: transparent;
  color: #fa7a50;
  border-color: #fa7a50;
  box-shadow: none;
}

.btn-outline-success {
  color: #18ce0f;
  border-color: #18ce0f;
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .btn-outline-success:active:hover, .btn-outline-success.active:hover, .show > .btn-outline-success.dropdown-toggle, .show > .btn-outline-success.dropdown-toggle:focus, .show > .btn-outline-success.dropdown-toggle:hover {
  background-color: transparent;
  color: #1beb11;
  border-color: #1beb11;
  box-shadow: none;
}

.btn-outline-info {
  color: #2CA8FF;
  border-color: #2CA8FF;
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .btn-outline-info:active:hover, .btn-outline-info.active:hover, .show > .btn-outline-info.dropdown-toggle, .show > .btn-outline-info.dropdown-toggle:focus, .show > .btn-outline-info.dropdown-toggle:hover {
  background-color: transparent;
  color: #4bb5ff;
  border-color: #4bb5ff;
  box-shadow: none;
}

.btn-outline-warning {
  color: #FFB236;
  border-color: #FFB236;
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .btn-outline-warning:active:hover, .btn-outline-warning.active:hover, .show > .btn-outline-warning.dropdown-toggle, .show > .btn-outline-warning.dropdown-toggle:focus, .show > .btn-outline-warning.dropdown-toggle:hover {
  background-color: transparent;
  color: #ffbe55;
  border-color: #ffbe55;
  box-shadow: none;
}

.btn-outline-danger {
  color: #FF3636;
  border-color: #FF3636;
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .btn-outline-danger:active:hover, .btn-outline-danger.active:hover, .show > .btn-outline-danger.dropdown-toggle, .show > .btn-outline-danger.dropdown-toggle:focus, .show > .btn-outline-danger.dropdown-toggle:hover {
  background-color: transparent;
  color: #ff5555;
  border-color: #ff5555;
  box-shadow: none;
}

.btn-outline-default {
  color: #888888;
  border-color: #888888;
}
.btn-outline-default:hover, .btn-outline-default:focus, .btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .btn-outline-default:active:hover, .btn-outline-default.active:hover, .show > .btn-outline-default.dropdown-toggle, .show > .btn-outline-default.dropdown-toggle:focus, .show > .btn-outline-default.dropdown-toggle:hover {
  background-color: transparent;
  color: #979797;
  border-color: #979797;
  box-shadow: none;
}

.btn-round {
  border-width: 1px;
  border-radius: 30px !important;
  padding: 11px 23px;
}
.btn-round[class*=btn-outline-] {
  padding: 10px 22px;
}

[class*=btn-outline-] {
  border: 1px solid;
  padding: 10px 22px;
  background-color: transparent;
}

[class*=btn-outline-].disabled, [class*=btn-outline-].disabled:hover, [class*=btn-outline-].disabled:focus, [class*=btn-outline-].disabled.focus, [class*=btn-outline-].disabled:active, [class*=btn-outline-].disabled.active, [class*=btn-outline-]:disabled, [class*=btn-outline-]:disabled:hover, [class*=btn-outline-]:disabled:focus, [class*=btn-outline-]:disabled.focus, [class*=btn-outline-]:disabled:active, [class*=btn-outline-]:disabled.active, [class*=btn-outline-][disabled], [class*=btn-outline-][disabled]:hover, [class*=btn-outline-][disabled]:focus, [class*=btn-outline-][disabled].focus, [class*=btn-outline-][disabled]:active, [class*=btn-outline-][disabled].active, fieldset[disabled] [class*=btn-outline-], fieldset[disabled] [class*=btn-outline-]:hover, fieldset[disabled] [class*=btn-outline-]:focus, fieldset[disabled] [class*=btn-outline-].focus, fieldset[disabled] [class*=btn-outline-]:active, fieldset[disabled] [class*=btn-outline-].active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
  background-color: transparent;
}

.btn-lg {
  font-size: 1em;
  border-radius: 0.25rem;
  padding: 15px 48px;
}
.btn-lg[class*=btn-outline-] {
  padding: 14px 47px;
}

.btn-sm {
  font-size: 14px;
  border-radius: 0.1875rem;
  padding: 5px 15px;
}
.btn-sm[class*=btn-outline-] {
  padding: 4px 14px;
}

.btn-link {
  border: 0;
  padding: 0.5rem 0.7rem;
  background-color: transparent;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-facebook, .btn-facebook:hover, .btn-facebookfocus, .btn-facebook:active, .btn-facebook:active:focus {
  color: #3b5998 !important;
}

.btn-twitter, .btn-twitter:hover, .btn-twitterfocus, .btn-twitter:active, .btn-twitter:active:focus {
  color: #55acee !important;
}

.btn-google, .btn-google:hover, .btn-googlefocus, .btn-google:active, .btn-google:active:focus {
  color: #dd4b39 !important;
}

.btn-github, .btn-github:hover, .btn-githubfocus, .btn-github:active, .btn-github:active:focus {
  color: #333333 !important;
}

.btn-linkedin, .btn-linkedin:hover, .btn-linkedinfocus, .btn-linkedin:active, .btn-linkedin:active:focus {
  color: #0077B5 !important;
}

.form-control::-moz-placeholder {
  color: #888888;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.form-control:-moz-placeholder {
  color: #888888;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.form-control::-webkit-input-placeholder {
  color: #888888;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.form-control:-ms-input-placeholder {
  color: #888888;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.form-control {
  background-color: transparent;
  border: 1px solid #E3E3E3;
  border-radius: 30px;
  color: #2c2c2c;
  height: auto;
  line-height: normal;
  font-size: 0.8571em;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  box-shadow: none;
}
.has-success .form-control {
  border-color: #E3E3E3;
}
.form-control:focus {
  border: 1px solid #f96332;
  box-shadow: none;
  outline: 0 !important;
  color: #2c2c2c;
}
.form-control:focus + .input-group-text, .form-control:focus ~ .input-group-text {
  border: 1px solid #f96332;
  border-left: none;
  background-color: transparent;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  box-shadow: none;
}
.has-success .form-control:focus {
  border-color: #1be611;
}
.has-danger .form-control.form-control-success, .has-danger .form-control.form-control-danger, .has-success .form-control.form-control-success, .has-success .form-control.form-control-danger {
  background-image: none;
}
.has-danger .form-control {
  border-color: #ffcfcf;
  color: #FF3636;
  background-color: rgba(222, 222, 222, 0.1);
}
.has-danger .form-control:focus {
  background-color: #FFFFFF;
}
.form-control + .form-control-feedback {
  border-radius: 0.25rem;
  font-size: 14px;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 0.25rem 0.25rem 0 0;
  border-bottom-color: transparent;
}

.has-success:after,
.has-danger:after {
  font-family: "Nucleo Outline";
  content: "\\ea22";
  display: inline-block;
  position: absolute;
  right: 20px;
  top: 12px;
  color: #18ce0f;
  font-size: 11px;
}
.has-success.input-lg:after,
.has-danger.input-lg:after {
  font-size: 13px;
  top: 13px;
}

.has-danger:after {
  content: "\\ea53";
  color: #FF3636;
}

.form-group.no-border.input-lg .input-group-text,
.input-group.no-border.input-lg .input-group-text {
  padding: 15px 0 15px 19px;
}
.form-group.no-border.input-lg .form-control,
.input-group.no-border.input-lg .form-control {
  padding: 15px 19px;
}
.form-group.no-border.input-lg .form-control + .input-group-text,
.input-group.no-border.input-lg .form-control + .input-group-text {
  padding: 15px 19px 15px 0;
}

.form-group.input-lg .form-control,
.input-group.input-lg .form-control {
  padding: 14px 18px;
}
.form-group.input-lg .form-control + .input-group-text,
.input-group.input-lg .form-control + .input-group-text {
  padding: 14px 18px 14px 0;
}
.form-group.input-lg .input-group-text,
.input-group.input-lg .input-group-text {
  padding: 14px 0 15px 18px;
}
.form-group.input-lg .input-group-text + .form-control,
.input-group.input-lg .input-group-text + .form-control {
  padding: 15px 18px 15px 16px;
}

.form-group.no-border .form-control,
.input-group.no-border .form-control {
  padding: 11px 19px;
}
.form-group.no-border .form-control + .input-group-text,
.input-group.no-border .form-control + .input-group-text {
  padding: 11px 19px 11px 0;
}
.form-group.no-border .input-group-text,
.input-group.no-border .input-group-text {
  padding: 11px 0 11px 19px;
}

.form-group .form-control,
.input-group .form-control {
  padding: 10px 18px 10px 18px;
}
.form-group .form-control + .input-group-text,
.input-group .form-control + .input-group-text {
  padding: 10px 18px 10px 0;
}
.form-group .input-group-text,
.input-group .input-group-text {
  padding: 10px 0 10px 18px;
}
.form-group .input-group-text + .form-control, .form-group .input-group-text ~ .form-control,
.input-group .input-group-text + .form-control,
.input-group .input-group-text ~ .form-control {
  padding: 10px 19px 11px 16px;
}

.form-group.no-border .form-control,
.form-group.no-border .form-control + .input-group-text,
.input-group.no-border .form-control,
.input-group.no-border .form-control + .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: medium none;
}
.form-group.no-border .form-control:focus, .form-group.no-border .form-control:active, .form-group.no-border .form-control:active,
.form-group.no-border .form-control + .input-group-text:focus,
.form-group.no-border .form-control + .input-group-text:active,
.form-group.no-border .form-control + .input-group-text:active,
.input-group.no-border .form-control:focus,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control + .input-group-text:focus,
.input-group.no-border .form-control + .input-group-text:active,
.input-group.no-border .form-control + .input-group-text:active {
  border: medium none;
  background-color: rgba(222, 222, 222, 0.5);
}
.form-group.no-border .form-control:focus + .input-group-text,
.input-group.no-border .form-control:focus + .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.form-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
  border-left: transparent !important;
}
.form-group.no-border.input-group-focus.no-border .input-group-text,
.input-group.no-border.input-group-focus.no-border .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}

.has-error .form-control-feedback, .has-error .control-label {
  color: #FF3636;
}

.has-success .form-control-feedback, .has-success .control-label {
  color: #18ce0f;
}

.input-group-text {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 30px;
  color: #555555;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.input-group-focus .input-group-text {
  background-color: #FFFFFF;
  border-color: #f96332;
}
.has-success .input-group-text, .has-danger .input-group-text {
  background-color: #FFFFFF;
}
.has-danger .form-control:focus + .input-group-text {
  color: #FF3636;
}
.has-success .form-control:focus + .input-group-text {
  color: #18ce0f;
}
.input-group-text + .form-control, .input-group-text ~ .form-control {
  padding: -0.5rem 0.7rem;
  padding-left: 18px;
}
.input-group-text i {
  width: 17px;
}

.input-group,
.form-group {
  margin-bottom: 10px;
  position: relative;
}

.input-group[disabled] .input-group-text {
  background-color: #E3E3E3;
}

.input-group .input-group-prepend,
.form-group .input-group-prepend {
  margin-right: 0;
}
.input-group .input-group-prepend .input-group-text,
.form-group .input-group-prepend .input-group-text {
  border-left: 1px solid #E3E3E3;
}
.input-group .input-group-append .input-group-text,
.form-group .input-group-append .input-group-text {
  border-right: 1px solid #E3E3E3;
  padding: 10px 18px 10px 0;
}
.input-group.input-group-focus .input-group-prepend .input-group-text,
.form-group.input-group-focus .input-group-prepend .input-group-text {
  border-left: 1px solid #f96332;
}
.input-group.input-group-focus .input-group-append .input-group-text,
.form-group.input-group-focus .input-group-append .input-group-text {
  border-right: 1px solid #f96332;
}
.input-group.input-group-focus.no-border .input-group-prepend .input-group-text,
.form-group.input-group-focus.no-border .input-group-prepend .input-group-text {
  border-left: transparent;
}

.input-group .form-control:first-child,
.input-group-text:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-text:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #E3E3E3;
  color: #888888;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 11px 0.7rem;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #DDDDDD;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

textarea.form-control {
  max-width: 100%;
  max-height: 80px;
  padding: 10px 10px 0 0;
  resize: none;
  border: none;
  border-bottom: 1px solid #E3E3E3;
  border-radius: 0;
  line-height: 2;
}
textarea.form-control:focus, textarea.form-control:active {
  border-left: none;
  border-top: none;
  border-right: none;
}

.has-success.form-group .form-control, .has-success.form-group.no-border .form-control,
.has-danger.form-group .form-control,
.has-danger.form-group.no-border .form-control {
  padding-right: 40px;
}

.form.form-newsletter .form-group {
  float: left;
  width: 78%;
  margin-right: 2%;
  margin-top: 9px;
}

.input-group .input-group-btn {
  padding: 0 12px;
}

.form-group input[type=file] {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.form-check {
  margin-top: 0.65rem;
  padding-left: 0;
}

.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  line-height: 26px;
  margin-bottom: 0;
  transition: color 0.3s linear;
}

.radio .form-check-sign {
  padding-left: 28px;
}

.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 26px;
  height: 26px;
  left: 0;
  cursor: pointer;
  border-radius: 3px;
  top: 0;
  background-color: transparent;
  border: 1px solid #E3E3E3;
  transition: opacity 0.3s linear;
}

.form-check .form-check-sign::after {
  font-family: "Nucleo Outline";
  content: "\\ea22";
  top: 0px;
  text-align: center;
  font-size: 14px;
  opacity: 0;
  color: #555555;
  border: 0;
  background-color: inherit;
}

.form-check.disabled .form-check-label,
.form-check.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check input[type=checkbox]:disabled + .form-check-sign,
.form-check input[type=radio]:disabled + .form-check-sign {
  pointer-events: none;
}

.form-check-radio .form-check-sign::before,
.form-check-radio .form-check-sign::after {
  content: " ";
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #E3E3E3;
  display: inline-block;
  position: absolute;
  left: 3px;
  top: 3px;
  padding: 1px;
  transition: opacity 0.3s linear;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  width: 4px;
  height: 4px;
  background-color: #555555;
  border-color: #555555;
  top: 11px;
  left: 11px;
  opacity: 1;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign {
  color: #9A9A9A;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9A9A9A;
}

.progress-container {
  position: relative;
}
.progress-container + .progress-container, .progress-container ~ .progress-container {
  margin-top: 15px;
}
.progress-container .progress-badge {
  color: #888888;
  font-size: 0.8571em;
  text-transform: uppercase;
}
.progress-container .progress {
  height: 1px;
  border-radius: 0;
  box-shadow: none;
  background: rgba(222, 222, 222, 0.8);
  margin-top: 14px;
}
.progress-container .progress .progress-bar {
  box-shadow: none;
  background-color: #888888;
}
.progress-container .progress .progress-value {
  position: absolute;
  top: 2px;
  right: 0;
  color: #888888;
  font-size: 0.8571em;
}
.progress-container.progress-neutral .progress {
  background: rgba(255, 255, 255, 0.3);
}
.progress-container.progress-neutral .progress-bar {
  background: #FFFFFF;
}
.progress-container.progress-neutral .progress-value,
.progress-container.progress-neutral .progress-badge {
  color: #FFFFFF;
}
.progress-container.progress-primary .progress {
  background: rgba(249, 99, 50, 0.3);
}
.progress-container.progress-primary .progress-bar {
  background: #f96332;
}
.progress-container.progress-primary .progress-value,
.progress-container.progress-primary .progress-badge {
  color: #f96332;
}
.progress-container.progress-info .progress {
  background: rgba(44, 168, 255, 0.3);
}
.progress-container.progress-info .progress-bar {
  background: #2CA8FF;
}
.progress-container.progress-info .progress-value,
.progress-container.progress-info .progress-badge {
  color: #2CA8FF;
}
.progress-container.progress-success .progress {
  background: rgba(24, 206, 15, 0.3);
}
.progress-container.progress-success .progress-bar {
  background: #18ce0f;
}
.progress-container.progress-success .progress-value,
.progress-container.progress-success .progress-badge {
  color: #18ce0f;
}
.progress-container.progress-warning .progress {
  background: rgba(255, 178, 54, 0.3);
}
.progress-container.progress-warning .progress-bar {
  background: #FFB236;
}
.progress-container.progress-warning .progress-value,
.progress-container.progress-warning .progress-badge {
  color: #FFB236;
}
.progress-container.progress-danger .progress {
  background: rgba(255, 54, 54, 0.3);
}
.progress-container.progress-danger .progress-bar {
  background: #FF3636;
}
.progress-container.progress-danger .progress-value,
.progress-container.progress-danger .progress-badge {
  color: #FF3636;
}

/*           badges             */
.badge {
  border-radius: 8px;
  padding: 4px 8px;
  text-transform: uppercase;
  font-size: 0.7142em;
  line-height: 12px;
  background-color: transparent;
  border: 1px solid;
  margin-bottom: 5px;
  color: #FFFFFF;
  border-radius: 0.875rem;
}
.badge:hover, .badge:focus {
  text-decoration: none;
}

.badge-icon {
  padding: 0.4em 0.55em;
}
.badge-icon i {
  font-size: 0.8em;
}

.badge-default, .badge-default[href]:focus, .badge-default[href]:hover {
  border-color: #888888;
  background-color: #888888;
  color: #FFFFFF;
}

.badge-primary, .badge-primary[href]:focus, .badge-primary[href]:hover {
  border-color: #f96332;
  background-color: #f96332;
  color: #FFFFFF;
}

.badge-info, .badge-info[href]:focus, .badge-info[href]:hover {
  border-color: #2CA8FF;
  background-color: #2CA8FF;
  color: #FFFFFF;
}

.badge-success, .badge-success[href]:focus, .badge-success[href]:hover {
  border-color: #18ce0f;
  background-color: #18ce0f;
  color: #FFFFFF;
}

.badge-warning, .badge-warning[href]:focus, .badge-warning[href]:hover {
  border-color: #FFB236;
  background-color: #FFB236;
  color: #FFFFFF;
}

.badge-danger, .badge-danger[href]:focus, .badge-danger[href]:hover {
  border-color: #FF3636;
  background-color: #FF3636;
  color: #FFFFFF;
}

.badge-neutral {
  color: inherit !important;
}
.badge-neutral, .badge-neutral[href]:focus, .badge-neutral[href]:hover {
  border-color: #FFFFFF;
  background-color: #FFFFFF;
  color: #FFFFFF;
}

.pagination .page-item .page-link {
  border: 0;
  border-radius: 30px !important;
  transition: all 0.3s;
  padding: 0px 11px;
  margin: 0 3px;
  min-width: 30px;
  text-align: center;
  box-shadow: none;
  height: 30px;
  line-height: 30px;
  color: #2c2c2c;
  cursor: pointer;
  font-size: 14px;
  text-transform: uppercase;
  background: transparent;
}
.pagination .page-item .page-link:hover, .pagination .page-item .page-link:focus {
  color: #2c2c2c;
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
}
.pagination .arrow-margin-left,
.pagination .arrow-margin-right {
  position: absolute;
}
.pagination .arrow-margin-right {
  right: 0;
}
.pagination .arrow-margin-left {
  left: 0;
}
.pagination .page-item.active > .page-link {
  color: #E3E3E3;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}
.pagination .page-item.active > .page-link, .pagination .page-item.active > .page-link:focus, .pagination .page-item.active > .page-link:hover {
  background-color: #888888;
  border-color: #888888;
  color: #FFFFFF;
}
.pagination .page-item.disabled > .page-link {
  opacity: 0.5;
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.pagination.pagination-info .page-item.active > .page-link, .pagination.pagination-info .page-item.active > .page-link:focus, .pagination.pagination-info .page-item.active > .page-link:hover {
  background-color: #2CA8FF;
  border-color: #2CA8FF;
}
.pagination.pagination-success .page-item.active > .page-link, .pagination.pagination-success .page-item.active > .page-link:focus, .pagination.pagination-success .page-item.active > .page-link:hover {
  background-color: #18ce0f;
  border-color: #18ce0f;
}
.pagination.pagination-primary .page-item.active > .page-link, .pagination.pagination-primary .page-item.active > .page-link:focus, .pagination.pagination-primary .page-item.active > .page-link:hover {
  background-color: #f96332;
  border-color: #f96332;
}
.pagination.pagination-warning .page-item.active > .page-link, .pagination.pagination-warning .page-item.active > .page-link:focus, .pagination.pagination-warning .page-item.active > .page-link:hover {
  background-color: #FFB236;
  border-color: #FFB236;
}
.pagination.pagination-danger .page-item.active > .page-link, .pagination.pagination-danger .page-item.active > .page-link:focus, .pagination.pagination-danger .page-item.active > .page-link:hover {
  background-color: #FF3636;
  border-color: #FF3636;
}
.pagination.pagination-neutral .page-item > .page-link {
  color: #FFFFFF;
}
.pagination.pagination-neutral .page-item > .page-link:focus, .pagination.pagination-neutral .page-item > .page-link:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.pagination.pagination-neutral .page-item.active > .page-link, .pagination.pagination-neutral .page-item.active > .page-link:focus, .pagination.pagination-neutral .page-item.active > .page-link:hover {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
  color: #f96332;
}

.pagination-container {
  display: flex;
  align-items: center;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 400;
}

small {
  font-size: 60%;
}

a {
  color: #f96332;
}
a:hover, a:focus {
  color: #f96332;
}

h1, .h1 {
  font-size: 3.5em;
  line-height: 1.15;
  margin-bottom: 30px;
}
h1 small, .h1 small {
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.8;
}

h2, .h2 {
  font-size: 2.5em;
  margin-bottom: 30px;
}

h3, .h3 {
  font-size: 1.825em;
  margin-bottom: 30px;
  line-height: 1.4em;
}

h4, .h4 {
  font-size: 1.5em;
  line-height: 1.45em;
  margin-top: 30px;
  margin-bottom: 15px;
}
h4 + .category, h4.title + .category, .h4 + .category, .h4.title + .category {
  margin-top: -5px;
}

h5, .h5 {
  font-size: 1.3em;
  line-height: 1.4em;
  margin-bottom: 15px;
}
h5.category, .h5.category {
  font-weight: 400;
}

h6, .h6 {
  font-size: 0.9em;
  font-weight: 700;
  text-transform: uppercase;
}

p {
  line-height: 1.61em;
  font-weight: 300;
  font-size: 1.2em;
}

.title {
  font-weight: 700;
  padding-top: 30px;
}
.title.title-up {
  text-transform: uppercase;
}
.title.title-up a {
  color: #2c2c2c;
  text-decoration: none;
}
.title + .category {
  margin-top: -25px;
}

.description,
.card-description,
.footer-big p {
  color: #9A9A9A;
  font-weight: 300;
}

.category {
  text-transform: capitalize;
  font-weight: 700;
  color: #9A9A9A;
}

.text-primary {
  color: #f96332 !important;
}

.text-info {
  color: #2CA8FF !important;
}

.text-success {
  color: #18ce0f !important;
}

.text-warning {
  color: #FFB236 !important;
}

.text-danger {
  color: #FF3636 !important;
}

.text-black {
  color: #444;
}

.blockquote {
  border-left: none;
  border: 1px solid #888888;
  padding: 20px;
  font-size: 1.1em;
  line-height: 1.8;
}
.blockquote small {
  color: #888888;
  font-size: 0.8571em;
  text-transform: uppercase;
}
.blockquote.blockquote-primary {
  border-color: #f96332;
  color: #f96332;
}
.blockquote.blockquote-primary small {
  color: #f96332;
}
.blockquote.blockquote-danger {
  border-color: #FF3636;
  color: #FF3636;
}
.blockquote.blockquote-danger small {
  color: #FF3636;
}
.blockquote.blockquote-white {
  border-color: rgba(255, 255, 255, 0.8);
  color: #FFFFFF;
}
.blockquote.blockquote-white small {
  color: rgba(255, 255, 255, 0.8);
}

body {
  color: #2c2c2c;
  font-size: 14px;
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
  overflow-x: hidden;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.main {
  position: relative;
  background: #FFFFFF;
}

/* Animations */
.nav-pills .nav-link,
.nav-item .nav-link,
.navbar,
.nav-tabs .nav-link,
.tag,
.tag [data-role=remove] {
  transition: all 300ms ease 0s;
}

.card a,
.bootstrap-switch-label:before {
  transition: all 150ms ease 0s;
}

.dropdown-toggle:after,
[data-toggle=collapse][data-parent="#accordion"] i {
  transition: transform 150ms ease 0s;
}

.dropdown-toggle[aria-expanded=true]:after,
[data-toggle=collapse][data-parent="#accordion"][aria-expanded=true] i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.button-bar {
  display: block;
  position: relative;
  width: 22px;
  height: 1px;
  border-radius: 1px;
  background: #FFFFFF;
}
.button-bar + .button-bar {
  margin-top: 7px;
}
.button-bar:nth-child(2) {
  width: 17px;
}

.separator-line {
  height: 2px;
  width: 44px;
  background-color: #888888;
  margin: 20px auto;
}
.separator-line.separator-primary {
  background-color: #f96332;
}

.section-space {
  height: 62px;
  display: block;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.title-up {
  text-transform: uppercase;
}

.nav-pills.nav-pills-just-icons .nav-item .nav-link {
  text-align: center;
  border-radius: 50%;
  height: 80px;
  width: 80px;
  padding: 0;
  max-width: 80px;
  min-width: auto;
  margin-bottom: 4px;
}
.nav-pills.nav-pills-just-icons .nav-item .nav-link i {
  line-height: 80px;
}
.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
  margin-right: 19px;
}
.nav-pills .nav-item .nav-link {
  padding: 10px 23px;
  background-color: rgba(222, 222, 222, 0.3);
  min-width: 100px;
  font-weight: 400;
  text-align: center;
  color: #444;
}
.nav-pills .nav-item .nav-link:hover {
  background-color: rgba(222, 222, 222, 0.3);
}
.nav-pills .nav-item .nav-link.active, .nav-pills .nav-item .nav-link.active:focus, .nav-pills .nav-item .nav-link.active:hover {
  background-color: #9A9A9A;
  color: #FFFFFF;
  box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);
}
.nav-pills .nav-item .nav-link.disabled, .nav-pills .nav-item .nav-link:disabled, .nav-pills .nav-item .nav-link[disabled] {
  opacity: 0.5;
}
.nav-pills .nav-item i {
  display: block;
  line-height: 60px;
  font-size: 24px;
}
.nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.nav-pills.nav-pills-neutral .nav-item .nav-link.active, .nav-pills.nav-pills-neutral .nav-item .nav-link.active:focus, .nav-pills.nav-pills-neutral .nav-item .nav-link.active:hover {
  background-color: #FFFFFF;
  color: #f96332;
}
.nav-pills.nav-pills-primary .nav-item .nav-link.active, .nav-pills.nav-pills-primary .nav-item .nav-link.active:focus, .nav-pills.nav-pills-primary .nav-item .nav-link.active:hover {
  background-color: #f96332;
}
.nav-pills.nav-pills-info .nav-item .nav-link.active, .nav-pills.nav-pills-info .nav-item .nav-link.active:focus, .nav-pills.nav-pills-info .nav-item .nav-link.active:hover {
  background-color: #2CA8FF;
}
.nav-pills.nav-pills-success .nav-item .nav-link.active, .nav-pills.nav-pills-success .nav-item .nav-link.active:focus, .nav-pills.nav-pills-success .nav-item .nav-link.active:hover {
  background-color: #18ce0f;
}
.nav-pills.nav-pills-warning .nav-item .nav-link.active, .nav-pills.nav-pills-warning .nav-item .nav-link.active:focus, .nav-pills.nav-pills-warning .nav-item .nav-link.active:hover {
  background-color: #FFB236;
}
.nav-pills.nav-pills-danger .nav-item .nav-link.active, .nav-pills.nav-pills-danger .nav-item .nav-link.active:focus, .nav-pills.nav-pills-danger .nav-item .nav-link.active:hover {
  background-color: #FF3636;
}

.tab-space {
  padding: 20px 0 50px 0px;
}

.nav-align-center {
  text-align: center;
}
.nav-align-center .nav-pills {
  display: inline-flex;
}

/* --------------------------------

Nucleo Outline Web Font - nucleoapp.com/
License - nucleoapp.com/license/
Created using IcoMoon - icomoon.io

-------------------------------- */
@font-face {
  font-family: "Nucleo Outline";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.now-ui-icons {
  display: inline-block;
  font: normal normal normal 14px/1 "Nucleo Outline";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
/*----------------------------------
  add a square/circle background
-----------------------------------*/
.now-ui-icons.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.now-ui-icons.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .now-ui-icons {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .now-ui-icons.circle {
  top: -0.19047619em;
  left: -1.9047619em;
}

/*------------------------
  spinning icons
-------------------------*/
.now-ui-icons.spin {
  animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
/*------------------------
	font icons
-------------------------*/
.now-ui-icons.ui-1_check:before {
  content: "\\ea22";
}

.now-ui-icons.ui-1_email-85:before {
  content: "\\ea2a";
}

.now-ui-icons.arrows-1_cloud-download-93:before {
  content: "\\ea21";
}

.now-ui-icons.arrows-1_cloud-upload-94:before {
  content: "\\ea24";
}

.now-ui-icons.arrows-1_minimal-down:before {
  content: "\\ea39";
}

.now-ui-icons.arrows-1_minimal-left:before {
  content: "\\ea3a";
}

.now-ui-icons.arrows-1_minimal-right:before {
  content: "\\ea3b";
}

.now-ui-icons.arrows-1_minimal-up:before {
  content: "\\ea3c";
}

.now-ui-icons.arrows-1_refresh-69:before {
  content: "\\ea44";
}

.now-ui-icons.arrows-1_share-66:before {
  content: "\\ea4c";
}

.now-ui-icons.business_badge:before {
  content: "\\ea09";
}

.now-ui-icons.business_bank:before {
  content: "\\ea0a";
}

.now-ui-icons.business_briefcase-24:before {
  content: "\\ea13";
}

.now-ui-icons.business_bulb-63:before {
  content: "\\ea15";
}

.now-ui-icons.business_chart-bar-32:before {
  content: "\\ea1e";
}

.now-ui-icons.business_chart-pie-36:before {
  content: "\\ea1f";
}

.now-ui-icons.business_globe:before {
  content: "\\ea2f";
}

.now-ui-icons.business_money-coins:before {
  content: "\\ea40";
}

.now-ui-icons.clothes_tie-bow:before {
  content: "\\ea5b";
}

.now-ui-icons.design_vector:before {
  content: "\\ea61";
}

.now-ui-icons.design_app:before {
  content: "\\ea08";
}

.now-ui-icons.design_bullet-list-67:before {
  content: "\\ea14";
}

.now-ui-icons.design_image:before {
  content: "\\ea33";
}

.now-ui-icons.design_palette:before {
  content: "\\ea41";
}

.now-ui-icons.design_scissors:before {
  content: "\\ea4a";
}

.now-ui-icons.design-2_html5:before {
  content: "\\ea32";
}

.now-ui-icons.design-2_ruler-pencil:before {
  content: "\\ea48";
}

.now-ui-icons.emoticons_satisfied:before {
  content: "\\ea49";
}

.now-ui-icons.files_box:before {
  content: "\\ea12";
}

.now-ui-icons.files_paper:before {
  content: "\\ea43";
}

.now-ui-icons.files_single-copy-04:before {
  content: "\\ea52";
}

.now-ui-icons.health_ambulance:before {
  content: "\\ea07";
}

.now-ui-icons.loader_gear:before {
  content: "\\ea4e";
}

.now-ui-icons.loader_refresh:before {
  content: "\\ea44";
}

.now-ui-icons.location_bookmark:before {
  content: "\\ea10";
}

.now-ui-icons.location_compass-05:before {
  content: "\\ea25";
}

.now-ui-icons.location_map-big:before {
  content: "\\ea3d";
}

.now-ui-icons.location_pin:before {
  content: "\\ea47";
}

.now-ui-icons.location_world:before {
  content: "\\ea63";
}

.now-ui-icons.media-1_album:before {
  content: "\\ea02";
}

.now-ui-icons.media-1_button-pause:before {
  content: "\\ea16";
}

.now-ui-icons.media-1_button-play:before {
  content: "\\ea18";
}

.now-ui-icons.media-1_button-power:before {
  content: "\\ea19";
}

.now-ui-icons.media-1_camera-compact:before {
  content: "\\ea1c";
}

.now-ui-icons.media-2_note-03:before {
  content: "\\ea3f";
}

.now-ui-icons.media-2_sound-wave:before {
  content: "\\ea57";
}

.now-ui-icons.objects_diamond:before {
  content: "\\ea29";
}

.now-ui-icons.objects_globe:before {
  content: "\\ea2f";
}

.now-ui-icons.objects_key-25:before {
  content: "\\ea38";
}

.now-ui-icons.objects_planet:before {
  content: "\\ea46";
}

.now-ui-icons.objects_spaceship:before {
  content: "\\ea55";
}

.now-ui-icons.objects_support-17:before {
  content: "\\ea56";
}

.now-ui-icons.objects_umbrella-13:before {
  content: "\\ea5f";
}

.now-ui-icons.education_agenda-bookmark:before {
  content: "\\ea01";
}

.now-ui-icons.education_atom:before {
  content: "\\ea0c";
}

.now-ui-icons.education_glasses:before {
  content: "\\ea2d";
}

.now-ui-icons.education_hat:before {
  content: "\\ea30";
}

.now-ui-icons.education_paper:before {
  content: "\\ea42";
}

.now-ui-icons.shopping_bag-16:before {
  content: "\\ea0d";
}

.now-ui-icons.shopping_basket:before {
  content: "\\ea0b";
}

.now-ui-icons.shopping_box:before {
  content: "\\ea11";
}

.now-ui-icons.shopping_cart-simple:before {
  content: "\\ea1d";
}

.now-ui-icons.shopping_credit-card:before {
  content: "\\ea28";
}

.now-ui-icons.shopping_delivery-fast:before {
  content: "\\ea27";
}

.now-ui-icons.shopping_shop:before {
  content: "\\ea50";
}

.now-ui-icons.shopping_tag-content:before {
  content: "\\ea59";
}

.now-ui-icons.sport_trophy:before {
  content: "\\ea5d";
}

.now-ui-icons.sport_user-run:before {
  content: "\\ea60";
}

.now-ui-icons.tech_controller-modern:before {
  content: "\\ea26";
}

.now-ui-icons.tech_headphones:before {
  content: "\\ea31";
}

.now-ui-icons.tech_laptop:before {
  content: "\\ea36";
}

.now-ui-icons.tech_mobile:before {
  content: "\\ea3e";
}

.now-ui-icons.tech_tablet:before {
  content: "\\ea58";
}

.now-ui-icons.tech_tv:before {
  content: "\\ea5e";
}

.now-ui-icons.tech_watch-time:before {
  content: "\\ea62";
}

.now-ui-icons.text_align-center:before {
  content: "\\ea05";
}

.now-ui-icons.text_align-left:before {
  content: "\\ea06";
}

.now-ui-icons.text_bold:before {
  content: "\\ea0e";
}

.now-ui-icons.text_caps-small:before {
  content: "\\ea1b";
}

.now-ui-icons.gestures_tap-01:before {
  content: "\\ea5a";
}

.now-ui-icons.transportation_air-baloon:before {
  content: "\\ea03";
}

.now-ui-icons.transportation_bus-front-12:before {
  content: "\\ea17";
}

.now-ui-icons.travel_info:before {
  content: "\\ea04";
}

.now-ui-icons.travel_istanbul:before {
  content: "\\ea34";
}

.now-ui-icons.ui-1_bell-53:before {
  content: "\\ea0f";
}

.now-ui-icons.ui-1_calendar-60:before {
  content: "\\ea1a";
}

.now-ui-icons.ui-1_lock-circle-open:before {
  content: "\\ea35";
}

.now-ui-icons.ui-1_send:before {
  content: "\\ea4d";
}

.now-ui-icons.ui-1_settings-gear-63:before {
  content: "\\ea4e";
}

.now-ui-icons.ui-1_simple-add:before {
  content: "\\ea4f";
}

.now-ui-icons.ui-1_simple-delete:before {
  content: "\\ea54";
}

.now-ui-icons.ui-1_simple-remove:before {
  content: "\\ea53";
}

.now-ui-icons.ui-1_zoom-bold:before {
  content: "\\ea64";
}

.now-ui-icons.ui-2_chat-round:before {
  content: "\\ea20";
}

.now-ui-icons.ui-2_favourite-28:before {
  content: "\\ea2b";
}

.now-ui-icons.ui-2_like:before {
  content: "\\ea37";
}

.now-ui-icons.ui-2_settings-90:before {
  content: "\\ea4b";
}

.now-ui-icons.ui-2_time-alarm:before {
  content: "\\ea5c";
}

.now-ui-icons.users_circle-08:before {
  content: "\\ea23";
}

.now-ui-icons.users_single-02:before {
  content: "\\ea51";
}

.all-icons .font-icon-detail {
  text-align: center;
  padding: 45px 0px 30px;
  border: 1px solid #e5e5e5;
  border-radius: 0.1875rem;
  margin: 15px 0;
  min-height: 168px;
}

.all-icons [class*=now-ui-icons] {
  font-size: 32px;
}

.all-icons .font-icon-detail p {
  margin: 25px auto 0;
  width: 100%;
  text-align: center;
  display: block;
  color: #B8B8B8;
  padding: 0 10px;
  font-size: 0.7142em;
}

.nav-tabs {
  border: 0;
  padding: 15px 0.7rem;
}
.nav-tabs:not(.nav-tabs-neutral) > .nav-item > .nav-link.active {
  box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);
}
.card .nav-tabs {
  border-top-right-radius: 0.1875rem;
  border-top-left-radius: 0.1875rem;
}
.nav-tabs > .nav-item > .nav-link {
  color: #888888;
  margin: 0;
  margin-right: 5px;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 30px;
  font-size: 14px;
  padding: 11px 23px;
  line-height: 1.5;
}
.nav-tabs > .nav-item > .nav-link:hover {
  background-color: transparent;
}
.nav-tabs > .nav-item > .nav-link.active {
  background-color: #444;
  border-radius: 30px;
  color: #FFFFFF;
}
.nav-tabs > .nav-item > .nav-link i.now-ui-icons {
  font-size: 14px;
  position: relative;
  top: 1px;
  margin-right: 3px;
}
.nav-tabs > .nav-item.disabled > .nav-link, .nav-tabs > .nav-item.disabled > .nav-link:hover {
  color: rgba(255, 255, 255, 0.5);
}
.nav-tabs.nav-tabs-neutral > .nav-item > .nav-link {
  color: #FFFFFF;
}
.nav-tabs.nav-tabs-neutral > .nav-item > .nav-link.active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.nav-tabs.nav-tabs-primary > .nav-item > .nav-link.active {
  background-color: #f96332;
}
.nav-tabs.nav-tabs-info > .nav-item > .nav-link.active {
  background-color: #2CA8FF;
}
.nav-tabs.nav-tabs-danger > .nav-item > .nav-link.active {
  background-color: #FF3636;
}
.nav-tabs.nav-tabs-warning > .nav-item > .nav-link.active {
  background-color: #FFB236;
}
.nav-tabs.nav-tabs-success > .nav-item > .nav-link.active {
  background-color: #18ce0f;
}

.navbar {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  min-height: 53px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
}
.navbar a {
  vertical-align: middle;
}
.navbar a:not(.btn):not(.dropdown-item) {
  color: #FFFFFF;
}
.navbar p {
  display: inline-block;
  margin: 0;
  line-height: 21px;
  font-weight: inherit;
  font-size: inherit;
}
.navbar .navbar-nav.navbar-logo {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 49px;
  top: -4px;
}
.navbar .navbar-nav .nav-link.btn {
  padding: 11px 22px;
}
.navbar .navbar-nav .nav-link.btn.btn-lg {
  padding: 15px 48px;
}
.navbar .navbar-nav .nav-link.btn.btn-sm {
  padding: 5px 15px;
}
.navbar .navbar-nav .nav-link:not(.btn) {
  text-transform: uppercase;
  font-size: 0.7142em;
  padding: 0.5rem 0.7rem;
  line-height: 1.625rem;
}
.navbar .navbar-nav .nav-link:not(.btn) i.fab + p,
.navbar .navbar-nav .nav-link:not(.btn) i.now-ui-icons + p {
  margin-left: 3px;
}
.navbar .navbar-nav .nav-link:not(.btn) i.fab,
.navbar .navbar-nav .nav-link:not(.btn) i.now-ui-icons {
  font-size: 18px;
  position: relative;
  top: 3px;
  text-align: center;
  width: 21px;
}
.navbar .navbar-nav .nav-link:not(.btn) i.now-ui-icons {
  top: 4px;
  font-size: 16px;
}
.navbar .navbar-nav .nav-link:not(.btn).profile-photo .profile-photo-small {
  width: 27px;
  height: 27px;
}
.navbar .navbar-nav .nav-link:not(.btn).disabled {
  opacity: 0.5;
  color: #FFFFFF;
}
.navbar .navbar-nav .nav-item.active .nav-link:not(.btn),
.navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):active {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 0.1875rem;
}
.navbar .logo-container {
  width: 27px;
  height: 27px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 50%;
  border: 1px solid transparent;
}
.navbar .navbar-brand {
  text-transform: uppercase;
  font-size: 0.8571em;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  line-height: 1.625rem;
}
.navbar .navbar-toggler {
  width: 37px;
  height: 27px;
  outline: 0;
  cursor: pointer;
}
.navbar .navbar-toggler.navbar-toggler-left {
  position: relative;
  left: 0;
  padding-left: 0;
}
.navbar .navbar-toggler .navbar-toggler-bar.middle-bar {
  width: 17px;
  transition: width 0.2s linear;
}
.navbar .navbar-toggler:hover .navbar-toggler-bar.middle-bar {
  width: 22px;
}
.navbar .button-dropdown .navbar-toggler-bar:nth-child(2) {
  width: 17px;
}
.navbar.navbar-transparent {
  background-color: transparent !important;
  box-shadow: none;
  color: #FFFFFF;
  padding-top: 20px !important;
}
.navbar.bg-white:not(.navbar-transparent) a:not(.dropdown-item):not(.btn) {
  color: #888888;
}
.navbar.bg-white:not(.navbar-transparent) a:not(.dropdown-item):not(.btn).disabled {
  opacity: 0.5;
  color: #888888;
}
.navbar.bg-white:not(.navbar-transparent) .button-bar {
  background: #888888;
}
.navbar.bg-white:not(.navbar-transparent) .nav-item.active .nav-link:not(.btn),
.navbar.bg-white:not(.navbar-transparent) .nav-item .nav-link:not(.btn):focus,
.navbar.bg-white:not(.navbar-transparent) .nav-item .nav-link:not(.btn):hover,
.navbar.bg-white:not(.navbar-transparent) .nav-item .nav-link:not(.btn):active {
  background-color: rgba(222, 222, 222, 0.3);
}
.navbar.bg-white:not(.navbar-transparent) .logo-container {
  border: 1px solid #888888;
}

.bg-default {
  background-color: #888888 !important;
}

.bg-primary {
  background-color: #f96332 !important;
}

.bg-info {
  background-color: #2CA8FF !important;
}

.bg-success {
  background-color: #18ce0f !important;
}

.bg-danger {
  background-color: #FF3636 !important;
}

.bg-warning {
  background-color: #FFB236 !important;
}

.bg-white {
  background-color: #FFFFFF !important;
}

.dropdown-menu {
  border: 0;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0.125rem;
  transition: all 150ms linear;
  font-size: 14px;
}
.dropdown-menu.dropdown-menu-right:before {
  left: auto;
  right: 10px;
}
.dropdown .dropdown-menu {
  transform: translate3d(0, -25px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 100% !important;
}
.dropdown.show .dropdown-menu, .dropdown-menu.open {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
  transform: translate3d(0, 0px, 0) !important;
}
.dropdown-menu .dropdown-item, .bootstrap-select .dropdown-menu.inner li a {
  font-size: 0.8571em;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
  outline: none;
}
.dropdown-menu .dropdown-item:hover, .dropdown-menu .dropdown-item:focus, .bootstrap-select .dropdown-menu.inner li a:hover, .bootstrap-select .dropdown-menu.inner li a:focus {
  background-color: rgba(222, 222, 222, 0.3);
}
.dropdown-menu .dropdown-item.disabled, .dropdown-menu .dropdown-item:disabled, .bootstrap-select .dropdown-menu.inner li a.disabled, .bootstrap-select .dropdown-menu.inner li a:disabled {
  color: rgba(182, 182, 182, 0.6);
}
.dropdown-menu .dropdown-item.disabled:hover, .dropdown-menu .dropdown-item.disabled:focus, .dropdown-menu .dropdown-item:disabled:hover, .dropdown-menu .dropdown-item:disabled:focus, .bootstrap-select .dropdown-menu.inner li a.disabled:hover, .bootstrap-select .dropdown-menu.inner li a.disabled:focus, .bootstrap-select .dropdown-menu.inner li a:disabled:hover, .bootstrap-select .dropdown-menu.inner li a:disabled:focus {
  background-color: transparent;
}
.dropdown-menu:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #FFFFFF;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropdown-menu .dropdown-divider {
  background-color: rgba(222, 222, 222, 0.5);
}
.dropdown-menu .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(182, 182, 182, 0.6);
  font-size: 0.7142em;
  text-transform: uppercase;
  font-weight: 700;
}
.dropdown-menu.dropdown-primary {
  background-color: #f95823;
}
.dropdown-menu.dropdown-primary:before {
  color: #f95823;
}
.dropdown-menu.dropdown-primary .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-primary .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover, .dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-primary .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info {
  background-color: #1da2ff;
}
.dropdown-menu.dropdown-info:before {
  color: #1da2ff;
}
.dropdown-menu.dropdown-info .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-info .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-info .dropdown-item:hover, .dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger {
  background-color: #ff2727;
}
.dropdown-menu.dropdown-danger:before {
  color: #ff2727;
}
.dropdown-menu.dropdown-danger .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-danger .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover, .dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success {
  background-color: #16c00e;
}
.dropdown-menu.dropdown-success:before {
  color: #16c00e;
}
.dropdown-menu.dropdown-success .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-success .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-success .dropdown-item:hover, .dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning {
  background-color: #ffac27;
}
.dropdown-menu.dropdown-warning:before {
  color: #ffac27;
}
.dropdown-menu.dropdown-warning .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-warning .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover, .dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}

.button-dropdown {
  padding-right: 0.7rem;
  cursor: pointer;
}
.button-dropdown .dropdown-toggle {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: block;
}
.button-dropdown .dropdown-toggle:after {
  display: none;
}

.alert {
  border: 0;
  border-radius: 0;
  color: #FFFFFF;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
}
.alert .alert-link {
  color: #FFFFFF;
  opacity: 0.8;
}
.alert.alert-success {
  background-color: rgba(24, 206, 15, 0.8);
}
.alert.alert-danger {
  background-color: rgba(255, 54, 54, 0.8);
}
.alert.alert-warning {
  background-color: rgba(255, 178, 54, 0.8);
}
.alert.alert-info {
  background-color: rgba(44, 168, 255, 0.8);
}
.alert.alert-primary {
  background-color: rgba(249, 99, 50, 0.8);
}
.alert .alert-icon {
  display: block;
  float: left;
  margin-right: 15px;
  margin-top: -1px;
}
.alert strong {
  text-transform: uppercase;
  font-size: 12px;
}
.alert i.fa,
.alert i.now-ui-icons {
  font-size: 20px;
}
.alert .close {
  color: #FFFFFF;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
  display: inline-block;
  cursor: pointer;
}

img {
  max-width: 100%;
  border-radius: 1px;
}

.img-raised {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.popover {
  font-size: 14px;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border: none;
  line-height: 1.7;
  max-width: 240px;
}
.popover.bs-popover-top .arrow:before, .popover.bs-popover-left .arrow:before, .popover.bs-popover-right .arrow:before, .popover.bs-popover-bottom .arrow:before {
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.popover .popover-header {
  color: rgba(182, 182, 182, 0.6);
  font-size: 14px;
  text-transform: capitalize;
  font-weight: 600;
  margin: 0;
  margin-top: 5px;
  border: none;
  background-color: transparent;
}
.popover:before {
  display: none;
}
.popover.bs-tether-element-attached-top:after {
  border-bottom-color: #FFFFFF;
  top: -9px;
}
.popover.popover-primary {
  background-color: #f96332;
}
.popover.popover-primary .popover-body {
  color: #FFFFFF;
}
.popover.popover-primary.bs-popover-right .arrow:after {
  border-right-color: #f96332;
}
.popover.popover-primary.bs-popover-top .arrow:after {
  border-top-color: #f96332;
}
.popover.popover-primary.bs-popover-bottom .arrow:after {
  border-bottom-color: #f96332;
}
.popover.popover-primary.bs-popover-left .arrow:after {
  border-left-color: #f96332;
}
.popover.popover-primary .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-info {
  background-color: #2CA8FF;
}
.popover.popover-info .popover-body {
  color: #FFFFFF;
}
.popover.popover-info.bs-popover-right .arrow:after {
  border-right-color: #2CA8FF;
}
.popover.popover-info.bs-popover-top .arrow:after {
  border-top-color: #2CA8FF;
}
.popover.popover-info.bs-popover-bottom .arrow:after {
  border-bottom-color: #2CA8FF;
}
.popover.popover-info.bs-popover-left .arrow:after {
  border-left-color: #2CA8FF;
}
.popover.popover-info .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-warning {
  background-color: #FFB236;
}
.popover.popover-warning .popover-body {
  color: #FFFFFF;
}
.popover.popover-warning.bs-popover-right .arrow:after {
  border-right-color: #FFB236;
}
.popover.popover-warning.bs-popover-top .arrow:after {
  border-top-color: #FFB236;
}
.popover.popover-warning.bs-popover-bottom .arrow:after {
  border-bottom-color: #FFB236;
}
.popover.popover-warning.bs-popover-left .arrow:after {
  border-left-color: #FFB236;
}
.popover.popover-warning .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-danger {
  background-color: #FF3636;
}
.popover.popover-danger .popover-body {
  color: #FFFFFF;
}
.popover.popover-danger.bs-popover-right .arrow:after {
  border-right-color: #FF3636;
}
.popover.popover-danger.bs-popover-top .arrow:after {
  border-top-color: #FF3636;
}
.popover.popover-danger.bs-popover-bottom .arrow:after {
  border-bottom-color: #FF3636;
}
.popover.popover-danger.bs-popover-left .arrow:after {
  border-left-color: #FF3636;
}
.popover.popover-danger .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-success {
  background-color: #18ce0f;
}
.popover.popover-success .popover-body {
  color: #FFFFFF;
}
.popover.popover-success.bs-popover-right .arrow:after {
  border-right-color: #18ce0f;
}
.popover.popover-success.bs-popover-top .arrow:after {
  border-top-color: #18ce0f;
}
.popover.popover-success.bs-popover-bottom .arrow:after {
  border-bottom-color: #18ce0f;
}
.popover.popover-success.bs-popover-left .arrow:after {
  border-left-color: #18ce0f;
}
.popover.popover-success .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}

.tooltip.bs-tooltip-right .arrow:before {
  border-right-color: #FFFFFF;
}
.tooltip.bs-tooltip-top .arrow:before {
  border-top-color: #FFFFFF;
}
.tooltip.bs-tooltip-bottom .arrow:before {
  border-bottom-color: #FFFFFF;
}
.tooltip.bs-tooltip-left .arrow:before {
  border-left-color: #FFFFFF;
}

.tooltip-inner {
  padding: 0.5rem 0.7rem;
  min-width: 130px;
  background-color: #FFFFFF;
  font-size: 14px;
  color: inherit;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}

.modal-content {
  border-radius: 0.1875rem;
  border: none;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.5);
}
.modal-content .modal-header {
  border-bottom: none;
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 0;
  padding-left: 24px;
}
.modal-content .modal-header button {
  position: absolute;
  right: 27px;
  top: 30px;
  outline: 0;
}
.modal-content .modal-header .title {
  margin-top: 5px;
  margin-bottom: 0;
}
.modal-content .modal-body {
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  line-height: 1.9;
}
.modal-content .modal-footer {
  border-top: none;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px; /* Safari 6.1+ */
  justify-content: space-between;
}
.modal-content .modal-footer button {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}
.modal-content .modal-footer button.pull-left {
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  left: -5px;
}
.modal-content .modal-body + .modal-footer {
  padding-top: 0;
}

.modal-backdrop {
  background: rgba(0, 0, 0, 0.3);
}

.modal.modal-mini p {
  text-align: center;
}
.modal.modal-mini .modal-dialog {
  max-width: 255px;
  margin: 0 auto;
}
.modal.modal-mini .modal-profile {
  width: 70px;
  height: 70px;
  background-color: #FFFFFF;
  border-radius: 50%;
  text-align: center;
  line-height: 5.7;
  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.3);
}
.modal.modal-mini .modal-profile i {
  color: #f96332;
  font-size: 21px;
}
.modal.modal-mini .modal-profile[class*=modal-profile-] i {
  color: #FFFFFF;
}
.modal.modal-mini .modal-profile.modal-profile-primary {
  background-color: #f96332;
}
.modal.modal-mini .modal-profile.modal-profile-danger {
  background-color: #FF3636;
}
.modal.modal-mini .modal-profile.modal-profile-warning {
  background-color: #FFB236;
}
.modal.modal-mini .modal-profile.modal-profile-success {
  background-color: #18ce0f;
}
.modal.modal-mini .modal-profile.modal-profile-info {
  background-color: #2CA8FF;
}
.modal.modal-mini .modal-footer button {
  text-transform: uppercase;
}
.modal.modal-mini .modal-footer button:first-child {
  opacity: 0.5;
}
.modal.modal-default .modal-content {
  background-color: #FFFFFF;
  color: #2c2c2c;
}
.modal.modal-default .modal-header .close {
  color: #2c2c2c;
}
.modal.modal-primary .modal-content {
  background-color: #f96332;
  color: #FFFFFF;
}
.modal.modal-primary .modal-header .close {
  color: #FFFFFF;
}
.modal.modal-danger .modal-content {
  background-color: #FF3636;
  color: #FFFFFF;
}
.modal.modal-danger .modal-header .close {
  color: #FFFFFF;
}
.modal.modal-warning .modal-content {
  background-color: #FFB236;
  color: #FFFFFF;
}
.modal.modal-warning .modal-header .close {
  color: #FFFFFF;
}
.modal.modal-success .modal-content {
  background-color: #18ce0f;
  color: #FFFFFF;
}
.modal.modal-success .modal-header .close {
  color: #FFFFFF;
}
.modal.modal-info .modal-content {
  background-color: #2CA8FF;
  color: #FFFFFF;
}
.modal.modal-info .modal-header .close {
  color: #FFFFFF;
}
.modal.show.modal-mini .modal-dialog {
  transform: translate(0, 30%);
}
.modal .modal-header .close {
  color: #FF3636;
  text-shadow: none;
}
.modal .modal-header .close:hover, .modal .modal-header .close:focus {
  opacity: 1;
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
  display: block;
}

.carousel .carousel-inner {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
  border-radius: 0.1875rem;
}
.carousel .card {
  max-width: 650px;
  margin: 60px auto;
  display: block;
}

.footer {
  padding: 24px 0;
}
.footer.footer-default {
  background-color: #f2f2f2;
}
.footer nav {
  display: inline-block;
  float: left;
}
.footer ul {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}
.footer ul li {
  display: inline-block;
}
.footer ul li a {
  color: inherit;
  padding: 0.5rem;
  font-size: 0.8571em;
  text-transform: uppercase;
  text-decoration: none;
}
.footer ul li a:hover {
  text-decoration: none;
}
.footer .copyright {
  font-size: 0.8571em;
}
.footer:after {
  display: table;
  clear: both;
  content: " ";
}

.card {
  border: 0;
  border-radius: 0.1875rem;
  display: inline-block;
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}
.card .card-header {
  background-color: transparent;
  border-bottom: 0;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
}
.card .card-footer {
  padding: 0;
  margin-top: 15px;
  background-color: transparent;
  border: 0;
}
.card[data-background-color=orange] {
  background-color: #f96332;
}
.card[data-background-color=red] {
  background-color: #FF3636;
}
.card[data-background-color=yellow] {
  background-color: #FFB236;
}
.card[data-background-color=blue] {
  background-color: #2CA8FF;
}
.card[data-background-color=green] {
  background-color: #15b60d;
}

.card-plain {
  background: transparent;
  box-shadow: none;
}
.card-plain .card-body,
.card-plain .card-header {
  padding-left: 5px;
  padding-right: 5px;
}
.card-plain .card-header:after {
  width: 100%;
  left: 0;
}

.card-signup {
  max-width: 350px;
  margin: 0 auto;
}
.card-signup .card-header {
  margin: 0 20px;
  padding: 30px 0;
}
.card-signup .card-title {
  margin-top: 15px;
  margin-bottom: 15px;
}
.card-signup .card-footer {
  margin-bottom: 10px;
  margin-top: 24px;
  padding: 24px 0;
}
.card-signup .card-body {
  padding-top: 0px;
  padding-bottom: 0px;
  min-height: auto;
}
.card-signup .form-check,
.card-signup .form-check.form-check-radio {
  margin-top: 20px;
}
.card-signup .form-check label,
.card-signup .form-check.form-check-radio label {
  margin-left: 11px;
  color: initial;
  padding-left: 40px;
}
.card-signup .card-description {
  margin-top: 15px;
  margin-bottom: 20px;
}
.card-signup .social-line {
  margin-top: 20px;
  text-align: center;
}
.card-signup .social-line .btn.btn-icon,
.card-signup .social-line .btn.btn-icon .btn-icon {
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 0;
  margin-bottom: 0;
  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);
}

.index-page .page-header {
  height: 125vh;
}
.index-page .page-header .container > .content-center {
  top: 37%;
}
.index-page .page-header .category-absolute {
  position: absolute;
  top: 100vh;
  margin-top: -60px;
  padding: 0 15px;
  width: 100%;
  color: rgba(255, 255, 255, 0.5);
}

.landing-page .header {
  height: 100vh;
  position: relative;
}
.landing-page .header .container {
  padding-top: 26vh;
  color: #FFFFFF;
  z-index: 2;
  position: relative;
}
.landing-page .header .share {
  margin-top: 150px;
}
.landing-page .header h1 {
  font-weight: 600;
}
.landing-page .header .title {
  color: #FFFFFF;
}
.landing-page .section-team .team .team-player img {
  max-width: 100px;
}
.landing-page .section-team .team-player {
  margin-bottom: 15px;
}
.landing-page .section-contact-us .title {
  margin-bottom: 15px;
}
.landing-page .section-contact-us .description {
  margin-bottom: 30px;
}
.landing-page .section-contact-us .input-group,
.landing-page .section-contact-us .send-button,
.landing-page .section-contact-us .textarea-container {
  padding: 0 40px;
}
.landing-page .section-contact-us .textarea-container {
  margin: 40px 0;
}
.landing-page .section-contact-us a.btn {
  margin-top: 35px;
}

.profile-page .page-header {
  min-height: 550px;
}
.profile-page .profile-container {
  color: #FFFFFF;
}
.profile-page .photo-container {
  width: 123px;
  height: 123px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}
.profile-page .title {
  text-align: center;
  margin-top: 30px;
}
.profile-page .description,
.profile-page .category {
  text-align: center;
}
.profile-page h5.description {
  max-width: 700px;
  margin: 20px auto 75px;
}
.profile-page .nav-align-center {
  margin-top: 30px;
}
.profile-page .content {
  max-width: 450px;
  margin: 0 auto;
}
.profile-page .content .social-description {
  display: inline-block;
  max-width: 150px;
  width: 145px;
  text-align: center;
  margin: 15px 0 0px;
}
.profile-page .content .social-description h2 {
  margin-bottom: 15px;
}
.profile-page .button-container {
  text-align: center;
  margin-top: -106px;
}
.profile-page .collections img {
  margin-bottom: 30px;
}
.profile-page .gallery {
  margin-top: 45px;
  padding-bottom: 50px;
}

.section-full-page:after, .section-full-page:before {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
.section-full-page:before {
  background-color: rgba(0, 0, 0, 0.5);
}
.section-full-page[filter-color=purple]:after, .section-full-page[filter-color=primary]:after {
  background: rgba(227, 227, 227, 0.26); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(227, 227, 227, 0.26), rgba(249, 99, 50, 0.95)); /* Standard syntax */
}
.section-full-page[data-image]:after {
  opacity: 0.5;
}
.section-full-page > .content,
.section-full-page > .footer {
  position: relative;
  z-index: 4;
}
.section-full-page > .content {
  min-height: calc(100vh - 80px);
}
.section-full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.section-full-page .footer nav > ul a:not(.btn),
.section-full-page .footer,
.section-full-page .footer .copyright a {
  color: #FFFFFF;
}

.login-page .page-header:before,
.profile-page .page-header:before {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.5);
}

.login-page .card-login {
  border-radius: 0.25rem;
  padding-bottom: 0.7rem;
  max-width: 320px;
}
.login-page .card-login .btn-wd {
  min-width: 180px;
}
.login-page .card-login .logo-container {
  width: 65px;
  margin: 0 auto;
  margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
  width: 100%;
}
.login-page .card-login .input-group:last-child {
  margin-bottom: 40px;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-control:focus {
  border-color: #FFFFFF;
  background-color: transparent;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
  color: #FFFFFF;
}
.login-page .card-login.card-plain .has-danger .form-control {
  background-color: transparent;
}
.login-page .card-login.card-plain .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .input-group-focus .input-group-text {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus, .login-page .card-login.card-plain .form-group.no-border .form-control:active, .login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-text:focus, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-text:active, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-text:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus + .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus + .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border.input-group-focus .input-group-text,
.login-page .card-login.card-plain .input-group.no-border.input-group-focus .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .input-group-text,
.login-page .card-login.card-plain .form-group.no-border .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-text {
  color: rgba(255, 255, 255, 0.8);
}
.login-page .link {
  font-size: 10px;
  color: #FFFFFF;
  text-decoration: none;
}

.section {
  padding: 70px 0;
  position: relative;
  background: #FFFFFF;
}
.section .row + .category {
  margin-top: 15px;
}

.section-navbars {
  padding-bottom: 0;
}

.section-full-screen {
  height: 100vh;
}

.section-signup {
  padding-top: 20vh;
}

.page-header {
  min-height: 100vh;
  max-height: 999px;
  padding: 0;
  color: #FFFFFF;
  position: relative;
  overflow: hidden;
}
.page-header > .content {
  margin-top: 12%;
  text-align: center;
  margin-bottom: 50px;
}
.page-header.page-header-small {
  min-height: 60vh;
  max-height: 440px;
}
.page-header:before {
  background-color: rgba(0, 0, 0, 0.3);
}
.page-header > .container {
  z-index: 2;
  padding-top: 12vh;
  padding-bottom: 40px;
}
.page-header .page-header-image {
  position: absolute;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.page-header .content-center {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #FFFFFF;
  padding: 0 15px;
  width: 100%;
  max-width: 880px;
}
.page-header footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.page-header .container {
  height: 100%;
  z-index: 1;
  text-align: center;
  position: relative;
}
.page-header .category,
.page-header .description {
  color: rgba(255, 255, 255, 0.8);
}
.page-header:after, .page-header:before {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
}

.clear-filter:after, .clear-filter:before {
  display: none;
}
.clear-filter[filter-color=orange] {
  background: rgba(44, 44, 44, 0.2); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(44, 44, 44, 0.2), rgba(224, 23, 3, 0.6)); /* Standard syntax */
}

.section-story-overview {
  padding: 50px 0;
}
.section-story-overview .image-container {
  height: 335px;
  position: relative;
  background-position: center center;
  background-size: cover;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
  border-radius: 0.25rem;
}
.section-story-overview .image-container + .category {
  padding-top: 15px;
}
.section-story-overview .image-container.image-right {
  z-index: 2;
}
.section-story-overview .image-container.image-right + h3.title {
  margin-top: 120px;
}
.section-story-overview .image-container.image-left {
  z-index: 1;
}
.section-story-overview .image-container:nth-child(2) {
  margin-top: 420px;
  margin-left: -105px;
}
.section-story-overview p.blockquote {
  width: 220px;
  min-height: 180px;
  text-align: left;
  position: absolute;
  top: 376px;
  right: 155px;
  z-index: 0;
}

.section-nucleo-icons .nucleo-container img {
  width: auto;
  left: 0;
  top: 0;
  height: 100%;
  position: absolute;
}
.section-nucleo-icons .nucleo-container {
  height: 335px;
  position: relative;
}
.section-nucleo-icons h5 {
  margin-bottom: 35px;
}
.section-nucleo-icons .icons-container {
  position: relative;
  max-width: 450px;
  height: 300px;
  max-height: 300px;
  margin: 0 auto;
}
.section-nucleo-icons .icons-container i {
  font-size: 34px;
  position: absolute;
  left: 0;
  top: 0;
}
.section-nucleo-icons .icons-container i:nth-child(1) {
  top: 5%;
  left: 7%;
}
.section-nucleo-icons .icons-container i:nth-child(2) {
  top: 28%;
  left: 24%;
}
.section-nucleo-icons .icons-container i:nth-child(3) {
  top: 40%;
}
.section-nucleo-icons .icons-container i:nth-child(4) {
  top: 18%;
  left: 62%;
}
.section-nucleo-icons .icons-container i:nth-child(5) {
  top: 74%;
  left: 3%;
}
.section-nucleo-icons .icons-container i:nth-child(6) {
  top: 36%;
  left: 44%;
  font-size: 65px;
  color: #f96332;
  padding: 1px;
}
.section-nucleo-icons .icons-container i:nth-child(7) {
  top: 59%;
  left: 26%;
}
.section-nucleo-icons .icons-container i:nth-child(8) {
  top: 60%;
  left: 69%;
}
.section-nucleo-icons .icons-container i:nth-child(9) {
  top: 72%;
  left: 47%;
}
.section-nucleo-icons .icons-container i:nth-child(10) {
  top: 88%;
  left: 27%;
}
.section-nucleo-icons .icons-container i:nth-child(11) {
  top: 31%;
  left: 80%;
}
.section-nucleo-icons .icons-container i:nth-child(12) {
  top: 88%;
  left: 68%;
}
.section-nucleo-icons .icons-container i:nth-child(13) {
  top: 5%;
  left: 81%;
}
.section-nucleo-icons .icons-container i:nth-child(14) {
  top: 58%;
  left: 90%;
}
.section-nucleo-icons .icons-container i:nth-child(15) {
  top: 6%;
  left: 40%;
}

.section-images {
  max-height: 670px;
  height: 670px;
}
.section-images .hero-images-container,
.section-images .hero-images-container-1,
.section-images .hero-images-container-2 {
  margin-top: -38vh;
}
.section-images .hero-images-container {
  max-width: 670px;
}
.section-images .hero-images-container-1 {
  max-width: 390px;
  position: absolute;
  top: 55%;
  right: 18%;
}
.section-images .hero-images-container-2 {
  max-width: 225px;
  position: absolute;
  top: 68%;
  right: 12%;
}

[data-background-color=orange] {
  background-color: #e95e38;
}

[data-background-color=black] {
  background-color: #2c2c2c;
}

[data-background-color]:not([data-background-color=gray]) {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .title,
[data-background-color]:not([data-background-color=gray]) .social-description h2,
[data-background-color]:not([data-background-color=gray]) p,
[data-background-color]:not([data-background-color=gray]) p.blockquote,
[data-background-color]:not([data-background-color=gray]) p.blockquote small {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .separator {
  background-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .navbar.bg-white p {
  color: #888888;
}
[data-background-color]:not([data-background-color=gray]) h1, [data-background-color]:not([data-background-color=gray]) h2, [data-background-color]:not([data-background-color=gray]) h3, [data-background-color]:not([data-background-color=gray]) h4, [data-background-color]:not([data-background-color=gray]) h5, [data-background-color]:not([data-background-color=gray]) h6, [data-background-color]:not([data-background-color=gray]) a:not(.btn):not(.dropdown-item),
[data-background-color]:not([data-background-color=gray]) .icons-container {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .input-group-text,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .input-group-text {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color=gray]) .description,
[data-background-color]:not([data-background-color=gray]) .social-description p {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color=gray]) p.blockquote {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color=gray]) .checkbox label::before,
[data-background-color]:not([data-background-color=gray]) .checkbox label::after,
[data-background-color]:not([data-background-color=gray]) .radio label::before,
[data-background-color]:not([data-background-color=gray]) .radio label::after {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color=gray]) .checkbox label::after,
[data-background-color]:not([data-background-color=gray]) .checkbox label,
[data-background-color]:not([data-background-color=gray]) .radio label {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .checkbox input[type=checkbox]:disabled + label,
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:disabled + label {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:not(:disabled):hover + label::after,
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:checked + label::after {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-control:focus {
  border-color: #FFFFFF;
  background-color: transparent;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .has-success:after,
[data-background-color]:not([data-background-color=gray]) .has-danger:after {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .has-danger .form-control {
  background-color: transparent;
}
[data-background-color]:not([data-background-color=gray]) .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .input-group-focus .input-group-text {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:focus, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:active, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:focus,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-text:focus, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-text:active, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-text:focus,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:focus + .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:focus + .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border.input-group-focus .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border.input-group-focus .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-] {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:hover, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:focus, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:not(:disabled):not(.disabled):active, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:not(:disabled):not(.disabled).active, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:not(:disabled):not(.disabled):active:focus, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:not(:disabled):not(.disabled).active:focus, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:active:hover, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-].active:hover, .show > [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-].dropdown-toggle, .show > [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-].dropdown-toggle:focus, .show > [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-].dropdown-toggle:hover {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .nav-tabs > .nav-item > .nav-link i.now-ui-icons {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).section-nucleo-icons .icons-container i:nth-child(6) {
  color: #FFFFFF;
}

@media screen and (max-width: 991px) {
  .sidebar-collapse .navbar-collapse {
    position: fixed;
    display: block !important;
    top: 0;
    height: 100% !important;
    width: 300px;
    right: 0;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    max-height: none !important;
    transform: translate3d(300px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .sidebar-collapse .navbar-collapse:before {
    background: #f96332; /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
    background: linear-gradient(#f96332 0%, #000 80%); /* Standard syntax (must be last) */
    opacity: 0.76;
    filter: alpha(opacity=76);
    display: block;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .sidebar-collapse .navbar-collapse .navbar-nav:not(.navbar-logo) .nav-link {
    margin: 0 1rem;
    margin-top: 0.3125rem;
  }
  .sidebar-collapse .navbar-collapse .navbar-nav:not(.navbar-logo) .nav-link:not(.btn) {
    color: #FFFFFF !important;
  }
  .sidebar-collapse .navbar-collapse .dropdown-menu .dropdown-item {
    color: #FFFFFF;
  }
  .sidebar-collapse.menu-on-left .navbar-translate {
    flex-direction: row-reverse;
  }
  .sidebar-collapse .navbar .navbar-nav {
    margin-top: 53px;
    position: relative;
    max-height: calc(100vh - 75px);
    min-height: 100%;
    overflow: auto;
  }
  .sidebar-collapse .navbar .navbar-nav.navbar-logo {
    top: 0;
    height: 53px;
  }
  .sidebar-collapse .navbar .dropdown.show .dropdown-menu,
  .sidebar-collapse .navbar .dropdown .dropdown-menu {
    background-color: transparent;
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    margin: 0 1rem;
    margin-bottom: 15px;
    padding-top: 0;
    height: 125px;
    overflow-y: scroll;
  }
  .sidebar-collapse .navbar .dropdown.show .dropdown-menu:before,
  .sidebar-collapse .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .sidebar-collapse .navbar .dropdown .dropdown-item {
    padding-left: 2.5rem;
  }
  .sidebar-collapse .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .sidebar-collapse .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .sidebar-collapse .navbar .dropdown-menu .dropdown-item:focus,
  .sidebar-collapse .navbar .dropdown-menu .dropdown-item:hover {
    color: #FFFFFF;
    border-radius: 0.1875rem;
  }
  .sidebar-collapse .navbar .navbar-translate {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .sidebar-collapse .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #FFFFFF;
  }
  .sidebar-collapse .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .sidebar-collapse .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .sidebar-collapse .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background: #888888;
  }
  .sidebar-collapse .top-bar {
    transform: rotate(0);
  }
  .sidebar-collapse .middle-bar {
    opacity: 1;
  }
  .sidebar-collapse .bottom-bar {
    transform: rotate(0);
  }
  .sidebar-collapse .top-bar,
  .sidebar-collapse .middle-bar,
  .sidebar-collapse .bottom-bar {
    transition: all 0.2s;
  }
  .sidebar-collapse .toggled .top-bar {
    transform: rotate(45deg);
    transform-origin: 0%;
  }
  .sidebar-collapse .toggled .bottom-bar {
    transform: rotate(-45deg);
    transform-origin: 0%;
  }
  .sidebar-collapse .toggled .middle-bar {
    opacity: 0;
  }
  .sidebar-collapse [class*=navbar-expand-] .navbar-collapse {
    width: 300px;
  }
  .sidebar-collapse .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .sidebar-collapse #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    left: auto;
    right: 300px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .sidebar-collapse.menu-on-left .navbar-collapse {
    right: auto;
    left: 0;
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .sidebar-collapse .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .sidebar-collapse .wrapper {
    transform: translate3d(-150px, 0, 0);
  }
  .nav-open .sidebar-collapse .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .sidebar-collapse.menu-on-left .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .sidebar-collapse.menu-on-left .navbar-translate {
    transform: translate3d(300px, 0, 0);
  }
  .nav-open .sidebar-collapse.menu-on-left .wrapper {
    transform: translate3d(150px, 0, 0);
  }
  .nav-open .sidebar-collapse.menu-on-left #bodyClick {
    right: auto;
    left: 300px;
  }
  .navbar-nav .nav-link i.fab,
  .navbar-nav .nav-link i.now-ui-icons {
    opacity: 0.5;
  }
  .bootstrap-collapse .navbar .navbar-collapse {
    background: none !important;
  }
  .bootstrap-collapse.menu-on-left .navbar-translate {
    flex-direction: row-reverse;
  }
  .bootstrap-collapse .navbar .navbar-nav {
    margin-top: 53px;
    position: relative;
    max-height: calc(100vh - 75px);
    min-height: 100%;
    overflow: auto;
  }
  .bootstrap-collapse .navbar .navbar-nav.navbar-logo {
    top: 0;
    height: 53px;
  }
  .bootstrap-collapse .navbar .dropdown.show .dropdown-menu,
  .bootstrap-collapse .navbar .dropdown .dropdown-menu {
    background-color: transparent;
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    margin: 0 1rem;
    margin-bottom: 15px;
    padding-top: 0;
    height: 125px;
    overflow-y: scroll;
  }
  .bootstrap-collapse .navbar .dropdown.show .dropdown-menu:before,
  .bootstrap-collapse .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .bootstrap-collapse .navbar .dropdown .dropdown-item {
    padding-left: 2.5rem;
  }
  .bootstrap-collapse .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .bootstrap-collapse .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .bootstrap-collapse .navbar .dropdown-menu .dropdown-item:focus,
  .bootstrap-collapse .navbar .dropdown-menu .dropdown-item:hover {
    color: #FFFFFF;
    border-radius: 0.1875rem;
  }
  .bootstrap-collapse .navbar .navbar-translate {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .bootstrap-collapse .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #FFFFFF;
  }
  .bootstrap-collapse .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .bootstrap-collapse .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .bootstrap-collapse .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background: #888888;
  }
  .bootstrap-collapse .top-bar {
    transform: rotate(0);
  }
  .bootstrap-collapse .middle-bar {
    opacity: 1;
  }
  .bootstrap-collapse .bottom-bar {
    transform: rotate(0);
  }
  .bootstrap-collapse .top-bar,
  .bootstrap-collapse .middle-bar,
  .bootstrap-collapse .bottom-bar {
    transition: all 0.2s;
  }
  .bootstrap-collapse .toggled .top-bar {
    transform: rotate(45deg);
    transform-origin: 0%;
  }
  .bootstrap-collapse .toggled .bottom-bar {
    transform: rotate(-45deg);
    transform-origin: 0%;
  }
  .bootstrap-collapse .toggled .middle-bar {
    opacity: 0;
  }
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  .button-dropdown {
    display: none;
  }
  .section-nucleo-icons .container .row > [class*=col-]:first-child {
    text-align: center;
  }
  .footer .copyright {
    text-align: right;
  }
  .section-nucleo-icons .icons-container {
    margin-top: 65px;
  }
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.now-ui-icons {
    opacity: 0.5;
  }
  .section-images {
    height: 500px;
    max-height: 500px;
  }
  .section-images .hero-images-container {
    max-width: 500px;
  }
  .section-images .hero-images-container-1 {
    right: 10%;
    top: 68%;
    max-width: 269px;
  }
  .section-images .hero-images-container-2 {
    right: 5%;
    max-width: 135px;
    top: 93%;
  }
}
@media screen and (min-width: 992px) {
  .navbar-collapse:not(.has-image) {
    background: transparent !important;
  }
  .burger-menu .navbar-collapse {
    position: fixed;
    display: block !important;
    top: 0;
    height: 100% !important;
    width: 300px;
    right: 0;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    max-height: none !important;
    transform: translate3d(300px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu .navbar-collapse:before {
    background: #f96332; /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
    background: linear-gradient(#f96332 0%, #000 80%); /* Standard syntax (must be last) */
    opacity: 0.76;
    filter: alpha(opacity=76);
    display: block;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .burger-menu .navbar-collapse .navbar-nav:not(.navbar-logo) .nav-link {
    margin: 0 1rem;
    margin-top: 0.3125rem;
  }
  .burger-menu .navbar-collapse .navbar-nav:not(.navbar-logo) .nav-link:not(.btn) {
    color: #FFFFFF !important;
  }
  .burger-menu .navbar-collapse .dropdown-menu .dropdown-item {
    color: #FFFFFF;
  }
  .burger-menu.menu-on-left .navbar-translate {
    flex-direction: row-reverse;
  }
  .burger-menu .navbar .navbar-nav {
    margin-top: 53px;
    position: relative;
    max-height: calc(100vh - 75px);
    min-height: 100%;
    overflow: auto;
  }
  .burger-menu .navbar .navbar-nav.navbar-logo {
    top: 0;
    height: 53px;
  }
  .burger-menu .navbar .dropdown.show .dropdown-menu,
  .burger-menu .navbar .dropdown .dropdown-menu {
    background-color: transparent;
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    margin: 0 1rem;
    margin-bottom: 15px;
    padding-top: 0;
    height: 125px;
    overflow-y: scroll;
  }
  .burger-menu .navbar .dropdown.show .dropdown-menu:before,
  .burger-menu .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .burger-menu .navbar .dropdown .dropdown-item {
    padding-left: 2.5rem;
  }
  .burger-menu .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .burger-menu .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .burger-menu .navbar .dropdown-menu .dropdown-item:focus,
  .burger-menu .navbar .dropdown-menu .dropdown-item:hover {
    color: #FFFFFF;
    border-radius: 0.1875rem;
  }
  .burger-menu .navbar .navbar-translate {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #FFFFFF;
  }
  .burger-menu .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .burger-menu .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .burger-menu .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background: #888888;
  }
  .burger-menu .top-bar {
    transform: rotate(0);
  }
  .burger-menu .middle-bar {
    opacity: 1;
  }
  .burger-menu .bottom-bar {
    transform: rotate(0);
  }
  .burger-menu .top-bar,
  .burger-menu .middle-bar,
  .burger-menu .bottom-bar {
    transition: all 0.2s;
  }
  .burger-menu .toggled .top-bar {
    transform: rotate(45deg);
    transform-origin: 0%;
  }
  .burger-menu .toggled .bottom-bar {
    transform: rotate(-45deg);
    transform-origin: 0%;
  }
  .burger-menu .toggled .middle-bar {
    opacity: 0;
  }
  .burger-menu [class*=navbar-expand-] .navbar-collapse {
    width: 300px;
  }
  .burger-menu .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    left: auto;
    right: 300px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .burger-menu .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .burger-menu .navbar-collapse {
    display: block !important;
  }
  .burger-menu .navbar-collapse .navbar-nav {
    margin-top: 53px;
    height: 100%;
    z-index: 2;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .burger-menu .navbar-collapse .navbar-nav .nav-item {
    margin: 0;
  }
  .burger-menu.menu-on-left .navbar-collapse {
    right: auto;
    left: 0;
    transform: translate3d(-300px, 0, 0);
  }
  .burger-menu [class*=navbar-expand-] .navbar-nav .dropdown-menu {
    position: static;
    float: none;
  }
  .burger-menu [class*=navbar-expand-] .navbar-toggler {
    display: inline-block;
  }
  .burger-menu .section-navbars .navbar-collapse {
    display: none !important;
  }
  .nav-open .burger-menu.menu-on-left .navbar .navbar-translate {
    transform: translate3d(300px, 0, 0);
  }
  .nav-open .burger-menu .navbar .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .burger-menu.menu-on-left .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .burger-menu.menu-on-left #bodyClick {
    right: auto;
    left: 300px;
  }
  .burger-menu.menu-on-left .navbar-brand {
    float: right;
    margin-right: 0;
    margin-left: 1rem;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .navbar-nav .nav-link.btn:not(.btn-sm) {
    margin: 0;
  }
  .navbar-nav .nav-item:not(:last-child) {
    margin-right: 5px;
  }
  .section-nucleo-icons .icons-container {
    margin: 0 0 0 auto;
  }
  .dropdown-menu .dropdown-item {
    color: inherit;
    display: flex;
    align-items: center;
  }
  .dropdown-menu .dropdown-item i {
    margin-right: 5px;
    position: relative;
    top: 1px;
  }
  .footer .copyright {
    float: right;
  }
}
@media screen and (min-width: 768px) {
  .image-container.image-right {
    top: 80px;
    margin-left: -100px;
    margin-bottom: 130px;
  }
  .image-container.image-left {
    margin-right: -100px;
  }
}
@media screen and (max-width: 768px) {
  .image-container.image-left {
    margin-bottom: 220px;
  }
  .image-container.image-left p.blockquote {
    margin: 0 auto;
    position: relative;
    right: 0;
  }
  .nav-tabs {
    display: inline-block;
    width: 100%;
    padding-left: 100px;
    padding-right: 100px;
    text-align: center;
  }
  .nav-tabs .nav-item > .nav-link {
    margin-bottom: 5px;
  }
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 576px) {
  .navbar[class*=navbar-expand-] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .footer .copyright {
    text-align: center;
  }
  .section-nucleo-icons .icons-container i {
    font-size: 30px;
  }
  .section-nucleo-icons .icons-container i:nth-child(6) {
    font-size: 48px;
  }
  .page-header .container h6.category-absolute {
    width: 90%;
  }
}
@media screen and (min-width: 991px) and (max-width: 1200px) {
  .section-images .hero-images-container-1 {
    right: 9%;
    max-width: 370px;
  }
  .section-images .hero-images-container-2 {
    right: 2%;
    max-width: 216px;
  }
}
@media screen and (max-width: 768px) {
  .section-images {
    height: 300px;
    max-height: 300px;
  }
  .section-images .hero-images-container {
    max-width: 380px;
  }
  .section-images .hero-images-container-1 {
    right: 7%;
    top: 87%;
    max-width: 210px;
  }
  .section-images .hero-images-container-2 {
    right: 1%;
    max-width: 133px;
    top: 99%;
  }
}
@media screen and (max-width: 517px) {
  .alert .alert-icon {
    margin-top: 10px;
  }
}
@media screen and (min-width: 1200px) {
  .section-images .hero-images-container-1 {
    top: 51%;
    right: 21%;
  }
  .section-images .hero-images-container-2 {
    top: 66%;
    right: 14%;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .section-images .hero-images-container,
  .section-images .hero-images-container-1,
  .section-images .hero-images-container-2 {
    margin-top: -15vh;
    margin-left: 80px;
  }
  .section-images .hero-images-container {
    max-width: 300px;
  }
  .section-images .hero-images-container-1 {
    right: 28%;
    top: 40%;
  }
  .section-images .hero-images-container-2 {
    right: 21%;
    top: 55%;
  }
  .index-page .category-absolute {
    top: 90vh;
  }
}
@media screen and (max-width: 580px) {
  .alert button.close {
    position: absolute;
    right: 11px;
    top: 50%;
    transform: translateY(-50%);
  }
}
@media only screen and (min-height: 950px) {
  .index-page .page-header .category-absolute {
    margin-top: -330px;
  }
}
/*! nouislider - 14.0.2 - 6/28/2019 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
/*

This file was modified by Creative-Tim

*/
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 1px;
}

.noUi-horizontal .noUi-handle {
  width: 15px;
  height: 15px;
  left: -7px;
  top: 0px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 15px;
  height: 15px;
  left: 0px;
  top: -7px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -7px;
  left: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connects {
  border-radius: 3px;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}

.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  width: 260px;
  padding: 4px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.125rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #ffffff;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #FFFFFF !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  height: 30px;
  line-height: 33px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover {
  background-color: #f96332 !important;
  color: #FFFFFF;
}

.rdtDays tr .dow {
  text-align: center;
  border-bottom: 1px solid #e3e3e3;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
}
.rdtDays tr .rdtOld,
.rdtDays tr .rdtNew {
  color: #DDDDDD;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker .dow {
  width: 14.2857%;
  border-bottom: none;
}

.rdtPicker th.rdtSwitch {
  width: 50px;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 21px;
  vertical-align: top;
  border-radius: 50%;
  line-height: 33px;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #f96332;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #f96332;
  border-radius: 50%;
  border: 1px solid #f96332;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #DDDDDD;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
  background-color: #f96332 !important;
  color: #FFFFFF;
}

*:focus {
  outline: none;
}

.blockquote.blockquote-info {
  border-color: #2CA8FF;
  color: #2CA8FF;
}
.blockquote.blockquote-info small {
  color: #2CA8FF;
}

.dropdown-menu a.dropdown-header[tabindex="-1"] {
  color: hsla(0, 0%, 71%, 0.6);
  font-size: 0.7142em;
  text-transform: uppercase;
  font-weight: 700;
}

.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
}

.modal.modal-mini .modal-profile i {
  color: #2CA8FF;
  font-size: 21px;
}

.popover .arrow:before {
  border-color: transparent !important;
}

.popover-primary .popover {
  background-color: #f96332;
}
.popover-primary .popover .popover-body {
  color: #FFFFFF;
}
.popover-primary .popover.bs-popover-right .arrow:after {
  border-right-color: #f96332;
}
.popover-primary .popover.bs-popover-top .arrow:after {
  border-top-color: #f96332;
}
.popover-primary .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #f96332;
}
.popover-primary .popover.bs-popover-left .arrow:after {
  border-left-color: #f96332;
}
.popover-primary .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-primary .popover .arrow:after {
  border-left-color: #f96332;
}

.popover-info .popover {
  background-color: #2CA8FF;
}
.popover-info .popover .popover-body {
  color: #FFFFFF;
}
.popover-info .popover.bs-popover-right .arrow:after {
  border-right-color: #2CA8FF;
}
.popover-info .popover.bs-popover-top .arrow:after {
  border-top-color: #2CA8FF;
}
.popover-info .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #2CA8FF;
}
.popover-info .popover.bs-popover-left .arrow:after {
  border-left-color: #2CA8FF;
}
.popover-info .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-info .popover .arrow:after {
  border-left-color: #2CA8FF;
}

.popover-warning .popover {
  background-color: #FFB236;
}
.popover-warning .popover .popover-body {
  color: #FFFFFF;
}
.popover-warning .popover.bs-popover-right .arrow:after {
  border-right-color: #FFB236;
}
.popover-warning .popover.bs-popover-top .arrow:after {
  border-top-color: #FFB236;
}
.popover-warning .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #FFB236;
}
.popover-warning .popover.bs-popover-left .arrow:after {
  border-left-color: #FFB236;
}
.popover-warning .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-warning .popover .arrow:after {
  border-left-color: #FFB236;
}

.popover-danger .popover {
  background-color: #FF3636;
}
.popover-danger .popover .popover-body {
  color: #FFFFFF;
}
.popover-danger .popover.bs-popover-right .arrow:after {
  border-right-color: #FF3636;
}
.popover-danger .popover.bs-popover-top .arrow:after {
  border-top-color: #FF3636;
}
.popover-danger .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #FF3636;
}
.popover-danger .popover.bs-popover-left .arrow:after {
  border-left-color: #FF3636;
}
.popover-danger .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-danger .popover .arrow:after {
  border-left-color: #FF3636;
}

.popover-success .popover {
  background-color: #18ce0f;
}
.popover-success .popover .popover-body {
  color: #FFFFFF;
}
.popover-success .popover.bs-popover-right .arrow:after {
  border-right-color: #18ce0f;
}
.popover-success .popover.bs-popover-top .arrow:after {
  border-top-color: #18ce0f;
}
.popover-success .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #18ce0f;
}
.popover-success .popover.bs-popover-left .arrow:after {
  border-left-color: #18ce0f;
}
.popover-success .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-success .popover .arrow:after {
  border-left-color: #18ce0f;
}

.bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before {
  border-left-color: #FFFFFF;
}

.bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before {
  border-right-color: #FFFFFF;
}

.bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before {
  border-top-color: #FFFFFF;
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before {
  border-bottom-color: #FFFFFF;
}

.clear-filter[filter-color=blue] {
  background: rgba(44, 44, 44, 0.2); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(44, 44, 44, 0.2), rgba(3, 161, 224, 0.6)); /* Standard syntax */
}

[data-background-color=blue] {
  background-color: #2CA8FF;
}

.section-nucleo-icons .icons-container i:nth-child(6) {
  color: #2CA8FF;
}

.page-header.page-header-small {
  min-height: 60vh;
  max-height: 640px;
}

@media screen and (max-width: 991px) {
  .sidebar-collapse .navbar-collapse:before {
    background: #2CA8FF;
    background: linear-gradient(#2CA8FF, #2c2c2c 80%);
  }
  .navbar-nav .dropdown-menu {
    position: static !important;
  }
}
@media screen and (max-width: 768px) {
  .nav-tabs {
    padding-left: 10px;
    padding-right: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/now-ui-kit.scss","webpack://./src/assets/scss/now-ui-kit/_variables.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-bootstrap-switch.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-datepicker.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_transparency.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_datepicker.scss","webpack://./src/assets/scss/now-ui-kit/_buttons.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_buttons.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_inputs.scss","webpack://./src/assets/scss/now-ui-kit/_inputs.scss","webpack://./src/assets/scss/now-ui-kit/_checkboxes-radio.scss","webpack://./src/assets/scss/now-ui-kit/_progress.scss","webpack://./src/assets/scss/now-ui-kit/_badges.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_badges.scss","webpack://./src/assets/scss/now-ui-kit/_pagination.scss","webpack://./src/assets/scss/now-ui-kit/_typography.scss","webpack://./src/assets/scss/now-ui-kit/_misc.scss","webpack://./src/assets/scss/now-ui-kit/_pills.scss","webpack://./src/assets/scss/now-ui-kit/_nucleo-outline.scss","webpack://./src/assets/scss/now-ui-kit/_tabs.scss","webpack://./src/assets/scss/now-ui-kit/_navbar.scss","webpack://./src/assets/scss/now-ui-kit/_dropdown.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_dropdown.scss","webpack://./src/assets/scss/now-ui-kit/_alerts.scss","webpack://./src/assets/scss/now-ui-kit/_images.scss","webpack://./src/assets/scss/now-ui-kit/_popups.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_popovers.scss","webpack://./src/assets/scss/now-ui-kit/_modals.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_modals.scss","webpack://./src/assets/scss/now-ui-kit/_carousel.scss","webpack://./src/assets/scss/now-ui-kit/_footers.scss","webpack://./src/assets/scss/now-ui-kit/_cards.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-plain.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-signup.scss","webpack://./src/assets/scss/now-ui-kit/_example-pages.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_pages.scss","webpack://./src/assets/scss/now-ui-kit/_sections.scss","webpack://./src/assets/scss/now-ui-kit/_responsive.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_navbar.scss","webpack://./src/assets/scss/react/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/react/now-ui-kit/_misc.scss","webpack://./src/assets/scss/react/now-ui-kit/_typography.scss","webpack://./src/assets/scss/react/now-ui-kit/_dropdowns.scss","webpack://./src/assets/scss/react/now-ui-kit/_modals.scss","webpack://./src/assets/scss/react/now-ui-kit/_popovers.scss","webpack://./src/assets/scss/react/now-ui-kit/_tooltips.scss","webpack://./src/assets/scss/react/now-ui-kit/_sections.scss","webpack://./src/assets/scss/react/now-ui-kit/_responsive.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;EAAA;ACyEA,kCAAA;AAUA,8BAAA;ACnFA;;;;;;EAAA;AA8CA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;EACA,kBAAA;EACA,iCAAA;AFnBF;;AEsBA;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;AFnBF;;AEqBA;;;EAKE,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEQ,0BAAA;AFlBV;;AEqBA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AFlBF;;AEoBA;;EAEE,WAAA;EACA,mBD7D2B;AD4C7B;;AEmBA;;EAEE,WAAA;EACA,mBDxD2B;ADwC7B;;AEkBA;;EAEE,WAAA;EACA,mBDlE2B;ADmD7B;;AEiBA;;EAEE,mBD5D2B;EC6D3B,WAAA;AFdF;;AEgBA;;EAEE,WAAA;EACA,mBD7D2B;ADgD7B;;AEeA;;EAEE,WAAA;AFZF;;AEcA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;AFXF;;AEcA;EACI,uCAAA;AFXJ;;AEaA;EACI,sBAAA;EACA,kBAAA;AFVJ;;AEYA;EACI,sBAAA;EACA,kBAAA;AFTJ;;AEWA;EACE,8BAAA;EACA,2BAAA;AFRF;;AEUA;EACE,gBAAA;AFPF;;AESA;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AFNF;;AEQA;;EAEE,YAAA;AFLF;;AEOA;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;AFJF;;AEMA;;;EAGE,iBAAA;EACA,eAAA;EACA,gBAAA;AFHF;;AEKA;;;EAGE,iBAAA;EACA,eAAA;EACA,iBAAA;AFFF;;AEIA;;;EAGE,0BAAA;AFDF;;AEGA;;;;;;;;;EASE,YAAA;EACA,yBAAA;EACA,0BAAA;AFAF;;AEEA;EAEE,4BAAA;AFCF;;AECA;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;AFEF;;AEAA;EACE,6BAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;AFGF;;AEgBA;EACI,4BAAA;AFbJ;;AEgBA;EACI,6BAAA;AFbJ;;AEiBI;EACI,yBAAA;AFdR;;AEkBA;EACI,yBD1MyB;AD2L7B;;AEkBA;EACI,yBDnNyB;ADoM7B;;AEkBA;EACI,yBDjOyB;ADkN7B;;AEkBA;EACI,yBD1OyB;AD2N7B;;AEkBA;EACI,yBDpOyB;ADqN7B;;AEkBA;;;;;EAKI,yBDhRyB;ADiQ7B;;AEkBA;EACI,UAAA;AFfJ;;AEkBA;EACI,UAAA;AFfJ;;AG/RA,yBAAA;AACA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AHkSF;;AGhSA;EACE,kBAAA;EACA,cAAA;AHmSF;;AGjSA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AHoSF;;AGlSA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AHqSF;;AGnSA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EAGA,qBAAA;AHsSF;;AGpSA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;AHuSF;;AGrSA;;EAAA;AAGA;EACE,QAAA;AHwSF;;AGtSA;EACE,SAAA;AHySF;;AGvSA;EACE,kBAAA;AH0SF;;AGxSA;;EAGE,0BAAA;AH2SF;;AGzSA;EACE,0BAAA;AH4SF;;AG1SA;EAAA;AAEA;EACE,WAAA;AH6SF;;AG3SA;EACI,kBAAA;EACH,yBFvE4B;EEwE5B,2CAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACG,gBAAA;EACA,aAAA;AH8SJ;;AG5SA;EACC,WAAA;AH+SD;;AG7SA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AHgTF;;AG9SA;EACE,YAAA;EACA,UAAA;AHiTF;;AG/SA;;EAAA;AAGC;EACC,0CAAA;EACA,kBAAA;AHkTF;;AGhTA;EACE,kBAAA;AHmTF;;AGjTA;EACC,mBFrE4B;EEsEzB,kBAAA;EAEH,4BAAA;AHoTD;;AGlTA;EAAA;AAEA;EACE,iBAAA;AHqTF;;AGnTA;EACE,iBAAA;AHsTF;;AGpTA;EAEC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;EAGA,iCAAA;EACG,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;AHoTJ;;AGlTA;EAKI,+BAAA;AHqTJ;;AGnTA;EAAA;AAEA;;EAEE,aAAA;AHsTF;;AGpTA;EACE,UAAA;AHuTF;;AGrTA;;EAEE,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AHwTF;;AGtTA;EACE,SAAA;AHyTF;;AGvTA;EAAA;AAEA;EACE,mBAAA;AH0TF;;AGxTA;;;EAGE,mBAAA;AH2TF;;AGzTA;;EAAA;AAGA;;EAGE,sBAAA;AH4TF;;AG1TA;EACE,kBAAA;EACA,WAAA;AH6TF;;AG3TA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AH8TF;;AG5TA;EACE,WAAA;EACA,eAAA;AH+TF;;AG7TA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AHgUF;;AG9TA;EACE,gBAAA;AHiUF;;AG/TA;EACE,gBAAA;AHkUF;;AGhUA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AHmUF;;AGjUA;EAEE,+BAAA;AHoUF;;AGlUA;EAEE,8BAAA;AHqUF;;AGnUA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AHsUF;;AGpUA;EACE,YAAA;AHuUF;;AGrUA;EACE,YAAA;AHwUF;;AGtUA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AHyUF;;AGvUA;EAEE,gCAAA;EACA,kBAAA;AH0UF;;AGxUA;EAEE,4BAAA;AH2UF;;AGzUA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AH4UF;;AG1UA;EACE,WAAA;AH6UF;;AG3UA;EACE,WAAA;AH8UF;;AG5UA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AH+UF;;AG7UA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AHgVF;;AG9UA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AHiVF;;AG3UE;EAEU,yBFlSiB;AD+mB7B;AG1UE;EACC,0CAAA;AH4UH;AGzUE;EACC,yBF1S0B;ADqnB7B;AGtUE;EAEU,yBF3QiB;ADklB7B;AGpUE;EACC,wCF7Q0B;ADmlB7B;AGnUE;EACC,yBFnR0B;ADwlB7B;AGhUQ;EAEI,yBFhRiB;ADilB7B;AG9TE;EACC,yCFlR0B;ADklB7B;AG7TE;EACC,yBFxR0B;ADulB7B;AG3TQ;EAEI,yBFnSiB;AD+lB7B;AGzTQ;EACL,wCFrS0B;ADgmB7B;AGxTE;EACC,yBF3S0B;ADqmB7B;AGtTQ;EAEI,yBFvSiB;AD8lB7B;AGpTQ;EACL,yCFzS0B;AD+lB7B;AGnTE;EACC,yBF/S0B;ADomB7B;AGjTQ;EAEI,yBFhTiB;ADkmB7B;AG/SQ;EACL,wCFlT0B;ADmmB7B;AG9SE;EACC,yBFxT0B;ADwmB7B;;AI5qBA;;;;EAAA;AAMA;EACE,gBAAA;EAGA,kBAAA;EACA,cAAA;ECuDM,mCAAA;EDrDN,yGAAA;EEVA,UFYiB;EETjB,wBAAA;EFUA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AJkrBF;AIhrBE;EACI,aAAA;AJkrBN;AI/qBE;EGxBE,yBN+CyB;AD2pB7B;AOxsBI;;;EAGI,cNIqB;ADssB7B;AOvsBI;EACI,4BNsCqB;ADmqB7B;AOtsBI;EACI,yBNkCqB;ADsqB7B;AOrsBI;EACI,+BNgB4B;ADurBpC;AOpsBI;;;;EAIG,+BNU6B;AD4rBpC;AOnsBI;;EAEI,oCNQqB;AD6rB7B;AOlsBI;;;;EAIE,oCNEuB;ADksB7B;AOjsBI;;;;EAKE,yBNnCuB;EMoCvB,cNEuB;ADgsB7B;AO/rBI;;EAEE,oCNZuB;AD6sB7B;AO9rBI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE,yBNpFuB;ADoxB7B;AO7rBI;;;;;;;;;;;;;;;;;;;;EAoBI,cNrEqB;ADowB7B;;AIvxBA;EACE,YAAA;AJ0xBF;;AIxxBA;EACE,cAAA;AJ2xBF;;AIzxBA;EACE,UAAA;AJ4xBF;;AI1xBA;EACE,YAAA;AJ6xBF;;AI3xBA;EACE,MAAA;EACA,OAAA;AJ8xBF;;AI5xBA;EACE,WAAA;EACA,qBAAA;EACA,kCAAA;EACA,mCAAA;EACA,oCAAA;EACA,aAAA;EACA,uCAAA;EACA,kBAAA;AJ+xBF;;AI7xBA;EACE,WAAA;EACA,qBAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;AJgyBF;;AI9xBA;EACE,SAAA;AJiyBF;;AI/xBA;EACE,SAAA;AJkyBF;;AIhyBA;EACE,UAAA;AJmyBF;;AIjyBA;EACE,UAAA;AJoyBF;;AIlyBA;EACE,SAAA;AJqyBF;;AInyBA;EACE,SAAA;AJsyBF;;AIpyBA;EACE,YAAA;EACA,gBAAA;EACA,iCAAA;AJuyBF;;AIryBA;EACE,YAAA;EACA,gBAAA;EACA,0BAAA;AJwyBF;;AItyBA;EACE,SAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EACA,YAAA;EACA,gBAAA;AJyyBF;;AIvyBA;;ECpFI,6BAAA;EDuFF,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,kBAAA;EACA,gBHiD8B;EGhD9B,eH2C6B;EG1C7B,YAAA;EACC,UAAA;EACD,kBAAA;EACA,eAAA;AJ8yBF;;AI3yBA;EACI,cH1EyB;ADw3B7B;;AI3yBA;;;;;;EAMI,YAAA;EACA,kBAAA;EACA,eAAA;AJ8yBJ;;AI3yBA;;EAEE,6BAAA;AJ8yBF;;AI5yBA;;EAEE,gBAAA;EACA,eAAA;AJ+yBF;;AI7yBA;;EAEE,cHvG2B;ADu5B7B;;AI9yBA;;EAEE,gBAAA;EACA,cH5G2B;EG6G3B,eAAA;AJizBF;;AI/yBA;EACE,mBAAA;EACA,gBAAA;AJkzBF;;AIhzBA;;;;EAIE,yBAAA;EAMA,8DAAA;EACA,2BAAA;EACA,kHAAA;EACA,qCAAA;EACA,uEAAA;EACA,iEAAA;EACA,WAAA;AJmzBF;;AIjzBA;;;;;;;;;;;;;;;;;;;;EAoBE,yBAAA;AJozBF;;AIlzBA;;;;;;;;EAQE,6BAAA;AJqzBF;;AInzBA;EACE,WAAA;AJszBF;;AIpzBA;EACE,WAAA;AJuzBF;;AIrzBA;;;;EAIE,gBAAA;EAGA,gBAAA;AJwzBF;;AItzBA;;;;EAIE,yBAAA;EAMA,8DAAA;EACA,2BAAA;EACA,kHAAA;EACA,qCAAA;EACA,uEAAA;EACA,iEAAA;EAGA,gBAAA;AJyzBF;;AIvzBA;;;;;;;;;;;;;;;;;;;;EAoBE,yBAAA;AJ0zBF;;AIxzBA;;;;;;;;EAQE,6BAAA;AJ2zBF;;AIzzBA;;;;EAIE,yBAAA;EAMA,8DAAA;EACA,2BAAA;EACA,kHAAA;EACA,qCAAA;EACA,uEAAA;EACA,iEAAA;EACA,WAAA;EACA,yCAAA;AJ4zBF;;AI1zBA;;;;;;;;;;;;;;;;;;;;EAoBE,yBAAA;AJ6zBF;;AI3zBA;;;;;;;;EAQE,6BAAA;AJ8zBF;;AI5zBA;;;;EAKE,yBH5R2B;EG6R3B,cHnU2B;EGoU3B,+CAAA;AJ8zBF;;AI5zBA;;;;;;;;;;;;;;;;;;;;EAoBE,yBHpT2B;ADmnC7B;;AI7zBA;;;;;;;;EAQE,6BAAA;AJg0BF;;AI9zBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,eH1N6B;EG2N7B,eAAA;EAGA,kBAAA;AJi0BF;;AI9zBA;;EAEE,gBAAA;AJi0BF;;AI/zBA;;EAEE,gBAAA;EACA,cHzV2B;EG0V3B,eAAA;AJk0BF;;AIh0BA;;;;EAIE,WAAA;EACA,yBH7V2B;ADgqC7B;;AIj0BA;;;;;;;;;;;;;;;;;;;;EAoBG,yBHnX0B;EGoX1B,+CAAA;AJo0BH;;AIl0BA;;;;;;;;EAQE,6BAAA;AJq0BF;;AIn0BA;;EAEE,cHtY2B;AD4sC7B;;AIp0BA;EACE,WAAA;EACA,wBHvT8B;AD8nChC;;AIr0BA;;;;EAIE,eAAA;AJw0BF;;AIp0BI;;EAEI,WAAA;EACA,YAAA;AJu0BR;AIp0BI;EACI,kBAAA;EACA,QAAA;AJs0BR;AIn0BI;EACI,UAAA;AJq0BR;AIl0BI;EACI,WAAA;AJo0BR;;AIh0BA;;;;EAIE,gBAAA;AJm0BF;;AIj0BA;;EAEE,kBAAA;AJo0BF;;AIl0BA;EACE,eAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;AJq0BF;;AIn0BA;;EAEE,eAAA;AJs0BF;;AIp0BA;;EAEE,eAAA;AJu0BF;;AIr0BA;EACE,kBAAA;AJw0BF;;AIt0BA;EAGE,0BAAA;AJy0BF;;AIv0BA;EAGE,0BAAA;AJ00BF;;AIx0BA;EACE,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AJ20BF;;AIx0BA;EACK,kBAAA;EACA,WAAA;AJ20BL;;AQv1CA;;EAEI,iBPMyB;EOLzB,gBPgK4B;EO/J5B,mBPwJ2B;EOvJ3B,mBPqKyB;EOpKzB,gBAAA;EACA,YAAA;EACA,wBPuH4B;EOtH5B,kBAAA;EACA,eAAA;ECRA,yBR0CyB;EQyFrB,cR3HqB;AD41C7B;ASh2CI;;;;;;;;;;;;EAWI,yBR4BqB;EQ3BrB,cRRqB;EQSrB,gBAAA;ATm2CR;ASh2CI;;EACI,2CAAA;ATm2CR;AS51CQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,yBRQiB;EQPjB,qBROiB;AD02C7B;AS9wCI;;EACI,cR7FqB;EQ8FrB,qBR9FqB;AD+2C7B;AS/wCQ;;;;;;;;;;;;EAWI,6BR9GiB;EQ+GjB,cR3GiB;EQ4GjB,qBR5GiB;EQ6GjB,gBAAA;ATkxCZ;AS9wCI;;EACI,cRnHqB;ADo4C7B;AS/wCQ;;;;;;;;;;;;EAWI,6BRnIiB;EQoIjB,cRhIiB;EQiIjB,qBAAA;EACA,gBAAA;ATkxCZ;AQn7CI;;;EFXF,UEauB;EFVvB,0BAAA;EEWM,qBAAA;ARu7CR;AQr7CI;;;;EHjBM,gBGoBD;EACA,qBAAA;ARy7CT;AQt7CI;;EAEI,gBP+GwB;EO9GxB,mBP8GwB;EO7GxB,eP6GwB;EO5GxB,UAAA;EACA,oBP4GwB;EO3GxB,gBAAA;EACA,kBAAA;EACA,mBAAA;ARw7CR;AQt7CQ;;EACI,UAAA;ARy7CZ;AQt7CQ;;EACI,gBPoGoB;EOnGpB,mBPmGoB;EOlGpB,ePkGoB;ADu1ChC;AQv7CY;;;;EAEI,oBP6FgB;AD81ChC;AQv7CQ;;EACI,cP2FoB;EO1FpB,iBP0FoB;EOzFpB,aPyFoB;ADi2ChC;AQx7CY;;;;EAEI,mBPoFgB;ADw2ChC;AQx7CQ;;;EAEI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;AR27CZ;AQt7CI;;EACI,kBAAA;EACA,QAAA;ARy7CR;;AQn7CA;ECjFI,yBR8CyB;EQqFrB,cR3HqB;ADigD7B;ASrgDI;EAWI,yBRgCqB;EQ/BrB,cRRqB;EQSrB,gBAAA;AT6/CR;AS1/CI;EACI,2CAAA;AT4/CR;ASr/CQ;EAMI,yBRYiB;EQXjB,qBRWiB;ADu+C7B;AS/4CI;EACI,cRzFqB;EQ0FrB,qBR1FqB;AD2+C7B;AS/4CQ;EAWI,6BR9GiB;EQ+GjB,cRvGiB;EQwGjB,qBRxGiB;EQyGjB,gBAAA;ATu4CZ;ASn4CI;EACI,cR/GqB;ADo/C7B;ASn4CQ;EAWI,6BRnIiB;EQoIjB,cR5HiB;EQ6HjB,qBAAA;EACA,gBAAA;AT23CZ;;AQt9CA;EClFI,yBRmDyB;EQgFrB,cR3HqB;ADqiD7B;ASziDI;EAWI,yBRqCqB;EQpCrB,cRRqB;EQSrB,gBAAA;ATiiDR;AS9hDI;EACI,2CAAA;ATgiDR;ASzhDQ;EAMI,yBRiBiB;EQhBjB,qBRgBiB;ADsgD7B;ASn7CI;EACI,cRpFqB;EQqFrB,qBRrFqB;AD0gD7B;ASn7CQ;EAWI,6BR9GiB;EQ+GjB,cRlGiB;EQmGjB,qBRnGiB;EQoGjB,gBAAA;AT26CZ;ASv6CI;EACI,cR1GqB;ADmhD7B;ASv6CQ;EAWI,6BRnIiB;EQoIjB,cRvHiB;EQwHjB,qBAAA;EACA,gBAAA;AT+5CZ;;AQz/CA;ECnFI,yBRwDyB;EQ2ErB,cR3HqB;ADykD7B;AS7kDI;EAWI,yBR0CqB;EQzCrB,cRRqB;EQSrB,gBAAA;ATqkDR;ASlkDI;EACI,2CAAA;ATokDR;AS7jDQ;EAMI,yBRsBiB;EQrBjB,qBRqBiB;ADqiD7B;ASv9CI;EACI,cR/EqB;EQgFrB,qBRhFqB;ADyiD7B;ASv9CQ;EAWI,6BR9GiB;EQ+GjB,cR7FiB;EQ8FjB,qBR9FiB;EQ+FjB,gBAAA;AT+8CZ;AS38CI;EACI,cRrGqB;ADkjD7B;AS38CQ;EAWI,6BRnIiB;EQoIjB,cRlHiB;EQmHjB,qBAAA;EACA,gBAAA;ATm8CZ;;AQ5hDA;ECpFI,yBR6DyB;EQsErB,cR3HqB;AD6mD7B;ASjnDI;EAWI,yBR+CqB;EQ9CrB,cRRqB;EQSrB,gBAAA;ATymDR;AStmDI;EACI,2CAAA;ATwmDR;ASjmDQ;EAMI,yBR2BiB;EQ1BjB,qBR0BiB;ADokD7B;AS3/CI;EACI,cR1EqB;EQ2ErB,qBR3EqB;ADwkD7B;AS3/CQ;EAWI,6BR9GiB;EQ+GjB,cRxFiB;EQyFjB,qBRzFiB;EQ0FjB,gBAAA;ATm/CZ;AS/+CI;EACI,cRhGqB;ADilD7B;AS/+CQ;EAWI,6BRnIiB;EQoIjB,cR7GiB;EQ8GjB,qBAAA;EACA,gBAAA;ATu+CZ;;AQ/jDA;ECrFI,yBRkEyB;EQiErB,cR3HqB;ADipD7B;ASrpDI;EAWI,yBRoDqB;EQnDrB,cRRqB;EQSrB,gBAAA;AT6oDR;AS1oDI;EACI,2CAAA;AT4oDR;ASroDQ;EAMI,yBRgCiB;EQ/BjB,qBR+BiB;ADmmD7B;AS/hDI;EACI,cRrEqB;EQsErB,qBRtEqB;ADumD7B;AS/hDQ;EAWI,6BR9GiB;EQ+GjB,cRnFiB;EQoFjB,qBRpFiB;EQqFjB,gBAAA;ATuhDZ;ASnhDI;EACI,cR3FqB;ADgnD7B;ASnhDQ;EAWI,6BRnIiB;EQoIjB,cRxGiB;EQyGjB,qBAAA;EACA,gBAAA;AT2gDZ;;AQlmDA;ECtFI,yBRQyB;EQiCrB,cRKqB;AD+oD7B;ASzrDI;EAWI,yBRPqB;EQQrB,cRRqB;EQSrB,gBAAA;ATirDR;AS9qDI;EACI,2CAAA;ATgrDR;ASzqDQ;EAMI,yBR1BiB;EQ2BjB,qBR3BiB;ADisD7B;AS7pDQ;EACI,cRqBiB;AD0oD7B;AS7pDY;EAGI,yBAAA;AT6pDhB;ASzpDQ;EACI,cRTiB;ADoqD7B;ASzpDY;EAGI,yBAAA;ATypDhB;ASrpDQ;EACI,cRTiB;ADgqD7B;ASrpDY;EAGI,yBAAA;ATqpDhB;ASjpDQ;EACI,cRdiB;ADiqD7B;ASjpDY;EAGI,yBAAA;ATipDhB;AS7oDQ;EACI,cRlCiB;ADirD7B;AS7oDY;EAGI,yBAAA;AT6oDhB;ASzoDQ;EACI,cRrDiB;ADgsD7B;ASzoDY;EAGI,yBAAA;ATyoDhB;ASroDQ;EAWI,yBR3GiB;EQ4GjB,cRrEiB;EQsEjB,gBAAA;AT6nDZ;AS1nDQ;EAEI,yBAAA;AT2nDZ;ASznDY;EACI,gBAAA;AT2nDhB;ASlnDI;EACI,cR/HqB;EQgIrB,qBRhIqB;ADovD7B;ASlnDQ;EAWI,6BR9GiB;EQ+GjB,cR9IiB;EQ+IjB,qBR/IiB;EQgJjB,gBAAA;AT0mDZ;AStmDI;EACI,cRrJqB;AD6vD7B;AStmDQ;EAWI,6BRnIiB;EQoIjB,cRnKiB;EQoKjB,qBAAA;EACA,gBAAA;AT8lDZ;;AQnrDA;EC2FE,cRrI2B;EQsI3B,qBRtI2B;ADkuD7B;AS1lDE;EAWI,6BR1JuB;EQ2JvB,cRnJuB;EQoJvB,qBRpJuB;EQqJvB,gBAAA;ATklDN;;AQ7rDA;EC0FE,cRhI2B;EQiI3B,qBRjI2B;ADwuD7B;ASrmDE;EAWI,6BR1JuB;EQ2JvB,cR9IuB;EQ+IvB,qBR/IuB;EQgJvB,gBAAA;AT6lDN;;AQvsDA;ECyFE,cR3H2B;EQ4H3B,qBR5H2B;AD8uD7B;AShnDE;EAWI,6BR1JuB;EQ2JvB,cRzIuB;EQ0IvB,qBR1IuB;EQ2IvB,gBAAA;ATwmDN;;AQjtDA;ECwFE,cRtH2B;EQuH3B,qBRvH2B;ADovD7B;AS3nDE;EAWI,6BR1JuB;EQ2JvB,cRpIuB;EQqIvB,qBRrIuB;EQsIvB,gBAAA;ATmnDN;;AQ3tDA;ECuFE,cRjH2B;EQkH3B,qBRlH2B;AD0vD7B;AStoDE;EAWI,6BR1JuB;EQ2JvB,cR/HuB;EQgIvB,qBRhIuB;EQiIvB,gBAAA;AT8nDN;;AQruDA;ECsFE,cRzI2B;EQ0I3B,qBR1I2B;AD6xD7B;ASjpDE;EAWI,6BR1JuB;EQ2JvB,cRvJuB;EQwJvB,qBRxJuB;EQyJvB,gBAAA;ATyoDN;;AQ9uDA;EACI,iBP3FyB;EO4FzB,8BAAA;EACA,kBAAA;ARivDJ;AQ/uDI;EACI,kBAAA;ARivDR;;AQ9uDA;EACI,iBPkB4B;EOjB5B,kBAAA;EACA,6BPpEyB;ADqzD7B;;AQxuDQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,6BPnFiB;ADi1D7B;;AQzvDA;EC2EG,cR9C4B;EQ+C5B,sBR7E6B;EQ8E7B,kBAAA;ATkrDH;AShrDG;EACC,kBAAA;ATkrDJ;;AQ/vDA;ECwEG,eR/C4B;EQgD5B,wBR9E6B;EQ+E7B,iBAAA;AT2rDH;ASzrDG;EACC,iBAAA;AT2rDJ;;AQpwDA;EACI,SPnIyB;EOoIzB,sBAAA;EACA,6BPlGyB;ADy2D7B;;AQpwDA;EACI,gBAAA;ARuwDJ;;AQrwDA;EACI,WAAA;ARwwDJ;;AQtwDA;EACI,gBAAA;ARywDJ;;AQvwDA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AR0wDJ;;AQtwDE;EAKE,yBAAA;ARqwDJ;;AQ/vDE;EAKE,yBAAA;AR8vDJ;;AQzvDE;EAKE,yBAAA;ARwvDJ;;AQnvDE;EAKE,yBAAA;ARkvDJ;;AQ7uDE;EAKE,yBAAA;AR4uDJ;;AUp7DG;EACI,cTsCsB;EKzC3B,YKHgD;ELMhD,yBAAA;ANy7DF;;AUt7DG;EACI,cTkCsB;EKzC3B,YKHgD;ELMhD,yBAAA;AN+7DF;;AUx7DG;EACI,cT8BsB;EKzC3B,YKHgD;ELMhD,yBAAA;ANq8DF;;AU17DG;EACI,cT0BsB;EKzC3B,YKHgD;ELMhD,yBAAA;AN28DF;;AW/8DA;EACI,6BVsCyB;EUrCzB,yBAAA;EACA,mBViI2B;EUhI3B,cVayB;EUZzB,YAAA;EACA,mBAAA;EACA,mBVmJ2B;EIlJ3B,oGAAA;EARM,gBMSN;AXu9DJ;AWr9DI;EACI,qBVQqB;AD+8D7B;AWp9DI;EACI,yBAAA;ENhBE,gBMiBF;EACA,qBAAA;EACA,cVFqB;ADy9D7B;AWr9DQ;EAEI,yBAAA;EACA,iBAAA;EACA,6BVciB;ADw8D7B;AWl9DI;EN7BM,gBMiCF;AXk9DR;AW/8DI;EACI,qBAAA;AXi9DR;AW38DQ;EAEI,sBAAA;AX48DZ;AWx8DI;EACI,qBAAA;EACA,cVeqB;EUdrB,0CAAA;AX08DR;AWx8DQ;EACI,yBV/CiB;ADy/D7B;AWt8DI;EACI,sBVkEwB;EUjExB,eV8FuB;EU7FvB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AXw8DR;AWr8DI;EACI,kCAAA;EACA,gCAAA;AXu8DR;;AW77DI;;EACI,6BAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cVrCqB;EUsCrB,eAAA;AXi8DR;AW77DQ;;EACI,eAAA;EACA,SAAA;AXg8DZ;;AW17DI;EACI,gBAAA;EACA,cVrCqB;ADk+D7B;;AUngEQ;;EACI,yBAAA;AVugEZ;AUpgEQ;;EACI,kBAAA;AVugEZ;AUrgEY;;EACI,yBAAA;AVwgEhB;;AUjgEQ;;EACI,kBAAA;AVqgEZ;AUngEY;;EACI,yBAAA;AVsgEhB;AUlgEQ;;EACI,yBAAA;AVqgEZ;AUngEY;;EACI,4BAAA;AVsgEhB;;AU3/DQ;;EACI,kBAAA;AV+/DZ;AU7/DY;;EACI,yBAAA;AVggEhB;AU5/DQ;;EACI,yBAAA;AV+/DZ;;AUz/DQ;;EACI,4BAAA;AV6/DZ;AU3/DY;;EACI,yBAAA;AV8/DhB;AU1/DQ;;EACI,yBAAA;AV6/DZ;AU3/DY;;;EAEI,4BAAA;AV8/DhB;;AWj/DI;;;;EAEI,0CV1FqB;EU2FrB,mBAAA;AXs/DR;AWr/DQ;;;;;;;;;;EAGI,mBAAA;EACA,0CV/FiB;AD6lE7B;AWx/DY;;EACI,0CVtGa;ADimE7B;AWt/DM;;EACI,0CV7GmB;EU8GnB,YAAA;EACA,mCAAA;AXy/DV;AWn/DY;;EACI,0CVrHa;AD2mE7B;;AW/+DI;EACI,cVpFqB;ADskE7B;;AW9+DI;EACI,cVxGqB;ADylE7B;;AW7+DA;EACI,yBVvJyB;EUwJzB,yBAAA;EACA,mBV9B2B;EU+B3B,cV3HyB;EIhCzB,oGAAA;ALgpEJ;AWj/DI;EACE,yBV/JuB;EUgKvB,qBV3HuB;AD8mE7B;AWh/DI;EAEI,yBVtKqB;ADupE7B;AW/+DI;EACI,cV/GqB;ADgmE7B;AW/+DI;EACI,cVjIqB;ADknE7B;AW9+DI;EDxLA,uBAAA;EC2LI,kBAAA;AX++DR;AW5+DI;EACI,WAAA;AX8+DR;;AW1+DA;;EAEI,mBAAA;EACA,kBAAA;AX6+DJ;;AW1+DI;EACI,yBVrLqB;ADkqE7B;;AWv+DE;;EACE,eAAA;AX2+DJ;AWz+DI;;EACE,8BAAA;AX4+DN;AWz+DE;;EACE,+BAAA;EACA,yBAAA;AX4+DJ;AWx+DI;;EACE,8BAAA;AX2+DN;AWz+DI;;EACE,+BAAA;AX4+DN;AWz+DM;;EACE,wBAAA;AX4+DR;;AWt+DA;;;;EAII,oBAAA;AXy+DJ;;AWv+DA;;;;EAII,mBAAA;AX0+DJ;;AWx+DA;EACI,yBVnOyB;EUoOzB,cV9MyB;EU+MzB,mBAAA;AX2+DJ;;AWx+DA;EACI,iBVxPyB;EUyPzB,oBAAA;AX2+DJ;;AWz+DA;EACI,qBV5OyB;ADwtE7B;;AWz+DA;EACI,cAAA;AX4+DJ;;AW1+DA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;AX6+DJ;AW3+DI;EAEI,iBAAA;EACA,gBAAA;EACA,kBAAA;AX4+DR;;AWr+DI;;;EAEI,mBAAA;AXy+DR;;AWr+DA;EACI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AXw+DJ;;AWr+DA;EACI,eAAA;AXw+DJ;;AWp+DA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AXu+DF;;AYhyEA;EACC,mBAAA;EACA,eAAA;AZmyED;;AYhyEA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAKA,6BAAA;AZmyEF;;AYjyEA;EACI,kBAAA;AZoyEJ;;AYjyEA;;EAEE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,6BAAA;EACA,yBAAA;EAKA,+BAAA;AZoyEF;;AYjyEC;EACC,6BAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,cXP2B;EWQ3B,SAAA;EACA,yBAAA;AZoyEF;;AYjyEA;;EAEI,cXhCyB;EWiCzB,YAAA;EACA,mBAAA;AZoyEJ;;AYjyEA;;EAEE,UAAA;EACA,kBAAA;EACA,kBAAA;AZoyEF;;AYlyEA;EACE,UAAA;AZqyEF;;AYlyEA;;EAEI,mBAAA;AZqyEJ;;AYlyEA;;EAEI,oBAAA;AZqyEJ;;AYlyEA;;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EAKA,+BAAA;AZqyEF;;AYlyEA;;EAEI,UAAA;AZqyEJ;;AYnyEA;EACI,UAAA;EACA,WAAA;EACA,yBXjEyB;EWkEzB,qBXlEyB;EWmEzB,SAAA;EACA,UAAA;EACA,UAAA;AZsyEJ;;AYnyEA;EACI,UAAA;AZsyEJ;;AYnyEA;EACE,cX/F2B;ADq4E7B;;AYnyEA;;EAEE,cXpG2B;AD04E7B;;Aaj6EA;EACI,kBAAA;Abo6EJ;Aal6EI;EAEI,gBZkHuB;ADizE/B;Aaj6EI;EACI,cZmCqB;EYlCrB,mBZkJuB;EYjJvB,yBAAA;Abm6ER;Aa/5EI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCZSqB;EYRrB,gBAAA;Abi6ER;Aa/5EQ;EACI,gBAAA;EACA,yBZoBiB;AD64E7B;Aa95EQ;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,cZaiB;EYZjB,mBZ4HmB;ADoyE/B;Aa35EQ;EACI,oCAAA;Ab65EZ;Aa15EQ;EACI,mBZ/BiB;AD27E7B;Aaz5EQ;;EAEI,cZrCiB;ADg8E7B;Aat5EQ;EACI,kCZHiB;AD25E7B;Aar5EQ;EACI,mBZTiB;ADg6E7B;Aap5EQ;;EAEI,cZdiB;ADo6E7B;Aaj5EQ;EACI,mCZRiB;AD25E7B;Aah5EQ;EACI,mBZdiB;ADg6E7B;Aa/4EQ;;EAEI,cZnBiB;ADo6E7B;Aa54EQ;EACI,kCZ5BiB;AD06E7B;Aa34EQ;EACI,mBZlCiB;AD+6E7B;Aa14EQ;;EAEI,cZvCiB;ADm7E7B;Aav4EQ;EACI,mCZjCiB;AD06E7B;Aat4EQ;EACI,mBZvCiB;AD+6E7B;Aar4EQ;;EAEI,cZ5CiB;ADm7E7B;Aal4EQ;EACI,kCZ3CiB;AD+6E7B;Aaj4EQ;EACI,mBZjDiB;ADo7E7B;Aah4EQ;;EAEI,cZtDiB;ADw7E7B;;Ac5/EA,iCAAA;AACA;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBbsJ2B;EarJ3B,iBAAA;EACA,6BbkCyB;EajCzB,iBbqH4B;EapH5B,kBAAA;EACA,cAAA;EACA,uBbsH4B;ADy4EhC;Ac7/EI;EAEE,qBAAA;Ad8/EN;;Ac1/EA;EACI,qBAAA;Ad6/EJ;Ac5/EI;EACG,gBAAA;Ad8/EP;;AelhFI;EAGE,qBduCuB;EctCvB,yBdsCuB;EcrCvB,cdGuB;ADghF7B;;AexhFI;EAGE,qBd2CuB;Ec1CvB,yBd0CuB;EczCvB,cdGuB;ADshF7B;;Ae9hFI;EAGE,qBdqDuB;EcpDvB,yBdoDuB;EcnDvB,cdGuB;AD4hF7B;;AepiFI;EAGE,qBdgDuB;Ec/CvB,yBd+CuB;Ec9CvB,cdGuB;ADkiF7B;;Ae1iFI;EAGE,qBd0DuB;EczDvB,yBdyDuB;EcxDvB,cdGuB;ADwiF7B;;AehjFI;EAGE,qBd+DuB;Ec9DvB,yBd8DuB;Ec7DvB,cdGuB;AD8iF7B;;Ac7gFA;EAEI,yBAAA;Ad+gFJ;Ae1jFI;EAGE,qBdKuB;EcJvB,yBdIuB;EcHvB,cdGuB;ADujF7B;;AgB/jFI;EACI,SAAA;EACA,8BAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cfMqB;EeLrB,eAAA;EACA,ef8IuB;Ee7IvB,yBAAA;EACA,uBAAA;AhBkkFR;AgBhkFQ;EAEI,cfFiB;EeGjB,0CfIiB;EeHjB,YAAA;AhBikFZ;AgB7jFI;;EAEI,kBAAA;AhB+jFR;AgB5jFI;EACI,QAAA;AhB8jFR;AgB3jFI;EACI,OAAA;AhB6jFR;AgB1jFI;EACI,cfnBqB;EeoBrB,+CAAA;AhB4jFR;AgB1jFQ;EAGI,yBfHiB;EeIjB,qBfJiB;EeKjB,cfvCiB;ADimF7B;AgBtjFI;EACI,YAAA;EACA,0CAAA;EACA,cf9CqB;ADsmF7B;AgBljFY;EAGI,yBfPa;EeQb,qBfRa;AD0jF7B;AgB3iFY;EAGI,yBfvBa;EewBb,qBfxBa;ADmkF7B;AgBpiFY;EAGI,yBfvCa;EewCb,qBfxCa;AD4kF7B;AgB7hFY;EAGI,yBfnCa;EeoCb,qBfpCa;ADikF7B;AgBthFY;EAGI,yBfzCa;Ee0Cb,qBf1Ca;ADgkF7B;AgBhhFQ;EACI,cf3GiB;AD6nF7B;AgBhhFY;EAEI,0CflFa;EemFb,cfhHa;ADioF7B;AgB5gFY;EAGI,yBfvHa;EewHb,qBfxHa;EeyHb,cfpFa;ADgmF7B;;AgBrgFA;EACI,aAAA;EACA,mBAAA;AhBwgFJ;;AiBrpFA;;;;;EAKI,8DhBDyB;ADypF7B;;AiBtpFA;EACI,gBhB2J4B;AD8/EhC;;AiBtpFA;EACI,cAAA;AjBypFJ;;AiBtpFA;EACI,chBgCyB;ADynF7B;AiBxpFI;EAEI,chB6BqB;AD4nF7B;;AiBtpFA;EACI,gBhB2H2B;EgB1H3B,iBAAA;EACA,mBAAA;AjBypFJ;AiBvpFI;EACI,gBhByIwB;EgBxIxB,yBAAA;EACA,YAAA;AjBypFR;;AiBtpFA;EACI,gBhBiH2B;EgBhH3B,mBAAA;AjBypFJ;;AiBvpFA;EACI,kBhB8G2B;EgB7G3B,mBAAA;EACA,kBAAA;AjB0pFJ;;AiBxpFA;EACI,gBhB0G2B;EgBzG3B,mBAAA;EACA,gBAAA;EACA,mBhB0E2B;ADilF/B;AiBzpFI;EAEI,gBAAA;AjB0pFR;;AiBvpFA;EACI,gBhBgG2B;EgB/F3B,kBAAA;EACA,mBAAA;AjB0pFJ;AiBxpFI;EACI,gBAAA;AjB0pFR;;AiBvpFA;EACI,gBhBwF2B;EgBvF3B,gBhBqG4B;EgBpG5B,yBAAA;AjB0pFJ;;AiBxpFA;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;AjB2pFJ;;AiBxpFA;EACI,gBhB2F4B;EgB1F5B,iBAAA;AjB2pFJ;AiBxpFI;EACI,yBAAA;AjB0pFR;AiBxpFQ;EACI,chB/DiB;EgBgEjB,qBAAA;AjB0pFZ;AiBvpFI;EACI,iBAAA;AjBypFR;;AiBrpFA;;;EAGI,chBtEyB;EgBuEzB,gBhBmE4B;ADqlFhC;;AiBtpFA;EACI,0BAAA;EACA,gBhBkE4B;EgBjE5B,chB5EyB;ADquF7B;;AiBvpFA;EACE,yBAAA;AjB0pFF;;AiBxpFA;EACE,yBAAA;AjB2pFF;;AiBzpFA;EACE,yBAAA;AjB4pFF;;AiB1pFA;EACE,yBAAA;AjB6pFF;;AiB3pFA;EACE,yBAAA;AjB8pFF;;AiB5pFA;EACE,WhBvG2B;ADswF7B;;AiB5pFA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBhBmC2B;EgBlC3B,gBAAA;AjB+pFJ;AiB7pFI;EACI,chBrFqB;EgBsFrB,mBhB0BuB;EgBzBvB,yBAAA;AjB+pFR;AiB5pFI;EACI,qBhBvFqB;EgBwFrB,chBxFqB;ADsvF7B;AiB5pFQ;EACI,chB3FiB;ADyvF7B;AiB1pFI;EACI,qBhB5EqB;EgB6ErB,chB7EqB;ADyuF7B;AiB1pFQ;EACI,chBhFiB;AD4uF7B;AiBxpFI;EACI,sChBzHqB;EgB0HrB,chBhJqB;AD0yF7B;AiBxpFQ;EACI,+BhB7HiB;ADuxF7B;;AkBvzFA;EACI,cjBkByB;EiBjBzB,ejB2J2B;EiB1J3B,8DjBCyB;EiBAzB,kBAAA;EACA,kCAAA;EACA,mCAAA;AlB0zFJ;;AkBvzFA;EACI,kBAAA;EACA,mBjBDyB;AD2zF7B;;AkBxzFA,eAAA;AACA;;;;;;EbKI,6BAAA;ALg0FJ;;AkB3zFA;;EbLI,6BAAA;ALy0FJ;;AkB/zFA;;EbFI,mCAAA;AL00FJ;;AkBn0FA;;EbHI,gEAAA;EAGA,yBAAA;AL20FJ;;AkBt0FA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBjBlCyB;AD22F7B;AkBv0FI;EACI,eAAA;AlBy0FR;AkBt0FI;EACI,WAAA;AlBw0FR;;AkBp0FA;EACI,WAAA;EACA,WAAA;EACA,yBjBfyB;EiBgBzB,iBAAA;AlBu0FJ;AkBr0FI;EACI,yBjBfqB;ADs1F7B;;AkBn0FA;EACI,YAAA;EACA,cAAA;AlBs0FJ;;AkBn0FA;EACE,WAAA;AlBs0FF;;AkBp0FA;EACE,YAAA;AlBu0FF;;AkBp0FA;EACE,yBAAA;AlBu0FF;;AmBp5FM;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AnBu5FR;AmBr5FQ;EACE,iBAAA;AnBu5FV;AmBj5FQ;EACI,kBAAA;AnBm5FZ;AmB94FQ;EACE,kBAAA;EACA,0ClBFmB;EkBGnB,gBAAA;EACA,gBlBqIsB;EkBpItB,kBAAA;EACA,WlBjBmB;ADi6F7B;AmB74FY;EACI,0ClBVa;ADy5F7B;AmB34FgB;EAGI,yBlBnBS;EkBoBT,clBlCS;EkBmCT,+CAAA;AnB24FpB;AmBv4FY;EAGI,YAAA;AnBu4FhB;AmBn4FQ;EACI,cAAA;EACA,iBAAA;EACA,eAAA;AnBq4FZ;AmB/3FY;EACI,0ClB3Ba;EkB4Bb,clBzDa;AD07F7B;AmB93FoB;EAGI,yBlB/DK;EkBgEL,clB1BK;ADw5F7B;AmBp3FgB;EAGI,yBlBvCS;AD25F7B;AmB32FgB;EAGI,yBlBzCS;ADo5F7B;AmBl2FgB;EAGI,yBlB1DS;AD45F7B;AmBz1FgB;EAGI,yBlB5DS;ADq5F7B;AmBh1FgB;EAGI,yBlBnES;ADm5F7B;;AmB10FA;EACI,wBAAA;AnB60FJ;;AmB10FA;EACI,kBAAA;AnB60FJ;AmB30FI;EACI,oBAAA;AnB60FR;;AoBl+FA;;;;;;kCAAA;AAQA;EACE,6BAAA;EACA,4CAAA;EACA,qPAAA;EAIA,mBAAA;EACA,kBAAA;ApBi+FF;AoB99FA;;0BAAA;AAIA;EACE,qBAAA;EACA,kDAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;ApB+9FF;;AoB59FA;;0BAAA;AAIA;;oCAAA;AAIA;EACE,qBAAA;EACA,oBAAA;EACA,sBAAA;ApB69FF;;AoB19FA;EACE,kBAAA;ApB69FF;;AoB19FA;;0BAAA;AAIA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;ApB49FF;;AoBz9FA;EACE,kBAAA;ApB49FF;;AoBz9FA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;ApB49FF;;AoBz9FA;EACE,kBAAA;EACA,kBAAA;ApB49FF;;AoBz9FA;;0BAAA;AAIA;EAGE,0CAAA;ApB29FF;AoBp8FA;EACE;IAKE,uBAAA;EpBu9FF;EoBp9FA;IAKE,yBAAA;EpBs9FF;AACF;AoBn9FA;;0BAAA;AAIA;;0BAAA;AAIA;EACI,gBAAA;ApBm9FJ;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACE,gBAAA;ApBm9FF;;AoBh9FA;EACI,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;ApBm9FJ;;AoBh9FA;EACI,eAAA;ApBm9FJ;;AoBh9FA;EACI,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;ApBm9FJ;;AqB3/GA;EACI,SAAA;EACA,oBAAA;ArB8/GJ;AqB5/GI;EACI,+CAAA;ArB8/GR;AqB3/GI;EACI,kCpBoHwB;EoBnHxB,iCpBmHwB;AD04GhC;AqBz/GQ;EACI,cpB2BiB;EoB1BjB,SAAA;EACA,iBAAA;EACA,6BpBqBiB;EoBpBjB,6BAAA;EACA,mBAAA;EACA,epBsImB;EoBrInB,kBAAA;EACA,gBpB8IiB;AD62G7B;AqBz/GY;EACI,6BpBaa;AD8+G7B;AqBx/GY;EACI,sBpBjBa;EoBkBb,mBAAA;EACA,cpBxBa;ADkhH7B;AqBv/GY;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;ArBy/GhB;AqBr/GQ;EAEI,+BAAA;ArBs/GZ;AqBh/GY;EACI,cpB5Ca;AD8hH7B;AqBh/GgB;EACI,0CpBlBS;EoBmBT,cpBhDS;ADkiH7B;AqBz+GgB;EACI,yBpBpBS;AD+/G7B;AqBl+GgB;EACI,yBpBpBS;ADw/G7B;AqB39GgB;EACI,yBpBpBS;ADi/G7B;AqBp9GgB;EACI,yBpBnCS;ADy/G7B;AqB78GgB;EACI,yBpBvDS;ADsgH7B;;AsB3jHA;EACI,qBrB2M6B;EqB1M7B,wBrB0M6B;EqBzM7B,gBAAA;EACA,mBAAA;EACA,gDAAA;AtB8jHJ;AsB5jHI;EACI,sBAAA;AtB8jHR;AsB5jHQ;EACI,crBDiB;AD+jH7B;AsB1jHI;EACI,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AtB4jHR;AsBxjHQ;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;AtB0jHZ;AsBvjHQ;EACI,kBAAA;AtByjHZ;AsBvjHY;EACI,kBAAA;AtByjHhB;AsBtjHY;EACI,iBAAA;AtBwjHhB;AsBpjHQ;EACI,yBAAA;EACA,mBrB4GmB;EqB3GnB,sBAAA;EACA,qBrBuHiB;AD+7G7B;AsBpjHY;;EAEI,gBAAA;AtBsjHhB;AsBnjHY;;EAEI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AtBqjHhB;AsBljHY;EACI,QAAA;EACA,eAAA;AtBojHhB;AsBhjHgB;EACI,WAAA;EACA,YAAA;AtBkjHpB;AsB9iHY;EACI,YAAA;EACA,crBrEa;ADqnH7B;AsB5iHQ;;;;EAII,0CrBhDiB;EqBiDjB,wBrBuCoB;ADugHhC;AsB1iHI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AtB4iHR;AsBziHI;EACI,yBAAA;EACA,mBrBqDuB;EqBpDvB,mBrBLuB;EqBMvB,sBrBNuB;EqBOvB,qBrB8DqB;AD6+G7B;AsBxiHI;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AtB0iHR;AsBxiHQ;EACI,kBAAA;EACA,OAAA;EACA,eAAA;AtB0iHZ;AsBviHQ;EACE,WAAA;EACA,6BAAA;AtByiHV;AsBriHY;EACI,WAAA;AtBuiHhB;AsBjiHQ;EACI,WAAA;AtBmiHZ;AsB/hHI;EACI,wCAAA;EACA,gBAAA;EACA,crBpIqB;EqBqIrB,4BAAA;AtBiiHR;AsB7hHQ;EACI,crBxGiB;ADuoH7B;AsB7hHY;EACI,YAAA;EACA,crB5Ga;AD2oH7B;AsB3hHQ;EACI,mBrBjHiB;AD8oH7B;AsB1hHQ;;;;EAII,0CrB1IiB;ADsqH7B;AsBzhHQ;EACI,yBAAA;AtB2hHZ;;AsBthHA;EACI,oCAAA;AtByhHJ;;AsBthHA;EACI,oCAAA;AtByhHJ;;AsBthHA;EACI,oCAAA;AtByhHJ;;AsBthHA;EACI,oCAAA;AtByhHJ;;AsBthHA;EACI,oCAAA;AtByhHJ;;AsBthHA;EACI,oCAAA;AtByhHJ;;AsBthHA;EACI,oCAAA;AtByhHJ;;AuB/tHA;EACI,SAAA;EACA,gDAAA;EACA,uBtB2H4B;EI3G5B,4BAAA;EkBdA,etBwJ2B;AD8kH/B;AuBnuHQ;EACI,UAAA;EACA,WAAA;AvBquHZ;AuBjuHI;ElB4CG,8CAAA;EkB1CC,kBAAA;EACA,cAAA;EjBdN,UiBeuB;EjBZvB,wBAAA;EiBaM,oBAAA;AvBwuHR;AuBruHI;EjBnBF,UiBqBuB;EjBlBvB,0BAAA;EiBmBM,mBAAA;ElBiCD,4CAAA;AL2sHP;AuBxuHI;EAEE,mBtB6HyB;EsB5HzB,mBAAA;EACA,sBAAA;EACA,eAAA;ElBfF,4BAAA;EkBiBE,aAAA;AvB6uHN;AuB3uHM;EAEE,0CtBdqB;AD0vH7B;AuBzuHM;EAEE,+BtBCqB;ADyuH7B;AuBxuHQ;EAEE,6BAAA;AvByuHV;AuBpuHI;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,ctBtDqB;EsBuDrB,0BAAA;EACA,qCAAA;EACA,oCAAA;AvBsuHR;AuBnuHI;EACI,0CtB5CqB;ADixH7B;AuBluHI;EACI,+BtB7BqB;EsB8BrB,mBtB+EuB;EsB9EvB,yBAAA;EACA,gBtBuFwB;AD6oHhC;AuBjuHI;EChFA,yBDiF6B;AvBmuHjC;AwBlzHI;EACI,cD8EyB;AvBsuHjC;AwBjzHI;EACI,+BvBwBqB;AD2xH7B;AwBhzHI;EACI,cvBFqB;ADozH7B;AwBhzHQ;EAEI,0CvBuBiB;AD0xH7B;AwB7yHI;EACI,0CvBkBqB;AD6xH7B;AuB/uHI;ECpFA,yBDqF6B;AvBivHjC;AwBp0HI;EACI,cDkFyB;AvBovHjC;AwBn0HI;EACI,+BvBwBqB;AD6yH7B;AwBl0HI;EACI,cvBFqB;ADs0H7B;AwBl0HQ;EAEI,0CvBuBiB;AD4yH7B;AwB/zHI;EACI,0CvBkBqB;AD+yH7B;AuB7vHI;ECxFA,yBDyF6B;AvB+vHjC;AwBt1HI;EACI,cDsFyB;AvBkwHjC;AwBr1HI;EACI,+BvBwBqB;AD+zH7B;AwBp1HI;EACI,cvBFqB;ADw1H7B;AwBp1HQ;EAEI,0CvBuBiB;AD8zH7B;AwBj1HI;EACI,0CvBkBqB;ADi0H7B;AuB3wHI;EC5FA,yBD6F6B;AvB6wHjC;AwBx2HI;EACI,cD0FyB;AvBgxHjC;AwBv2HI;EACI,+BvBwBqB;ADi1H7B;AwBt2HI;EACI,cvBFqB;AD02H7B;AwBt2HQ;EAEI,0CvBuBiB;ADg1H7B;AwBn2HI;EACI,0CvBkBqB;ADm1H7B;AuBzxHI;EChGA,yBDiG6B;AvB2xHjC;AwB13HI;EACI,cD8FyB;AvB8xHjC;AwBz3HI;EACI,+BvBwBqB;ADm2H7B;AwBx3HI;EACI,cvBFqB;AD43H7B;AwBx3HQ;EAEI,0CvBuBiB;ADk2H7B;AwBr3HI;EACI,0CvBkBqB;ADq2H7B;;AuBvyHA;EACI,qBtBF2B;EsBG3B,eAAA;AvB0yHJ;AuBxyHI;EACI,mBtBPuB;EsBQvB,sBtBRuB;EsBSvB,cAAA;AvB0yHR;AuBxyHQ;EACI,aAAA;AvB0yHZ;;AyBx5HA;EACI,SAAA;EACA,gBAAA;EACA,cxBMyB;EwBLzB,mBAAA;EACA,sBAAA;AzB25HJ;AyBz5HI;EACE,cxBCuB;EwBAvB,YAAA;AzB25HN;AyBx5HI;EACI,wCxB0CqB;ADg3H7B;AyBv5HI;EACI,wCxBqDqB;ADo2H7B;AyBt5HI;EACI,yCxB4CqB;AD42H7B;AyBr5HI;EACI,yCxBmCqB;ADo3H7B;AyBp5HI;EACI,wCxBqBqB;ADi4H7B;AyBn5HI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AzBq5HR;AyBl5HI;EACI,yBAAA;EACA,eAAA;AzBo5HR;AyBj5HI;;EAEI,eAAA;AzBm5HR;AyBh5HI;EACI,cxBzCqB;EwB0CrB,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;AzBk5HR;;A0B38HA;EACI,eAAA;EACA,kBAAA;A1B88HJ;;A0B58HA;EACI,gDzB6KuB;ADkyH3B;;A2Bp9HA;EACI,e1B4J2B;E0B3J3B,gDAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;A3Bu9HJ;A2Br9HI;EAII,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;A3Bo9HR;A2Bj9HI;EACI,+B1B4BqB;E0B3BrB,e1B0IuB;E0BzIvB,0BAAA;EACA,gB1B+IwB;E0B9IxB,SAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;A3Bm9HR;A2Bh9HI;EACI,aAAA;A3Bk9HR;A2B/8HI;EACI,4B1BvBqB;E0BwBrB,SAAA;A3Bi9HR;A2B98HI;ECpCA,yB3B+CyB;ADs8H7B;A4Bn/HI;EACI,c3BMqB;AD++H7B;A4Bj/HI;EACI,2B3BuCqB;AD48H7B;A4Bh/HI;EACI,yB3BmCqB;AD+8H7B;A4B/+HI;EACI,4B3B+BqB;ADk9H7B;A4B9+HI;EACI,0B3B2BqB;ADq9H7B;A4B7+HI;EACI,c3BfqB;E2BgBrB,YAAA;A5B++HR;A2Bh+HI;ECxCA,yB3ByDyB;ADk9H7B;A4BzgII;EACI,c3BMqB;ADqgI7B;A4BvgII;EACI,2B3BiDqB;ADw9H7B;A4BtgII;EACI,yB3B6CqB;AD29H7B;A4BrgII;EACI,4B3ByCqB;AD89H7B;A4BpgII;EACI,0B3BqCqB;ADi+H7B;A4BngII;EACI,c3BfqB;E2BgBrB,YAAA;A5BqgIR;A2Bl/HI;EC5CA,yB3B8DyB;ADm+H7B;A4B/hII;EACI,c3BMqB;AD2hI7B;A4B7hII;EACI,2B3BsDqB;ADy+H7B;A4B5hII;EACI,yB3BkDqB;AD4+H7B;A4B3hII;EACI,4B3B8CqB;AD++H7B;A4B1hII;EACI,0B3B0CqB;ADk/H7B;A4BzhII;EACI,c3BfqB;E2BgBrB,YAAA;A5B2hIR;A2BpgII;EChDA,yB3BmEyB;ADo/H7B;A4BrjII;EACI,c3BMqB;ADijI7B;A4BnjII;EACI,2B3B2DqB;AD0/H7B;A4BljII;EACI,yB3BuDqB;AD6/H7B;A4BjjII;EACI,4B3BmDqB;ADggI7B;A4BhjII;EACI,0B3B+CqB;ADmgI7B;A4B/iII;EACI,c3BfqB;E2BgBrB,YAAA;A5BijIR;A2BthII;ECpDA,yB3BoDyB;ADyhI7B;A4B3kII;EACI,c3BMqB;ADukI7B;A4BzkII;EACI,2B3B4CqB;AD+hI7B;A4BxkII;EACI,yB3BwCqB;ADkiI7B;A4BvkII;EACI,4B3BoCqB;ADqiI7B;A4BtkII;EACI,0B3BgCqB;ADwiI7B;A4BrkII;EACI,c3BfqB;E2BgBrB,YAAA;A5BukIR;;A2BriII;EACI,2B1BnDqB;AD2lI7B;A2BriII;EACI,yB1BvDqB;AD8lI7B;A2BpiII;EACI,4B1B3DqB;ADimI7B;A2BniII;EACI,0B1B/DqB;ADomI7B;;A2BjiIA;EACI,sBAAA;EACA,gBAAA;EACA,yB1BtEyB;E0BuEzB,e1B4E2B;E0B3E3B,cAAA;EACA,+CAAA;A3BoiIJ;;A6BnnIA;EAEE,wB5ByH8B;E4BxH9B,YAAA;EACA,gDAAA;A7BqnIF;A6BlnIE;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;A7BonIJ;A6BlnII;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;A7BonIR;A6BlnII;EACI,eAAA;EACA,gBAAA;A7BonIR;A6B/mIE;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;A7BinIJ;A6B9mIE;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA,EACA,gBAAA;EACA,8BAAA;A7BgnIJ;A6B9mII;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;A7BgnIN;A6B/mIM;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A7BinIR;A6B5mIE;EACE,cAAA;A7B8mIJ;;A6B3mIA;EACE,8BAAA;A7B8mIF;;A6BxmIQ;EACI,kBAAA;A7B2mIZ;A6BxmIQ;EACI,gBAAA;EACA,cAAA;A7B0mIZ;A6BvmIQ;EACI,WAAA;EACA,YAAA;EACA,yB5B1EiB;E4B2EjB,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;A7BymIZ;A6BvmIY;EACI,c5B3Ca;E4B4Cb,eAAA;A7BymIhB;A6BrmIgB;EACI,c5BvFS;AD8rI7B;A6BnmIY;EACI,yB5BtDa;AD2pI7B;A6BlmIY;EACI,yB5BtCa;AD0oI7B;A6BjmIY;EACI,yB5B/Ca;ADkpI7B;A6BhmIY;EACI,yB5B7Da;AD+pI7B;A6B/lIY;EACI,yB5B5Da;AD6pI7B;A6B5lIY;EACI,yBAAA;A7B8lIhB;A6B5lIgB;EACI,YAAA;A7B8lIpB;A8B5tII;EACI,yB7BQqB;E6BPrB,c7BgBqB;AD8sI7B;A8B3tII;EACI,c7BYqB;ADitI7B;A8BnuII;EACI,yB7B8CqB;E6B7CrB,c7BOqB;AD8tI7B;A8BluII;EACI,c7BGqB;ADiuI7B;A8B1uII;EACI,yB7BkEqB;E6BjErB,c7BOqB;ADquI7B;A8BzuII;EACI,c7BGqB;ADwuI7B;A8BjvII;EACI,yB7B6DqB;E6B5DrB,c7BOqB;AD4uI7B;A8BhvII;EACI,c7BGqB;AD+uI7B;A8BxvII;EACI,yB7BmDqB;E6BlDrB,c7BOqB;ADmvI7B;A8BvvII;EACI,c7BGqB;ADsvI7B;A8B/vII;EACI,yB7BwDqB;E6BvDrB,c7BOqB;AD0vI7B;A8B9vII;EACI,c7BGqB;AD6vI7B;A6B1mII;EAGI,4BAAA;A7B4mIR;A6BzmII;EACI,c5BhGqB;E4BiGrB,iBAAA;A7B2mIR;A6BzmIQ;EAEI,UAAA;A7B0mIZ;;A+BlxIA;;;EAGI,cAAA;A/BqxIJ;;A+BjxII;EACI,gD9ByKmB;E8BxKnB,wB9BqHwB;AD+pIhC;A+BjxII;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;A/BmxIR;;AgCnyIA;EACI,eAAA;AhCsyIJ;AgCpyII;EACI,yBAAA;AhCsyIR;AgCnyII;EACI,qBAAA;EACA,WAAA;AhCqyIR;AgClyII;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;AhCoyIR;AgClyIQ;EACI,qBAAA;AhCoyIZ;AgClyIY;EACI,cAAA;EACA,e/B6Ee;E+B5Ef,mB/BqIe;E+BpIf,yBAAA;EACA,qBAAA;AhCoyIhB;AgClyIgB;EACI,qBAAA;AhCoyIpB;AgC9xII;EACI,mB/ByHuB;ADuqI/B;AgC7xII;EACI,cAAA;EACA,WAAA;EACA,YAAA;AhC+xIR;;AiCx0IA;EACE,SAAA;EACA,wBhC6H8B;EgC5H9B,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,+CAAA;AjC20IF;AiCz0IE;EACE,6BhC+ByB;EgC9BzB,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;AjC20IJ;AiCx0IE;EACE,UAAA;EACA,gBAAA;EACA,6BhCqByB;EgCpBzB,SAAA;AjC00IJ;AiCv0IE;EACI,yBhCuBuB;ADkzI7B;AiCt0IE;EACI,yBhCuCuB;ADiyI7B;AiCr0IE;EACI,yBhC8BuB;ADyyI7B;AiCp0IE;EACI,yBhCqBuB;ADizI7B;AiCn0IE;EACI,yBAAA;AjCq0IN;;AkC92IA;EACI,uBAAA;EACA,gBAAA;AlCi3IJ;AkC/2II;;EAEI,iBAAA;EACA,kBAAA;AlCi3IR;AkC92II;EACI,WAAA;EACA,OAAA;AlCg3IR;;AmC53IA;EACI,gBAAA;EACA,cAAA;AnC+3IJ;AmC73II;EACE,cAAA;EACA,eAAA;AnC+3IN;AmC53II;EACE,gBAAA;EACA,mBAAA;AnC83IN;AmC33II;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AnC63IN;AmC13II;EACI,gBAAA;EACA,mBAAA;EACA,gBAAA;AnC43IR;AmCz3II;;EAEI,gBAAA;AnC23IR;AmCz3IQ;;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;AnC43IZ;AmCx3II;EACI,gBAAA;EACA,mBAAA;AnC03IR;AmCv3II;EACI,gBAAA;EACA,kBAAA;AnCy3IR;AmCv3IQ;;EAEI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,+CAAA;AnCy3IZ;;AoC36II;EACI,aAAA;ApC86IR;AoC36IY;EACI,QAAA;ApC66IhB;AoCz6IQ;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;ApC26IZ;;AoCr6II;EACI,aAAA;EACA,kBAAA;ApCw6IR;AoCt6IQ;EACI,iBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;ApCw6IZ;AoCr6IQ;EACI,iBAAA;ApCu6IZ;AoCr6IQ;EACI,gBAAA;ApCu6IZ;AoCr6IQ;EACI,cnC/BiB;ADs8I7B;AoCl6IQ;EACI,gBAAA;ApCo6IZ;AoCj6IQ;EACI,mBAAA;ApCm6IZ;AoC95IQ;EACI,mBAAA;ApCg6IZ;AoC75IQ;EACI,mBAAA;ApC+5IZ;AoC55IQ;;;EAGI,eAAA;ApC85IZ;AoC35IQ;EACI,cAAA;ApC65IZ;AoC15IQ;EACI,gBAAA;ApC45IZ;;AoCp5II;EACI,iBAAA;ApCu5IR;AoCp5II;EACI,cAAA;ApCs5IR;AoCp5II;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gDAAA;ApCs5IR;AoCn5II;EACI,kBAAA;EACA,gBAAA;ApCq5IR;AoCl5II;;EAEI,kBAAA;ApCo5IR;AoCj5II;EACI,gBAAA;EACA,sBAAA;ApCm5IR;AoCh5II;EACI,gBAAA;ApCk5IR;AoC/4II;EACI,gBAAA;EACA,cAAA;ApCi5IR;AoC/4IQ;EACI,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ApCi5IZ;AoC/4IY;EACI,mBAAA;ApCi5IhB;AoC54II;EACI,kBAAA;EACA,kBAAA;ApC84IR;AoC14IQ;EACI,mBAAA;ApC44IZ;AoCx4II;EACI,gBAAA;EACA,oBAAA;ApC04IR;;AoCp4II;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;ApCs4IR;AoCn4II;EACI,oCAAA;ApCq4IR;AoCh4IQ;EC3KJ,qCD4KiC,EC5KZ,+CAAA,EACrB,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,qFAAA,EAAA,oBAAA;ArC8iJJ;AoCh4II;EACI,YAAA;ApCk4IR;AoC/3II;;EAEI,kBAAA;EACA,UAAA;ApCi4IR;AoC93II;EACI,8BAAA;ApCg4IR;AoC73II;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;ApC+3IR;AoC33II;;;EAGI,cnCvMqB;ADokJ7B;;AoCt3IE;;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,oCAAA;ApC03IJ;;AoCl3II;EACI,sBnC1GwB;EmC2GxB,sBnCvIuB;EmCwIvB,gBAAA;ApCq3IR;AoCn3IQ;EACI,gBAAA;ApCq3IZ;AoCl3IQ;EACI,WAAA;EACA,cAAA;EACA,mBAAA;ApCo3IZ;AoCl3IY;EACI,WAAA;ApCo3IhB;AoCh3IQ;EACI,mBAAA;ApCk3IZ;AU1mJG;EACI,cA+G+B;EJlHpC,UIkHyD;EJ/GzD,0BAAA;AN8mJF;AU3mJG;EACI,cA2G+B;EJlHpC,UIkHyD;EJ/GzD,0BAAA;ANmnJF;AU5mJG;EACI,cAuG+B;EJlHpC,UIkHyD;EJ/GzD,0BAAA;ANwnJF;AU7mJG;EACI,cAmG+B;EJlHpC,UIkHyD;EJ/GzD,0BAAA;AN6nJF;AU5gJI;EACI,sCTzFqB;ES0FrB,cT/GqB;AD6nJ7B;AU5gJQ;EACI,qBTlHiB;ESmHjB,6BTpFiB;ESqFjB,cTpHiB;ADkoJ7B;AUxgJQ;;EACI,cT3HiB;ADsoJ7B;AUtgJQ;EACI,6BTlGiB;AD0mJ7B;AUpgJI;EACI,6BTvGqB;ESwGrB,sCTlHqB;ESmHrB,cTxIqB;AD8oJ7B;AUlgJQ;EACI,6BT9GiB;ES+GjB,qBT9IiB;ES+IjB,cT/IiB;ADmpJ7B;AU9/IQ;;EACI,0CT1HiB;ES2HjB,cTvJiB;ADwpJ7B;AU//IY;;;;EAGI,0CT/Ha;ESgIb,cT7Ja;AD+pJ7B;AU9/IQ;;EACI,0CTtIiB;ADuoJ7B;AU//IY;;;;EAGI,0CT1Ia;ES2Ib,cTxKa;AD0qJ7B;AU5/IgB;;EACI,0CTlJS;ESmJT,cThLS;AD+qJ7B;AU1/IQ;;EACI,0CT1JiB;ES2JjB,YAAA;EACA,cTxLiB;ADqrJ7B;AUz/IY;;EACI,0CThKa;ESiKb,cT9La;AD0rJ7B;AoCj8IY;;;EAGI,+BnCtOa;ADyqJ7B;AoC97II;EACI,eAAA;EACA,cnCnQqB;EmCoQrB,qBAAA;ApCg8IR;;AsC9sJA;EACI,eAAA;EACA,kBAAA;EACA,mBrCOyB;AD0sJ7B;AsC/sJI;EACI,gBrCkHuB;AD+lJ/B;;AsC9sJA;EACI,iBAAA;AtCitJJ;;AsC9sJA;EACI,aAAA;AtCitJJ;;AsC/sJA;EACI,iBAAA;AtCktJJ;;AsC/sJA;EACE,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,crCd2B;EqCe3B,kBAAA;EACA,gBAAA;AtCktJF;AsChtJE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AtCktJJ;AsC/sJE;EACI,gBAAA;EACA,iBAAA;AtCitJN;AsC9sJE;EACI,oCAAA;AtCgtJN;AsC7sJE;EACE,UAAA;EACA,iBAAA;EACA,oBAAA;AtC+sJJ;AsC5sJI;EACI,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AtC8sJR;AsC3sJI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EAGA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AtC6sJN;AsCzsJI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AtC2sJR;AsCzsJI;EACI,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AtC2sJR;AsCxsJI;;EAEE,+BrCxDuB;ADkwJ7B;AsCvsJI;EAEI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;AtCwsJR;;AsCnsJI;EAEI,aAAA;AtCqsJR;AsClsJI;ED7GA,iCC8G6B,ED9GR,+CAAA,EACrB,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,+EAAA,EAAA,oBAAA;ArCkzJJ;;AsCpsJA;EACI,eAAA;AtCusJJ;AsCrsJI;EACI,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,sBAAA;EACA,gDrCuDmB;EqCtDnB,sBAAA;AtCusJR;AsCrsJQ;EACI,iBAAA;AtCusJZ;AsCpsJQ;EACI,UAAA;AtCssJZ;AsCpsJY;EACI,iBAAA;AtCssJhB;AsClsJQ;EACI,UAAA;AtCosJZ;AsCjsJQ;EACI,iBAAA;EACA,mBAAA;AtCmsJZ;AsC/rJI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AtCisJR;;AsC5rJK;EACG,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;AtC+rJR;AsC5rJK;EACG,aAAA;EACA,kBAAA;AtC8rJR;AsC3rJK;EACG,mBAAA;AtC6rJR;AsC1rJK;EACG,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AtC4rJR;AsCzrJK;EACG,eAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AtC2rJR;AsCxrJK;EACG,OAAA;EACA,QAAA;AtC0rJR;AsCvrJK;EACI,QAAA;EACA,SAAA;AtCyrJT;AsCtrJK;EACI,QAAA;AtCwrJT;AsCrrJK;EACI,QAAA;EACA,SAAA;AtCurJT;AsCprJK;EACI,QAAA;EACA,QAAA;AtCsrJT;AsCnrJK;EACI,QAAA;EACA,SAAA;EACD,eAAA;EACA,cAAA;EACA,YAAA;AtCqrJR;AsClrJK;EACI,QAAA;EACA,SAAA;AtCorJT;AsCjrJK;EACI,QAAA;EACA,SAAA;AtCmrJT;AsChrJK;EACG,QAAA;EACA,SAAA;AtCkrJR;AsC/qJK;EACI,QAAA;EACA,SAAA;AtCirJT;AsC9qJK;EACI,QAAA;EACA,SAAA;AtCgrJT;AsC7qJK;EACI,QAAA;EACA,SAAA;AtC+qJT;AsC5qJK;EACI,OAAA;EACA,SAAA;AtC8qJT;AsC3qJK;EACI,QAAA;EACA,SAAA;AtC6qJT;AsC1qJK;EACG,OAAA;EACA,SAAA;AtC4qJR;;AsCxqJA;EACI,iBAAA;EACA,aAAA;AtC2qJJ;AsCzqJI;;;EAGI,iBAAA;AtC2qJR;AsCxqJI;EACI,gBAAA;AtC0qJR;AsCvqJI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AtCyqJR;AsCrqJI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AtCuqJR;;AsClqJA;EACI,yBrClSyB;ADu8J7B;;AsCnqJA;EACI,yBrC9RyB;ADo8J7B;;AsCnqJA;EACI,crC3SyB;ADi9J7B;AsCpqJI;;;;;EAKI,crClTqB;ADw9J7B;AsCnqJI;EACI,yBrCtTqB;AD29J7B;AsClqJI;EACI,crCxRqB;AD47J7B;AsCjqJI;;EAEE,crC/TuB;ADk+J7B;AsChqJI;;;EAGE,+BrC/SuB;ADi9J7B;AsC/pJI;;EAEI,+BrCpTqB;ADq9J7B;AsC9pJI;EACI,sCrCjTqB;ADi9J7B;AsC5pJI;;;;EAII,sCrCzTqB;ADu9J7B;AsC3pJI;;;EAGI,crC5VqB;ADy/J7B;AsC1pJI;;EAEI,crCjWqB;AD6/J7B;AsCzpJI;;EAEI,yBrCtWqB;EqCuWrB,qBrCvWqB;ADkgK7B;AUvgKG;EACI,cA+G+B;EJlHpC,UIkHyD;EJ/GzD,0BAAA;AN2gKF;AUxgKG;EACI,cA2G+B;EJlHpC,UIkHyD;EJ/GzD,0BAAA;ANghKF;AUzgKG;EACI,cAuG+B;EJlHpC,UIkHyD;EJ/GzD,0BAAA;ANqhKF;AU1gKG;EACI,cAmG+B;EJlHpC,UIkHyD;EJ/GzD,0BAAA;AN0hKF;AUz6JI;EACI,sCTzFqB;ES0FrB,cT/GqB;AD0hK7B;AUz6JQ;EACI,qBTlHiB;ESmHjB,6BTpFiB;ESqFjB,cTpHiB;AD+hK7B;AUr6JQ;;EACI,cT3HiB;ADmiK7B;AUn6JQ;EACI,6BTlGiB;ADugK7B;AUj6JI;EACI,6BTvGqB;ESwGrB,sCTlHqB;ESmHrB,cTxIqB;AD2iK7B;AU/5JQ;EACI,6BT9GiB;ES+GjB,qBT9IiB;ES+IjB,cT/IiB;ADgjK7B;AU35JQ;;EACI,0CT1HiB;ES2HjB,cTvJiB;ADqjK7B;AU55JY;;;;EAGI,0CT/Ha;ESgIb,cT7Ja;AD4jK7B;AU35JQ;;EACI,0CTtIiB;ADoiK7B;AU55JY;;;;EAGI,0CT1Ia;ES2Ib,cTxKa;ADukK7B;AUz5JgB;;EACI,0CTlJS;ESmJT,cThLS;AD4kK7B;AUv5JQ;;EACI,0CT1JiB;ES2JjB,YAAA;EACA,cTxLiB;ADklK7B;AUt5JY;;EACI,0CThKa;ESiKb,cT9La;ADulK7B;AsCzuJI;EACI,6BrChVqB;EqCiVrB,sCrC3VqB;EqC4VrB,crCjXqB;AD4lK7B;AsCzuJQ;EAWI,6BrC/ViB;EqCgWjB,qBrC/XiB;EqCgYjB,crChYiB;ADimK7B;AsCztJgB;EACI,crCzYS;ADomK7B;AsCrtJI;EACI,crChZqB;ADumK7B;;AuCjnKA;ECiLI;IACI,eAAA;IACA,yBAAA;IACA,MAAA;IACA,uBAAA;IACA,YAAA;IACA,QAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IAEA,2BAAA;InC7IA,mCAAA;IA/BJ,0DAAA;ELynKF;EwCx8JM;IACI,mBvCrJiB,EuCqJW,+CAAA,EAC5B,0BAAA,EACA,2BAAA,EACA,0BAAA;IACA,iDAAA,EAAA,mCAAA;IlCtMV,akCuM2B;IlCpM3B,yBAAA;IkCsMU,cAAA;IACA,WAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;ExC08JV;EwCt8JU;IACI,cAAA;IACA,qBAAA;ExCw8Jd;EwCt8Jc;IACI,yBAAA;ExCw8JlB;EwCn8JM;IACI,cvCxNiB;ED6pK3B;EwCtqKE;IACE,2BAAA;ExCwqKJ;EwCpqKM;IACI,gBAAA;IACA,kBAAA;IACD,8BAAA;IACA,gBAAA;IACA,cAAA;ExCsqKT;EwCpqKU;IACI,MAAA;IACA,YAAA;ExCsqKd;EwClqKM;;IAEI,6BAAA;IACA,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,cAAA;IACA,mBAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;ExCoqKV;EwClqKU;;IACI,aAAA;ExCqqKd;EwChqKU;IACI,oBAAA;ExCkqKd;EwC/pKU;IACG,aAAA;ExCiqKb;EwC9pKS;IACI,cAAA;ExCgqKb;EwC5pKM;;IAEI,cvC5CiB;IuC6CjB,wBvCwEoB;EDslK9B;EwC3pKM;IACE,WAAA;IACA,kBAAA;IACA,aAAA;IAEA,yCAAA;IAEA,mBAAA;InCfF,iCAAA;IA/BJ,0DAAA;ELqtKF;EwClqKM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mBvCjEiB;EDquK3B;EwClqKU;IACI,eAAA;ExCoqKd;EwCjqKU;IACI,WAAA;IACA,6BAAA;ExCmqKd;EwC/pKM;IACI,mBvC7CiB;ED8sK3B;EwChoKA;IACE,oBAAA;ExCkoKF;EwChoKA;IACE,UAAA;ExCkoKF;EwChoKA;IACE,oBAAA;ExCkoKF;EwC/nKA;;;IAGE,oBAAA;ExCioKF;EwC3nKE;IACA,wBAAA;IACA,oBAAA;ExC6nKF;EwC3nKE;IACE,yBAAA;IACA,oBAAA;ExC6nKJ;EwC3nKE;IACE,UAAA;ExC6nKJ;EwC1iKE;IACI,YAAA;ExC4iKN;EwCziKE;InC1NA,0DAAA;EL0wKF;EwC5iKE;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;InCzOJ,0DAAA;EL4xKF;EuC1yKU;IACI,WAAA;IACA,OAAA;IlC2CR,oCAAA;ELswKN;EuC3yKU;IlCqCJ,iCAAA;EL6wKN;EuC9yKU;IlCiCJ,oCAAA;ELoxKN;EuCjzKU;IlC6BJ,oCAAA;EL2xKN;EuCnzKc;IlCwBR,iCAAA;ELkyKN;EuCtzKc;IlCoBR,mCAAA;ELyyKN;EuCzzKc;IlCgBR,mCAAA;ELgzKN;EuC5zKc;IACI,WAAA;IACA,WAAA;EvC8zKlB;EuCxzKE;;IAEE,YAAA;EvC0zKJ;EuCtzKM;IACI,2BAAA;EvCwzKV;EwC52KE;IACE,2BAAA;ExC82KJ;EwC12KM;IACI,gBAAA;IACA,kBAAA;IACD,8BAAA;IACA,gBAAA;IACA,cAAA;ExC42KT;EwC12KU;IACI,MAAA;IACA,YAAA;ExC42Kd;EwCx2KM;;IAEI,6BAAA;IACA,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,cAAA;IACA,mBAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;ExC02KV;EwCx2KU;;IACI,aAAA;ExC22Kd;EwCt2KU;IACI,oBAAA;ExCw2Kd;EwCr2KU;IACG,aAAA;ExCu2Kb;EwCp2KS;IACI,cAAA;ExCs2Kb;EwCl2KM;;IAEI,cvC5CiB;IuC6CjB,wBvCwEoB;ED4xK9B;EwCj2KM;IACE,WAAA;IACA,kBAAA;IACA,aAAA;IAEA,yCAAA;IAEA,mBAAA;InCfF,iCAAA;IA/BJ,0DAAA;EL25KF;EwCx2KM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mBvCjEiB;ED26K3B;EwCx2KU;IACI,eAAA;ExC02Kd;EwCv2KU;IACI,WAAA;IACA,6BAAA;ExCy2Kd;EwCr2KM;IACI,mBvC7CiB;EDo5K3B;EwCt0KA;IACE,oBAAA;ExCw0KF;EwCt0KA;IACE,UAAA;ExCw0KF;EwCt0KA;IACE,oBAAA;ExCw0KF;EwCr0KA;;;IAGE,oBAAA;ExCu0KF;EwCj0KE;IACA,wBAAA;IACA,oBAAA;ExCm0KF;EwCj0KE;IACE,yBAAA;IACA,oBAAA;ExCm0KJ;EwCj0KE;IACE,UAAA;ExCm0KJ;EuC/5KE;IACI,iBAAA;EvCi6KN;EuC95KE;IACI,aAAA;EvCg6KN;EuC75KE;IACI,kBAAA;EvC+5KN;EuC35KM;IACI,iBAAA;EvC65KV;EuCz5KE;IACI,gBAAA;EvC25KN;EuCt5KU;;IAEI,YAAA;EvCw5Kd;EuCn5KE;IACI,aAAA;IACA,iBAAA;EvCq5KN;EuCn5KM;IACI,gBAAA;EvCq5KV;EuCl5KM;IACI,UAAA;IACA,QAAA;IACA,gBAAA;EvCo5KV;EuCj5KM;IACI,SAAA;IACA,gBAAA;IACA,QAAA;EvCm5KV;AACF;AuC/4KA;EACE;IACE,kCAAA;EvCi5KF;EwCj1KE;IACI,eAAA;IACA,yBAAA;IACA,MAAA;IACA,uBAAA;IACA,YAAA;IACA,QAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IAEA,2BAAA;InC7IA,mCAAA;IA/BJ,0DAAA;ELwgLF;EwCv1KM;IACI,mBvCrJiB,EuCqJW,+CAAA,EAC5B,0BAAA,EACA,2BAAA,EACA,0BAAA;IACA,iDAAA,EAAA,mCAAA;IlCtMV,akCuM2B;IlCpM3B,yBAAA;IkCsMU,cAAA;IACA,WAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;ExCy1KV;EwCr1KU;IACI,cAAA;IACA,qBAAA;ExCu1Kd;EwCr1Kc;IACI,yBAAA;ExCu1KlB;EwCl1KM;IACI,cvCxNiB;ED4iL3B;EwCrjLE;IACE,2BAAA;ExCujLJ;EwCnjLM;IACI,gBAAA;IACA,kBAAA;IACD,8BAAA;IACA,gBAAA;IACA,cAAA;ExCqjLT;EwCnjLU;IACI,MAAA;IACA,YAAA;ExCqjLd;EwCjjLM;;IAEI,6BAAA;IACA,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,cAAA;IACA,mBAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;ExCmjLV;EwCjjLU;;IACI,aAAA;ExCojLd;EwC/iLU;IACI,oBAAA;ExCijLd;EwC9iLU;IACG,aAAA;ExCgjLb;EwC7iLS;IACI,cAAA;ExC+iLb;EwC3iLM;;IAEI,cvC5CiB;IuC6CjB,wBvCwEoB;EDq+K9B;EwC1iLM;IACE,WAAA;IACA,kBAAA;IACA,aAAA;IAEA,yCAAA;IAEA,mBAAA;InCfF,iCAAA;IA/BJ,0DAAA;ELomLF;EwCjjLM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mBvCjEiB;EDonL3B;EwCjjLU;IACI,eAAA;ExCmjLd;EwChjLU;IACI,WAAA;IACA,6BAAA;ExCkjLd;EwC9iLM;IACI,mBvC7CiB;ED6lL3B;EwC/gLA;IACE,oBAAA;ExCihLF;EwC/gLA;IACE,UAAA;ExCihLF;EwC/gLA;IACE,oBAAA;ExCihLF;EwC9gLA;;;IAGE,oBAAA;ExCghLF;EwC1gLE;IACA,wBAAA;IACA,oBAAA;ExC4gLF;EwC1gLE;IACE,yBAAA;IACA,oBAAA;ExC4gLJ;EwC1gLE;IACE,UAAA;ExC4gLJ;EwCz7KE;IACI,YAAA;ExC27KN;EwCx7KE;InC1NA,0DAAA;ELypLF;EwC37KE;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;InCzOJ,0DAAA;EL2qLF;EuCxkLM;IlCpEA,iCAAA;ELmpLN;EuC3kLM;IACI,yBAAA;EvC6kLV;EuC3kLU;IACI,gBAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IAIA,aAAA;IAKA,sBAAA;EvC6kLd;EuC3kLc;IACI,SAAA;EvC6kLlB;EuCxkLM;IACI,WAAA;IACA,OAAA;IlClGJ,oCAAA;ELirLN;EuC1kLU;IACI,gBAAA;IACA,WAAA;EvC4kLd;EuCzkLU;IACI,qBAAA;EvC2kLd;EuCvkLM;IACI,wBAAA;EvCykLV;EuCrkLU;IlCtHJ,mCAAA;ELksLN;EuCxkLU;IlC1HJ,oCAAA;ELysLN;EuC3kLU;IlC9HJ,iCAAA;ELgtLN;EuC9kLU;IACI,WAAA;IACA,WAAA;EvCglLd;EuC5kLM;IACI,YAAA;IACA,eAAA;IACA,iBAAA;EvC8kLV;EuCxkLU;IACI,UAAA;IACA,kBAAA;EvC0kLd;EuCvkLU;IACI,SAAA;EvCykLd;EuCrkLM;IACI,iBAAA;EvCukLV;EuClkLE;IACI,kBAAA;EvCokLN;EuCjkLE;IACI,cAAA;IACA,aAAA;IACA,mBAAA;EvCmkLN;EuCjkLM;IACE,iBAAA;IACA,kBAAA;IACA,QAAA;EvCmkLR;EuC9jLM;IACI,YAAA;EvCgkLV;AACF;AuC5jLA;EAEQ;IACI,SAAA;IACA,mBAAA;IACA,oBAAA;EvC6jLV;EuC1jLM;IACI,oBAAA;EvC4jLV;AACF;AuCxjLA;EAEQ;IACI,oBAAA;EvCyjLV;EuCvjLU;IACI,cAAA;IACA,kBAAA;IACA,QAAA;EvCyjLd;EuCpjLE;IACI,qBAAA;IACA,WAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;EvCsjLN;EuCpjLM;IACI,kBAAA;EvCsjLV;EuCljLE;IACI,cAAA;IACA,mBAAA;EvCojLN;AACF;AuCjjLA;EACI;IACI,cAAA;IACA,eAAA;EvCmjLN;EuC/iLM;IACI,kBAAA;EvCijLV;EuC3iLU;IACI,eAAA;EvC6iLd;EuC3iLc;IACI,eAAA;EvC6iLlB;EuCtiLM;IACI,UAAA;EvCwiLV;AACF;AuCpiLA;EAEQ;IACI,SAAA;IACA,gBAAA;EvCqiLV;EuCliLM;IACI,SAAA;IACA,gBAAA;EvCoiLV;AACF;AuChiLA;EACI;IACI,aAAA;IACA,iBAAA;EvCkiLN;EuChiLM;IACI,gBAAA;EvCkiLV;EuC/hLM;IACI,SAAA;IACA,QAAA;IACA,gBAAA;EvCiiLV;EuC9hLM;IACI,SAAA;IACA,gBAAA;IACA,QAAA;EvCgiLV;AACF;AuC5hLA;EACI;IACI,gBAAA;EvC8hLN;AACF;AuC3hLA;EAEQ;IACI,QAAA;IACA,UAAA;EvC4hLV;EuCzhLM;IACI,QAAA;IACA,UAAA;EvC2hLV;AACF;AuCthLA;EAII;;;IAGI,iBAAA;IACA,iBAAA;EvCqhLN;EuClhLE;IACI,gBAAA;EvCohLN;EuCjhLE;IACI,UAAA;IACA,QAAA;EvCmhLN;EuChhLE;IACI,UAAA;IACA,QAAA;EvCkhLN;EuC/gLE;IACI,SAAA;EvCihLN;AACF;AuC9gLA;EAEQ;IACI,kBAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;EvC+gLV;AACF;AuC3gLA;EACE;IACE,kBAAA;EvC6gLF;AACF;AyCz6LA,qCAAA;AACA;;;EAAA;AAIA;;;;CAAA;AAKA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AzC26LF;;AyCz6LA;EACE,kBAAA;EACA,cAAA;AzC46LF;;AyC16LA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AzC66LF;;AyC36LA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AzC86LF;;AyC56LA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;AzC+6LF;;AyC76LA;EACE,YAAA;EACA,WAAA;AzCg7LF;;AyC96LA;EACE,WAAA;EACA,UAAA;AzCi7LF;;AyC/6LA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;AzCk7LF;;AyCh7LA;;EAAA;AAGA;EACE,QAAA;AzCm7LF;;AyCj7LA;EACE,SAAA;AzCo7LF;;AyCl7LA;EAEE,2BAAA;EACA,kBAAA;AzCq7LF;;AyCn7LA;EACE,YAAA;EACA,WAAA;AzCs7LF;;AyCp7LA;;EAGE,0BAAA;AzCu7LF;;AyCr7LA;EACE,0BAAA;AzCw7LF;;AyCt7LA;EAAA;AAEA;EACE,WAAA;AzCy7LF;;AyCv7LA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;AzC07LF;;AyCx7LA;EACE,WAAA;AzC27LF;;AyCz7LA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;AzC47LF;;AyC17LA;EACE,WAAA;EACA,UAAA;AzC67LF;;AyC37LA;;EAAA;AAGA;EACE,0CAAA;EACA,kBAAA;AzC87LF;;AyC57LA;EACE,kBAAA;AzC+7LF;;AyC17LA;EAAA;AAEA;EACE,iBAAA;AzC67LF;;AyC37LA;EACE,iBAAA;AzC87LF;;AyC57LA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;AzC+7LF;;AyC77LA;EACE,yEAAA;AzCg8LF;;AyC97LA;EAAA;AAEA;EACE,mBAAA;AzCi8LF;;AyC/7LA;;;EAGE,mBAAA;AzCk8LF;;AyCh8LA;;EAAA;AAGA;;EAGE,sBAAA;AzCm8LF;;AyCj8LA;EACE,kBAAA;EACA,WAAA;AzCo8LF;;AyCl8LA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AzCq8LF;;AyCn8LA;EACE,WAAA;EACA,eAAA;AzCs8LF;;AyCp8LA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AzCu8LF;;AyCr8LA;EACE,gBAAA;AzCw8LF;;AyCt8LA;EACE,gBAAA;AzCy8LF;;AyCv8LA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AzC08LF;;AyCx8LA;EAEE,+BAAA;AzC28LF;;AyCz8LA;EAEE,8BAAA;AzC48LF;;AyC18LA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AzC68LF;;AyC38LA;EACE,YAAA;AzC88LF;;AyC58LA;EACE,YAAA;AzC+8LF;;AyC78LA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AzCg9LF;;AyC98LA;EAEE,6BAAA;EACA,kBAAA;AzCi9LF;;AyC/8LA;EAEE,4BAAA;AzCk9LF;;AyCh9LA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AzCm9LF;;AyCj9LA;EACE,WAAA;AzCo9LF;;AyCl9LA;EACE,WAAA;AzCq9LF;;AyCn9LA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AzCs9LF;;AyCp9LA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AzCu9LF;;AyCr9LA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AzCw9LF;;A0CzuMA;;CAAA;AAGA;EACE,kBAAA;A1C4uMF;A0C3uME;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;A1C6uMJ;A0C1uMI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;A1C4uMN;;A0CxuMA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gDAAA;EAEA,4BAAA;EACA,gBAAA;A1C2uMF;A0CzuME;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;A1C2uMJ;A0CzuME;EACE,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A1C2uMJ;;A0CvuMA;EACE,cAAA;EACA,SAAA;A1C0uMF;;A0CxuMA;EACE,gBAAA;EACA,gBAAA;A1C2uMF;;A0CxuMA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;A1C2uMF;;A0CxuMA;EACE,WAAA;EACA,SAAA;EACA,gCAAA;A1C2uMF;;A0CzuMA;;EAEE,kBAAA;EACA,YAAA;A1C4uMF;;A0C1uMA;EACE,eAAA;A1C6uMF;;A0C3uMA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A1C8uMF;A0C7uME;EAGE,oCAAA;EACA,czC9FyB;AD20M7B;;A0CxuMI;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;A1C2uMN;A0CzuMI;;EAEE,czCjGuB;AD40M7B;;A0CtuMA;;;;;EAKE,mBAAA;EACA,eAAA;A1CyuMF;;A0CvuMA;EACE,kBAAA;A1C0uMF;;A0CxuMA;EACE,yBAAA;A1C2uMF;;A0CzuMA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A1C4uMF;;A0CzuMA;EACE,cAAA;A1C4uMF;;A0C1uMA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A1C6uMF;;A0C3uMA;EACE,eAAA;EACA,mBAAA;A1C8uMF;;A0C5uMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A1C+uMF;;A0C7uMA;;EAEE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;A1CgvMF;;A0C5uME;;;;;EAKE,czClIyB;ADi3M7B;;A0C3uMA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A1C8uMF;;A0C3uMA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A1C8uMF;;A0C5uMA;EACE,eAAA;A1C+uMF;;A0C7uMA;EACE,mBAAA;A1CgvMF;;A0C7uMA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A1CgvMF;;A0C9uMA;EACE,sBAAA;A1CivMF;;A0C9uMA;EACE,WAAA;EACA,YAAA;A1CivMF;;A0C9uMA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;A1CivMF;;A0C/uMA;;EAEE,gBAAA;A1CkvMF;;A0C/uMA;EACE,qBAAA;A1CkvMF;;A0C9uME;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;A1CivMJ;A0C/uME;EACE,QAAA;EACA,6BAAA;A1CivMJ;;A0C7uMA;EACE,aAAA;A1CgvMF;;A0C7uMA;EACE,WAAA;A1CgvMF;A0C/uME;EACE,YAAA;EACA,YAAA;EACA,6BAAA;A1CivMJ;;A0C5uMI;EACE,czCxNuB;EyCyNvB,kBAAA;EACA,yBAAA;A1C+uMN;;A0C1uMA;EACE,YAAA;EACA,kBAAA;A1C6uMF;;A0C3uMA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,czCjQ2B;EyCsQ3B,4BAAA;EAEA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A1C6uMF;;A0C3uMA;EACE,gBAAA;EACA,cAAA;A1C8uMF;;A0C5uMA;EACE,kBAAA;EACA,iBAAA;A1C+uMF;;A0C5uMA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;A1C+uMF;;A0C5uMA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;A1C+uMF;;A0C7uMA;;EAEE,oBAAA;A1CgvMF;A0C/uME;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A1CmvMJ;A0CjvMI;;;;EACE,oCAAA;EACA,czChUuB;ADsjN7B;;A2ChkNA;EACE,aAAA;A3CmkNF;;A4CnkNI;EACI,qB3CwDqB;E2CvDrB,c3CuDqB;AD+gN7B;A4CpkNQ;EACI,c3CoDiB;ADkhN7B;;A6C5kNA;EACE,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;A7C+kNF;;A6C5kNA;EACE,mBAAA;EACA,qBAAA;A7C+kNF;;A8CxlNA;EACE,c7CyD2B;E6CxD3B,eAAA;A9C2lNF;;A+C5lNE;EACE,oCAAA;A/C+lNJ;;A+C1lNE;EnBNE,yB3B+CyB;ADqjN7B;A4BlmNI;EACI,c3BMqB;AD8lN7B;A4BhmNI;EACI,2B3BuCqB;AD2jN7B;A4B/lNI;EACI,yB3BmCqB;AD8jN7B;A4B9lNI;EACI,4B3B+BqB;ADikN7B;A4B7lNI;EACI,0B3B2BqB;ADokN7B;A4B5lNI;EACI,c3BfqB;E2BgBrB,YAAA;A5B8lNR;A+C/mNI;EACE,0B9CsCuB;AD2kN7B;;A+C3mNE;EnBfE,yB3ByDyB;ADqkN7B;A4B5nNI;EACI,c3BMqB;ADwnN7B;A4B1nNI;EACI,2B3BiDqB;AD2kN7B;A4BznNI;EACI,yB3B6CqB;AD8kN7B;A4BxnNI;EACI,4B3ByCqB;ADilN7B;A4BvnNI;EACI,0B3BqCqB;ADolN7B;A4BtnNI;EACI,c3BfqB;E2BgBrB,YAAA;A5BwnNR;A+ChoNI;EACE,0B9CuCuB;AD2lN7B;;A+C5nNE;EnBxBE,yB3B8DyB;AD0lN7B;A4BtpNI;EACI,c3BMqB;ADkpN7B;A4BppNI;EACI,2B3BsDqB;ADgmN7B;A4BnpNI;EACI,yB3BkDqB;ADmmN7B;A4BlpNI;EACI,4B3B8CqB;ADsmN7B;A4BjpNI;EACI,0B3B0CqB;ADymN7B;A4BhpNI;EACI,c3BfqB;E2BgBrB,YAAA;A5BkpNR;A+CjpNI;EACE,0B9CmCuB;ADgnN7B;;A+C7oNE;EnBjCE,yB3BmEyB;AD+mN7B;A4BhrNI;EACI,c3BMqB;AD4qN7B;A4B9qNI;EACI,2B3B2DqB;ADqnN7B;A4B7qNI;EACI,yB3BuDqB;ADwnN7B;A4B5qNI;EACI,4B3BmDqB;AD2nN7B;A4B3qNI;EACI,0B3B+CqB;AD8nN7B;A4B1qNI;EACI,c3BfqB;E2BgBrB,YAAA;A5B4qNR;A+ClqNI;EACE,0B9C+BuB;ADqoN7B;;A+C9pNE;EnB1CE,yB3BoDyB;ADwpN7B;A4B1sNI;EACI,c3BMqB;ADssN7B;A4BxsNI;EACI,2B3B4CqB;AD8pN7B;A4BvsNI;EACI,yB3BwCqB;ADiqN7B;A4BtsNI;EACI,4B3BoCqB;ADoqN7B;A4BrsNI;EACI,0B3BgCqB;ADuqN7B;A4BpsNI;EACI,c3BfqB;E2BgBrB,YAAA;A5BssNR;A+CnrNI;EACE,0B9COuB;AD8qN7B;;AgDnuNA;EACE,0B/CU2B;AD4tN7B;;AgDpuNA;EACE,2B/CO2B;ADguN7B;;AgDruNA;EACE,yB/CI2B;ADouN7B;;AgDtuNA;EACE,4B/CC2B;ADwuN7B;;AiDnvNA;EZCI,iCAAA,EAAA,+CAAA,EACA,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,gFAAA,EAAA,oBAAA;ArCsvNJ;;AiDxvNA;EACI,yBhDsDyB;ADqsN7B;;AiDzvNA;EACE,chDmD2B;ADysN7B;;AiDzvNE;EACE,gBAAA;EACA,iBAAA;AjD4vNJ;;AkDxwNA;EACE;IACE,mBjDwDyB;IiDvDzB,iDAAA;ElD2wNF;EkDzwNA;IACE,2BAAA;ElD2wNF;AACF;AkDxwNA;EACE;IACE,kBAAA;IACA,mBAAA;ElD0wNF;AACF","sourcesContent":["/*!\r\n\r\n =========================================================\r\n * Now UI Kit React - v1.5.2 based on Now UI Kit - v1.3.0\r\n =========================================================\r\n\r\n * Product Page: https://www.creative-tim.com/product/now-ui-kit-react\r\n * Copyright 2023 Creative Tim (http://www.creative-tim.com)\r\n * Licensed under MIT (https://github.com/creativetimofficial/now-ui-kit-react/blob/main/LICENSE.md)\r\n\r\n * Designed by www.invisionapp.com Coded by www.creative-tim.com\r\n\r\n =========================================================\r\n\r\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\r\n\r\n */\r\n\r\n@import \"now-ui-kit/variables\";\r\n@import \"now-ui-kit/mixins\";\r\n\r\n// Plugins CSS\r\n@import \"now-ui-kit/plugins/plugin-bootstrap-switch\";\r\n@import \"now-ui-kit/plugins/plugin-nouislider\";\r\n@import \"now-ui-kit/plugins/plugin-datepicker\";\r\n\r\n// Core CSS\r\n@import \"now-ui-kit/buttons\";\r\n@import \"now-ui-kit/inputs\";\r\n@import \"now-ui-kit/checkboxes-radio\";\r\n@import \"now-ui-kit/progress\";\r\n@import \"now-ui-kit/badges\";\r\n@import \"now-ui-kit/pagination\";\r\n@import \"now-ui-kit/typography\";\r\n@import \"now-ui-kit/misc\";\r\n@import \"now-ui-kit/pills\";\r\n\r\n// components\r\n@import \"now-ui-kit/nucleo-outline\";\r\n\r\n@import \"now-ui-kit/tabs\";\r\n@import \"now-ui-kit/navbar\";\r\n@import \"now-ui-kit/dropdown\";\r\n@import \"now-ui-kit/alerts\";\r\n@import \"now-ui-kit/images\";\r\n@import \"now-ui-kit/popups\";\r\n@import \"now-ui-kit/modals\";\r\n@import \"now-ui-kit/carousel\";\r\n@import \"now-ui-kit/footers\";\r\n\r\n// Cards\r\n@import \"now-ui-kit/cards\";\r\n@import \"now-ui-kit/cards/card-plain\";\r\n@import \"now-ui-kit/cards/card-signup\";\r\n\r\n// example pages and sections\r\n@import \"now-ui-kit/example-pages\";\r\n@import \"now-ui-kit/sections\";\r\n\r\n@import \"now-ui-kit/responsive\";\r\n\r\n// React\r\n@import \"react/react-differences\";\r\n","//== Buttons\r\n//\r\n//## For each of Bootstrap's buttons, define text, background and border color.\r\n\r\n$sans-serif-family:          'Montserrat', 'Helvetica Neue',  Arial, sans-serif !default;\r\n\r\n$none:                       0   !default;\r\n$border-thin:                1px !default;\r\n$border-thick:               2px !default;\r\n\r\n$white-color:                #FFFFFF !default;\r\n$white-bg:                   #FFFFFF !default;\r\n$orange-bg:                  #e95e38 !default;\r\n\r\n$smoke-bg:                   #F5F5F5 !default;\r\n$light-black:                #444    !default;\r\n\r\n$black-bg:                   rgba(30,30,30,.97) !default;\r\n\r\n$black-color:                #2c2c2c !default;\r\n$black-hr:                   #444444 !default;\r\n\r\n$light-gray:                 #E3E3E3 !default;\r\n$medium-gray:                #DDDDDD !default;\r\n$dark-gray:                  #9A9A9A !default;\r\n\r\n$opacity-gray-3:             rgba(222,222,222, .3) !default;\r\n$opacity-gray-5:             rgba(222,222,222, .5) !default;\r\n$opacity-gray-8:             rgba(222,222,222, .8) !default;\r\n\r\n\r\n$opacity-5:                  rgba(255,255,255, .5) !default;\r\n$opacity-8:                  rgba(255,255,255, .8) !default;\r\n\r\n$datepicker-color-days:             rgba(255,255,255, .8)  !default;\r\n$datepicker-color-old-new-days:     rgba(255,255,255, .4)  !default;\r\n\r\n\r\n$opacity-1:                  rgba(255,255,255, .1) !default;\r\n$opacity-2:                  rgba(255,255,255, .2) !default;\r\n\r\n$transparent-bg:             transparent !default;\r\n$dark-background:            #555555 !default;\r\n\r\n$default-color:              #888888 !default;\r\n$default-states-color:       lighten($default-color, 6%) !default;\r\n$default-color-opacity:      rgba(182, 182, 182, .6) !default;\r\n\r\n$primary-color:              #f96332 !default;\r\n$primary-states-color:       lighten($primary-color, 6%) !default;\r\n$primary-color-opacity:      rgba(249, 99, 50, .3) !default;\r\n$primary-color-alert:        rgba(249, 99, 50, .8) !default;\r\n\r\n$success-color:              #18ce0f !default;\r\n$success-states-color:       lighten($success-color, 6%) !default;\r\n$success-color-opacity:      rgba(24, 206, 15, .3) !default;\r\n$success-color-alert:        rgba(24, 206, 15, .8) !default;\r\n\r\n$info-color:                 #2CA8FF !default;\r\n$info-states-color:          lighten($info-color, 6%) !default;\r\n$info-color-opacity:         rgba(44, 168, 255, .3) !default;\r\n$info-color-alert:           rgba(44, 168, 255, .8) !default;\r\n\r\n$warning-color:              #FFB236 !default;\r\n$warning-states-color:       lighten($warning-color, 6%) !default;\r\n$warning-color-opacity:      rgba(255, 178, 54, .3) !default;\r\n$warning-color-alert:        rgba(255, 178, 54, .8) !default;\r\n\r\n$danger-color:               #FF3636 !default;\r\n$danger-states-color:        lighten($danger-color, 6%) !default;\r\n$danger-color-opacity:       rgba(255, 54, 54, .3) !default;\r\n$danger-color-alert:         rgba(255, 54, 54, .8) !default;\r\n\r\n/*     brand Colors              */\r\n$brand-primary:              $primary-color !default;\r\n$brand-info:                 $info-color !default;\r\n$brand-success:              $success-color !default;\r\n$brand-warning:              $warning-color !default;\r\n$brand-danger:               $danger-color !default;\r\n$brand-inverse:              $black-color !default;\r\n\r\n$link-disabled-color:        #666666 !default;\r\n\r\n/*      light colors         */\r\n$light-blue:                 rgba($primary-color, .2);\r\n$light-azure:                rgba($info-color, .2);\r\n$light-green:                rgba($success-color, .2);\r\n$light-orange:               rgba($warning-color, .2);\r\n$light-red:                  rgba($danger-color, .2);\r\n\r\n//== Components\r\n//\r\n\r\n$padding-input-vertical:        11px !default;\r\n$padding-input-horizontal:      19px !default;\r\n\r\n$padding-btn-vertical:         11px !default;\r\n$padding-btn-horizontal:       22px !default;\r\n\r\n$padding-base-vertical:        .5rem !default;\r\n$padding-base-horizontal:      .7rem !default;\r\n\r\n$padding-round-horizontal:     23px !default;\r\n\r\n$padding-simple-vertical:      10px !default;\r\n$padding-simple-horizontal:    17px !default;\r\n\r\n$padding-large-vertical:       15px !default;\r\n$padding-large-horizontal:     48px !default;\r\n\r\n$padding-small-vertical:        5px !default;\r\n$padding-small-horizontal:     15px !default;\r\n\r\n// $padding-xs-vertical:           1px !default;\r\n// $padding-xs-horizontal:         5px !default;\r\n\r\n$padding-label-vertical:        2px !default;\r\n$padding-label-horizontal:     12px !default;\r\n\r\n$margin-large-vertical:        30px !default;\r\n$margin-base-vertical:         15px !default;\r\n\r\n$margin-base-horizontal:       15px !default;\r\n\r\n$margin-bottom:                 10px        !default;\r\n$border:                        1px solid   !default;\r\n$border-radius-extra-small:     0.125rem    !default;\r\n$border-radius-small:           0.1875rem   !default;\r\n$border-radius-large:           0.25rem     !default;\r\n$border-radius-extreme:         0.875rem    !default;\r\n\r\n$border-radius-large-top:      $border-radius-large $border-radius-large 0 0 !default;\r\n$border-radius-large-bottom:   0 0 $border-radius-large $border-radius-large !default;\r\n\r\n$btn-round-radius:             30px         !default;\r\n\r\n$height-base:                  55px         !default;\r\n\r\n$btn-icon-size:                 3.5rem       !default;\r\n$btn-icon-size-regular:         2.375rem      !default;\r\n$btn-icon-font-size-regular:    0.9375rem     !default;\r\n$btn-icon-font-size-small:      0.6875rem      !default;\r\n$btn-icon-size-small:           1.875rem     !default;\r\n$btn-icon-font-size-lg:         1.325rem     !default;\r\n$btn-icon-size-lg:              3.6rem         !default;\r\n\r\n$font-size-h1:                 3.5em        !default; // ~ 49px\r\n$font-size-h2:                 2.5em        !default; // ~ 35px\r\n$font-size-h3:                 1.825em      !default; // ~ 28px\r\n$font-size-h4:                 1.5em        !default; // ~ 24px\r\n$font-size-h5:                 1.3em        !default; // ~ 22px\r\n$font-size-h6:                 .9em         !default; // ~ 12px\r\n\r\n$font-paragraph:               1.2em          !default;\r\n$font-size-navbar:             1em          !default;\r\n$font-size-mini:               0.7142em     !default;\r\n$font-size-small:              0.8571em     !default;\r\n$font-size-base:               14px         !default;\r\n$font-size-large:              1em          !default;\r\n$font-size-large-navbar:       20px         !default;\r\n$font-size-blockquote:         1.1em        !default; // ~ 15px\r\n\r\n$font-weight-light:             300         !default;\r\n$font-weight-normal:            400         !default;\r\n$font-weight-semi:              600         !default;\r\n$font-weight-bold:              700         !default;\r\n\r\n$line-height-general:        1.5            !default;\r\n$line-height-nav-link:       1.625rem       !default;\r\n$btn-icon-line-height:       2.4em          !default;\r\n$line-height:                1.35em         !default;\r\n$line-height-lg:             54px           !default;\r\n\r\n\r\n$border-radius-top:        10px 10px 0 0     !default;\r\n$border-radius-bottom:     0 0 10px 10px     !default;\r\n\r\n$dropdown-shadow:          1px 2px 3px rgba(0, 0, 0, 0.125);\r\n$box-shadow-raised:        0px 10px 25px 0px rgba(0, 0, 0, 0.3);\r\n\r\n$general-transition-time:  300ms             !default;\r\n\r\n$slow-transition-time:           370ms       !default;\r\n$dropdown-coordinates:      29px -50px       !default;\r\n\r\n$fast-transition-time:           150ms       !default;\r\n$select-coordinates:         50% -40px       !default;\r\n\r\n$transition-linear:         linear           !default;\r\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\r\n$transition-ease:           ease 0s;\r\n\r\n\r\n//$navbar-padding-a:               9px 13px;\r\n$navbar-margin-a:                15px 0px;\r\n\r\n$padding-social-a:               10px 5px;\r\n\r\n$navbar-margin-a-btn:            15px 0px;\r\n$navbar-margin-a-btn-round:      16px 0px;\r\n\r\n$navbar-padding-a-icons:         6px 15px;\r\n$navbar-margin-a-icons:          6px  3px;\r\n\r\n$navbar-padding-base:            0.625rem;\r\n//$navbar-margin-brand:             5px  0px;\r\n\r\n$navbar-margin-brand-icons:      12px auto;\r\n$navbar-margin-btn:              15px  3px;\r\n\r\n$height-icon-sm:\t\t\t\t 32px;\r\n$width-icon-sm:\t\t\t\t\t 32px;\r\n$padding-icon-sm:\t\t\t     4px;\r\n$border-radius-icon-sm:\t\t\t 7px;\r\n\r\n$height-icon-message:\t\t\t 40px;\r\n$width-icon-message:\t\t\t 40px;\r\n\r\n$height-icon-message-sm: \t\t 20px;\r\n$width-icon-message-sm:\t\t\t 20px;\r\n\r\n$white-navbar:                  rgba(#FFFFFF, .96);\r\n$primary-navbar:                rgba(#34ACDC, .98);\r\n$info-navbar:                   rgba(#5BCAFF, .98);\r\n$success-navbar:                rgba(#4CD964, .98);\r\n$warning-navbar:                rgba(#FF9500, .98);\r\n$danger-navbar:                 rgba(#FF4C40, .98);\r\n\r\n$topbar-x:             topbar-x !default;\r\n$topbar-back:          topbar-back !default;\r\n$bottombar-x:          bottombar-x !default;\r\n$bottombar-back:       bottombar-back !default;\r\n\r\n//Nucleo Icons\r\n\r\n$nc-font-path:        '~assets/fonts' !default;\r\n$nc-font-size-base:   14px !default;\r\n$nc-css-prefix:       now-ui !default;\r\n$nc-background-color:     #eee !default;\r\n$nc-li-width:         calc(30em / 14) !default;\r\n$nc-padding-width:    calc(1em / 3) !default;\r\n\r\n// Social icons color\r\n$social-twitter:                   #55acee !default;\r\n$social-twitter-state-color:       lighten(#55acee, 6%) !default;\r\n\r\n$social-facebook: \t\t\t       #3b5998 !default;\r\n$social-facebook-state-color:      lighten(#3b5998, 6%) !default;\r\n\r\n$social-google: \t\t\t       #dd4b39 !default;\r\n$social-google-state-color:        lighten(#dd4b39, 6%) !default;\r\n\r\n$social-linkedin: \t\t\t       #0077B5 !default;\r\n$social-linkedin-state-color:      lighten(#0077B5, 6%) !default;\r\n\r\n$social-pinterest: \t\t\t       #cc2127 !default;\r\n$social-pinterest-state-color:     lighten(#cc2127, 6%) !default;\r\n\r\n$social-dribbble: \t\t           #ea4c89 !default;\r\n$social-dribbble-state-color:      lighten(#ea4c89, 6%) !default;\r\n\r\n$social-github: \t\t      \t   #333333 !default;\r\n$social-github-state-color:        lighten(#333333, 6%) !default;\r\n\r\n$social-youtube: \t\t    \t   #e52d27 !default;\r\n$social-youtube-state-color:       lighten(#e52d27, 6%) !default;\r\n\r\n$social-instagram: \t\t           #125688 !default;\r\n$social-instagram-state-color:     lighten(#125688, 6%) !default;\r\n\r\n$social-reddit: \t\t  \t       #ff4500 !default;\r\n$social-reddit-state-color:        lighten(#ff4500, 6%) !default;\r\n\r\n$social-tumblr: \t\t\t       #35465c !default;\r\n$social-tumblr-state-color:        lighten(#35465c, 6%) !default;\r\n\r\n$social-behance: \t\t\t       #1769ff !default;\r\n$social-behance-state-color:       lighten(#1769ff, 6%) !default;\r\n","/* ========================================================================\r\n * bootstrap-switch - v3.3.2\r\n * http://www.bootstrap-switch.org\r\n * ========================================================================\r\n * Copyright 2012-2013 Mattia Larentis\r\n * http://www.apache.org/licenses/LICENSE-2.0\r\n */\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n //* IMPORTANT! Creative Tim Notice: this file has major changes to fit the NOW UI Kit's design. If you want to use the plugin as it was before our changes, please get the old files from http://www.bootstrap-switch.org\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.bootstrap-switch {\r\n  display: inline-block;\r\n  direction: ltr;\r\n  cursor: pointer;\r\n  border-radius: 30px;\r\n  border: 0;\r\n  position: relative;\r\n  text-align: left;\r\n  margin-bottom: 10px;\r\n  line-height: 8px;\r\n  width: 59px !important;\r\n  height: 22px;\r\n  outline: none;\r\n  z-index: 0;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  vertical-align: middle;\r\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n  margin-right: 20px;\r\n  background: rgba($black-color, .2);\r\n}\r\n\r\n.bootstrap-switch .bootstrap-switch-container {\r\n  display: inline-flex;\r\n  top: 0;\r\n  height: 22px;\r\n  border-radius: 4px;\r\n  -webkit-transform: translate3d(0, 0, 0);\r\n  transform: translate3d(0, 0, 0);\r\n  width: 100px !important;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on,\r\n.bootstrap-switch .bootstrap-switch-handle-off,\r\n.bootstrap-switch .bootstrap-switch-label {\r\n  -webkit-box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n  cursor: pointer;\r\n  display: inline-block !important;\r\n  height: 100%;\r\n  color: #fff;\r\n  padding: 6px 12px;\r\n  font-size: 11px;\r\n  text-indent: -5px;\r\n  line-height: 15px;\r\n  -webkit-transition: 0.25s ease-out;\r\n          transition: 0.25s ease-out;\r\n\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on,\r\n.bootstrap-switch .bootstrap-switch-handle-off {\r\n  text-align: center;\r\n  z-index: 1;\r\n  float: left;\r\n  line-height: 11px;\r\n  width: 50% !important;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-brown,\r\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-brown {\r\n  color: #fff;\r\n  background: $brand-primary;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-blue,\r\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-blue {\r\n  color: #fff;\r\n  background: $brand-info;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-green,\r\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-green {\r\n  color: #fff;\r\n  background: $brand-success;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-orange,\r\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-orange {\r\n  background: $brand-warning;\r\n  color: #fff;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-red,\r\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-red {\r\n  color: #fff;\r\n  background: $brand-danger;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,\r\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\r\n  color: #fff;\r\n}\r\n.bootstrap-switch .bootstrap-switch-label {\r\n  text-align: center;\r\n  z-index: 100;\r\n  color: #333333;\r\n  background: #ffffff;\r\n  width: 22px !important;\r\n  height: 22px !important;\r\n  margin: 0px -11px;\r\n  border-radius: 20px;\r\n  position: absolute;\r\n  float: left;\r\n  top: 0;\r\n  left: 50%;\r\n  padding: 0;\r\n  box-shadow: 0 1px 11px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label{\r\n    background-color: rgba(23, 23, 23, .4);\r\n}\r\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label{\r\n    width: 27px !important;\r\n    margin-left: -16px;\r\n}\r\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label{\r\n    width: 27px !important;\r\n    margin-left: -11px;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-on {\r\n  border-bottom-left-radius: 3px;\r\n  border-top-left-radius: 3px;\r\n}\r\n.bootstrap-switch .bootstrap-switch-handle-off {\r\n  text-indent: 6px;\r\n}\r\n.bootstrap-switch input[type='radio'],\r\n.bootstrap-switch input[type='checkbox'] {\r\n  position: absolute !important;\r\n  top: 0;\r\n  left: 0;\r\n  opacity: 0;\r\n  filter: alpha(opacity=0);\r\n  z-index: -1;\r\n}\r\n.bootstrap-switch input[type='radio'].form-control,\r\n.bootstrap-switch input[type='checkbox'].form-control {\r\n  height: auto;\r\n}\r\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\r\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\r\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\r\n  padding: 1px 5px;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n}\r\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\r\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\r\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\r\n  padding: 5px 10px;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n}\r\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\r\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\r\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\r\n  padding: 6px 16px;\r\n  font-size: 18px;\r\n  line-height: 1.33;\r\n}\r\n.bootstrap-switch.bootstrap-switch-disabled,\r\n.bootstrap-switch.bootstrap-switch-readonly,\r\n.bootstrap-switch.bootstrap-switch-indeterminate {\r\n  cursor: default !important;\r\n}\r\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\r\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\r\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\r\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\r\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\r\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\r\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\r\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\r\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n  cursor: default !important;\r\n}\r\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\r\n  -webkit-transition: margin-left 0.5s;\r\n  transition: margin-left 0.5s;\r\n}\r\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\r\n  border-bottom-left-radius: 0;\r\n  border-top-left-radius: 0;\r\n  border-bottom-right-radius: 3px;\r\n  border-top-right-radius: 3px;\r\n}\r\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\r\n  border-bottom-right-radius: 0;\r\n  border-top-right-radius: 0;\r\n  border-bottom-left-radius: 3px;\r\n  border-top-left-radius: 3px;\r\n}\r\n.bootstrap-switch.bootstrap-switch-focused {\r\n  // border-color: #66afe9;\r\n  // outline: 0;\r\n  // -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\r\n  // box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\r\n}\r\n// .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label,\r\n// .bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-off .bootstrap-switch-label {\r\n//   border-bottom-right-radius: 3px;\r\n//   border-top-right-radius: 3px;\r\n// }\r\n// .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label,\r\n// .bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-on .bootstrap-switch-label {\r\n//   border-bottom-left-radius: 3px;\r\n//   border-top-left-radius: 3px;\r\n// }\r\n\r\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container{\r\n    margin-left: -2px !important;\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container{\r\n    margin-left: -39px !important;\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label{\r\n    &:before{\r\n        background-color: #FFFFFF;\r\n    }\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-red ~ .bootstrap-switch-default{\r\n    background-color: $brand-danger;\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-orange ~ .bootstrap-switch-default{\r\n    background-color: $brand-warning;\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-green ~ .bootstrap-switch-default{\r\n    background-color: $brand-success;\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-brown ~ .bootstrap-switch-default{\r\n    background-color: $brand-primary;\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-blue ~ .bootstrap-switch-default{\r\n    background-color: $brand-info;\r\n}\r\n\r\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-red,\r\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-brown,\r\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-blue,\r\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-orange,\r\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-green{\r\n    background-color: $light-gray;\r\n}\r\n\r\n.bootstrap-switch-off .bootstrap-switch-handle-on{\r\n    opacity: 0;\r\n}\r\n\r\n.bootstrap-switch-on .bootstrap-switch-handle-off{\r\n    opacity: 0;\r\n}\r\n","/*! nouislider - 13.1.4 */\r\n/* Functional styling;\r\n * These styles are required for noUiSlider to function.\r\n * You don't need to change these rules to apply your design.\r\n */\r\n.noUi-target,\r\n.noUi-target * {\r\n  -webkit-touch-callout: none;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n  -webkit-user-select: none;\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  -ms-user-select: none;\r\n  -moz-user-select: none;\r\n  user-select: none;\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n.noUi-target {\r\n  position: relative;\r\n  direction: ltr;\r\n}\r\n.noUi-base,\r\n.noUi-connects {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n/* Wrapper for all connect elements.\r\n */\r\n.noUi-connects {\r\n  overflow: hidden;\r\n  z-index: 0;\r\n}\r\n.noUi-connect,\r\n.noUi-origin {\r\n  will-change: transform;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  -ms-transform-origin: 0 0;\r\n  -webkit-transform-origin: 0 0;\r\n  transform-origin: 0 0;\r\n}\r\n/* Offset direction\r\n */\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n/* Give origins 0 height/width so they don't interfere with clicking the\r\n * connect elements.\r\n */\r\n.noUi-vertical .noUi-origin {\r\n  width: 0;\r\n}\r\n.noUi-horizontal .noUi-origin {\r\n  height: 0;\r\n}\r\n.noUi-handle {\r\n  position: absolute;\r\n}\r\n.noUi-state-tap .noUi-connect,\r\n.noUi-state-tap .noUi-origin {\r\n  -webkit-transition: transform 0.3s;\r\n  transition: transform 0.3s;\r\n}\r\n.noUi-state-drag * {\r\n  cursor: inherit !important;\r\n}\r\n/* Slider size and handle placement;\r\n */\r\n.noUi-horizontal {\r\n  height: 1px;\r\n}\r\n.noUi-horizontal .noUi-handle {\r\n    border-radius: 50%;\r\n\tbackground-color: $white-color;\r\n\tbox-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);\r\n\theight:15px;\r\n\twidth:15px;\r\n\tcursor:pointer;\r\n    margin-top: -7px;\r\n    outline: none;\r\n}\r\n.noUi-vertical {\r\n\twidth: 18px;\r\n}\r\n.noUi-vertical .noUi-handle {\r\n  width: 28px;\r\n  height: 34px;\r\n  left: -6px;\r\n  top: -17px;\r\n}\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n  right: -15px;\r\n  left: auto;\r\n}\r\n/* Styling;\r\n * Giving the connect element a border radius causes issues with using transform: scale\r\n */\r\n .noUi-target {\r\n \tbackground-color: rgba(182, 182, 182, .3);\r\n \tborder-radius: 3px;\r\n }\r\n.noUi-connects {\r\n  border-radius: 3px;\r\n}\r\n.noUi-connect {\r\n\tbackground: $default-color;\r\n    border-radius: 3px;\r\n-webkit-transition: background 450ms;\r\n\ttransition: background 450ms;\r\n}\r\n/* Handles and cursors;\r\n */\r\n.noUi-draggable {\r\n  cursor: ew-resize;\r\n}\r\n.noUi-vertical .noUi-draggable {\r\n  cursor: ns-resize;\r\n}\r\n.noUi-handle {\r\n\t// border: 1px solid #D9D9D9;\r\n\tborder-radius: 3px;\r\n\tbackground: #FFF;\r\n\tcursor: default;\r\n\tbox-shadow: inset 0 0 1px #FFF,\r\n\t\t\t\tinset 0 1px 7px #EBEBEB,\r\n\t\t\t\t0 3px 6px -3px #BBB;\r\n\t-webkit-transition: $general-transition-time $transition-ease;\r\n    -moz-transition: $general-transition-time $transition-ease;\r\n    -ms-transition: $general-transition-time $transition-ease;\r\n    -o-transform: $general-transition-time $transition-ease;\r\n    transition: $general-transition-time $transition-ease;\r\n}\r\n.noUi-active {\r\n\t-webkit-transform: scale3d(1.5,1.5,1);\r\n    -moz-transform: scale3d(1.5,1.5,1);\r\n    -ms-transform: scale3d(1.5,1.5,1);\r\n    -o-transform: scale3d(1.5,1.5,1);\r\n    transform: scale3d(1.5,1.5,1);\r\n}\r\n/* Handle stripes;\r\n */\r\n.noUi-handle:before,\r\n.noUi-handle:after {\r\n  display: none;\r\n}\r\n.noUi-handle:after {\r\n  left: 17px;\r\n}\r\n.noUi-vertical .noUi-handle:before,\r\n.noUi-vertical .noUi-handle:after {\r\n  width: 14px;\r\n  height: 1px;\r\n  left: 6px;\r\n  top: 14px;\r\n}\r\n.noUi-vertical .noUi-handle:after {\r\n  top: 17px;\r\n}\r\n/* Disabled state;\r\n */\r\n[disabled] .noUi-connect {\r\n  background: #B8B8B8;\r\n}\r\n[disabled].noUi-target,\r\n[disabled].noUi-handle,\r\n[disabled] .noUi-handle {\r\n  cursor: not-allowed;\r\n}\r\n/* Base;\r\n *\r\n */\r\n.noUi-pips,\r\n.noUi-pips * {\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n.noUi-pips {\r\n  position: absolute;\r\n  color: #999;\r\n}\r\n/* Values;\r\n *\r\n */\r\n.noUi-value {\r\n  position: absolute;\r\n  white-space: nowrap;\r\n  text-align: center;\r\n}\r\n.noUi-value-sub {\r\n  color: #ccc;\r\n  font-size: 10px;\r\n}\r\n/* Markings;\r\n *\r\n */\r\n.noUi-marker {\r\n  position: absolute;\r\n  background: #CCC;\r\n}\r\n.noUi-marker-sub {\r\n  background: #AAA;\r\n}\r\n.noUi-marker-large {\r\n  background: #AAA;\r\n}\r\n/* Horizontal layout;\r\n *\r\n */\r\n.noUi-pips-horizontal {\r\n  padding: 10px 0;\r\n  height: 80px;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n.noUi-value-horizontal {\r\n  -webkit-transform: translate(-50%, 50%);\r\n  transform: translate(-50%, 50%);\r\n}\r\n.noUi-rtl .noUi-value-horizontal {\r\n  -webkit-transform: translate(50%, 50%);\r\n  transform: translate(50%, 50%);\r\n}\r\n.noUi-marker-horizontal.noUi-marker {\r\n  margin-left: -1px;\r\n  width: 2px;\r\n  height: 5px;\r\n}\r\n.noUi-marker-horizontal.noUi-marker-sub {\r\n  height: 10px;\r\n}\r\n.noUi-marker-horizontal.noUi-marker-large {\r\n  height: 15px;\r\n}\r\n/* Vertical layout;\r\n *\r\n */\r\n.noUi-pips-vertical {\r\n  padding: 0 10px;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 100%;\r\n}\r\n.noUi-value-vertical {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%, 0);\r\n  padding-left: 25px;\r\n}\r\n.noUi-rtl .noUi-value-vertical {\r\n  -webkit-transform: translate(0, 50%);\r\n  transform: translate(0, 50%);\r\n}\r\n.noUi-marker-vertical.noUi-marker {\r\n  width: 5px;\r\n  height: 2px;\r\n  margin-top: -1px;\r\n}\r\n.noUi-marker-vertical.noUi-marker-sub {\r\n  width: 10px;\r\n}\r\n.noUi-marker-vertical.noUi-marker-large {\r\n  width: 15px;\r\n}\r\n.noUi-tooltip {\r\n  display: block;\r\n  position: absolute;\r\n  border: 1px solid #D9D9D9;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n  color: #000;\r\n  padding: 5px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n.noUi-horizontal .noUi-tooltip {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n  left: 50%;\r\n  bottom: 120%;\r\n}\r\n.noUi-vertical .noUi-tooltip {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n  top: 50%;\r\n  right: 120%;\r\n}\r\n\r\n.slider {\r\n\r\n\t&.slider-neutral{\r\n\t\t& .noUi-connect,\r\n        &.noUi-connect{\r\n            background-color: $white-color;\r\n        }\r\n\r\n\t\t&.noUi-target{\r\n\t\t\tbackground-color: rgba(255,255,255, .3);\r\n\t\t}\r\n\r\n\t\t& .noUi-handle{\r\n\t\t\tbackground-color: $white-color;\r\n\t\t}\r\n\t}\r\n\r\n\t&.slider-primary{\r\n\t\t& .noUi-connect,\r\n        &.noUi-connect{\r\n            background-color: $primary-color;\r\n        }\r\n\r\n\t\t&.noUi-target{\r\n\t\t\tbackground-color: $primary-color-opacity;\r\n\t\t}\r\n\r\n\t\t& .noUi-handle{\r\n\t\t\tbackground-color: $brand-primary;\r\n\t\t}\r\n\t}\r\n\r\n    &.slider-info{\r\n        & .noUi-connect,\r\n        &.noUi-connect{\r\n            background-color: $brand-info;\r\n        }\r\n\r\n\t\t&.noUi-target{\r\n\t\t\tbackground-color: $info-color-opacity;\r\n\t\t}\r\n\r\n\t\t& .noUi-handle{\r\n\t\t\tbackground-color: $brand-info;\r\n\t\t}\r\n    }\r\n    &.slider-success{\r\n        & .noUi-connect,\r\n        &.noUi-connect{\r\n            background-color: $brand-success;\r\n        }\r\n\r\n        &.noUi-target{\r\n\t\t\tbackground-color: $success-color-opacity;\r\n\t\t}\r\n\r\n\t\t& .noUi-handle{\r\n\t\t\tbackground-color: $brand-success;\r\n\t\t}\r\n    }\r\n    &.slider-warning{\r\n        & .noUi-connect,\r\n        &.noUi-connect{\r\n            background-color: $brand-warning;\r\n        }\r\n\r\n        &.noUi-target{\r\n\t\t\tbackground-color: $warning-color-opacity;\r\n\t\t}\r\n\r\n\t\t& .noUi-handle{\r\n\t\t\tbackground-color: $brand-warning;\r\n\t\t}\r\n    }\r\n    &.slider-danger{\r\n        & .noUi-connect,\r\n        &.noUi-connect{\r\n            background-color: $brand-danger;\r\n        }\r\n\r\n        &.noUi-target{\r\n\t\t\tbackground-color: $danger-color-opacity;\r\n\t\t}\r\n\r\n\t\t& .noUi-handle{\r\n\t\t\tbackground-color: $brand-danger;\r\n\t\t}\r\n    }\r\n\r\n}\r\n","/*!\r\n * Datepicker for Bootstrap v1.7.0-dev (https://github.com/uxsolutions/bootstrap-datepicker)\r\n *\r\n * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)\r\n */\r\n\r\n.datepicker {\r\n  padding: 8px 6px;\r\n  -webkit-border-radius: 4px;\r\n  -moz-border-radius: 4px;\r\n  border-radius: 4px;\r\n  direction: ltr;\r\n  @include transform-translate-y(-40px);\r\n  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;\r\n\r\n  @include opacity(0);\r\n  visibility: hidden;\r\n  display: block;\r\n  width: 254px;\r\n  max-width: 254px;\r\n\r\n  &.dropdown-menu:before{\r\n      display: none;\r\n  }\r\n\r\n  &.datepicker-primary{\r\n      @include datepicker-colors($primary-color);\r\n  }\r\n}\r\n.datepicker-inline {\r\n  width: 220px;\r\n}\r\n.datepicker.datepicker-rtl {\r\n  direction: rtl;\r\n}\r\n.datepicker.datepicker-rtl.dropdown-menu {\r\n  left: auto;\r\n}\r\n.datepicker.datepicker-rtl table tr td span {\r\n  float: right;\r\n}\r\n.datepicker-dropdown {\r\n  top: 0;\r\n  left: 0;\r\n}\r\n.datepicker-dropdown:before {\r\n  content: '';\r\n  display: inline-block;\r\n  border-left: 7px solid transparent;\r\n  border-right: 7px solid transparent;\r\n  border-bottom: 7px solid transparent;\r\n  border-top: 0;\r\n  border-bottom-color: rgba(0, 0, 0, 0.2);\r\n  position: absolute;\r\n}\r\n.datepicker-dropdown:after {\r\n  content: '';\r\n  display: inline-block;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-bottom: 6px solid #fff;\r\n  border-top: 0;\r\n  position: absolute;\r\n}\r\n.datepicker-dropdown.datepicker-orient-left:before {\r\n  left: 6px;\r\n}\r\n.datepicker-dropdown.datepicker-orient-left:after {\r\n  left: 7px;\r\n}\r\n.datepicker-dropdown.datepicker-orient-right:before {\r\n  right: 6px;\r\n}\r\n.datepicker-dropdown.datepicker-orient-right:after {\r\n  right: 7px;\r\n}\r\n.datepicker-dropdown.datepicker-orient-bottom:before {\r\n  top: -7px;\r\n}\r\n.datepicker-dropdown.datepicker-orient-bottom:after {\r\n  top: -6px;\r\n}\r\n.datepicker-dropdown.datepicker-orient-top:before {\r\n  bottom: -7px;\r\n  border-bottom: 0;\r\n  border-top: 7px solid transparent;\r\n}\r\n.datepicker-dropdown.datepicker-orient-top:after {\r\n  bottom: -6px;\r\n  border-bottom: 0;\r\n  border-top: 6px solid #fff;\r\n}\r\n.datepicker table {\r\n  margin: 0;\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  width: 241px;\r\n  max-width: 241px;\r\n}\r\n.datepicker .day div,\r\n.datepicker th {\r\n  @include transition($general-transition-time, $transition-ease);\r\n  text-align: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 2.2;\r\n  -webkit-border-radius: 4px;\r\n  -moz-border-radius: 4px;\r\n  border-radius: 50%;\r\n  font-weight: $font-weight-light;\r\n  font-size: $font-size-base;\r\n  border: none;\r\n   z-index: 1;\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.datepicker th{\r\n    color: $primary-color;\r\n}\r\n\r\n.table-condensed > tbody > tr > td,\r\n.table-condensed > tbody > tr > th,\r\n.table-condensed > tfoot > tr > td,\r\n.table-condensed > tfoot > tr > th,\r\n.table-condensed > thead > tr > td,\r\n.table-condensed > thead > tr > th{\r\n    padding: 2px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.table-striped .datepicker table tr td,\r\n.table-striped .datepicker table tr th {\r\n  background-color: transparent;\r\n}\r\n.datepicker table tr td.day:hover div,\r\n.datepicker table tr td.day.focused div {\r\n  background: #eee;\r\n  cursor: pointer;\r\n}\r\n.datepicker table tr td.old,\r\n.datepicker table tr td.new {\r\n  color: $default-color;\r\n}\r\n.datepicker table tr td.disabled,\r\n.datepicker table tr td.disabled:hover {\r\n  background: none;\r\n  color: $default-color ;\r\n  cursor: default;\r\n}\r\n.datepicker table tr td.highlighted {\r\n  background: #d9edf7;\r\n  border-radius: 0;\r\n}\r\n.datepicker table tr td.today,\r\n.datepicker table tr td.today:hover,\r\n.datepicker table tr td.today.disabled,\r\n.datepicker table tr td.today.disabled:hover {\r\n  background-color: #fde19a;\r\n  background-image: -moz-linear-gradient(to bottom, #fdd49a, #fdf59a);\r\n  background-image: -ms-linear-gradient(to bottom, #fdd49a, #fdf59a);\r\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#fdd49a), to(#fdf59a));\r\n  background-image: -webkit-linear-gradient(to bottom, #fdd49a, #fdf59a);\r\n  background-image: -o-linear-gradient(to bottom, #fdd49a, #fdf59a);\r\n  background-image: linear-gradient(to bottom, #fdd49a, #fdf59a);\r\n  background-repeat: repeat-x;\r\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fdd49a', endColorstr='#fdf59a', GradientType=0);\r\n  border-color: #fdf59a #fdf59a #fbed50;\r\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\r\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\r\n  color: #000;\r\n}\r\n.datepicker table tr td.today:hover,\r\n.datepicker table tr td.today:hover:hover,\r\n.datepicker table tr td.today.disabled:hover,\r\n.datepicker table tr td.today.disabled:hover:hover,\r\n.datepicker table tr td.today:active,\r\n.datepicker table tr td.today:hover:active,\r\n.datepicker table tr td.today.disabled:active,\r\n.datepicker table tr td.today.disabled:hover:active,\r\n.datepicker table tr td.today.active,\r\n.datepicker table tr td.today:hover.active,\r\n.datepicker table tr td.today.disabled.active,\r\n.datepicker table tr td.today.disabled:hover.active,\r\n.datepicker table tr td.today.disabled,\r\n.datepicker table tr td.today:hover.disabled,\r\n.datepicker table tr td.today.disabled.disabled,\r\n.datepicker table tr td.today.disabled:hover.disabled,\r\n.datepicker table tr td.today[disabled],\r\n.datepicker table tr td.today:hover[disabled],\r\n.datepicker table tr td.today.disabled[disabled],\r\n.datepicker table tr td.today.disabled:hover[disabled] {\r\n  background-color: #fdf59a;\r\n}\r\n.datepicker table tr td.today:active,\r\n.datepicker table tr td.today:hover:active,\r\n.datepicker table tr td.today.disabled:active,\r\n.datepicker table tr td.today.disabled:hover:active,\r\n.datepicker table tr td.today.active,\r\n.datepicker table tr td.today:hover.active,\r\n.datepicker table tr td.today.disabled.active,\r\n.datepicker table tr td.today.disabled:hover.active {\r\n  background-color: #fbf069 \\9;\r\n}\r\n.datepicker table tr td.today:hover:hover {\r\n  color: #000;\r\n}\r\n.datepicker table tr td.today.active:hover {\r\n  color: #fff;\r\n}\r\n.datepicker table tr td.range,\r\n.datepicker table tr td.range:hover,\r\n.datepicker table tr td.range.disabled,\r\n.datepicker table tr td.range.disabled:hover {\r\n  background: #eee;\r\n  -webkit-border-radius: 0;\r\n  -moz-border-radius: 0;\r\n  border-radius: 0;\r\n}\r\n.datepicker table tr td.range.today,\r\n.datepicker table tr td.range.today:hover,\r\n.datepicker table tr td.range.today.disabled,\r\n.datepicker table tr td.range.today.disabled:hover {\r\n  background-color: #f3d17a;\r\n  background-image: -moz-linear-gradient(to bottom, #f3c17a, #f3e97a);\r\n  background-image: -ms-linear-gradient(to bottom, #f3c17a, #f3e97a);\r\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#f3c17a), to(#f3e97a));\r\n  background-image: -webkit-linear-gradient(to bottom, #f3c17a, #f3e97a);\r\n  background-image: -o-linear-gradient(to bottom, #f3c17a, #f3e97a);\r\n  background-image: linear-gradient(to bottom, #f3c17a, #f3e97a);\r\n  background-repeat: repeat-x;\r\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f3c17a', endColorstr='#f3e97a', GradientType=0);\r\n  border-color: #f3e97a #f3e97a #edde34;\r\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\r\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\r\n  -webkit-border-radius: 0;\r\n  -moz-border-radius: 0;\r\n  border-radius: 0;\r\n}\r\n.datepicker table tr td.range.today:hover,\r\n.datepicker table tr td.range.today:hover:hover,\r\n.datepicker table tr td.range.today.disabled:hover,\r\n.datepicker table tr td.range.today.disabled:hover:hover,\r\n.datepicker table tr td.range.today:active,\r\n.datepicker table tr td.range.today:hover:active,\r\n.datepicker table tr td.range.today.disabled:active,\r\n.datepicker table tr td.range.today.disabled:hover:active,\r\n.datepicker table tr td.range.today.active,\r\n.datepicker table tr td.range.today:hover.active,\r\n.datepicker table tr td.range.today.disabled.active,\r\n.datepicker table tr td.range.today.disabled:hover.active,\r\n.datepicker table tr td.range.today.disabled,\r\n.datepicker table tr td.range.today:hover.disabled,\r\n.datepicker table tr td.range.today.disabled.disabled,\r\n.datepicker table tr td.range.today.disabled:hover.disabled,\r\n.datepicker table tr td.range.today[disabled],\r\n.datepicker table tr td.range.today:hover[disabled],\r\n.datepicker table tr td.range.today.disabled[disabled],\r\n.datepicker table tr td.range.today.disabled:hover[disabled] {\r\n  background-color: #f3e97a;\r\n}\r\n.datepicker table tr td.range.today:active,\r\n.datepicker table tr td.range.today:hover:active,\r\n.datepicker table tr td.range.today.disabled:active,\r\n.datepicker table tr td.range.today.disabled:hover:active,\r\n.datepicker table tr td.range.today.active,\r\n.datepicker table tr td.range.today:hover.active,\r\n.datepicker table tr td.range.today.disabled.active,\r\n.datepicker table tr td.range.today.disabled:hover.active {\r\n  background-color: #efe24b \\9;\r\n}\r\n.datepicker table tr td.selected,\r\n.datepicker table tr td.selected:hover,\r\n.datepicker table tr td.selected.disabled,\r\n.datepicker table tr td.selected.disabled:hover {\r\n  background-color: #9e9e9e;\r\n  background-image: -moz-linear-gradient(to bottom, #b3b3b3, #808080);\r\n  background-image: -ms-linear-gradient(to bottom, #b3b3b3, #808080);\r\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#b3b3b3), to(#808080));\r\n  background-image: -webkit-linear-gradient(to bottom, #b3b3b3, #808080);\r\n  background-image: -o-linear-gradient(to bottom, #b3b3b3, #808080);\r\n  background-image: linear-gradient(to bottom, #b3b3b3, #808080);\r\n  background-repeat: repeat-x;\r\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#b3b3b3', endColorstr='#808080', GradientType=0);\r\n  border-color: #808080 #808080 #595959;\r\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\r\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\r\n  color: #fff;\r\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\r\n}\r\n.datepicker table tr td.selected:hover,\r\n.datepicker table tr td.selected:hover:hover,\r\n.datepicker table tr td.selected.disabled:hover,\r\n.datepicker table tr td.selected.disabled:hover:hover,\r\n.datepicker table tr td.selected:active,\r\n.datepicker table tr td.selected:hover:active,\r\n.datepicker table tr td.selected.disabled:active,\r\n.datepicker table tr td.selected.disabled:hover:active,\r\n.datepicker table tr td.selected.active,\r\n.datepicker table tr td.selected:hover.active,\r\n.datepicker table tr td.selected.disabled.active,\r\n.datepicker table tr td.selected.disabled:hover.active,\r\n.datepicker table tr td.selected.disabled,\r\n.datepicker table tr td.selected:hover.disabled,\r\n.datepicker table tr td.selected.disabled.disabled,\r\n.datepicker table tr td.selected.disabled:hover.disabled,\r\n.datepicker table tr td.selected[disabled],\r\n.datepicker table tr td.selected:hover[disabled],\r\n.datepicker table tr td.selected.disabled[disabled],\r\n.datepicker table tr td.selected.disabled:hover[disabled] {\r\n  background-color: #808080;\r\n}\r\n.datepicker table tr td.selected:active,\r\n.datepicker table tr td.selected:hover:active,\r\n.datepicker table tr td.selected.disabled:active,\r\n.datepicker table tr td.selected.disabled:hover:active,\r\n.datepicker table tr td.selected.active,\r\n.datepicker table tr td.selected:hover.active,\r\n.datepicker table tr td.selected.disabled.active,\r\n.datepicker table tr td.selected.disabled:hover.active {\r\n  background-color: #666666 \\9;\r\n}\r\n.datepicker table tr td.active div,\r\n.datepicker table tr td.active:hover div,\r\n.datepicker table tr td.active.disabled div,\r\n.datepicker table tr td.active.disabled:hover div {\r\n\r\n  background-color: $primary-color;\r\n  color: $white-color;\r\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n.datepicker table tr td.active:hover div,\r\n.datepicker table tr td.active:hover:hover div,\r\n.datepicker table tr td.active.disabled:hover div,\r\n.datepicker table tr td.active.disabled:hover:hover div,\r\n.datepicker table tr td.active:active div,\r\n.datepicker table tr td.active:hover:active div,\r\n.datepicker table tr td.active.disabled:active div,\r\n.datepicker table tr td.active.disabled:hover:active div,\r\n.datepicker table tr td.active.active div,\r\n.datepicker table tr td.active:hover.active div,\r\n.datepicker table tr td.active.disabled.active div,\r\n.datepicker table tr td.active.disabled:hover.active div,\r\n.datepicker table tr td.active.disabled div,\r\n.datepicker table tr td.active:hover.disabled div,\r\n.datepicker table tr td.active.disabled.disabled div,\r\n.datepicker table tr td.active.disabled:hover.disabled div,\r\n.datepicker table tr td.active[disabled] div,\r\n.datepicker table tr td.active:hover[disabled] div,\r\n.datepicker table tr td.active.disabled[disabled] div,\r\n.datepicker table tr td.active.disabled:hover[disabled] div{\r\n  background-color: $primary-color;\r\n}\r\n.datepicker table tr td.active:active,\r\n.datepicker table tr td.active:hover:active,\r\n.datepicker table tr td.active.disabled:active,\r\n.datepicker table tr td.active.disabled:hover:active,\r\n.datepicker table tr td.active.active,\r\n.datepicker table tr td.active:hover.active,\r\n.datepicker table tr td.active.disabled.active,\r\n.datepicker table tr td.active.disabled:hover.active {\r\n  background-color: #003399 \\9;\r\n}\r\n.datepicker table tr td span {\r\n  display: block;\r\n  width: 41px;\r\n  height: 41px;\r\n  line-height: 41px;\r\n  float: left;\r\n  margin: 1%;\r\n  font-size: $font-size-base;\r\n  cursor: pointer;\r\n  -webkit-border-radius: 50%;\r\n  -moz-border-radius: 50%;\r\n  border-radius: 50%;\r\n\r\n}\r\n.datepicker table tr td span:hover,\r\n.datepicker table tr td span.focused {\r\n  background: #eee;\r\n}\r\n.datepicker table tr td span.disabled,\r\n.datepicker table tr td span.disabled:hover {\r\n  background: none;\r\n  color: $default-color;\r\n  cursor: default;\r\n}\r\n.datepicker table tr td span.active,\r\n.datepicker table tr td span.active:hover,\r\n.datepicker table tr td span.active.disabled,\r\n.datepicker table tr td span.active.disabled:hover {\r\n  color: #fff;\r\n  background-color: $primary-color;\r\n}\r\n.datepicker table tr td span.active:hover,\r\n.datepicker table tr td span.active:hover:hover,\r\n.datepicker table tr td span.active.disabled:hover,\r\n.datepicker table tr td span.active.disabled:hover:hover,\r\n.datepicker table tr td span.active:active,\r\n.datepicker table tr td span.active:hover:active,\r\n.datepicker table tr td span.active.disabled:active,\r\n.datepicker table tr td span.active.disabled:hover:active,\r\n.datepicker table tr td span.active.active,\r\n.datepicker table tr td span.active:hover.active,\r\n.datepicker table tr td span.active.disabled.active,\r\n.datepicker table tr td span.active.disabled:hover.active,\r\n.datepicker table tr td span.active.disabled,\r\n.datepicker table tr td span.active:hover.disabled,\r\n.datepicker table tr td span.active.disabled.disabled,\r\n.datepicker table tr td span.active.disabled:hover.disabled,\r\n.datepicker table tr td span.active[disabled],\r\n.datepicker table tr td span.active:hover[disabled],\r\n.datepicker table tr td span.active.disabled[disabled],\r\n.datepicker table tr td span.active.disabled:hover[disabled] {\r\n   background-color: $primary-color;\r\n   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n.datepicker table tr td span.active:active,\r\n.datepicker table tr td span.active:hover:active,\r\n.datepicker table tr td span.active.disabled:active,\r\n.datepicker table tr td span.active.disabled:hover:active,\r\n.datepicker table tr td span.active.active,\r\n.datepicker table tr td span.active:hover.active,\r\n.datepicker table tr td span.active.disabled.active,\r\n.datepicker table tr td span.active.disabled:hover.active {\r\n  background-color: #003399 \\9;\r\n}\r\n.datepicker table tr td span.old,\r\n.datepicker table tr td span.new {\r\n  color: $default-color;\r\n}\r\n.datepicker .datepicker-switch {\r\n  width: auto;\r\n  border-radius: $border-radius-small;\r\n}\r\n.datepicker .datepicker-switch,\r\n.datepicker .prev,\r\n.datepicker .next,\r\n.datepicker tfoot tr th {\r\n  cursor: pointer;\r\n}\r\n\r\n.datepicker{\r\n    .prev,\r\n    .next{\r\n        width: 35px;\r\n        height: 35px;\r\n    }\r\n\r\n    i{\r\n        position: relative;\r\n        top: 2px;\r\n    }\r\n\r\n    .prev i{\r\n        left: -1px;\r\n    }\r\n\r\n    .next i{\r\n        right: -1px;\r\n    }\r\n}\r\n\r\n.datepicker .datepicker-switch:hover,\r\n.datepicker .prev:hover,\r\n.datepicker .next:hover,\r\n.datepicker tfoot tr th:hover {\r\n  background: #eee;\r\n}\r\n.datepicker .prev.disabled,\r\n.datepicker .next.disabled {\r\n  visibility: hidden;\r\n}\r\n.datepicker .cw {\r\n  font-size: 10px;\r\n  width: 12px;\r\n  padding: 0 2px 0 5px;\r\n  vertical-align: middle;\r\n}\r\n.input-append.date .add-on,\r\n.input-prepend.date .add-on {\r\n  cursor: pointer;\r\n}\r\n.input-append.date .add-on i,\r\n.input-prepend.date .add-on i {\r\n  margin-top: 3px;\r\n}\r\n.input-daterange input {\r\n  text-align: center;\r\n}\r\n.input-daterange input:first-child {\r\n  -webkit-border-radius: 3px 0 0 3px;\r\n  -moz-border-radius: 3px 0 0 3px;\r\n  border-radius: 3px 0 0 3px;\r\n}\r\n.input-daterange input:last-child {\r\n  -webkit-border-radius: 0 3px 3px 0;\r\n  -moz-border-radius: 0 3px 3px 0;\r\n  border-radius: 0 3px 3px 0;\r\n}\r\n.input-daterange .add-on {\r\n  display: inline-block;\r\n  width: auto;\r\n  min-width: 16px;\r\n  height: 18px;\r\n  padding: 4px 5px;\r\n  font-weight: normal;\r\n  line-height: 18px;\r\n  text-align: center;\r\n  text-shadow: 0 1px 0 #fff;\r\n  vertical-align: middle;\r\n  background-color: #eee;\r\n  border: 1px solid #ccc;\r\n  margin-left: -5px;\r\n  margin-right: -5px;\r\n}\r\n\r\n.table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th{\r\n     position: relative;\r\n     z-index: -1;\r\n}\r\n","@mixin box-shadow($shadow...) {\r\n  -webkit-box-shadow: $shadow; // iOS <4.3 & Android <4.1\r\n          box-shadow: $shadow;\r\n}\r\n\r\n@mixin transition-input-focus-color() {\r\n    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n    -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n    -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n    -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n}\r\n\r\n\r\n@mixin transition($time, $type){\r\n    -webkit-transition: all $time $type;\r\n    -moz-transition: all $time $type;\r\n    -o-transition: all $time $type;\r\n    -ms-transition: all $time $type;\r\n    transition: all $time $type;\r\n}\r\n\r\n@mixin transition-on-prop($prop ,$time, $type){\r\n    -webkit-transition: $prop $time $type;\r\n    -moz-transition: $prop $time $type;\r\n    -o-transition: $prop $time $type;\r\n    -ms-transition: all $time $type;\r\n    transition: $prop $time $type;\r\n}\r\n\r\n@mixin rotate-180(){\r\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\r\n    -webkit-transform: rotate(180deg);\r\n    -ms-transform: rotate(180deg);\r\n    transform: rotate(180deg);\r\n}\r\n\r\n@mixin transform-scale($value){\r\n-webkit-transform: scale($value);\r\n-moz-transform: scale($value);\r\n-o-transform: scale($value);\r\n-ms-transform: scale($value);\r\ntransform: scale($value);\r\n}\r\n\r\n@mixin transform-translate-x($value){\r\n     -webkit-transform:  translate3d($value, 0, 0);\r\n        -moz-transform: translate3d($value, 0, 0);\r\n        -o-transform: translate3d($value, 0, 0);\r\n        -ms-transform: translate3d($value, 0, 0);\r\n        transform: translate3d($value, 0, 0);\r\n}\r\n\r\n@mixin transform-translate-y-dropdown($value) {\r\n    -webkit-transform:  translate3d(0,$value,0) !important;\r\n       -moz-transform: translate3d(0,$value,0) !important;\r\n       -o-transform: translate3d(0,$value,0) !important;\r\n       -ms-transform: translate3d(0,$value,0) !important;\r\n       transform: translate3d(0,$value,0) !important;\r\n}\r\n\r\n@mixin transform-translate-y($value){\r\n     -webkit-transform:  translate3d(0,$value,0);\r\n        -moz-transform: translate3d(0,$value,0);\r\n        -o-transform: translate3d(0,$value,0);\r\n        -ms-transform: translate3d(0,$value,0);\r\n        transform: translate3d(0,$value,0);\r\n}\r\n\r\n@mixin bar-animation($type){\r\n     -webkit-animation: $type 500ms linear 0s;\r\n     -moz-animation: $type 500ms linear 0s;\r\n     animation: $type 500ms 0s;\r\n     -webkit-animation-fill-mode: forwards;\r\n     -moz-animation-fill-mode: forwards;\r\n     animation-fill-mode: forwards;\r\n}\r\n\r\n@mixin topbar-x-rotation(){\r\n    @keyframes topbar-x {\r\n      0% {top: 0px; transform: rotate(0deg); }\r\n      45% {top: 6px; transform: rotate(145deg); }\r\n      75% {transform: rotate(130deg); }\r\n      100% {transform: rotate(135deg); }\r\n    }\r\n    @-webkit-keyframes topbar-x {\r\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\r\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\r\n      75% {-webkit-transform: rotate(130deg); }\r\n      100% { -webkit-transform: rotate(135deg); }\r\n    }\r\n    @-moz-keyframes topbar-x {\r\n      0% {top: 0px; -moz-transform: rotate(0deg); }\r\n      45% {top: 6px; -moz-transform: rotate(145deg); }\r\n      75% {-moz-transform: rotate(130deg); }\r\n      100% { -moz-transform: rotate(135deg); }\r\n    }\r\n}\r\n\r\n@mixin topbar-back-rotation(){\r\n    @keyframes topbar-back {\r\n      0% { top: 6px; transform: rotate(135deg); }\r\n      45% { transform: rotate(-10deg); }\r\n      75% { transform: rotate(5deg); }\r\n      100% { top: 0px; transform: rotate(0); }\r\n    }\r\n\r\n    @-webkit-keyframes topbar-back {\r\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\r\n      45% { -webkit-transform: rotate(-10deg); }\r\n      75% { -webkit-transform: rotate(5deg); }\r\n      100% { top: 0px; -webkit-transform: rotate(0); }\r\n    }\r\n\r\n    @-moz-keyframes topbar-back {\r\n      0% { top: 6px; -moz-transform: rotate(135deg); }\r\n      45% { -moz-transform: rotate(-10deg); }\r\n      75% { -moz-transform: rotate(5deg); }\r\n      100% { top: 0px; -moz-transform: rotate(0); }\r\n    }\r\n}\r\n\r\n@mixin bottombar-x-rotation(){\r\n    @keyframes bottombar-x {\r\n      0% {bottom: 0px; transform: rotate(0deg);}\r\n      45% {bottom: 6px; transform: rotate(-145deg);}\r\n      75% {transform: rotate(-130deg);}\r\n      100% {transform: rotate(-135deg);}\r\n    }\r\n    @-webkit-keyframes bottombar-x {\r\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\r\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\r\n      75% {-webkit-transform: rotate(-130deg);}\r\n      100% {-webkit-transform: rotate(-135deg);}\r\n    }\r\n    @-moz-keyframes bottombar-x {\r\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\r\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\r\n      75% {-moz-transform: rotate(-130deg);}\r\n      100% {-moz-transform: rotate(-135deg);}\r\n    }\r\n}\r\n\r\n@mixin bottombar-back-rotation{\r\n    @keyframes bottombar-back {\r\n      0% { bottom: 6px;transform: rotate(-135deg);}\r\n      45% { transform: rotate(10deg);}\r\n      75% { transform: rotate(-5deg);}\r\n      100% { bottom: 0px;transform: rotate(0);}\r\n    }\r\n    @-webkit-keyframes bottombar-back {\r\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\r\n      45% {-webkit-transform: rotate(10deg);}\r\n      75% {-webkit-transform: rotate(-5deg);}\r\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\r\n    }\r\n    @-moz-keyframes bottombar-back {\r\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\r\n      45% {-moz-transform: rotate(10deg);}\r\n      75% {-moz-transform: rotate(-5deg);}\r\n      100% {bottom: 0px;-moz-transform: rotate(0);}\r\n    }\r\n\r\n}\r\n\r\n\r\n@mixin nc-rotate($degrees, $rotation) {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\r\n  -webkit-transform: rotate($degrees);\r\n  -moz-transform: rotate($degrees);\r\n  -ms-transform: rotate($degrees);\r\n  -o-transform: rotate($degrees);\r\n  transform: rotate($degrees);\r\n}\r\n\r\n@mixin nc-flip($horiz, $vert, $rotation) {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\r\n  -webkit-transform: scale($horiz, $vert);\r\n  -moz-transform: scale($horiz, $vert);\r\n  -ms-transform: scale($horiz, $vert);\r\n  -o-transform: scale($horiz, $vert);\r\n  transform: scale($horiz, $vert);\r\n}\r\n","// Opacity\r\n\r\n@mixin opacity($opacity) {\r\n  opacity: $opacity;\r\n  // IE8 filter\r\n  $opacity-ie: ($opacity * 100);\r\n  filter: #{alpha(opacity=$opacity-ie)};\r\n}\r\n","@mixin datepicker-colors($color) {\r\n    background-color: $color;\r\n\r\n    th,\r\n    .day div,\r\n    table tr td span{\r\n        color: $white-color;\r\n    }\r\n\r\n    &:after{\r\n        border-bottom-color: $color;\r\n    }\r\n\r\n    &.datepicker-orient-top:after{\r\n        border-top-color: $color;\r\n    }\r\n\r\n    .dow{\r\n        color: $datepicker-color-days;\r\n    }\r\n\r\n    table tr td.old div,\r\n    table tr td.new div,\r\n    table tr td span.old,\r\n    table tr td span.new{\r\n       color: $datepicker-color-old-new-days;\r\n    }\r\n\r\n    table tr td span:hover,\r\n    table tr td span.focused{\r\n        background:$opacity-1;\r\n    }\r\n\r\n    .datepicker-switch:hover,\r\n    .prev:hover,\r\n    .next:hover,\r\n    tfoot tr th:hover {\r\n      background: $opacity-2;\r\n    }\r\n\r\n    table tr td.active div,\r\n    table tr td.active:hover div,\r\n    table tr td.active.disabled div,\r\n    table tr td.active.disabled:hover div {\r\n\r\n      background-color: $white-color;\r\n      color: $color;\r\n    }\r\n\r\n    table tr td.day:hover div,\r\n    table tr td.day.focused div {\r\n      background: $opacity-2;\r\n    }\r\n\r\n    table tr td.active:hover div,\r\n    table tr td.active:hover:hover div,\r\n    table tr td.active.disabled:hover div,\r\n    table tr td.active.disabled:hover:hover div,\r\n    table tr td.active:active div,\r\n    table tr td.active:hover:active div,\r\n    table tr td.active.disabled:active div,\r\n    table tr td.active.disabled:hover:active div,\r\n    table tr td.active.active div,\r\n    table tr td.active:hover.active div,\r\n    table tr td.active.disabled.active div,\r\n    table tr td.active.disabled:hover.active div,\r\n    table tr td.active.disabled div,\r\n    table tr td.active:hover.disabled div,\r\n    table tr td.active.disabled.disabled div,\r\n    table tr td.active.disabled:hover.disabled div,\r\n    table tr td.active[disabled] div,\r\n    table tr td.active:hover[disabled] div,\r\n    table tr td.active.disabled[disabled] div,\r\n    table tr td.active.disabled:hover[disabled] div,\r\n    table tr td span.active:hover,\r\n    table tr td span.active:hover:hover,\r\n    table tr td span.active.disabled:hover,\r\n    table tr td span.active.disabled:hover:hover,\r\n    table tr td span.active:active,\r\n    table tr td span.active:hover:active,\r\n    table tr td span.active.disabled:active,\r\n    table tr td span.active.disabled:hover:active,\r\n    table tr td span.active.active,\r\n    table tr td span.active:hover.active,\r\n    table tr td span.active.disabled.active,\r\n    table tr td span.active.disabled:hover.active,\r\n    table tr td span.active.disabled,\r\n    table tr td span.active:hover.disabled,\r\n    table tr td span.active.disabled.disabled,\r\n    table tr td span.active.disabled:hover.disabled,\r\n    table tr td span.active[disabled],\r\n    table tr td span.active:hover[disabled],\r\n    table tr td span.active.disabled[disabled],\r\n    table tr td span.active.disabled:hover[disabled]{\r\n      background-color: $white-color;\r\n    }\r\n\r\n    table tr td span.active:hover,\r\n    table tr td span.active:hover:hover,\r\n    table tr td span.active.disabled:hover,\r\n    table tr td span.active.disabled:hover:hover,\r\n    table tr td span.active:active,\r\n    table tr td span.active:hover:active,\r\n    table tr td span.active.disabled:active,\r\n    table tr td span.active.disabled:hover:active,\r\n    table tr td span.active.active,\r\n    table tr td span.active:hover.active,\r\n    table tr td span.active.disabled.active,\r\n    table tr td span.active.disabled:hover.active,\r\n    table tr td span.active.disabled,\r\n    table tr td span.active:hover.disabled,\r\n    table tr td span.active.disabled.disabled,\r\n    table tr td span.active.disabled:hover.disabled,\r\n    table tr td span.active[disabled],\r\n    table tr td span.active:hover[disabled],\r\n    table tr td span.active.disabled[disabled],\r\n    table tr td span.active.disabled:hover[disabled]{\r\n        color: $color;\r\n    }\r\n\r\n}\r\n",".btn,\r\n.navbar .navbar-nav > a.btn{\r\n    border-width: $border-thick;\r\n    font-weight: $font-weight-normal;\r\n    font-size: $font-size-small;\r\n    line-height: $line-height;\r\n    margin: 10px 1px;\r\n    border: none;\r\n    border-radius: $border-radius-small;\r\n    padding: $padding-btn-vertical $padding-btn-horizontal;\r\n    cursor: pointer;\r\n\r\n    @include btn-styles($default-color, $default-states-color);\r\n\r\n    &:hover,\r\n    &:focus{\r\n        @include opacity(1);\r\n        outline: 0 !important;\r\n    }\r\n    &:active,\r\n    &.active,\r\n    .open > &.dropdown-toggle {\r\n         @include box-shadow(none);\r\n         outline: 0 !important;\r\n    }\r\n\r\n    &.btn-icon {\r\n        // see above for color variations\r\n        height: $btn-icon-size-regular;\r\n        min-width: $btn-icon-size-regular;\r\n        width: $btn-icon-size-regular;\r\n        padding: 0;\r\n        font-size: $btn-icon-font-size-regular;\r\n        overflow: hidden;\r\n        position: relative;\r\n        line-height: normal;\r\n\r\n        &[class*=\"btn-outline-\"]{\r\n            padding: 0;\r\n        }\r\n\r\n        &.btn-sm{\r\n            height: $btn-icon-size-small;\r\n            min-width: $btn-icon-size-small;\r\n            width: $btn-icon-size-small;\r\n\r\n            i.fab,\r\n            i.now-ui-icons{\r\n                font-size: $btn-icon-font-size-small;\r\n            }\r\n        }\r\n\r\n        &.btn-lg{\r\n            height: $btn-icon-size-lg;\r\n            min-width: $btn-icon-size-lg;\r\n            width: $btn-icon-size-lg;\r\n\r\n            i.now-ui-icons,\r\n            i.fab{\r\n                font-size: $btn-icon-font-size-lg;\r\n            }\r\n        }\r\n\r\n        &:not(.btn-footer) i.now-ui-icons,\r\n        &:not(.btn-footer) i.fab{\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            transform: translate(-12px, -12px);\r\n            line-height: 1.5626rem;\r\n            width: 23px;\r\n        }\r\n\r\n    }\r\n\r\n    &:not(.btn-icon) .now-ui-icons{\r\n        position: relative;\r\n        top: 1px;\r\n    }\r\n}\r\n\r\n// Apply the mixin to the buttons\r\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\r\n.btn-primary { @include btn-styles($primary-color, $primary-states-color); }\r\n.btn-success { @include btn-styles($success-color, $success-states-color); }\r\n.btn-info    { @include btn-styles($info-color, $info-states-color); }\r\n.btn-warning { @include btn-styles($warning-color, $warning-states-color); }\r\n.btn-danger  { @include btn-styles($danger-color, $danger-states-color); }\r\n.btn-neutral { @include btn-styles($white-color, $white-color); }\r\n\r\n.btn-outline-primary { @include outline-buttons($primary-color, $primary-states-color); }\r\n.btn-outline-success { @include outline-buttons($success-color, $success-states-color); }\r\n.btn-outline-info    { @include outline-buttons($info-color, $info-states-color); }\r\n.btn-outline-warning { @include outline-buttons($warning-color, $warning-states-color); }\r\n.btn-outline-danger  { @include outline-buttons($danger-color, $danger-states-color); }\r\n.btn-outline-default { @include outline-buttons($default-color, $default-states-color); }\r\n\r\n.btn-round{\r\n    border-width: $border-thin;\r\n    border-radius: $btn-round-radius !important;\r\n    padding: $padding-btn-vertical  $padding-round-horizontal;\r\n\r\n    &[class*=\"btn-outline-\"]{\r\n        padding: $padding-btn-vertical - 1  $padding-round-horizontal - 1;\r\n    }\r\n}\r\n[class*=\"btn-outline-\"]{\r\n    border: $border;\r\n    padding: $padding-btn-vertical - 1 $padding-round-horizontal - 1;\r\n    background-color: $transparent-bg;\r\n}\r\n\r\n[class*=\"btn-outline-\"],\r\n.btn-link{\r\n    &.disabled,\r\n    &:disabled,\r\n    &[disabled],\r\n    fieldset[disabled] & {\r\n        &,\r\n        &:hover,\r\n        &:focus,\r\n        &.focus,\r\n        &:active,\r\n        &.active {\r\n            background-color: $transparent-bg;\r\n        }\r\n    }\r\n}\r\n\r\n.btn-lg{\r\n   @include btn-size($padding-large-vertical, $padding-large-horizontal, $font-size-large, $border-radius-large);\r\n}\r\n.btn-sm{\r\n    @include btn-size($padding-small-vertical, $padding-small-horizontal, $font-size-base, $border-radius-small);\r\n}\r\n\r\n.btn-link{\r\n    border: $none;\r\n    padding: $padding-base-vertical $padding-base-horizontal;\r\n    background-color: $transparent-bg;\r\n}\r\n\r\n.btn-wd {\r\n    min-width: 140px;\r\n}\r\n.btn-group.select{\r\n    width: 100%;\r\n}\r\n.btn-group.select .btn{\r\n    text-align: left;\r\n}\r\n.btn-group.select .caret{\r\n    position: absolute;\r\n    top: 50%;\r\n    margin-top: -1px;\r\n    right: 8px;\r\n}\r\n\r\n.btn-facebook {\r\n  &,\r\n  &:hover,\r\n  &focus,\r\n  &:active,\r\n  &:active:focus {\r\n    color: $social-facebook !important;\r\n  }\r\n}\r\n\r\n.btn-twitter {\r\n\r\n  &,\r\n  &:hover,\r\n  &focus,\r\n  &:active,\r\n  &:active:focus {\r\n    color: $social-twitter !important;\r\n  }\r\n}\r\n\r\n.btn-google {\r\n  &,\r\n  &:hover,\r\n  &focus,\r\n  &:active,\r\n  &:active:focus {\r\n    color: $social-google !important;\r\n  }\r\n}\r\n\r\n.btn-github {\r\n  &,\r\n  &:hover,\r\n  &focus,\r\n  &:active,\r\n  &:active:focus {\r\n    color: $social-github !important;\r\n  }\r\n}\r\n\r\n.btn-linkedin {\r\n  &,\r\n  &:hover,\r\n  &focus,\r\n  &:active,\r\n  &:active:focus {\r\n    color: $social-linkedin !important;\r\n  }\r\n}\r\n","// Mixin for generating new styles\r\n@mixin btn-styles($btn-color, $btn-states-color) {\r\n    background-color: $btn-color;\r\n\r\n\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:not(:disabled):not(.disabled):active,\r\n    &:not(:disabled):not(.disabled).active,\r\n    &:not(:disabled):not(.disabled):active:focus,\r\n    &:not(:disabled):not(.disabled).active:focus,\r\n    &:active:hover,\r\n    &.active:hover,\r\n    .show > &.dropdown-toggle,\r\n    .show > &.dropdown-toggle:focus,\r\n    .show > &.dropdown-toggle:hover {\r\n        background-color: $btn-states-color;\r\n        color: $white-color;\r\n        box-shadow: none;\r\n    }\r\n\r\n    &:hover{\r\n        box-shadow:  0 3px 8px 0 rgba(0,0,0, 0.17);\r\n    }\r\n\r\n    &.disabled,\r\n    &:disabled,\r\n    &[disabled],\r\n    fieldset[disabled] & {\r\n        &,\r\n        &:hover,\r\n        &:focus,\r\n        &.focus,\r\n        &:active,\r\n        &.active {\r\n            background-color: $btn-color;\r\n            border-color: $btn-color;\r\n        }\r\n    }\r\n\r\n    // btn-neutral style\r\n    @if $btn-color == $white-color{\r\n        color: $primary-color;\r\n\r\n\r\n        &.btn-danger{\r\n            color: $danger-color;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active{\r\n                color: $danger-states-color !important;\r\n            }\r\n        }\r\n\r\n        &.btn-primary{\r\n            color: $primary-color;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active{\r\n                color: $primary-states-color !important;\r\n            }\r\n        }\r\n\r\n        &.btn-info{\r\n            color: $info-color;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active{\r\n                color: $info-states-color !important;\r\n            }\r\n        }\r\n\r\n        &.btn-warning{\r\n            color: $warning-color;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active{\r\n                color: $warning-states-color !important;\r\n            }\r\n        }\r\n\r\n        &.btn-success{\r\n            color: $success-color;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active{\r\n                color: $success-states-color !important;\r\n            }\r\n        }\r\n\r\n        &.btn-default{\r\n            color: $default-color;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active{\r\n                color: $default-states-color !important;\r\n            }\r\n        }\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:not(:disabled):not(.disabled):active,\r\n        &:not(:disabled):not(.disabled).active,\r\n        &:not(:disabled):not(.disabled):active:focus,\r\n        &:not(:disabled):not(.disabled).active:focus,\r\n        &:active:hover,\r\n        &.active:hover,\r\n        .show > &.dropdown-toggle,\r\n        .show > &.dropdown-toggle:focus,\r\n        .show > &.dropdown-toggle:hover {\r\n            background-color: $white-color;\r\n            color: $primary-states-color;\r\n            box-shadow: none;\r\n        }\r\n\r\n        &:hover,\r\n        &:focus{\r\n            color: $primary-states-color !important;\r\n\r\n            &:not(.nav-link){\r\n                box-shadow: none;\r\n            }\r\n\r\n        }\r\n\r\n    } @else {\r\n        color: $white-color;\r\n    }\r\n\r\n    &.btn-simple{\r\n        color: $btn-color;\r\n        border-color: $btn-color;\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:not(:disabled):not(.disabled):active,\r\n        &:not(:disabled):not(.disabled).active,\r\n        &:not(:disabled):not(.disabled):active:focus,\r\n        &:not(:disabled):not(.disabled).active:focus,\r\n        &:active:hover,\r\n        &.active:hover,\r\n        .show > &.dropdown-toggle,\r\n        .show > &.dropdown-toggle:focus,\r\n        .show > &.dropdown-toggle:hover{\r\n            background-color: $transparent-bg;\r\n            color: $btn-states-color;\r\n            border-color: $btn-states-color;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n\r\n    &.btn-link{\r\n        color: $btn-color;\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:not(:disabled):not(.disabled):active,\r\n        &:not(:disabled):not(.disabled).active,\r\n        &:not(:disabled):not(.disabled):active:focus,\r\n        &:not(:disabled):not(.disabled).active:focus,\r\n        &:active:hover,\r\n        &.active:hover,\r\n        .show > &.dropdown-toggle,\r\n        .show > &.dropdown-toggle:focus,\r\n        .show > &.dropdown-toggle:hover{\r\n            background-color: $transparent-bg;\r\n            color: $btn-states-color;\r\n            text-decoration: none;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin outline-buttons($btn-color, $btn-states-color) {\r\n  color: $btn-color;\r\n  border-color: $btn-color;\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active,\r\n  &:not(:disabled):not(.disabled):active:focus,\r\n  &:not(:disabled):not(.disabled).active:focus,\r\n  &:active:hover,\r\n  &.active:hover,\r\n  .show > &.dropdown-toggle,\r\n  .show > &.dropdown-toggle:focus,\r\n  .show > &.dropdown-toggle:hover {\r\n      background-color: $transparent-bg;\r\n      color: $btn-states-color;\r\n      border-color: $btn-states-color;\r\n      box-shadow: none;\r\n  }\r\n}\r\n\r\n\r\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\r\n   font-size: $font-size;\r\n   border-radius: $border;\r\n   padding: $padding-vertical $padding-horizontal;\r\n\r\n   &[class*=\"btn-outline-\"] {\r\n    padding: $padding-vertical - 1 $padding-horizontal - 1;\r\n   }\r\n\r\n}\r\n","@mixin input-size($padding-vertical, $padding-horizontal){\r\n    padding: $padding-vertical $padding-horizontal;\r\n}\r\n\r\n@mixin form-control-placeholder($color, $opacity){\r\n   .form-control::-moz-placeholder{\r\n       color: $color;\r\n       @include opacity($opacity);\r\n   }\r\n   .form-control:-moz-placeholder{\r\n       color: $color;\r\n       @include opacity($opacity);\r\n   }\r\n   .form-control::-webkit-input-placeholder{\r\n       color: $color;\r\n       @include opacity($opacity);\r\n   }\r\n   .form-control:-ms-input-placeholder{\r\n       color: $color;\r\n       @include opacity($opacity);\r\n   }\r\n}\r\n\r\n@mixin light-form(){\r\n    border-radius: 0;\r\n    border:0;\r\n    padding: 0;\r\n    background-color: transparent;\r\n\r\n}\r\n\r\n\r\n@mixin input-lg-padding($padding-vertical, $padding-horizontal) {\r\n    .form-group.no-border.input-lg,\r\n    .input-group.no-border.input-lg{\r\n        .input-group-text{\r\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\r\n        }\r\n\r\n        .form-control{\r\n            padding: $padding-vertical $padding-horizontal;\r\n\r\n            & + .input-group-text{\r\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    .form-group.input-lg,\r\n    .input-group.input-lg{\r\n        .form-control{\r\n            padding: $padding-vertical - 1 $padding-horizontal - 1;\r\n\r\n            & + .input-group-text{\r\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\r\n            }\r\n        }\r\n\r\n        .input-group-text{\r\n            padding: $padding-vertical - 1 0 $padding-vertical $padding-horizontal - 1;\r\n\r\n            & + .form-control{\r\n                padding: $padding-vertical  $padding-horizontal - 1 $padding-vertical $padding-horizontal - 3;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n@mixin input-base-padding($padding-vertical, $padding-horizontal) {\r\n    .form-group.no-border,\r\n    .input-group.no-border{\r\n        .form-control{\r\n            padding: $padding-vertical $padding-horizontal;\r\n\r\n            & + .input-group-text{\r\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\r\n            }\r\n        }\r\n\r\n        .input-group-text{\r\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\r\n        }\r\n    }\r\n\r\n    .form-group,\r\n    .input-group{\r\n        .form-control{\r\n            padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 $padding-horizontal - 1;\r\n\r\n            & + .input-group-text{\r\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\r\n            }\r\n        }\r\n\r\n        .input-group-text{\r\n            padding: $padding-vertical - 1 0 $padding-vertical - 1 $padding-horizontal - 1;\r\n\r\n            & + .form-control,\r\n            & ~ .form-control{\r\n                padding:$padding-vertical - 1 $padding-horizontal $padding-vertical $padding-horizontal - 3;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n//color1 = $opacity-5\r\n//color2 = $opacity-8\r\n//color3 = $white-color\r\n//color4 = $transparent-bg\r\n//color5 = $opacity-1\r\n//color6 = $opacity-2\r\n\r\n\r\n@mixin input-coloured-bg($color1, $color2, $color3, $color4, $color5, $color6) {\r\n    @include form-control-placeholder(darken($color2, 8%), 1);\r\n\r\n    .form-control{\r\n        border-color: $color1;\r\n        color: $color2;\r\n\r\n        &:focus{\r\n            border-color: $color3;\r\n            background-color: $color4;\r\n            color: $color3;\r\n        }\r\n    }\r\n\r\n    .has-success,\r\n    .has-danger{\r\n        &:after{\r\n            color: $color3;\r\n        }\r\n    }\r\n\r\n    .has-danger{\r\n        .form-control{\r\n            background-color: $color4;\r\n        }\r\n    }\r\n\r\n    .input-group-text{\r\n        background-color: $color4;\r\n        border-color: $color1;\r\n        color: $color2;\r\n    }\r\n\r\n    .input-group-focus{\r\n        .input-group-text{\r\n            background-color: $color4;\r\n            border-color: $color3;\r\n            color: $color3;\r\n        }\r\n    }\r\n\r\n    .form-group.no-border,\r\n    .input-group.no-border{\r\n        .form-control{\r\n            background-color: $color5;\r\n            color: $color2;\r\n\r\n            &:focus,\r\n            &:active,\r\n            &:active{\r\n                background-color: $color6;\r\n                color: $color3;\r\n            }\r\n        }\r\n\r\n        .form-control + .input-group-text{\r\n            background-color: $color5;\r\n\r\n            &:focus,\r\n            &:active,\r\n            &:active{\r\n                background-color: $color6;\r\n                color: $color3;\r\n            }\r\n        }\r\n\r\n        .form-control{\r\n            &:focus{\r\n                & + .input-group-text{\r\n                    background-color: $color6;\r\n                    color: $color3;\r\n                }\r\n            }\r\n        }\r\n\r\n        .input-group-text{\r\n            background-color: $color5;\r\n            border: none;\r\n            color: $color2;\r\n        }\r\n\r\n        &.input-group-focus{\r\n            .input-group-text{\r\n                background-color: $color6;\r\n                color: $color3;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@include form-control-placeholder($default-color, .8);\r\n\r\n.form-control {\r\n    background-color: $transparent-bg;\r\n    border: 1px solid $light-gray;\r\n    border-radius: $btn-round-radius;\r\n    color: $black-color;\r\n    height: auto;\r\n    line-height: normal;\r\n    font-size: $font-size-small;\r\n    @include transition-input-focus-color();\r\n    @include box-shadow(none);\r\n\r\n    .has-success &{\r\n        border-color: $light-gray;\r\n    }\r\n\r\n    &:focus{\r\n        border: 1px solid $primary-color;\r\n        @include box-shadow(none);\r\n        outline: 0 !important;\r\n        color: $black-color;\r\n\r\n        & + .input-group-text,\r\n        & ~ .input-group-text{\r\n            border: 1px solid $primary-color;\r\n            border-left: none;\r\n            background-color: $transparent-bg;\r\n        }\r\n    }\r\n\r\n    .has-success &,\r\n    .has-error &,\r\n    .has-success &:focus,\r\n    .has-error &:focus{\r\n        @include box-shadow(none);\r\n    }\r\n\r\n    .has-success &:focus{\r\n        border-color: lighten($success-color, 5%);\r\n    }\r\n\r\n\r\n    .has-danger &,\r\n    .has-success &{\r\n        &.form-control-success,\r\n        &.form-control-danger{\r\n            background-image: none;\r\n        }\r\n    }\r\n\r\n    .has-danger &{\r\n        border-color: lighten($danger-color, 30%);\r\n        color: $danger-color;\r\n        background-color: rgba(222,222,222, .1);\r\n\r\n        &:focus{\r\n            background-color: $white-color;\r\n        }\r\n    }\r\n\r\n    & + .form-control-feedback{\r\n        border-radius: $border-radius-large;\r\n        font-size: $font-size-base;\r\n        margin-top: -7px;\r\n        position: absolute;\r\n        right: 10px;\r\n        top: 50%;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .open &{\r\n        border-radius: $border-radius-large $border-radius-large 0 0;\r\n        border-bottom-color: transparent;\r\n    }\r\n\r\n    // & + .input-group-text{\r\n    //     background-color: $white-bg;\r\n    // }\r\n}\r\n\r\n.has-success,\r\n.has-danger{\r\n    &:after{\r\n        font-family: 'Nucleo Outline';\r\n        content: \"\\ea22\";\r\n        display: inline-block;\r\n        position: absolute;\r\n        right: 20px;\r\n        top: 12px;\r\n        color: $success-color;\r\n        font-size: 11px;\r\n    }\r\n\r\n    &.input-lg{\r\n        &:after{\r\n            font-size: 13px;\r\n            top: 13px;\r\n        }\r\n    }\r\n}\r\n\r\n.has-danger{\r\n    &:after{\r\n        content: \"\\ea53\";\r\n        color: $danger-color;\r\n    }\r\n}\r\n\r\n@include input-lg-padding($padding-large-vertical, $padding-input-horizontal);\r\n@include input-base-padding($padding-input-vertical, $padding-input-horizontal);\r\n\r\n.form-group.no-border,\r\n.input-group.no-border{\r\n    .form-control,\r\n    .form-control + .input-group-text{\r\n        background-color: $opacity-gray-3;\r\n        border: medium none;\r\n        &:focus,\r\n        &:active,\r\n        &:active{\r\n            border: medium none;\r\n            background-color: $opacity-gray-5;\r\n        }\r\n    }\r\n\r\n    .form-control{\r\n        &:focus{\r\n            & + .input-group-text{\r\n                background-color: $opacity-gray-5;\r\n            }\r\n        }\r\n    }\r\n    .input-group-prepend{\r\n      .input-group-text{\r\n          background-color: $opacity-gray-3;\r\n          border: none;\r\n          border-left: transparent !important;\r\n      }\r\n    }\r\n\r\n    &.input-group-focus{\r\n        &.no-border{\r\n            .input-group-text{\r\n                background-color: $opacity-gray-5;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.has-error{\r\n    .form-control-feedback, .control-label{\r\n        color: $danger-color;\r\n    }\r\n}\r\n.has-success{\r\n    .form-control-feedback, .control-label{\r\n        color: $success-color;\r\n    }\r\n}\r\n\r\n.input-group-text {\r\n    background-color: $white-bg;\r\n    border: 1px solid $light-gray;\r\n    border-radius: $btn-round-radius;\r\n    color: $dark-background;\r\n\r\n    @include transition-input-focus-color();\r\n\r\n    .input-group-focus &{\r\n      background-color: $white-bg;\r\n      border-color: $primary-color;\r\n    }\r\n\r\n    .has-success &,\r\n    .has-danger &{\r\n        background-color: $white-color;\r\n    }\r\n    .has-danger .form-control:focus + &{\r\n        color: $danger-color;\r\n    }\r\n    .has-success .form-control:focus + &{\r\n        color: $success-color;\r\n    }\r\n\r\n    & + .form-control,\r\n    & ~ .form-control{\r\n        @include input-size($padding-base-vertical - 1, $padding-base-horizontal);\r\n        padding-left: 18px;\r\n    }\r\n\r\n    i{\r\n        width: 17px;\r\n    }\r\n}\r\n\r\n.input-group,\r\n.form-group{\r\n    margin-bottom: 10px;\r\n    position: relative;\r\n}\r\n.input-group[disabled]{\r\n    .input-group-text{\r\n        background-color: $light-gray;\r\n    }\r\n}\r\n\r\n.input-group,\r\n.form-group{\r\n  .input-group-prepend{\r\n    margin-right: 0;\r\n\r\n    .input-group-text {\r\n      border-left: 1px solid #E3E3E3;\r\n    }\r\n  }\r\n  .input-group-append .input-group-text {\r\n    border-right: 1px solid #E3E3E3;\r\n    padding: 10px 18px 10px 0;\r\n  }\r\n\r\n  &.input-group-focus {\r\n    .input-group-prepend .input-group-text {\r\n      border-left: 1px solid #f96332;\r\n    }\r\n    .input-group-append .input-group-text {\r\n      border-right: 1px solid #f96332;\r\n    }\r\n    &.no-border{\r\n      .input-group-prepend .input-group-text{\r\n        border-left: transparent;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.input-group .form-control:first-child,\r\n.input-group-text:first-child,\r\n.input-group-btn:first-child > .dropdown-toggle,\r\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\r\n    border-right: 0 none;\r\n}\r\n.input-group .form-control:last-child,\r\n.input-group-text:last-child,\r\n.input-group-btn:last-child > .dropdown-toggle,\r\n.input-group-btn:first-child > .btn:not(:first-child) {\r\n    border-left: 0 none;\r\n}\r\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\r\n    background-color: $light-gray;\r\n    color: $default-color;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.input-group-btn .btn{\r\n    border-width: $border-thin;\r\n    padding: $padding-btn-vertical  $padding-base-horizontal;\r\n}\r\n.input-group-btn .btn-default:not(.btn-fill){\r\n    border-color: $medium-gray;\r\n}\r\n\r\n.input-group-btn:last-child > .btn{\r\n    margin-left: 0;\r\n}\r\ntextarea.form-control{\r\n    max-width: 100%;\r\n    max-height: 80px;\r\n    padding: 10px 10px 0 0;\r\n    resize: none;\r\n    border: none;\r\n    border-bottom: 1px solid $light-gray;\r\n    border-radius: 0;\r\n    line-height: 2;\r\n\r\n    &:focus,\r\n    &:active{\r\n        border-left: none;\r\n        border-top: none;\r\n        border-right: none;\r\n    }\r\n}\r\n\r\n.has-success,\r\n.has-danger{\r\n\r\n    &.form-group .form-control,\r\n    &.form-group.no-border .form-control{\r\n        padding-right: $padding-input-horizontal + 21;\r\n    }\r\n}\r\n\r\n.form.form-newsletter .form-group{\r\n    float: left;\r\n    width: 78%;\r\n    margin-right: 2%;\r\n    margin-top: 9px;\r\n}\r\n\r\n.input-group .input-group-btn{\r\n    padding: 0 12px;\r\n}\r\n\r\n// Input files - hide actual input - requires specific markup in the sample.\r\n.form-group input[type=file] {\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 100;\r\n}\r\n",".form-check{\r\n margin-top: .65rem;\r\n padding-left: 0;\r\n}\r\n\r\n.form-check .form-check-label{\r\n  display: inline-block;\r\n  position: relative;\r\n  cursor: pointer;\r\n  padding-left: 35px;\r\n  line-height: 26px;\r\n  margin-bottom: 0;\r\n  -webkit-transition: color 0.3s linear;\r\n  -moz-transition: color 0.3s linear;\r\n  -o-transition: color 0.3s linear;\r\n  -ms-transition: color 0.3s linear;\r\n  transition: color 0.3s linear;\r\n}\r\n.radio .form-check-sign{\r\n    padding-left: 28px;\r\n}\r\n\r\n.form-check .form-check-sign::before,\r\n.form-check .form-check-sign::after{\r\n  content: \" \";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 26px;\r\n  height: 26px;\r\n  left: 0;\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n  top: 0;\r\n  background-color: transparent;\r\n  border: 1px solid $light-gray;\r\n  -webkit-transition: opacity 0.3s linear;\r\n  -moz-transition: opacity 0.3s linear;\r\n  -o-transition: opacity 0.3s linear;\r\n  -ms-transition: opacity 0.3s linear;\r\n  transition: opacity 0.3s linear;\r\n}\r\n\r\n .form-check .form-check-sign::after{\r\n  font-family: 'Nucleo Outline';\r\n  content: \"\\ea22\";\r\n  top: 0px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  opacity: 0;\r\n  color: $dark-background;\r\n  border: 0;\r\n  background-color: inherit;\r\n}\r\n\r\n.form-check.disabled .form-check-label,\r\n.form-check.disabled .form-check-label {\r\n    color: $dark-gray;\r\n    opacity: .5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.form-check input[type=\"checkbox\"],\r\n.radio input[type=\"radio\"]{\r\n  opacity: 0;\r\n  position: absolute;\r\n  visibility: hidden;\r\n}\r\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\r\n  opacity: 1;\r\n}\r\n\r\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\r\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\r\n    cursor: not-allowed;\r\n}\r\n\r\n.form-check input[type=\"checkbox\"]:disabled + .form-check-sign,\r\n.form-check input[type=\"radio\"]:disabled + .form-check-sign{\r\n    pointer-events: none;\r\n}\r\n\r\n.form-check-radio .form-check-sign::before,\r\n.form-check-radio .form-check-sign::after{\r\n  content: \" \";\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  border: 1px solid $light-gray;\r\n  display: inline-block;\r\n  position: absolute;\r\n  left: 3px;\r\n  top: 3px;\r\n  padding: 1px;\r\n  -webkit-transition: opacity 0.3s linear;\r\n  -moz-transition: opacity 0.3s linear;\r\n  -o-transition: opacity 0.3s linear;\r\n  -ms-transition: opacity 0.3s linear;\r\n  transition: opacity 0.3s linear;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\r\n.form-check-radio input[type=\"radio\"] {\r\n    opacity: 0;\r\n}\r\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\r\n    width: 4px;\r\n    height: 4px;\r\n    background-color: $dark-background;\r\n    border-color: $dark-background;\r\n    top: 11px;\r\n    left: 11px;\r\n    opacity: 1;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\r\n    opacity: 1;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign {\r\n  color: $dark-gray;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\r\n  color: $dark-gray;\r\n}\r\n","// This file has been autogenerated by grunt task lessToSass. Any changes will be overwritten.\r\n.progress-container{\r\n    position: relative;\r\n\r\n    & + .progress-container,\r\n    & ~ .progress-container{\r\n        margin-top: $margin-base-vertical;\r\n    }\r\n    .progress-badge{\r\n        color: $default-color;\r\n        font-size: $font-size-small;\r\n        text-transform: uppercase;\r\n\r\n    }\r\n\r\n    .progress {\r\n        height: 1px;\r\n        border-radius: 0;\r\n        box-shadow: none;\r\n        background: $opacity-gray-8;\r\n        margin-top: 14px;\r\n\r\n        .progress-bar {\r\n            box-shadow: none;\r\n            background-color: $default-color;\r\n        }\r\n\r\n        .progress-value{\r\n            position: absolute;\r\n            top: 2px;\r\n            right: 0;\r\n            color: $default-color;\r\n            font-size: $font-size-small;\r\n        }\r\n    }\r\n\r\n    &.progress-neutral{\r\n        .progress{\r\n            background: rgba(255, 255, 255, .3);\r\n        }\r\n\r\n        .progress-bar{\r\n            background: $white-bg;\r\n        }\r\n\r\n        .progress-value,\r\n        .progress-badge{\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    &.progress-primary{\r\n        .progress{\r\n            background: $primary-color-opacity;\r\n        }\r\n\r\n        .progress-bar{\r\n            background: $brand-primary;\r\n        }\r\n\r\n        .progress-value,\r\n        .progress-badge{\r\n            color: $brand-primary;\r\n        }\r\n    }\r\n\r\n    &.progress-info{\r\n        .progress{\r\n            background: $info-color-opacity;\r\n        }\r\n\r\n        .progress-bar{\r\n            background: $brand-info;\r\n        }\r\n\r\n        .progress-value,\r\n        .progress-badge{\r\n            color: $brand-info;\r\n        }\r\n    }\r\n\r\n    &.progress-success{\r\n        .progress{\r\n            background: $success-color-opacity;\r\n        }\r\n\r\n        .progress-bar{\r\n            background: $brand-success;\r\n        }\r\n\r\n        .progress-value,\r\n        .progress-badge{\r\n            color: $brand-success;\r\n        }\r\n    }\r\n\r\n    &.progress-warning{\r\n        .progress{\r\n            background: $warning-color-opacity;\r\n        }\r\n\r\n        .progress-bar{\r\n            background: $brand-warning;\r\n        }\r\n\r\n        .progress-value,\r\n        .progress-badge{\r\n            color: $brand-warning;\r\n        }\r\n    }\r\n\r\n    &.progress-danger{\r\n        .progress{\r\n            background: $danger-color-opacity;\r\n        }\r\n\r\n        .progress-bar{\r\n            background: $brand-danger;\r\n        }\r\n\r\n        .progress-value,\r\n        .progress-badge{\r\n            color: $brand-danger;\r\n        }\r\n    }\r\n}\r\n","/*           badges             */\r\n.badge{\r\n    border-radius: 8px;\r\n    padding: 4px 8px;\r\n    text-transform: uppercase;\r\n    font-size: $font-size-mini;\r\n    line-height: 12px;\r\n    background-color: $transparent-bg;\r\n    border: $border;\r\n    margin-bottom: 5px;\r\n    color: $white-color;\r\n    border-radius: $border-radius-extreme;\r\n\r\n    &:hover,\r\n    &:focus{\r\n      text-decoration: none;\r\n    }\r\n\r\n}\r\n.badge-icon{\r\n    padding: 0.4em 0.55em;\r\n    i{\r\n       font-size: 0.8em;\r\n    }\r\n}\r\n.badge-default{\r\n    @include badge-color($default-color);\r\n}\r\n.badge-primary{\r\n    @include badge-color($primary-color);\r\n}\r\n.badge-info{\r\n    @include badge-color($info-color);\r\n}\r\n.badge-success{\r\n    @include badge-color($success-color);\r\n}\r\n.badge-warning{\r\n    @include badge-color($warning-color);\r\n}\r\n.badge-danger{\r\n    @include badge-color($danger-color);\r\n}\r\n.badge-neutral{\r\n    @include badge-color($white-color);\r\n    color: inherit !important;\r\n}\r\n","@mixin badge-color($color) {\r\n\r\n    &,\r\n    &[href]:focus,\r\n    &[href]:hover{\r\n      border-color: $color;\r\n      background-color: $color;\r\n      color: $white-color;\r\n    }\r\n}\r\n",".pagination{\r\n\r\n    .page-item .page-link{\r\n        border: 0;\r\n        border-radius: 30px !important;\r\n        transition: all .3s;\r\n        padding: 0px 11px;\r\n        margin: 0 3px;\r\n        min-width: 30px;\r\n        text-align: center;\r\n        box-shadow: none;\r\n        height: 30px;\r\n        line-height: 30px;\r\n        color: $black-color;\r\n        cursor: pointer;\r\n        font-size: $font-size-base;\r\n        text-transform: uppercase;\r\n        background: transparent;\r\n\r\n        &:hover,\r\n        &:focus{\r\n            color: $black-color;\r\n            background-color: $opacity-gray-3;\r\n            border: none;\r\n        }\r\n    }\r\n\r\n    .arrow-margin-left,\r\n    .arrow-margin-right{\r\n        position: absolute;\r\n    }\r\n\r\n    .arrow-margin-right{\r\n        right: 0;\r\n    }\r\n\r\n    .arrow-margin-left{\r\n        left: 0;\r\n    }\r\n\r\n    .page-item.active > .page-link{\r\n        color: $light-gray;\r\n        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\r\n\r\n        &,\r\n        &:focus,\r\n        &:hover{\r\n            background-color: $default-color;\r\n            border-color: $default-color;\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    .page-item.disabled > .page-link{\r\n        opacity: .5;\r\n        background-color: rgba(255,255,255, .2);\r\n        color: $white-color;\r\n    }\r\n\r\n    // Colors\r\n    &.pagination-info{\r\n        .page-item.active > .page-link{\r\n            &,\r\n            &:focus,\r\n            &:hover{\r\n                background-color: $brand-info;\r\n                border-color: $brand-info;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.pagination-success{\r\n        .page-item.active > .page-link{\r\n            &,\r\n            &:focus,\r\n            &:hover{\r\n                background-color: $brand-success;\r\n                border-color: $brand-success;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.pagination-primary{\r\n        .page-item.active > .page-link{\r\n            &,\r\n            &:focus,\r\n            &:hover{\r\n                background-color: $brand-primary;\r\n                border-color: $brand-primary;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.pagination-warning{\r\n        .page-item.active > .page-link{\r\n            &,\r\n            &:focus,\r\n            &:hover{\r\n                background-color: $brand-warning;\r\n                border-color: $brand-warning;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.pagination-danger{\r\n        .page-item.active > .page-link{\r\n            &,\r\n            &:focus,\r\n            &:hover{\r\n                background-color: $brand-danger;\r\n                border-color: $brand-danger;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.pagination-neutral{\r\n        .page-item > .page-link{\r\n            color: $white-color;\r\n\r\n            &:focus,\r\n            &:hover{\r\n                background-color: $opacity-2;\r\n                color: $white-color;\r\n            }\r\n        }\r\n\r\n        .page-item.active > .page-link{\r\n            &,\r\n            &:focus,\r\n            &:hover{\r\n                background-color: $white-bg;\r\n                border-color: $white-bg;\r\n                color: $brand-primary;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.pagination-container{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n","button,\r\ninput,\r\noptgroup,\r\nselect,\r\ntextarea{\r\n    font-family: $sans-serif-family;\r\n}\r\nh1,h2,h3,h4,h5,h6{\r\n    font-weight: $font-weight-normal;\r\n}\r\n\r\nsmall{\r\n    font-size: 60%;\r\n}\r\n\r\na{\r\n    color: $primary-color;\r\n    &:hover,\r\n    &:focus{\r\n        color: $primary-color;\r\n    }\r\n}\r\nh1, .h1 {\r\n    font-size: $font-size-h1;\r\n    line-height: 1.15;\r\n    margin-bottom: $margin-base-vertical * 2;\r\n\r\n    small{\r\n        font-weight: $font-weight-bold;\r\n        text-transform: uppercase;\r\n        opacity: .8;\r\n    }\r\n}\r\nh2, .h2{\r\n    font-size: $font-size-h2;\r\n    margin-bottom: $margin-base-vertical * 2;\r\n}\r\nh3, .h3{\r\n    font-size: $font-size-h3;\r\n    margin-bottom: $margin-base-vertical * 2;\r\n    line-height: 1.4em;\r\n}\r\nh4, .h4{\r\n    font-size: $font-size-h4;\r\n    line-height: 1.45em;\r\n    margin-top: $margin-base-vertical * 2;\r\n    margin-bottom: $margin-base-vertical;\r\n\r\n    & + .category,\r\n    &.title + .category{\r\n        margin-top: -5px;\r\n    }\r\n}\r\nh5, .h5 {\r\n    font-size: $font-size-h5;\r\n    line-height: 1.4em;\r\n    margin-bottom: 15px;\r\n\r\n    &.category{\r\n        font-weight: 400;\r\n    }\r\n}\r\nh6, .h6{\r\n    font-size: $font-size-h6;\r\n    font-weight: $font-weight-bold;\r\n    text-transform: uppercase;\r\n}\r\np{\r\n    line-height: 1.61em;\r\n    font-weight: 300;\r\n    font-size: 1.2em;\r\n}\r\n\r\n.title{\r\n    font-weight: $font-weight-bold;\r\n    padding-top: 30px;\r\n\r\n\r\n    &.title-up{\r\n        text-transform: uppercase;\r\n\r\n        a{\r\n            color: $black-color;\r\n            text-decoration: none;\r\n        }\r\n    }\r\n    & + .category{\r\n        margin-top: -25px;\r\n    }\r\n}\r\n\r\n.description,\r\n.card-description,\r\n.footer-big p{\r\n    color: $dark-gray;\r\n    font-weight: $font-weight-light;\r\n}\r\n.category{\r\n    text-transform: capitalize;\r\n    font-weight: $font-weight-bold;\r\n    color: $dark-gray;\r\n}\r\n.text-primary {\r\n  color: $brand-primary !important;\r\n}\r\n.text-info {\r\n  color: $brand-info !important;\r\n}\r\n.text-success {\r\n  color: $brand-success !important;\r\n}\r\n.text-warning {\r\n  color: $brand-warning !important;\r\n}\r\n.text-danger {\r\n  color: $brand-danger !important;\r\n}\r\n.text-black{\r\n  color: $light-black;\r\n}\r\n\r\n.blockquote{\r\n    border-left: none;\r\n    border: 1px solid $default-color;\r\n    padding: 20px;\r\n    font-size: $font-size-blockquote;\r\n    line-height: 1.8;\r\n\r\n    small{\r\n        color: $default-color;\r\n        font-size: $font-size-small;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    &.blockquote-primary{\r\n        border-color: $primary-color;\r\n        color: $primary-color;\r\n\r\n        small{\r\n            color: $primary-color;\r\n        }\r\n    }\r\n\r\n    &.blockquote-danger{\r\n        border-color: $danger-color;\r\n        color: $danger-color;\r\n\r\n        small{\r\n            color: $danger-color;\r\n        }\r\n    }\r\n\r\n    &.blockquote-white{\r\n        border-color: $opacity-8;\r\n        color: $white-color;\r\n\r\n        small{\r\n            color: $opacity-8;\r\n        }\r\n    }\r\n}\r\n","body{\r\n    color: $black-color;\r\n    font-size: $font-size-base;\r\n    font-family: $sans-serif-family;\r\n    overflow-x: hidden;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n.main{\r\n    position: relative;\r\n    background: $white-color;\r\n}\r\n/* Animations */\r\n.nav-pills .nav-link,\r\n.nav-item .nav-link,\r\n.navbar,\r\n.nav-tabs .nav-link,\r\n.tag,\r\n.tag [data-role=\"remove\"]{\r\n    @include transition($general-transition-time, $transition-ease);\r\n}\r\n\r\n//transition for dropdown caret\r\n.card a,\r\n.bootstrap-switch-label:before{\r\n    @include transition($fast-transition-time, $transition-ease);\r\n}\r\n\r\n.dropdown-toggle:after,\r\n[data-toggle=\"collapse\"][data-parent=\"#accordion\"] i{\r\n  @include transition-on-prop(transform, $fast-transition-time, $transition-ease);\r\n}\r\n\r\n.dropdown-toggle[aria-expanded=\"true\"]:after,\r\n[data-toggle=\"collapse\"][data-parent=\"#accordion\"][aria-expanded=\"true\"] i{\r\n    @include rotate-180();\r\n}\r\n\r\n.button-bar{\r\n    display: block;\r\n    position: relative;\r\n    width: 22px;\r\n    height: 1px;\r\n    border-radius: 1px;\r\n    background: $white-bg;\r\n\r\n    & + .button-bar{\r\n        margin-top: 7px;\r\n    }\r\n\r\n    &:nth-child(2){\r\n        width: 17px;\r\n    }\r\n}\r\n\r\n.separator-line{\r\n    height: 2px;\r\n    width: 44px;\r\n    background-color: $default-color;\r\n    margin: 20px auto;\r\n\r\n    &.separator-primary{\r\n        background-color: $primary-color;\r\n    }\r\n}\r\n\r\n.section-space{\r\n    height: 62px;\r\n    display: block;\r\n}\r\n\r\n.pull-left{\r\n  float: left;\r\n}\r\n.pull-right{\r\n  float: right;\r\n}\r\n\r\n.title-up{\r\n  text-transform: uppercase;\r\n}\r\n",".nav-pills{\r\n\r\n    &.nav-pills-just-icons{\r\n      .nav-item .nav-link{\r\n        text-align: center;\r\n        border-radius: 50%;\r\n        height: 80px;\r\n        width: 80px;\r\n        padding: 0;\r\n        max-width: 80px;\r\n        min-width: auto;\r\n        margin-bottom: 4px;\r\n\r\n        i{\r\n          line-height: 80px;\r\n        }\r\n      }\r\n    }\r\n\r\n    &:not(.flex-column) .nav-item {\r\n        &:not(:last-child) .nav-link{\r\n            margin-right: 19px;\r\n        }\r\n    }\r\n\r\n    .nav-item {\r\n        .nav-link{\r\n          padding: $padding-btn-vertical - 1 $padding-round-horizontal;\r\n          background-color: $opacity-gray-3;\r\n          min-width: 100px;\r\n          font-weight: $font-weight-normal;\r\n          text-align: center;\r\n          color: $light-black;\r\n\r\n\r\n            &:hover{\r\n                background-color: $opacity-gray-3;\r\n            }\r\n\r\n            &.active{\r\n                &,\r\n                &:focus,\r\n                &:hover{\r\n                    background-color: $dark-gray;\r\n                    color: $white-color;\r\n                    box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);\r\n                }\r\n            }\r\n\r\n            &.disabled,\r\n            &:disabled,\r\n            &[disabled]{\r\n                opacity: .5;\r\n            }\r\n        }\r\n\r\n        i{\r\n            display: block;\r\n            line-height: 60px;\r\n            font-size: 24px;\r\n        }\r\n    }\r\n\r\n    &.nav-pills-neutral{\r\n        .nav-item {\r\n            .nav-link{\r\n                background-color: $opacity-2;\r\n                color: $white-color;\r\n\r\n                &.active{\r\n                    &,\r\n                    &:focus,\r\n                    &:hover{\r\n                        background-color: $white-color;\r\n                        color: $primary-color;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-pills-primary{\r\n        .nav-item {\r\n            .nav-link.active{\r\n                &,\r\n                &:focus,\r\n                &:hover{\r\n                    background-color: $brand-primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-pills-info{\r\n        .nav-item {\r\n            .nav-link.active{\r\n                &,\r\n                &:focus,\r\n                &:hover{\r\n                    background-color: $brand-info;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-pills-success{\r\n        .nav-item {\r\n            .nav-link.active{\r\n                &,\r\n                &:focus,\r\n                &:hover{\r\n                    background-color: $brand-success;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-pills-warning{\r\n        .nav-item {\r\n            .nav-link.active{\r\n                &,\r\n                &:focus,\r\n                &:hover{\r\n                    background-color: $brand-warning;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-pills-danger{\r\n        .nav-item {\r\n            .nav-link.active{\r\n                &,\r\n                &:focus,\r\n                &:hover{\r\n                    background-color: $brand-danger;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.tab-space{\r\n    padding: 20px 0 50px 0px;\r\n}\r\n\r\n.nav-align-center{\r\n    text-align: center;\r\n\r\n    .nav-pills{\r\n        display: inline-flex;\r\n    }\r\n}\r\n","/* --------------------------------\r\n\r\nNucleo Outline Web Font - nucleoapp.com/\r\nLicense - nucleoapp.com/license/\r\nCreated using IcoMoon - icomoon.io\r\n\r\n-------------------------------- */\r\n\r\n@font-face {\r\n  font-family: 'Nucleo Outline';\r\n  src: url('~assets/fonts/nucleo-outline.eot');\r\n  src: url('~assets/fonts/nucleo-outline.eot') format('embedded-opentype'),\r\n  url('~assets/fonts/nucleo-outline.woff2') format('woff2'),\r\n  url('~assets/fonts/nucleo-outline.woff') format('woff'),\r\n  url('~assets/fonts/nucleo-outline.ttf') format('truetype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n/*------------------------\r\n\tbase class definition\r\n-------------------------*/\r\n\r\n.now-ui-icons {\r\n  display: inline-block;\r\n  font: normal normal normal 14px/1 'Nucleo Outline';\r\n  font-size: inherit;\r\n  speak: none;\r\n  text-transform: none;\r\n  /* Better Font Rendering */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/*------------------------\r\n  change icon size\r\n-------------------------*/\r\n\r\n/*----------------------------------\r\n  add a square/circle background\r\n-----------------------------------*/\r\n\r\n.now-ui-icons.circle {\r\n  padding: 0.33333333em;\r\n  vertical-align: -16%;\r\n  background-color: #eee;\r\n}\r\n\r\n.now-ui-icons.circle {\r\n  border-radius: 50%;\r\n}\r\n\r\n/*------------------------\r\n  list icons\r\n-------------------------*/\r\n\r\n.nc-icon-ul {\r\n  padding-left: 0;\r\n  margin-left: 2.14285714em;\r\n  list-style-type: none;\r\n}\r\n\r\n.nc-icon-ul > li {\r\n  position: relative;\r\n}\r\n\r\n.nc-icon-ul > li > .now-ui-icons {\r\n  position: absolute;\r\n  left: -1.57142857em;\r\n  top: 0.14285714em;\r\n  text-align: center;\r\n}\r\n\r\n.nc-icon-ul > li > .now-ui-icons.circle {\r\n  top: -0.19047619em;\r\n  left: -1.9047619em;\r\n}\r\n\r\n/*------------------------\r\n  spinning icons\r\n-------------------------*/\r\n\r\n.now-ui-icons.spin {\r\n  -webkit-animation: nc-icon-spin 2s infinite linear;\r\n  -moz-animation: nc-icon-spin 2s infinite linear;\r\n  animation: nc-icon-spin 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes nc-icon-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@-moz-keyframes nc-icon-spin {\r\n  0% {\r\n    -moz-transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    -moz-transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes nc-icon-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    -moz-transform: rotate(0deg);\r\n    -ms-transform: rotate(0deg);\r\n    -o-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    -moz-transform: rotate(360deg);\r\n    -ms-transform: rotate(360deg);\r\n    -o-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/*------------------------\r\n  rotated/flipped icons\r\n-------------------------*/\r\n\r\n/*------------------------\r\n\tfont icons\r\n-------------------------*/\r\n\r\n.now-ui-icons.ui-1_check:before{\r\n    content: \"\\ea22\";\r\n}\r\n\r\n.now-ui-icons.ui-1_email-85:before {\r\n  content: \"\\ea2a\";\r\n}\r\n\r\n.now-ui-icons.arrows-1_cloud-download-93:before {\r\n  content: \"\\ea21\";\r\n}\r\n\r\n.now-ui-icons.arrows-1_cloud-upload-94:before {\r\n  content: \"\\ea24\";\r\n}\r\n\r\n.now-ui-icons.arrows-1_minimal-down:before {\r\n  content: \"\\ea39\";\r\n}\r\n\r\n.now-ui-icons.arrows-1_minimal-left:before {\r\n  content: \"\\ea3a\";\r\n}\r\n\r\n.now-ui-icons.arrows-1_minimal-right:before {\r\n  content: \"\\ea3b\";\r\n}\r\n\r\n.now-ui-icons.arrows-1_minimal-up:before {\r\n  content: \"\\ea3c\";\r\n}\r\n\r\n.now-ui-icons.arrows-1_refresh-69:before {\r\n  content: \"\\ea44\";\r\n}\r\n\r\n.now-ui-icons.arrows-1_share-66:before {\r\n  content: \"\\ea4c\";\r\n}\r\n\r\n.now-ui-icons.business_badge:before {\r\n  content: \"\\ea09\";\r\n}\r\n\r\n.now-ui-icons.business_bank:before {\r\n  content: \"\\ea0a\";\r\n}\r\n\r\n.now-ui-icons.business_briefcase-24:before {\r\n  content: \"\\ea13\";\r\n}\r\n\r\n.now-ui-icons.business_bulb-63:before {\r\n  content: \"\\ea15\";\r\n}\r\n\r\n.now-ui-icons.business_chart-bar-32:before {\r\n  content: \"\\ea1e\";\r\n}\r\n\r\n.now-ui-icons.business_chart-pie-36:before {\r\n  content: \"\\ea1f\";\r\n}\r\n\r\n.now-ui-icons.business_globe:before {\r\n  content: \"\\ea2f\";\r\n}\r\n\r\n.now-ui-icons.business_money-coins:before {\r\n  content: \"\\ea40\";\r\n}\r\n\r\n.now-ui-icons.clothes_tie-bow:before {\r\n  content: \"\\ea5b\";\r\n}\r\n\r\n.now-ui-icons.design_vector:before {\r\n  content: \"\\ea61\";\r\n}\r\n\r\n.now-ui-icons.design_app:before {\r\n  content: \"\\ea08\";\r\n}\r\n\r\n.now-ui-icons.design_bullet-list-67:before {\r\n  content: \"\\ea14\";\r\n}\r\n\r\n.now-ui-icons.design_image:before {\r\n  content: \"\\ea33\";\r\n}\r\n\r\n.now-ui-icons.design_palette:before {\r\n  content: \"\\ea41\";\r\n}\r\n\r\n.now-ui-icons.design_scissors:before {\r\n  content: \"\\ea4a\";\r\n}\r\n\r\n.now-ui-icons.design-2_html5:before {\r\n  content: \"\\ea32\";\r\n}\r\n\r\n.now-ui-icons.design-2_ruler-pencil:before {\r\n  content: \"\\ea48\";\r\n}\r\n\r\n.now-ui-icons.emoticons_satisfied:before {\r\n  content: \"\\ea49\";\r\n}\r\n\r\n.now-ui-icons.files_box:before {\r\n  content: \"\\ea12\";\r\n}\r\n\r\n.now-ui-icons.files_paper:before {\r\n  content: \"\\ea43\";\r\n}\r\n\r\n.now-ui-icons.files_single-copy-04:before {\r\n  content: \"\\ea52\";\r\n}\r\n\r\n.now-ui-icons.health_ambulance:before {\r\n  content: \"\\ea07\";\r\n}\r\n\r\n.now-ui-icons.loader_gear:before {\r\n  content: \"\\ea4e\";\r\n}\r\n\r\n.now-ui-icons.loader_refresh:before {\r\n  content: \"\\ea44\";\r\n}\r\n\r\n.now-ui-icons.location_bookmark:before {\r\n  content: \"\\ea10\";\r\n}\r\n\r\n.now-ui-icons.location_compass-05:before {\r\n  content: \"\\ea25\";\r\n}\r\n\r\n.now-ui-icons.location_map-big:before {\r\n  content: \"\\ea3d\";\r\n}\r\n\r\n.now-ui-icons.location_pin:before {\r\n  content: \"\\ea47\";\r\n}\r\n\r\n.now-ui-icons.location_world:before {\r\n  content: \"\\ea63\";\r\n}\r\n\r\n.now-ui-icons.media-1_album:before {\r\n  content: \"\\ea02\";\r\n}\r\n\r\n.now-ui-icons.media-1_button-pause:before {\r\n  content: \"\\ea16\";\r\n}\r\n\r\n.now-ui-icons.media-1_button-play:before {\r\n  content: \"\\ea18\";\r\n}\r\n\r\n.now-ui-icons.media-1_button-power:before {\r\n  content: \"\\ea19\";\r\n}\r\n\r\n.now-ui-icons.media-1_camera-compact:before {\r\n  content: \"\\ea1c\";\r\n}\r\n\r\n.now-ui-icons.media-2_note-03:before {\r\n  content: \"\\ea3f\";\r\n}\r\n\r\n.now-ui-icons.media-2_sound-wave:before {\r\n  content: \"\\ea57\";\r\n}\r\n\r\n.now-ui-icons.objects_diamond:before {\r\n  content: \"\\ea29\";\r\n}\r\n\r\n.now-ui-icons.objects_globe:before {\r\n  content: \"\\ea2f\";\r\n}\r\n\r\n.now-ui-icons.objects_key-25:before {\r\n  content: \"\\ea38\";\r\n}\r\n\r\n.now-ui-icons.objects_planet:before {\r\n  content: \"\\ea46\";\r\n}\r\n\r\n.now-ui-icons.objects_spaceship:before {\r\n  content: \"\\ea55\";\r\n}\r\n\r\n.now-ui-icons.objects_support-17:before {\r\n  content: \"\\ea56\";\r\n}\r\n\r\n.now-ui-icons.objects_umbrella-13:before {\r\n  content: \"\\ea5f\";\r\n}\r\n\r\n.now-ui-icons.education_agenda-bookmark:before {\r\n  content: \"\\ea01\";\r\n}\r\n\r\n.now-ui-icons.education_atom:before {\r\n  content: \"\\ea0c\";\r\n}\r\n\r\n.now-ui-icons.education_glasses:before {\r\n  content: \"\\ea2d\";\r\n}\r\n\r\n.now-ui-icons.education_hat:before {\r\n  content: \"\\ea30\";\r\n}\r\n\r\n.now-ui-icons.education_paper:before {\r\n  content: \"\\ea42\";\r\n}\r\n\r\n.now-ui-icons.shopping_bag-16:before {\r\n  content: \"\\ea0d\";\r\n}\r\n\r\n.now-ui-icons.shopping_basket:before {\r\n  content: \"\\ea0b\";\r\n}\r\n\r\n.now-ui-icons.shopping_box:before {\r\n  content: \"\\ea11\";\r\n}\r\n\r\n.now-ui-icons.shopping_cart-simple:before {\r\n  content: \"\\ea1d\";\r\n}\r\n\r\n.now-ui-icons.shopping_credit-card:before {\r\n  content: \"\\ea28\";\r\n}\r\n\r\n.now-ui-icons.shopping_delivery-fast:before {\r\n  content: \"\\ea27\";\r\n}\r\n\r\n.now-ui-icons.shopping_shop:before {\r\n  content: \"\\ea50\";\r\n}\r\n\r\n.now-ui-icons.shopping_tag-content:before {\r\n  content: \"\\ea59\";\r\n}\r\n\r\n.now-ui-icons.sport_trophy:before {\r\n  content: \"\\ea5d\";\r\n}\r\n\r\n.now-ui-icons.sport_user-run:before {\r\n  content: \"\\ea60\";\r\n}\r\n\r\n.now-ui-icons.tech_controller-modern:before {\r\n  content: \"\\ea26\";\r\n}\r\n\r\n.now-ui-icons.tech_headphones:before {\r\n  content: \"\\ea31\";\r\n}\r\n\r\n.now-ui-icons.tech_laptop:before {\r\n  content: \"\\ea36\";\r\n}\r\n\r\n.now-ui-icons.tech_mobile:before {\r\n  content: \"\\ea3e\";\r\n}\r\n\r\n.now-ui-icons.tech_tablet:before {\r\n  content: \"\\ea58\";\r\n}\r\n\r\n.now-ui-icons.tech_tv:before {\r\n  content: \"\\ea5e\";\r\n}\r\n\r\n.now-ui-icons.tech_watch-time:before {\r\n  content: \"\\ea62\";\r\n}\r\n\r\n.now-ui-icons.text_align-center:before {\r\n  content: \"\\ea05\";\r\n}\r\n\r\n.now-ui-icons.text_align-left:before {\r\n  content: \"\\ea06\";\r\n}\r\n\r\n.now-ui-icons.text_bold:before {\r\n  content: \"\\ea0e\";\r\n}\r\n\r\n.now-ui-icons.text_caps-small:before {\r\n  content: \"\\ea1b\";\r\n}\r\n\r\n.now-ui-icons.gestures_tap-01:before {\r\n  content: \"\\ea5a\";\r\n}\r\n\r\n.now-ui-icons.transportation_air-baloon:before {\r\n  content: \"\\ea03\";\r\n}\r\n\r\n.now-ui-icons.transportation_bus-front-12:before {\r\n  content: \"\\ea17\";\r\n}\r\n\r\n.now-ui-icons.travel_info:before {\r\n  content: \"\\ea04\";\r\n}\r\n\r\n.now-ui-icons.travel_istanbul:before {\r\n  content: \"\\ea34\";\r\n}\r\n\r\n.now-ui-icons.ui-1_bell-53:before {\r\n  content: \"\\ea0f\";\r\n}\r\n\r\n.now-ui-icons.ui-1_calendar-60:before {\r\n  content: \"\\ea1a\";\r\n}\r\n\r\n.now-ui-icons.ui-1_lock-circle-open:before {\r\n  content: \"\\ea35\";\r\n}\r\n\r\n.now-ui-icons.ui-1_send:before {\r\n  content: \"\\ea4d\";\r\n}\r\n\r\n.now-ui-icons.ui-1_settings-gear-63:before {\r\n  content: \"\\ea4e\";\r\n}\r\n\r\n.now-ui-icons.ui-1_simple-add:before {\r\n  content: \"\\ea4f\";\r\n}\r\n\r\n.now-ui-icons.ui-1_simple-delete:before {\r\n  content: \"\\ea54\";\r\n}\r\n\r\n.now-ui-icons.ui-1_simple-remove:before {\r\n  content: \"\\ea53\";\r\n}\r\n\r\n.now-ui-icons.ui-1_zoom-bold:before {\r\n  content: \"\\ea64\";\r\n}\r\n\r\n.now-ui-icons.ui-2_chat-round:before {\r\n  content: \"\\ea20\";\r\n}\r\n\r\n.now-ui-icons.ui-2_favourite-28:before {\r\n  content: \"\\ea2b\";\r\n}\r\n\r\n.now-ui-icons.ui-2_like:before {\r\n  content: \"\\ea37\";\r\n}\r\n\r\n.now-ui-icons.ui-2_settings-90:before {\r\n  content: \"\\ea4b\";\r\n}\r\n\r\n.now-ui-icons.ui-2_time-alarm:before {\r\n  content: \"\\ea5c\";\r\n}\r\n\r\n.now-ui-icons.users_circle-08:before {\r\n  content: \"\\ea23\";\r\n}\r\n\r\n.now-ui-icons.users_single-02:before {\r\n  content: \"\\ea51\";\r\n}\r\n\r\n.all-icons .font-icon-detail {\r\n    text-align: center;\r\n    padding: 45px 0px 30px;\r\n    border: 1px solid #e5e5e5;\r\n    border-radius: 0.1875rem;\r\n    margin: 15px 0;\r\n    min-height: 168px;\r\n}\r\n\r\n.all-icons [class*=\"now-ui-icons\"] {\r\n    font-size: 32px;\r\n}\r\n\r\n.all-icons .font-icon-detail p {\r\n    margin: 25px auto 0;\r\n    width: 100%;\r\n    text-align: center;\r\n    display: block;\r\n    color: #B8B8B8;\r\n    padding:0 10px;\r\n    font-size: 0.7142em;\r\n}\r\n","// This file has been autogenerated by grunt task lessToSass. Any changes will be overwritten.\r\n\r\n.nav-tabs {\r\n    border: 0;\r\n    padding: $padding-large-vertical $padding-base-horizontal;\r\n\r\n    &:not(.nav-tabs-neutral) > .nav-item > .nav-link.active{\r\n        box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);\r\n    }\r\n\r\n    .card &{\r\n        border-top-right-radius: $border-radius-small;\r\n        border-top-left-radius: $border-radius-small;\r\n    }\r\n\r\n    > .nav-item{\r\n        > .nav-link{\r\n            color: $default-color;\r\n            margin: 0;\r\n            margin-right: 5px;\r\n            background-color: $transparent-bg;\r\n            border: 1px solid $transparent-bg;\r\n            border-radius: 30px;\r\n            font-size: $font-size-base;\r\n            padding: $padding-btn-vertical $padding-round-horizontal;\r\n            line-height: $line-height-general;\r\n\r\n            &:hover {\r\n                background-color: $transparent-bg;\r\n            }\r\n\r\n            &.active{\r\n                background-color: $light-black;\r\n                border-radius: 30px;\r\n                color: $white-color;\r\n            }\r\n\r\n            i.now-ui-icons{\r\n                font-size: 14px;\r\n                position: relative;\r\n                top: 1px;\r\n                margin-right: 3px;\r\n            }\r\n        }\r\n\r\n        &.disabled > .nav-link,\r\n        &.disabled > .nav-link:hover {\r\n            color: rgba(255,255,255,0.5);\r\n        }\r\n    }\r\n\r\n    &.nav-tabs-neutral{\r\n        > .nav-item{\r\n            > .nav-link{\r\n                color: $white-color;\r\n\r\n                &.active{\r\n                    background-color: $opacity-2;\r\n                    color: $white-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-tabs-primary{\r\n        > .nav-item{\r\n            > .nav-link{\r\n                &.active{\r\n                    background-color: $primary-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-tabs-info{\r\n        > .nav-item{\r\n            > .nav-link{\r\n                &.active{\r\n                    background-color: $info-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-tabs-danger{\r\n        > .nav-item{\r\n            > .nav-link{\r\n                &.active{\r\n                    background-color: $danger-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-tabs-warning{\r\n        > .nav-item{\r\n            > .nav-link{\r\n                &.active{\r\n                    background-color: $warning-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-tabs-success{\r\n        > .nav-item{\r\n            > .nav-link{\r\n                &.active{\r\n                    background-color: $success-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n",".navbar{\r\n    padding-top: $navbar-padding-base;\r\n    padding-bottom: $navbar-padding-base;\r\n    min-height: 53px;\r\n    margin-bottom: 20px;\r\n    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);\r\n\r\n    a{\r\n        vertical-align: middle;\r\n\r\n        &:not(.btn):not(.dropdown-item){\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    p{\r\n        display: inline-block;\r\n        margin: 0;\r\n        line-height: 21px;\r\n        font-weight: inherit;\r\n        font-size: inherit;\r\n    }\r\n\r\n    .navbar-nav{\r\n        &.navbar-logo{\r\n            position: absolute;\r\n            left: 0;\r\n            right: 0;\r\n            margin: 0 auto;\r\n            width: 49px;\r\n            top: -4px;\r\n        }\r\n\r\n        .nav-link.btn{\r\n            padding: $padding-btn-vertical $padding-btn-horizontal;\r\n\r\n            &.btn-lg{\r\n                padding: $padding-large-vertical $padding-large-horizontal;\r\n            }\r\n\r\n            &.btn-sm{\r\n                padding: $padding-small-vertical $padding-small-horizontal;\r\n            }\r\n        }\r\n\r\n        .nav-link:not(.btn){\r\n            text-transform: uppercase;\r\n            font-size: $font-size-mini;\r\n            padding: $padding-base-vertical $padding-base-horizontal;\r\n            line-height: $line-height-nav-link;\r\n\r\n            i.fab + p,\r\n            i.now-ui-icons + p{\r\n                margin-left: 3px;\r\n            }\r\n\r\n            i.fab,\r\n            i.now-ui-icons{\r\n                font-size: 18px;\r\n                position: relative;\r\n                top: 3px;\r\n                text-align: center;\r\n                width: 21px;\r\n            }\r\n\r\n            i.now-ui-icons{\r\n                top: 4px;\r\n                font-size: 16px;\r\n            }\r\n\r\n            &.profile-photo{\r\n                .profile-photo-small{\r\n                    width: 27px;\r\n                    height: 27px;\r\n                }\r\n            }\r\n\r\n            &.disabled{\r\n                opacity: .5;\r\n                color: $white-color;\r\n            }\r\n        }\r\n\r\n        .nav-item.active .nav-link:not(.btn),\r\n        .nav-item .nav-link:not(.btn):focus,\r\n        .nav-item .nav-link:not(.btn):hover,\r\n        .nav-item .nav-link:not(.btn):active{\r\n            background-color: $opacity-2;\r\n            border-radius: $border-radius-small;\r\n        }\r\n    }\r\n\r\n    .logo-container{\r\n        width: 27px;\r\n        height: 27px;\r\n        overflow: hidden;\r\n        margin: 0 auto;\r\n        border-radius: 50%;\r\n        border: 1px solid transparent;\r\n    }\r\n\r\n    .navbar-brand{\r\n        text-transform: uppercase;\r\n        font-size: $font-size-small;\r\n        padding-top: $padding-base-vertical;\r\n        padding-bottom: $padding-base-vertical;\r\n        line-height: $line-height-nav-link;\r\n    }\r\n\r\n    .navbar-toggler{\r\n        width: 37px;\r\n        height: 27px;\r\n        outline: 0;\r\n        cursor: pointer;\r\n\r\n        &.navbar-toggler-left{\r\n            position: relative;\r\n            left: 0;\r\n            padding-left: 0;\r\n        }\r\n\r\n        .navbar-toggler-bar.middle-bar{\r\n          width: 17px;\r\n          transition: width .2s linear;\r\n        }\r\n\r\n        &:hover{\r\n            & .navbar-toggler-bar.middle-bar{\r\n                width: 22px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .button-dropdown{\r\n        .navbar-toggler-bar:nth-child(2){\r\n            width: 17px;\r\n        }\r\n    }\r\n\r\n    &.navbar-transparent{\r\n        background-color: $transparent-bg !important;\r\n        box-shadow: none;\r\n        color: $white-color;\r\n        padding-top: 20px !important;\r\n    }\r\n\r\n    &.bg-white:not(.navbar-transparent){\r\n        a:not(.dropdown-item):not(.btn){\r\n            color: $default-color;\r\n\r\n            &.disabled{\r\n                opacity: .5;\r\n                color: $default-color;\r\n            }\r\n        }\r\n\r\n        .button-bar{\r\n            background: $default-color;\r\n        }\r\n\r\n        .nav-item.active .nav-link:not(.btn),\r\n        .nav-item .nav-link:not(.btn):focus,\r\n        .nav-item .nav-link:not(.btn):hover,\r\n        .nav-item .nav-link:not(.btn):active{\r\n            background-color: $opacity-gray-3;\r\n        }\r\n\r\n        .logo-container{\r\n            border: 1px solid $default-color;\r\n        }\r\n    }\r\n}\r\n\r\n.bg-default{\r\n    background-color: $default-color !important;\r\n}\r\n\r\n.bg-primary{\r\n    background-color: $primary-color !important;\r\n}\r\n\r\n.bg-info{\r\n    background-color: $info-color !important;\r\n}\r\n\r\n.bg-success{\r\n    background-color: $success-color !important;\r\n}\r\n\r\n.bg-danger{\r\n    background-color: $danger-color !important;\r\n}\r\n\r\n.bg-warning{\r\n    background-color: $warning-color !important;\r\n}\r\n\r\n.bg-white{\r\n    background-color: $white-color !important;\r\n}\r\n",".dropdown-menu{\r\n    border: 0;\r\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\r\n    border-radius: $border-radius-extra-small;\r\n    @include transition($fast-transition-time, $transition-linear);\r\n    font-size: $font-size-base;\r\n\r\n    &.dropdown-menu-right{\r\n        &:before{\r\n            left:auto;\r\n            right: 10px;\r\n        }\r\n    }\r\n\r\n    .dropdown &{\r\n        @include transform-translate-y-dropdown(-25px);\r\n        visibility: hidden;\r\n        display: block;\r\n        @include opacity(0);\r\n        top: 100% !important;\r\n    }\r\n\r\n    .dropdown.show &,\r\n    &.open{\r\n        @include opacity(1);\r\n        visibility: visible;\r\n        @include transform-translate-y-dropdown(0px);\r\n    }\r\n\r\n    .dropdown-item,\r\n    .bootstrap-select &.inner li a{\r\n      font-size: $font-size-small;\r\n      padding-top: .6rem;\r\n      padding-bottom: .6rem;\r\n      margin-top: 5px;\r\n      @include transition($fast-transition-time, $transition-linear);\r\n      outline: none;\r\n\r\n      &:hover,\r\n      &:focus{\r\n        background-color: $opacity-gray-3;\r\n      }\r\n\r\n      &.disabled,\r\n      &:disabled{\r\n        color: $default-color-opacity;\r\n\r\n        &:hover,\r\n        &:focus{\r\n          background-color: transparent;\r\n        }\r\n      }\r\n    }\r\n\r\n    &:before{\r\n        display: inline-block;\r\n        position: absolute;\r\n        width: 0;\r\n        height: 0;\r\n        vertical-align: middle;\r\n        content: \"\";\r\n        top: -5px;\r\n        left: 10px;\r\n        right: auto;\r\n        color: $white-color;\r\n        border-bottom: .4em solid;\r\n        border-right: .4em solid transparent;\r\n        border-left: .4em solid transparent;\r\n    }\r\n\r\n    .dropdown-divider{\r\n        background-color: $opacity-gray-5;\r\n    }\r\n\r\n    .dropdown-header:not([href]):not([tabindex]){\r\n        color: $default-color-opacity;\r\n        font-size: $font-size-mini;\r\n        text-transform: uppercase;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n\r\n    &.dropdown-primary{\r\n        @include dropdown-colors(darken($primary-color, 3%),$opacity-8,$white-color, $opacity-2);\r\n    }\r\n\r\n    &.dropdown-info{\r\n        @include dropdown-colors(darken($info-color, 3%),$opacity-8,$white-color, $opacity-2);\r\n    }\r\n\r\n    &.dropdown-danger{\r\n        @include dropdown-colors(darken($danger-color, 3%),$opacity-8,$white-color, $opacity-2);\r\n    }\r\n\r\n    &.dropdown-success{\r\n        @include dropdown-colors(darken($success-color, 3%),$opacity-8,$white-color, $opacity-2);\r\n    }\r\n\r\n    &.dropdown-warning{\r\n        @include dropdown-colors(darken($warning-color, 3%),$opacity-8,$white-color, $opacity-2);\r\n    }\r\n}\r\n.button-dropdown{\r\n    padding-right: $padding-base-horizontal;\r\n    cursor: pointer;\r\n\r\n    & .dropdown-toggle{\r\n        padding-top: $padding-base-vertical;\r\n        padding-bottom: $padding-base-vertical;\r\n        display: block;\r\n\r\n        &:after{\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n","@mixin dropdown-colors($brand-color, $dropdown-header-color, $dropdown-color, $background-color ) {\r\n    background-color: $brand-color;\r\n\r\n    &:before{\r\n        color: $brand-color;\r\n    }\r\n\r\n    .dropdown-header:not([href]):not([tabindex]){\r\n        color: $dropdown-header-color;\r\n    }\r\n\r\n    .dropdown-item{\r\n        color: $dropdown-color;\r\n\r\n        &:hover,\r\n        &:focus{\r\n            background-color: $background-color;\r\n        }\r\n    }\r\n\r\n    .dropdown-divider{\r\n        background-color: $background-color;\r\n    }\r\n}\r\n","// This file has been autogenerated by grunt task lessToSass. Any changes will be overwritten.\r\n.alert{\r\n    border: 0;\r\n    border-radius: 0;\r\n    color: $white-color;\r\n    padding-top: .9rem;\r\n    padding-bottom: .9rem;\r\n\r\n    .alert-link{\r\n      color: $white-color;\r\n      opacity: .8;\r\n    }\r\n\r\n    &.alert-success{\r\n        background-color: $success-color-alert;\r\n    }\r\n\r\n    &.alert-danger{\r\n        background-color: $danger-color-alert;\r\n    }\r\n\r\n    &.alert-warning{\r\n        background-color: $warning-color-alert;\r\n    }\r\n\r\n    &.alert-info{\r\n        background-color: $info-color-alert;\r\n    }\r\n\r\n    &.alert-primary{\r\n        background-color: $primary-color-alert;\r\n    }\r\n\r\n    .alert-icon{\r\n        display: block;\r\n        float: left;\r\n        margin-right: 15px;\r\n        margin-top: -1px;\r\n    }\r\n\r\n    strong{\r\n        text-transform: uppercase;\r\n        font-size: 12px;\r\n    }\r\n\r\n    i.fa,\r\n    i.now-ui-icons{\r\n        font-size: 20px;\r\n    }\r\n\r\n    .close{\r\n        color: $white-color;\r\n        opacity: .9;\r\n        text-shadow: none;\r\n        line-height: 0;\r\n        outline: 0;\r\n        display: inline-block;\r\n        cursor: pointer;\r\n\r\n    }\r\n}\r\n","img{\r\n    max-width: 100%;\r\n    border-radius: 1px;\r\n}\r\n.img-raised{\r\n    box-shadow: $box-shadow-raised;\r\n}\r\n",".popover{\r\n    font-size: $font-size-base;\r\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\r\n    border: none;\r\n    line-height: 1.7;\r\n    max-width: 240px;\r\n\r\n    &.bs-popover-top .arrow:before,\r\n    &.bs-popover-left .arrow:before,\r\n    &.bs-popover-right .arrow:before,\r\n    &.bs-popover-bottom .arrow:before,{\r\n        border-top-color: transparent;\r\n        border-left-color: transparent;\r\n        border-right-color: transparent;\r\n        border-bottom-color: transparent;\r\n    }\r\n\r\n    .popover-header{\r\n        color: $default-color-opacity;\r\n        font-size: $font-size-base;\r\n        text-transform: capitalize;\r\n        font-weight: $font-weight-semi;\r\n        margin: 0;\r\n        margin-top: 5px;\r\n        border: none;\r\n        background-color: transparent;\r\n    }\r\n\r\n    &:before{\r\n        display: none;\r\n    }\r\n\r\n    &.bs-tether-element-attached-top:after{\r\n        border-bottom-color:$white-color;\r\n        top: -9px;\r\n    }\r\n\r\n    &.popover-primary{\r\n        @include popover-color($primary-color, $white-color);\r\n    }\r\n\r\n    &.popover-info{\r\n        @include popover-color($info-color, $white-color);\r\n    }\r\n\r\n    &.popover-warning{\r\n        @include popover-color($warning-color, $white-color);\r\n    }\r\n\r\n    &.popover-danger{\r\n        @include popover-color($danger-color, $white-color);\r\n    }\r\n\r\n    &.popover-success{\r\n        @include popover-color($success-color, $white-color);\r\n    }\r\n}\r\n\r\n\r\n.tooltip{\r\n    &.bs-tooltip-right .arrow:before{\r\n        border-right-color:$white-color;\r\n    }\r\n\r\n    &.bs-tooltip-top .arrow:before{\r\n        border-top-color:$white-color;\r\n    }\r\n\r\n    &.bs-tooltip-bottom .arrow:before{\r\n        border-bottom-color:$white-color;\r\n    }\r\n\r\n    &.bs-tooltip-left .arrow:before{\r\n        border-left-color:$white-color;\r\n    }\r\n}\r\n\r\n.tooltip-inner{\r\n    padding: $padding-base-vertical $padding-base-horizontal;\r\n    min-width: 130px;\r\n    background-color: $white-color;\r\n    font-size: $font-size-base;\r\n    color: inherit;\r\n    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n","@mixin popover-color($color, $text-color) {\r\n    background-color: $color;\r\n\r\n    .popover-body{\r\n        color: $text-color;\r\n    }\r\n\r\n\r\n    &.bs-popover-right .arrow:after{\r\n        border-right-color:$color;\r\n    }\r\n\r\n    &.bs-popover-top .arrow:after{\r\n        border-top-color:$color;\r\n    }\r\n\r\n    &.bs-popover-bottom .arrow:after{\r\n        border-bottom-color:$color;\r\n    }\r\n\r\n    &.bs-popover-left .arrow:after{\r\n        border-left-color:$color;\r\n    }\r\n\r\n    .popover-header{\r\n        color: $text-color;\r\n        opacity: .6;\r\n    }\r\n}\r\n","//\r\n// Modals\r\n// Now Ui Kit Design element Dialogs\r\n// --------------------------------------------------\r\n.modal-content {\r\n\r\n  border-radius: $border-radius-small;\r\n  border: none;\r\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.5);\r\n  // Modal header\r\n  // Top section of the modal w/ title and dismiss\r\n  .modal-header {\r\n    border-bottom: none;\r\n    padding-top:    24px;\r\n    padding-right:  24px;\r\n    padding-bottom: 0;\r\n    padding-left:   24px;\r\n\r\n    & button{\r\n        position: absolute;\r\n        right: 27px;\r\n        top: 30px;\r\n        outline: 0;\r\n    }\r\n    .title{\r\n        margin-top: 5px;\r\n        margin-bottom: 0;\r\n    }\r\n  }\r\n  // Modal body\r\n  // Where all modal content resides (sibling of .modal-header and .modal-footer)\r\n  .modal-body {\r\n    padding-top:    24px;\r\n    padding-right:  24px;\r\n    padding-bottom: 16px;\r\n    padding-left:   24px;\r\n    line-height: 1.9;\r\n  }\r\n  // Footer (for actions)\r\n  .modal-footer {\r\n    border-top: none;\r\n    padding-right: 24px;\r\n    padding-bottom: 16px;\r\n    padding-left: 24px;\r\n    -webkit-justify-content: space-between; /* Safari 6.1+ */\r\n    justify-content: space-between;\r\n\r\n    button {\r\n      margin: 0;\r\n      padding-left: 16px;\r\n      padding-right: 16px;\r\n      width: auto;\r\n      &.pull-left {\r\n        padding-left: 5px;\r\n        padding-right: 5px;\r\n        position: relative;\r\n        left: -5px;\r\n      }\r\n    }\r\n\r\n  }\r\n  .modal-body + .modal-footer {\r\n    padding-top: 0;\r\n  }\r\n}\r\n.modal-backdrop {\r\n  background: rgba(0,0,0,0.3);\r\n}\r\n\r\n.modal{\r\n\r\n    &.modal-mini{\r\n        p{\r\n            text-align: center;\r\n        }\r\n\r\n        .modal-dialog{\r\n            max-width: 255px;\r\n            margin: 0 auto;\r\n        }\r\n\r\n        .modal-profile{\r\n            width: 70px;\r\n            height: 70px;\r\n            background-color: $white-color;\r\n            border-radius: 50%;\r\n            text-align: center;\r\n            line-height: 5.7;\r\n            box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.3);\r\n\r\n            i{\r\n                color: $primary-color;\r\n                font-size: 21px;\r\n            }\r\n\r\n            &[class*=\"modal-profile-\"]{\r\n                i{\r\n                    color: $white-color;\r\n                }\r\n            }\r\n\r\n            &.modal-profile-primary{\r\n                background-color: $primary-color;\r\n            }\r\n\r\n            &.modal-profile-danger{\r\n                background-color: $danger-color;\r\n            }\r\n\r\n            &.modal-profile-warning{\r\n                background-color: $warning-color;\r\n            }\r\n\r\n            &.modal-profile-success{\r\n                background-color: $success-color;\r\n            }\r\n\r\n            &.modal-profile-info{\r\n                background-color: $info-color;\r\n            }\r\n        }\r\n\r\n        .modal-footer{\r\n            button{\r\n                text-transform: uppercase;\r\n\r\n                &:first-child{\r\n                    opacity: .5;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.modal-default{\r\n        @include modal-colors($white-color, $black-color);\r\n    }\r\n\r\n    &.modal-primary{\r\n        @include modal-colors($primary-color, $white-color);\r\n    }\r\n\r\n    &.modal-danger{\r\n        @include modal-colors($danger-color, $white-color);\r\n    }\r\n\r\n    &.modal-warning{\r\n        @include modal-colors($warning-color, $white-color);\r\n    }\r\n\r\n    &.modal-success{\r\n        @include modal-colors($success-color, $white-color);\r\n    }\r\n\r\n    &.modal-info{\r\n        @include modal-colors($info-color, $white-color);\r\n    }\r\n\r\n    &.show.modal-mini .modal-dialog{\r\n        -webkit-transform: translate(0,30%);\r\n        -o-transform: translate(0,30%);\r\n        transform: translate(0,30%);\r\n    }\r\n\r\n    .modal-header .close{\r\n        color: $danger-color;\r\n        text-shadow: none;\r\n\r\n        &:hover,\r\n        &:focus{\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n","@mixin modal-colors($bg-color, $color) {\r\n    .modal-content{\r\n        background-color: $bg-color;\r\n        color: $color;\r\n    }\r\n\r\n    .modal-header .close{\r\n        color: $color;\r\n    }\r\n\r\n\r\n}\r\n","// display flex was causing errors\r\n.carousel-item-next,\r\n.carousel-item-prev,\r\n.carousel-item.active{\r\n    display: block;\r\n}\r\n\r\n.carousel{\r\n    .carousel-inner{\r\n        box-shadow: $box-shadow-raised;\r\n        border-radius: $border-radius-small;\r\n    }\r\n\r\n    .card {\r\n        max-width: 650px;\r\n        margin: 60px auto;\r\n        display: block;\r\n    }\r\n}\r\n",".footer{\r\n    padding: 24px 0;\r\n\r\n    &.footer-default{\r\n        background-color: #f2f2f2;\r\n    }\r\n\r\n    nav{\r\n        display: inline-block;\r\n        float: left;\r\n    }\r\n\r\n    ul{\r\n        margin-bottom: 0;\r\n        padding: 0;\r\n        list-style: none;\r\n\r\n        li{\r\n            display: inline-block;\r\n\r\n            a{\r\n                color: inherit;\r\n                padding: $padding-base-vertical;\r\n                font-size: $font-size-small;\r\n                text-transform: uppercase;\r\n                text-decoration: none;\r\n\r\n                &:hover{\r\n                    text-decoration: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .copyright{\r\n        font-size: $font-size-small;\r\n    }\r\n\r\n    &:after{\r\n        display: table;\r\n        clear: both;\r\n        content: \" \";\r\n    }\r\n}\r\n",".card{\r\n  border: 0;\r\n  border-radius: $border-radius-small;\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 100%;\r\n  margin-bottom: 30px;\r\n  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\r\n\r\n  .card-header{\r\n    background-color: $transparent-bg;\r\n    border-bottom: 0;\r\n    background-color: transparent;\r\n    border-radius: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .card-footer{\r\n    padding: 0;\r\n    margin-top: 15px;\r\n    background-color: $transparent-bg;\r\n    border:0;\r\n  }\r\n\r\n  &[data-background-color=\"orange\"]{\r\n      background-color: $primary-color;\r\n  }\r\n\r\n  &[data-background-color=\"red\"]{\r\n      background-color: $danger-color;\r\n  }\r\n\r\n  &[data-background-color=\"yellow\"]{\r\n      background-color: $warning-color;\r\n  }\r\n\r\n  &[data-background-color=\"blue\"]{\r\n      background-color: $info-color;\r\n  }\r\n\r\n  &[data-background-color=\"green\"]{\r\n      background-color: darken($success-color, 5%);\r\n  }\r\n}\r\n",".card-plain{\r\n    background: transparent;\r\n    box-shadow: none;\r\n\r\n    .card-body,\r\n    .card-header{\r\n        padding-left: 5px;\r\n        padding-right: 5px;\r\n    }\r\n\r\n    .card-header:after{\r\n        width: 100%;\r\n        left: 0;\r\n    }\r\n}\r\n",".card-signup{\r\n    max-width: 350px;\r\n    margin: 0 auto;\r\n\r\n    .card-header{\r\n      margin:0 20px;\r\n      padding: 30px 0;\r\n    }\r\n\r\n    .card-title{\r\n      margin-top: 15px;\r\n      margin-bottom: 15px;\r\n    }\r\n\r\n    .card-footer {\r\n      margin-bottom: 10px;\r\n      margin-top: 24px;\r\n      padding: 24px 0;\r\n    }\r\n\r\n    .card-body{\r\n        padding-top: 0px;\r\n        padding-bottom: 0px;\r\n        min-height: auto;\r\n    }\r\n\r\n    .form-check,\r\n    .form-check.form-check-radio{\r\n        margin-top: 20px;\r\n\r\n        label{\r\n            margin-left: 11px;\r\n            color: initial;\r\n            padding-left: 40px;\r\n        }\r\n    }\r\n\r\n    .card-description{\r\n        margin-top: 15px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .social-line{\r\n        margin-top: 20px;\r\n        text-align: center;\r\n\r\n        .btn.btn-icon ,\r\n        .btn.btn-icon .btn-icon{\r\n            margin-left: 5px;\r\n            margin-right: 5px;\r\n            margin-top: 0;\r\n            margin-bottom: 0;\r\n            box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);\r\n        }\r\n    }\r\n}\r\n","// style for the landing page\r\n.index-page{\r\n    .page-header{\r\n        height: 125vh;\r\n\r\n        .container{\r\n            > .content-center{\r\n                top: 37%;\r\n            }\r\n        }\r\n\r\n        .category-absolute{\r\n            position: absolute;\r\n            top: 100vh;\r\n            margin-top: -60px;\r\n            padding: 0 15px;\r\n            width: 100%;\r\n            color: rgba(255,255,255,.5);\r\n        }\r\n    }\r\n}\r\n.landing-page{\r\n\r\n    .header{\r\n        height: 100vh;\r\n        position: relative;\r\n\r\n        .container{\r\n            padding-top: 26vh;\r\n            color: #FFFFFF;\r\n            z-index: 2;\r\n            position: relative;\r\n        }\r\n\r\n        .share{\r\n            margin-top: 150px;\r\n        }\r\n        h1{\r\n            font-weight: 600;\r\n        }\r\n        .title{\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    .section-team{\r\n        .team .team-player img{\r\n            max-width: 100px;\r\n        }\r\n\r\n        .team-player{\r\n            margin-bottom: 15px;\r\n        }\r\n    }\r\n\r\n    .section-contact-us{\r\n        .title{\r\n            margin-bottom: 15px;\r\n        }\r\n\r\n        .description{\r\n            margin-bottom: 30px;\r\n        }\r\n\r\n        .input-group,\r\n        .send-button,\r\n        .textarea-container{\r\n            padding: 0 40px;\r\n        }\r\n\r\n        .textarea-container{\r\n            margin: 40px 0;\r\n        }\r\n\r\n        a.btn{\r\n            margin-top: 35px;\r\n        }\r\n    }\r\n}\r\n\r\n// style for the profile page\r\n.profile-page{\r\n\r\n    .page-header{\r\n        min-height: 550px;\r\n    }\r\n\r\n    .profile-container{\r\n        color: #FFFFFF;\r\n    }\r\n    .photo-container{\r\n        width: 123px;\r\n        height: 123px;\r\n        border-radius: 50%;\r\n        overflow: hidden;\r\n        margin: 0 auto;\r\n        box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\r\n    }\r\n\r\n    .title{\r\n        text-align: center;\r\n        margin-top: 30px;\r\n    }\r\n\r\n    .description,\r\n    .category{\r\n        text-align: center;\r\n    }\r\n\r\n    h5.description{\r\n        max-width: 700px;\r\n        margin: 20px auto 75px;\r\n    }\r\n\r\n    .nav-align-center{\r\n        margin-top: 30px;\r\n    }\r\n\r\n    .content{\r\n        max-width: 450px;\r\n        margin: 0 auto;\r\n\r\n        .social-description{\r\n            display: inline-block;\r\n            max-width: 150px;\r\n            width: 145px;\r\n            text-align: center;\r\n            margin: 15px 0 0px;\r\n\r\n            h2{\r\n                margin-bottom: 15px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .button-container{\r\n        text-align: center;\r\n        margin-top: -106px;\r\n    }\r\n\r\n    .collections{\r\n        img{\r\n            margin-bottom: 30px;\r\n        }\r\n    }\r\n\r\n    .gallery{\r\n        margin-top: 45px;\r\n        padding-bottom: 50px;\r\n    }\r\n}\r\n\r\n.section-full-page{\r\n\r\n    &:after,\r\n    &:before{\r\n        display: block;\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 2;\r\n    }\r\n\r\n    &:before{\r\n        background-color: rgba(0,0,0,.5);\r\n    }\r\n\r\n    &[filter-color=\"purple\"],\r\n    &[filter-color=\"primary\"]{\r\n        &:after{\r\n            @include linear-gradient(rgba($light-gray,.26), rgba($primary-color,.95));\r\n\r\n        }\r\n\r\n    }\r\n\r\n    &[data-image]:after{\r\n        opacity: .5;\r\n    }\r\n\r\n    > .content,\r\n    > .footer{\r\n        position: relative;\r\n        z-index: 4;\r\n    }\r\n\r\n    > .content{\r\n        min-height: calc(100vh - 80px);\r\n    }\r\n\r\n    .full-page-background{\r\n        position: absolute;\r\n        z-index: 1;\r\n        height: 100%;\r\n        width: 100%;\r\n        display: block;\r\n        top: 0;\r\n        left: 0;\r\n        background-size: cover;\r\n        background-position: center center;\r\n\r\n    }\r\n\r\n    .footer nav > ul a:not(.btn),\r\n    .footer,\r\n    .footer .copyright a{\r\n        color: $white-color;\r\n    }\r\n\r\n}\r\n\r\n.login-page,\r\n.profile-page {\r\n  .page-header:before {\r\n    position: absolute;\r\n    z-index: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    left: 0;\r\n    top: 0;\r\n    content: \"\";\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n  }\r\n}\r\n\r\n.login-page{\r\n\r\n\r\n\r\n    .card-login{\r\n        border-radius: $border-radius-large;\r\n        padding-bottom: $padding-base-horizontal;\r\n        max-width: 320px;\r\n\r\n        .btn-wd{\r\n            min-width: 180px;\r\n        }\r\n\r\n        .logo-container{\r\n            width: 65px;\r\n            margin: 0 auto;\r\n            margin-bottom: 55px;\r\n\r\n            img{\r\n                width: 100%;\r\n            }\r\n        }\r\n\r\n        .input-group:last-child{\r\n            margin-bottom: 40px;\r\n        }\r\n\r\n        &.card-plain{\r\n            @include input-coloured-bg($opacity-5, $white-color, $white-color, $transparent-bg, $opacity-1, $opacity-2);\r\n\r\n            .input-group-text,\r\n            .form-group.no-border .input-group-text,\r\n            .input-group.no-border .input-group-text{\r\n                color: $opacity-8;\r\n            }\r\n        }\r\n    }\r\n\r\n    .link{\r\n        font-size: 10px;\r\n        color: $white-color;\r\n        text-decoration: none;\r\n    }\r\n}\r\n","@mixin linear-gradient($color1, $color2){\r\n    background: $color1; /* For browsers that do not support gradients */\r\n    background: -webkit-linear-gradient(90deg, $color1 , $color2); /* For Safari 5.1 to 6.0 */\r\n    background: -o-linear-gradient(90deg, $color1, $color2); /* For Opera 11.1 to 12.0 */\r\n    background: -moz-linear-gradient(90deg, $color1, $color2); /* For Firefox 3.6 to 15 */\r\n    background: linear-gradient(0deg, $color1 , $color2); /* Standard syntax */\r\n}\r\n",".section{\r\n    padding: 70px 0;\r\n    position: relative;\r\n    background: $white-color;\r\n\r\n    .row + .category{\r\n        margin-top: $margin-base-vertical;\r\n    }\r\n}\r\n.section-navbars{\r\n    padding-bottom: 0;\r\n}\r\n\r\n.section-full-screen{\r\n    height: 100vh;\r\n}\r\n.section-signup{\r\n    padding-top: 20vh;\r\n}\r\n\r\n.page-header{\r\n  min-height: 100vh;\r\n  max-height: 999px;\r\n  padding: 0;\r\n  color: $white-color;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  & > .content{\r\n    margin-top: 12%;\r\n    text-align: center;\r\n    margin-bottom: 50px;\r\n  }\r\n\r\n  &.page-header-small{\r\n      min-height: 60vh;\r\n      max-height: 440px;\r\n  }\r\n\r\n  &:before{\r\n      background-color: rgba(0,0,0,.3);\r\n  }\r\n\r\n  > .container{\r\n    z-index: 2;\r\n    padding-top: 12vh;\r\n    padding-bottom: 40px;\r\n  }\r\n\r\n    .page-header-image{\r\n        position: absolute;\r\n        background-size: cover;\r\n        background-position: center center;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: -1;\r\n    }\r\n\r\n    .content-center{\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      z-index: 2;\r\n      -ms-transform: translate(-50%, -50%);\r\n      -webkit-transform: translate(-50%, -50%);\r\n      transform: translate(-50%, -50%);\r\n      text-align: center;\r\n      color: #FFFFFF;\r\n      padding: 0 15px;\r\n      width: 100%;\r\n      max-width: 880px;\r\n\r\n    }\r\n\r\n    footer{\r\n        position: absolute;\r\n        bottom: 0;\r\n        width: 100%;\r\n    }\r\n    .container{\r\n        height: 100%;\r\n        z-index: 1;\r\n        text-align: center;\r\n        position: relative;\r\n    }\r\n\r\n    .category,\r\n    .description{\r\n      color: $opacity-8;\r\n    }\r\n\r\n    &:after,\r\n    &:before{\r\n        position: absolute;\r\n        z-index: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        display: block;\r\n        left: 0;\r\n        top: 0;\r\n        content: \"\";\r\n    }\r\n}\r\n\r\n.clear-filter{\r\n    &:after,\r\n    &:before{\r\n        display: none;\r\n    }\r\n\r\n    &[filter-color=\"orange\"]{\r\n        @include linear-gradient(rgba($black-color,.20), rgba(224, 23, 3, 0.6));\r\n    }\r\n}\r\n\r\n.section-story-overview{\r\n    padding: 50px 0;\r\n\r\n    .image-container{\r\n        height: 335px;\r\n        position: relative;\r\n        background-position: center center;\r\n        background-size: cover;\r\n        box-shadow: $box-shadow-raised;\r\n        border-radius: .25rem;\r\n\r\n        & + .category{\r\n            padding-top: 15px;\r\n        }\r\n\r\n        &.image-right{\r\n            z-index: 2;\r\n\r\n            + h3.title{\r\n                margin-top: 120px;\r\n            }\r\n        }\r\n\r\n        &.image-left{\r\n            z-index: 1;\r\n        }\r\n\r\n        &:nth-child(2){\r\n            margin-top: 420px;\r\n            margin-left: -105px;\r\n        }\r\n    }\r\n\r\n    p.blockquote{\r\n        width: 220px;\r\n        min-height: 180px;\r\n        text-align: left;\r\n        position: absolute;\r\n        top: 376px;\r\n        right: 155px;\r\n        z-index: 0;\r\n    }\r\n}\r\n\r\n.section-nucleo-icons{\r\n     .nucleo-container img{\r\n        width: auto;\r\n        left: 0;\r\n        top: 0;\r\n        height: 100%;\r\n        position: absolute;\r\n    }\r\n\r\n     .nucleo-container{\r\n        height: 335px;\r\n        position: relative;\r\n    }\r\n\r\n     h5{\r\n        margin-bottom: 35px;\r\n    }\r\n\r\n     .icons-container{\r\n        position: relative;\r\n        max-width: 450px;\r\n        height: 300px;\r\n        max-height: 300px;\r\n        margin: 0 auto;\r\n\r\n    }\r\n     .icons-container i{\r\n        font-size: 34px;\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n    }\r\n\r\n     .icons-container i:nth-child(1){\r\n        top: 5%;\r\n        left: 7%;\r\n    }\r\n\r\n     .icons-container i:nth-child(2){\r\n         top: 28%;\r\n         left: 24%;\r\n    }\r\n\r\n     .icons-container i:nth-child(3){\r\n         top: 40%;\r\n    }\r\n\r\n     .icons-container i:nth-child(4){\r\n         top: 18%;\r\n         left: 62%;\r\n    }\r\n\r\n     .icons-container i:nth-child(5){\r\n         top: 74%;\r\n         left: 3%;\r\n    }\r\n\r\n     .icons-container i:nth-child(6){\r\n         top: 36%;\r\n         left: 44%;\r\n        font-size: 65px;\r\n        color: #f96332;\r\n        padding: 1px;\r\n    }\r\n\r\n     .icons-container i:nth-child(7){\r\n         top: 59%;\r\n         left: 26%;\r\n    }\r\n\r\n     .icons-container i:nth-child(8){\r\n         top: 60%;\r\n         left: 69%;\r\n    }\r\n\r\n     .icons-container i:nth-child(9){\r\n        top: 72%;\r\n        left: 47%;\r\n    }\r\n\r\n     .icons-container i:nth-child(10){\r\n         top: 88%;\r\n         left: 27%;\r\n    }\r\n\r\n     .icons-container i:nth-child(11){\r\n         top: 31%;\r\n         left: 80%;\r\n    }\r\n\r\n     .icons-container i:nth-child(12){\r\n         top: 88%;\r\n         left: 68%;\r\n    }\r\n\r\n     .icons-container i:nth-child(13){\r\n         top: 5%;\r\n         left: 81%;\r\n    }\r\n\r\n     .icons-container i:nth-child(14){\r\n         top: 58%;\r\n         left: 90%;\r\n    }\r\n\r\n     .icons-container i:nth-child(15){\r\n        top: 6%;\r\n        left: 40%;\r\n    }\r\n}\r\n\r\n.section-images{\r\n    max-height: 670px;\r\n    height: 670px;\r\n\r\n    .hero-images-container,\r\n    .hero-images-container-1,\r\n    .hero-images-container-2{\r\n        margin-top: -38vh;\r\n    }\r\n\r\n    .hero-images-container{\r\n        max-width: 670px;\r\n    }\r\n\r\n    .hero-images-container-1{\r\n        max-width: 390px;\r\n        position: absolute;\r\n        top: 55%;\r\n        right: 18%;\r\n\r\n    }\r\n\r\n    .hero-images-container-2{\r\n        max-width: 225px;\r\n        position: absolute;\r\n        top: 68%;\r\n        right: 12%;\r\n    }\r\n}\r\n\r\n\r\n[data-background-color=\"orange\"]{\r\n    background-color: $orange-bg;\r\n}\r\n[data-background-color=\"black\"]{\r\n    background-color: $black-color;\r\n}\r\n\r\n[data-background-color]:not([data-background-color=\"gray\"]){\r\n    color: $white-color;\r\n\r\n    .title,\r\n    .social-description h2,\r\n    p,\r\n    p.blockquote,\r\n    p.blockquote small{\r\n        color: $white-color;\r\n    }\r\n\r\n    .separator{\r\n        background-color: $white-color;\r\n    }\r\n\r\n    .navbar.bg-white p{\r\n        color: $default-color;\r\n    }\r\n\r\n    h1,h2,h3,h4,h5,h6,a:not(.btn):not(.dropdown-item),\r\n    .icons-container{\r\n      color: $white-color;\r\n    }\r\n\r\n    .input-group-text,\r\n    .form-group.no-border .input-group-text,\r\n    .input-group.no-border .input-group-text{\r\n      color: $opacity-8;\r\n    }\r\n\r\n    .description,\r\n    .social-description p{\r\n        color: $opacity-8;\r\n    }\r\n\r\n    p.blockquote{\r\n        border-color: $opacity-2;\r\n    }\r\n\r\n    //radio and checkboxes\r\n    .checkbox label::before,\r\n    .checkbox label::after,\r\n    .radio label::before,\r\n    .radio label::after{\r\n        border-color: $opacity-2;\r\n    }\r\n\r\n    .checkbox label::after,\r\n    .checkbox label,\r\n    .radio label{\r\n        color: $white-color;\r\n    }\r\n\r\n    .checkbox input[type=\"checkbox\"]:disabled + label,\r\n    .radio input[type=\"radio\"]:disabled + label  {\r\n        color: $white-color;\r\n    }\r\n\r\n    .radio input[type=\"radio\"]:not(:disabled):hover + label::after,\r\n    .radio input[type=\"radio\"]:checked + label::after {\r\n        background-color: $white-color;\r\n        border-color: $white-color;\r\n    }\r\n\r\n    //inputs\r\n    @include input-coloured-bg($opacity-5, $white-color, $white-color, $transparent-bg, $opacity-1, $opacity-2);\r\n\r\n    //buttons\r\n    .btn[class*=\"btn-outline-\"] {\r\n        background-color: $transparent-bg;\r\n        border-color: $opacity-5;\r\n        color: $white-color;\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:not(:disabled):not(.disabled):active,\r\n        &:not(:disabled):not(.disabled).active,\r\n        &:not(:disabled):not(.disabled):active:focus,\r\n        &:not(:disabled):not(.disabled).active:focus,\r\n        &:active:hover,\r\n        &.active:hover,\r\n        .show > &.dropdown-toggle,\r\n        .show > &.dropdown-toggle:focus,\r\n        .show > &.dropdown-toggle:hover {\r\n            background-color: $transparent-bg;\r\n            border-color: $white-color;\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    //tabs\r\n    .nav-tabs{\r\n        > .nav-item{\r\n            >.nav-link{\r\n                i.now-ui-icons{\r\n                    color: $white-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.section-nucleo-icons .icons-container i:nth-child(6){\r\n        color: $white-color;\r\n    }\r\n}\r\n","@media screen and (max-width: 991px){\r\n    .sidebar-collapse{\r\n        @include navbar-collapse();\r\n\r\n        &.menu-on-left{\r\n            .navbar-collapse{\r\n                right: auto;\r\n                left: 0;\r\n                @include transform-translate-x(-300px);\r\n            }\r\n        }\r\n\r\n        .nav-open &{\r\n            .navbar-collapse{\r\n                @include transform-translate-x(0px);\r\n            }\r\n\r\n            .wrapper{\r\n                @include transform-translate-x(-150px);\r\n            }\r\n\r\n            .navbar-translate{\r\n                @include transform-translate-x(-300px);\r\n            }\r\n\r\n            &.menu-on-left{\r\n                .navbar-collapse{\r\n                    @include transform-translate-x(0px);\r\n                }\r\n\r\n                .navbar-translate{\r\n                    @include transform-translate-x(300px);\r\n                }\r\n\r\n                .wrapper{\r\n                    @include transform-translate-x(150px);\r\n                }\r\n\r\n                #bodyClick{\r\n                    right: auto;\r\n                    left: 300px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .navbar-nav .nav-link i.fab,\r\n    .navbar-nav .nav-link i.now-ui-icons {\r\n      opacity: .5;\r\n    }\r\n\r\n    .bootstrap-collapse{\r\n        .navbar .navbar-collapse{\r\n            background: none !important;\r\n        }\r\n        @include navbar-responsive();\r\n    }\r\n\r\n    .profile-photo .profile-photo-small{\r\n        margin-left: -2px;\r\n    }\r\n\r\n    .button-dropdown{\r\n        display: none;\r\n    }\r\n\r\n    .section-nucleo-icons .container .row > [class*=\"col-\"]:first-child{\r\n        text-align: center;\r\n    }\r\n\r\n    .footer{\r\n        .copyright{\r\n            text-align: right;\r\n        }\r\n    }\r\n\r\n    .section-nucleo-icons .icons-container{\r\n        margin-top: 65px;\r\n    }\r\n\r\n    .navbar-nav{\r\n        .nav-link{\r\n            i.fa,\r\n            i.now-ui-icons{\r\n                opacity: .5;\r\n            }\r\n        }\r\n    }\r\n\r\n    .section-images{\r\n        height: 500px;\r\n        max-height: 500px;\r\n\r\n        .hero-images-container{\r\n            max-width: 500px;\r\n        }\r\n\r\n        .hero-images-container-1{\r\n            right: 10%;\r\n            top: 68%;\r\n            max-width: 269px;\r\n        }\r\n\r\n        .hero-images-container-2{\r\n            right: 5%;\r\n            max-width: 135px;\r\n            top: 93%;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 992px){\r\n  .navbar-collapse:not(.has-image) {\r\n    background: transparent !important;\r\n}\r\n    .burger-menu{\r\n        @include navbar-collapse();\r\n\r\n        .nav-open & .navbar-collapse{\r\n            @include transform-translate-x(0px);\r\n        }\r\n\r\n        .navbar-collapse {\r\n            display: block !important;\r\n\r\n            .navbar-nav {\r\n                margin-top: 53px;\r\n                height: 100%;\r\n                z-index: 2;\r\n                position: relative;\r\n                display: -webkit-box;\r\n                display: -webkit-flex;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                -webkit-box-orient: vertical;\r\n                -webkit-box-direction: normal;\r\n                -webkit-flex-direction: column;\r\n                -ms-flex-direction: column;\r\n                flex-direction: column;\r\n\r\n                .nav-item{\r\n                    margin: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        &.menu-on-left .navbar-collapse{\r\n            right: auto;\r\n            left: 0;\r\n            @include transform-translate-x(-300px);\r\n        }\r\n\r\n        [class*=\"navbar-expand-\"]{\r\n            .navbar-nav .dropdown-menu{\r\n                position: static;\r\n                float: none;\r\n            }\r\n\r\n            .navbar-toggler{\r\n                display: inline-block;\r\n            }\r\n        }\r\n\r\n        .section-navbars .navbar-collapse{\r\n            display: none !important;\r\n        }\r\n\r\n        .nav-open &{\r\n            &.menu-on-left .navbar .navbar-translate{\r\n                @include transform-translate-x(300px);\r\n            }\r\n\r\n            .navbar .navbar-translate{\r\n                @include transform-translate-x(-300px);\r\n            }\r\n\r\n            &.menu-on-left .navbar-collapse{\r\n                @include transform-translate-x(0px);\r\n            }\r\n\r\n            &.menu-on-left #bodyClick{\r\n                right: auto;\r\n                left: 300px;\r\n            }\r\n        }\r\n\r\n        &.menu-on-left .navbar-brand{\r\n            float: right;\r\n            margin-right: 0;\r\n            margin-left: 1rem;\r\n        }\r\n    }\r\n\r\n    .navbar-nav{\r\n        .nav-link{\r\n            &.profile-photo{\r\n                padding: 0;\r\n                margin: 7px $padding-base-horizontal;\r\n            }\r\n\r\n            &.btn:not(.btn-sm){\r\n                margin: 0;\r\n            }\r\n        }\r\n\r\n        .nav-item:not(:last-child){\r\n            margin-right: 5px;\r\n        }\r\n\r\n    }\r\n\r\n    .section-nucleo-icons .icons-container{\r\n        margin: 0 0 0 auto;\r\n    }\r\n\r\n    .dropdown-menu .dropdown-item{\r\n        color: inherit;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        i {\r\n          margin-right: 5px;\r\n          position: relative;\r\n          top: 1px;\r\n        }\r\n    }\r\n\r\n    .footer{\r\n        .copyright{\r\n            float: right;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 768px){\r\n    .image-container{\r\n        &.image-right{\r\n            top: 80px;\r\n            margin-left: - 100px;\r\n            margin-bottom: 130px;\r\n        }\r\n\r\n        &.image-left{\r\n            margin-right: -100px;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 768px){\r\n    .image-container{\r\n        &.image-left{\r\n            margin-bottom: 220px;\r\n\r\n            p.blockquote{\r\n                margin: 0 auto;\r\n                position: relative;\r\n                right: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    .nav-tabs{\r\n        display: inline-block;\r\n        width: 100%;\r\n        padding-left: 100px;\r\n        padding-right: 100px;\r\n        text-align: center;\r\n\r\n        .nav-item > .nav-link{\r\n            margin-bottom: 5px;\r\n        }\r\n    }\r\n\r\n    .landing-page .section-story-overview .image-container:nth-child(2){\r\n        margin-left: 0;\r\n        margin-bottom: 30px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 576px){\r\n    .navbar[class*='navbar-expand-'] .container{\r\n        margin-left: 0;\r\n        margin-right: 0;\r\n    }\r\n\r\n    .footer{\r\n        .copyright{\r\n            text-align: center;\r\n        }\r\n    }\r\n\r\n    .section-nucleo-icons{\r\n        .icons-container{\r\n            i{\r\n                font-size: 30px;\r\n\r\n                &:nth-child(6){\r\n                    font-size: 48px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .page-header{\r\n        .container h6.category-absolute{\r\n            width: 90%;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 991px) and (max-width: 1200px){\r\n    .section-images{\r\n        .hero-images-container-1{\r\n            right: 9%;\r\n            max-width: 370px;\r\n        }\r\n\r\n        .hero-images-container-2{\r\n            right: 2%;\r\n            max-width: 216px;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 768px){\r\n    .section-images{\r\n        height: 300px;\r\n        max-height: 300px;\r\n\r\n        .hero-images-container{\r\n            max-width: 380px;\r\n        }\r\n\r\n        .hero-images-container-1{\r\n            right: 7%;\r\n            top: 87%;\r\n            max-width: 210px;\r\n        }\r\n\r\n        .hero-images-container-2{\r\n            right: 1%;\r\n            max-width: 133px;\r\n            top: 99%;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 517px) {\r\n    .alert .alert-icon{\r\n        margin-top: 10px;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 1200px) {\r\n    .section-images{\r\n        .hero-images-container-1{\r\n            top: 51%;\r\n            right: 21%;\r\n        }\r\n\r\n        .hero-images-container-2{\r\n            top: 66%;\r\n            right: 14%;\r\n        }\r\n    }\r\n}\r\n\r\n// Ipad responsive portrait mode\r\n@media only screen\r\nand (min-device-width : 768px)\r\nand (max-device-width : 1024px)\r\nand ( orientation : portrait){\r\n    .section-images .hero-images-container,\r\n    .section-images .hero-images-container-1,\r\n    .section-images .hero-images-container-2{\r\n        margin-top: -15vh;\r\n        margin-left: 80px;\r\n    }\r\n\r\n    .section-images .hero-images-container{\r\n        max-width: 300px;\r\n    }\r\n\r\n    .section-images .hero-images-container-1{\r\n        right: 28%;\r\n        top: 40%;\r\n    }\r\n\r\n    .section-images .hero-images-container-2{\r\n        right: 21%;\r\n        top: 55%;\r\n    }\r\n\r\n    .index-page .category-absolute{\r\n        top: 90vh;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 580px) {\r\n    .alert{\r\n        button.close{\r\n            position: absolute;\r\n            right: 11px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (min-height: 950px) {\r\n  .index-page .page-header .category-absolute{\r\n    margin-top: -330px;\r\n  }\r\n}\r\n","@mixin navbar-responsive() {\r\n    &.menu-on-left .navbar-translate {\r\n      flex-direction: row-reverse;\r\n    }\r\n\r\n    .navbar{\r\n        .navbar-nav{\r\n            margin-top: 53px;\r\n            position: relative;\r\n        \t  max-height: calc(100vh - 75px);\r\n        \t  min-height: 100%;\r\n        \t  overflow: auto;\r\n\r\n            &.navbar-logo{\r\n                top: 0;\r\n                height: 53px;\r\n            }\r\n        }\r\n\r\n        .dropdown.show .dropdown-menu,\r\n        .dropdown .dropdown-menu{\r\n            background-color: transparent;\r\n            border: 0;\r\n            transition: none;\r\n            -webkit-box-shadow: none;\r\n            box-shadow: none;\r\n            width: auto;\r\n            margin: 0 1rem;\r\n            margin-bottom: 15px;\r\n            padding-top: 0;\r\n            height: 125px;\r\n            overflow-y: scroll;\r\n\r\n            &:before{\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .dropdown{\r\n            .dropdown-item{\r\n                padding-left: 2.5rem;\r\n            }\r\n\r\n            .dropdown-menu{\r\n               display: none;\r\n           }\r\n\r\n           &.show .dropdown-menu{\r\n               display: block;\r\n           }\r\n        }\r\n\r\n        .dropdown-menu .dropdown-item:focus,\r\n        .dropdown-menu .dropdown-item:hover{\r\n            color: $white-color;\r\n            border-radius: $border-radius-small;\r\n        }\r\n\r\n        .navbar-translate{\r\n          width: 100%;\r\n          position: relative;\r\n          display: flex;\r\n          -ms-flex-pack: justify!important;\r\n          justify-content: space-between!important;\r\n          -ms-flex-align: center;\r\n          align-items: center;\r\n          @include transform-translate-x(0px);\r\n          @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n        }\r\n\r\n        .navbar-toggler-bar{\r\n            display: block;\r\n            position: relative;\r\n            width: 22px;\r\n            height: 1px;\r\n            border-radius: 1px;\r\n            background: $white-bg;\r\n\r\n            & + .navbar-toggler-bar{\r\n                margin-top: 7px;\r\n            }\r\n\r\n            &.bar2{\r\n                width: 17px;\r\n                transition: width .2s linear;\r\n            }\r\n        }\r\n\r\n        &.bg-white:not(.navbar-transparent) .navbar-toggler-bar{\r\n            background: $default-color;\r\n        }\r\n\r\n    }\r\n\r\n    // .bar1,\r\n    // .bar2,\r\n    // .bar3 {\r\n    //   outline: 1px solid transparent;\r\n    // }\r\n    // .bar1 {\r\n    //   top: 0px;\r\n    //   @include bar-animation($topbar-back);\r\n    // }\r\n    // .bar2 {\r\n    //   opacity: 1;\r\n    // }\r\n    // .bar3 {\r\n    //   bottom: 0px;\r\n    //   @include bar-animation($bottombar-back);\r\n    // }\r\n    // .toggled .bar1 {\r\n    //   top: 6px;\r\n    //   @include bar-animation($topbar-x);\r\n    // }\r\n    // .toggled .bar2 {\r\n    //   opacity: 0;\r\n    // }\r\n    // .toggled .bar3 {\r\n    //   bottom: 6px;\r\n    //   @include bar-animation($bottombar-x);\r\n    // }\r\n\r\n  .top-bar {\r\n    transform: rotate(0);\r\n  }\r\n  .middle-bar {\r\n    opacity: 1;\r\n  }\r\n  .bottom-bar {\r\n    transform: rotate(0);\r\n  }\r\n\r\n  .top-bar,\r\n  .middle-bar,\r\n  .bottom-bar{\r\n    transition: all 0.2s;\r\n  }\r\n\r\n\r\n\r\n  .toggled {\r\n    .top-bar {\r\n    transform: rotate(45deg);\r\n    transform-origin: 0%;\r\n  }\r\n    .bottom-bar {\r\n      transform: rotate(-45deg);\r\n      transform-origin: 0%;\r\n    }\r\n    .middle-bar {\r\n      opacity: 0;\r\n    }\r\n  }\r\n\r\n\r\n\r\n    //\r\n    // @include topbar-x-rotation();\r\n    // @include topbar-back-rotation();\r\n    // @include bottombar-x-rotation();\r\n    // @include bottombar-back-rotation();\r\n    //\r\n    // @-webkit-keyframes fadeIn {\r\n    //   0% {opacity: 0;}\r\n    //   100% {opacity: 1;}\r\n    // }\r\n    // @-moz-keyframes fadeIn {\r\n    //   0% {opacity: 0;}\r\n    //   100% {opacity: 1;}\r\n    // }\r\n    // @keyframes fadeIn {\r\n    //   0% {opacity: 0;}\r\n    //   100% {opacity: 1;}\r\n    // }\r\n}\r\n\r\n@mixin navbar-collapse() {\r\n    .navbar-collapse{\r\n        position: fixed;\r\n        display: block !important;\r\n        top: 0;\r\n        height: 100% !important;\r\n        width: 300px;\r\n        right: 0;\r\n        z-index: 1032;\r\n        visibility: visible;\r\n        background-color: #999;\r\n        overflow-y: visible;\r\n        border-top: none;\r\n        text-align: left;\r\n\r\n        max-height: none !important;\r\n\r\n        @include transform-translate-x(300px);\r\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n\r\n        &:before{\r\n            background: $brand-primary; /* For browsers that do not support gradients */\r\n            background: -webkit-linear-gradient($brand-primary 0%, #000 80%); /* For Safari 5.1 to 6.0 */\r\n            background: -o-linear-gradient($brand-primary 0%, #000 80%); /* For Opera 11.1 to 12.0 */\r\n            background: -moz-linear-gradient($brand-primary 0%, #000 80%); /* For Firefox 3.6 to 15 */\r\n            background: linear-gradient($brand-primary 0%, #000 80%); /* Standard syntax (must be last) */\r\n            @include opacity(.76);\r\n\r\n            display: block;\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 100%;\r\n            height: 100%;\r\n            top: 0;\r\n            left: 0;\r\n            z-index: -1;\r\n        }\r\n\r\n        .navbar-nav:not(.navbar-logo){\r\n            .nav-link {\r\n                margin: 0 1rem;\r\n                margin-top: 0.3125rem;\r\n\r\n                &:not(.btn){\r\n                    color: $white-color !important;\r\n                }\r\n            }\r\n        }\r\n\r\n        .dropdown-menu .dropdown-item{\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    @include navbar-responsive();\r\n\r\n\r\n    [class*=\"navbar-expand-\"] .navbar-collapse{\r\n        width: 300px;\r\n    }\r\n\r\n    .wrapper{\r\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n    }\r\n\r\n    #bodyClick{\r\n        height: 100%;\r\n        width: 100%;\r\n        position: fixed;\r\n        opacity: 1;\r\n        top: 0;\r\n        left: auto;\r\n        right: 300px;\r\n        content: \"\";\r\n        z-index: 9999;\r\n        overflow-x: hidden;\r\n        background-color: transparent;\r\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n    }\r\n\r\n}\r\n","/*! nouislider - 14.0.2 - 6/28/2019 */\r\n/* Functional styling;\r\n * These styles are required for noUiSlider to function.\r\n * You don't need to change these rules to apply your design.\r\n */\r\n/*\r\n\r\nThis file was modified by Creative-Tim\r\n\r\n*/\r\n.noUi-target,\r\n.noUi-target * {\r\n  -webkit-touch-callout: none;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n  -webkit-user-select: none;\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  -ms-user-select: none;\r\n  -moz-user-select: none;\r\n  user-select: none;\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n.noUi-target {\r\n  position: relative;\r\n  direction: ltr;\r\n}\r\n.noUi-base,\r\n.noUi-connects {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n/* Wrapper for all connect elements.\r\n */\r\n.noUi-connects {\r\n  overflow: hidden;\r\n  z-index: 0;\r\n}\r\n.noUi-connect,\r\n.noUi-origin {\r\n  will-change: transform;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 0;\r\n  -ms-transform-origin: 0 0;\r\n  -webkit-transform-origin: 0 0;\r\n  -webkit-transform-style: preserve-3d;\r\n  transform-origin: 0 0;\r\n  transform-style: flat;\r\n}\r\n.noUi-connect {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.noUi-origin {\r\n  height: 10%;\r\n  width: 10%;\r\n}\r\n/* Offset direction\r\n */\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n/* Give origins 0 height/width so they don't interfere with clicking the\r\n * connect elements.\r\n */\r\n.noUi-vertical .noUi-origin {\r\n  width: 0;\r\n}\r\n.noUi-horizontal .noUi-origin {\r\n  height: 0;\r\n}\r\n.noUi-handle {\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  position: absolute;\r\n}\r\n.noUi-touch-area {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.noUi-state-tap .noUi-connect,\r\n.noUi-state-tap .noUi-origin {\r\n  -webkit-transition: transform 0.3s;\r\n  transition: transform 0.3s;\r\n}\r\n.noUi-state-drag * {\r\n  cursor: inherit !important;\r\n}\r\n/* Slider size and handle placement;\r\n */\r\n.noUi-horizontal {\r\n  height: 1px;\r\n}\r\n.noUi-horizontal .noUi-handle {\r\n  width: 15px;\r\n  height: 15px;\r\n  left: -7px;\r\n  top: 0px;\r\n}\r\n.noUi-vertical {\r\n  width: 18px;\r\n}\r\n.noUi-vertical .noUi-handle {\r\n  width: 15px;\r\n  height: 15px;\r\n  left: 0px;\r\n  top: -7px;\r\n}\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n  right: -7px;\r\n  left: auto;\r\n}\r\n/* Styling;\r\n * Giving the connect element a border radius causes issues with using transform: scale\r\n */\r\n.noUi-target {\r\n  background-color: rgba(182, 182, 182, 0.3);\r\n  border-radius: 3px;\r\n}\r\n.noUi-connects {\r\n  border-radius: 3px;\r\n}\r\n.noUi-connect {\r\n  // background: #3FB8AF;\r\n}\r\n/* Handles and cursors;\r\n */\r\n.noUi-draggable {\r\n  cursor: ew-resize;\r\n}\r\n.noUi-vertical .noUi-draggable {\r\n  cursor: ns-resize;\r\n}\r\n.noUi-handle {\r\n  border-radius: 3px;\r\n  background: #FFF;\r\n  cursor: default;\r\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\r\n}\r\n.noUi-active {\r\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\r\n}\r\n/* Disabled state;\r\n */\r\n[disabled] .noUi-connect {\r\n  background: #B8B8B8;\r\n}\r\n[disabled].noUi-target,\r\n[disabled].noUi-handle,\r\n[disabled] .noUi-handle {\r\n  cursor: not-allowed;\r\n}\r\n/* Base;\r\n *\r\n */\r\n.noUi-pips,\r\n.noUi-pips * {\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n.noUi-pips {\r\n  position: absolute;\r\n  color: #999;\r\n}\r\n/* Values;\r\n *\r\n */\r\n.noUi-value {\r\n  position: absolute;\r\n  white-space: nowrap;\r\n  text-align: center;\r\n}\r\n.noUi-value-sub {\r\n  color: #ccc;\r\n  font-size: 10px;\r\n}\r\n/* Markings;\r\n *\r\n */\r\n.noUi-marker {\r\n  position: absolute;\r\n  background: #CCC;\r\n}\r\n.noUi-marker-sub {\r\n  background: #AAA;\r\n}\r\n.noUi-marker-large {\r\n  background: #AAA;\r\n}\r\n/* Horizontal layout;\r\n *\r\n */\r\n.noUi-pips-horizontal {\r\n  padding: 10px 0;\r\n  height: 80px;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n.noUi-value-horizontal {\r\n  -webkit-transform: translate(-50%, 50%);\r\n  transform: translate(-50%, 50%);\r\n}\r\n.noUi-rtl .noUi-value-horizontal {\r\n  -webkit-transform: translate(50%, 50%);\r\n  transform: translate(50%, 50%);\r\n}\r\n.noUi-marker-horizontal.noUi-marker {\r\n  margin-left: -1px;\r\n  width: 2px;\r\n  height: 5px;\r\n}\r\n.noUi-marker-horizontal.noUi-marker-sub {\r\n  height: 10px;\r\n}\r\n.noUi-marker-horizontal.noUi-marker-large {\r\n  height: 15px;\r\n}\r\n/* Vertical layout;\r\n *\r\n */\r\n.noUi-pips-vertical {\r\n  padding: 0 10px;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 100%;\r\n}\r\n.noUi-value-vertical {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n  padding-left: 25px;\r\n}\r\n.noUi-rtl .noUi-value-vertical {\r\n  -webkit-transform: translate(0, 50%);\r\n  transform: translate(0, 50%);\r\n}\r\n.noUi-marker-vertical.noUi-marker {\r\n  width: 5px;\r\n  height: 2px;\r\n  margin-top: -1px;\r\n}\r\n.noUi-marker-vertical.noUi-marker-sub {\r\n  width: 10px;\r\n}\r\n.noUi-marker-vertical.noUi-marker-large {\r\n  width: 15px;\r\n}\r\n.noUi-tooltip {\r\n  display: block;\r\n  position: absolute;\r\n  border: 1px solid #D9D9D9;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n  color: #000;\r\n  padding: 5px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n.noUi-horizontal .noUi-tooltip {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n  left: 50%;\r\n  bottom: 120%;\r\n}\r\n.noUi-vertical .noUi-tooltip {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n  top: 50%;\r\n  right: 120%;\r\n}\r\n","/*!\r\n* https://github.com/YouCanBookMe/react-datetime\r\n*/\r\n.rdt {\r\n  position: relative;\r\n  .rdtPicker {\r\n    -webkit-transition: all 150ms linear;\r\n    -moz-transition: all 150ms linear;\r\n    -o-transition: all 150ms linear;\r\n    -ms-transition: all 150ms linear;\r\n    transition: all 150ms linear;\r\n    margin-top: -20px;\r\n    visibility: hidden;\r\n    display: block;\r\n    opacity: 0;\r\n  }\r\n  &.rdtOpen {\r\n    .rdtPicker {\r\n      opacity: 1;\r\n      visibility: visible;\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}\r\n.rdtPicker {\r\n  display: none;\r\n  position: absolute;\r\n  width: 260px;\r\n  padding: 4px;\r\n  margin-top: 1px;\r\n  z-index: 99999 !important;\r\n  background: #fff;\r\n  border-radius: 0.125rem;\r\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\r\n  -webkit-background-clip: padding-box;\r\n  background-clip: padding-box;\r\n  min-width: 160px;\r\n\r\n  &:before {\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n    vertical-align: middle;\r\n    content: \"\";\r\n    top: -5px;\r\n    left: 10px;\r\n    right: auto;\r\n    color: #ffffff;\r\n    border-bottom: 0.4em solid;\r\n    border-right: 0.4em solid transparent;\r\n    border-left: 0.4em solid transparent;\r\n  }\r\n  &:after {\r\n    border-bottom: 0.4em solid #ffffff;\r\n    border-right: 0.4em solid transparent;\r\n    border-left: 0.4em solid transparent;\r\n    content: \"\";\r\n    display: inline-block;\r\n    position: absolute;\r\n    top: -5px;\r\n    left: 10px;\r\n  }\r\n}\r\n\r\n.rdtPicker {\r\n  display: block;\r\n  top: 40px;\r\n}\r\n.rdtStatic .rdtPicker {\r\n  box-shadow: none;\r\n  position: static;\r\n}\r\n\r\n.rdtPicker .rdtTimeToggle {\r\n  text-align: center;\r\n  padding: 5px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.rdtPicker table {\r\n  width: 100%;\r\n  margin: 0;\r\n  border-color: $white-color !important;\r\n}\r\n.rdtPicker td,\r\n.rdtPicker th {\r\n  text-align: center;\r\n  padding: 1px;\r\n}\r\n.rdtPicker td {\r\n  cursor: pointer;\r\n}\r\n.rdtDay {\r\n  height: 30px;\r\n  line-height: 33px;\r\n  width: 30px;\r\n  text-align: center;\r\n  padding: 0px;\r\n  border-radius: 50%;\r\n  &.rdtToday.rdtActive,\r\n  &.rdtActive,\r\n  &.rdtActive:hover {\r\n    background-color: $primary-color !important;\r\n    color: $white-color;\r\n  }\r\n}\r\n.rdtDays {\r\n  tr {\r\n    .dow {\r\n      text-align: center;\r\n      border-bottom: 1px solid #e3e3e3;\r\n      font-size: 12px;\r\n      text-transform: uppercase;\r\n      font-weight: inherit;\r\n      padding-bottom: 5px;\r\n      padding-top: 10px;\r\n    }\r\n    .rdtOld,\r\n    .rdtNew {\r\n      color: $medium-gray;\r\n    }\r\n  }\r\n}\r\n\r\n.rdtPicker td.rdtDay:hover,\r\n.rdtPicker td.rdtHour:hover,\r\n.rdtPicker td.rdtMinute:hover,\r\n.rdtPicker td.rdtSecond:hover,\r\n.rdtPicker .rdtTimeToggle:hover {\r\n  background: #eeeeee;\r\n  cursor: pointer;\r\n}\r\n.rdtPicker td.rdtToday {\r\n  position: relative;\r\n}\r\n.rdtPicker td.rdtActive.rdtToday:before {\r\n  border-bottom-color: #fff;\r\n}\r\n.rdtPicker td.rdtDisabled,\r\n.rdtPicker td.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rdtPicker td span.rdtOld {\r\n  color: #999999;\r\n}\r\n.rdtPicker td span.rdtDisabled,\r\n.rdtPicker td span.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n.rdtPicker .dow {\r\n  width: 14.2857%;\r\n  border-bottom: none;\r\n}\r\n.rdtPicker th.rdtSwitch {\r\n  width: 50px;\r\n  padding: 5px;\r\n  border-radius: 4px;\r\n}\r\n.rdtPicker th.rdtNext,\r\n.rdtPicker th.rdtPrev {\r\n  font-size: 21px;\r\n  vertical-align: top;\r\n  border-radius: 50%;\r\n  line-height: 33px;\r\n}\r\n\r\n.rdtPicker {\r\n  .dow,\r\n  th.rdtSwitch,\r\n  th.rdtNext,\r\n  th.rdtPrev,\r\n  .rdtTimeToggle {\r\n    color: $primary-color;\r\n  }\r\n}\r\n\r\n.rdtPrev span,\r\n.rdtNext span {\r\n  display: block;\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none; /* Konqueror */\r\n  -moz-user-select: none; /* Firefox */\r\n  -ms-user-select: none; /* Internet Explorer/Edge */\r\n  user-select: none;\r\n}\r\n\r\n.rdtPicker th.rdtDisabled,\r\n.rdtPicker th.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n.rdtPicker thead tr:first-child th {\r\n  cursor: pointer;\r\n}\r\n.rdtPicker thead tr:first-child th:hover {\r\n  background: #eeeeee;\r\n}\r\n\r\n.rdtPicker button {\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n}\r\n.rdtPicker button:hover {\r\n  background-color: #eee;\r\n}\r\n\r\n.rdtPicker thead button {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\ntd.rdtMonth,\r\ntd.rdtYear {\r\n  height: 50px;\r\n  width: 25%;\r\n  cursor: pointer;\r\n}\r\ntd.rdtMonth:hover,\r\ntd.rdtYear:hover {\r\n  background: #eee;\r\n}\r\n\r\n.rdtCounters {\r\n  display: inline-block;\r\n}\r\n\r\n.rdtCounters {\r\n  > div {\r\n    float: left;\r\n    width: 40px;\r\n    font-weight: inherit;\r\n    margin: 3px;\r\n    border-radius: 50%;\r\n  }\r\n  .rdtCounterSeparator {\r\n    width: 0;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n\r\n.rdtCounter {\r\n  height: 100px;\r\n}\r\n\r\n.rdtCounter {\r\n  width: 40px;\r\n  .rdtCount {\r\n    padding: 7px;\r\n    height: 40px;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n.rdtCounters {\r\n  .rdtCounter:last-child {\r\n    .rdtCount {\r\n      color: $primary-color;\r\n      border-radius: 50%;\r\n      border: 1px solid $primary-color;\r\n    }\r\n  }\r\n}\r\n\r\n.rdtCounterSeparator {\r\n  padding: 7px;\r\n  line-height: 100px;\r\n}\r\n.rdtCounter .rdtBtn {\r\n  line-height: 40px;\r\n  cursor: pointer;\r\n  display: block;\r\n  border-radius: 50%;\r\n  color: $medium-gray;\r\n  -webkit-transition: all 60ms ease-in;\r\n  -moz-transition: all 60ms ease-in;\r\n  -o-transition: all 60ms ease-in;\r\n  -ms-transition: all 60ms ease-in;\r\n  transition: all 60ms ease-in;\r\n\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none; /* Konqueror */\r\n  -moz-user-select: none; /* Firefox */\r\n  -ms-user-select: none; /* Internet Explorer/Edge */\r\n  user-select: none;\r\n}\r\n.rdtCounter .rdtBtn:hover {\r\n  background: #eee;\r\n  color: #797979;\r\n}\r\n.rdtCounter .rdtCount {\r\n  font-size: inherit;\r\n  line-height: 25px;\r\n}\r\n\r\n.rdtMilli {\r\n  vertical-align: middle;\r\n  padding-left: 8px;\r\n  width: 48px;\r\n}\r\n\r\n.rdtMilli input {\r\n  width: 100%;\r\n  font-size: inherit;\r\n  margin-top: 37px;\r\n}\r\n.rdtMonths,\r\n.rdtYears {\r\n  padding-bottom: 10px;\r\n  .rdtMonth,\r\n  .rdtYear {\r\n    display: inline-block;\r\n    width: 56px;\r\n    height: 56px;\r\n    line-height: 56px;\r\n    margin: 3px 3px;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n\r\n    &.rdtActive {\r\n      background-color: $primary-color !important;\r\n      color: $white-color;\r\n    }\r\n  }\r\n}\r\n","*:focus{\r\n  outline: none;\r\n}\r\n",".blockquote{\r\n    &.blockquote-info{\r\n        border-color: $info-color;\r\n        color: $info-color;\r\n\r\n        small{\r\n            color: $info-color;\r\n        }\r\n    }\r\n}\r\n",".dropdown-menu a.dropdown-header[tabindex=\"-1\"]{\r\n  color: hsla(0,0%,71%,.6);\r\n  font-size: .7142em;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n}\r\n\r\n.dropdown-menu.dropdown-menu-right{\r\n  right: 0 !important;\r\n  left: auto !important;\r\n}\r\n",".modal.modal-mini .modal-profile i {\r\n  color: $info-color;\r\n  font-size: 21px;\r\n}\r\n",".popover{\r\n  .arrow:before {\r\n    border-color: transparent !important;\r\n  }\r\n}\r\n\r\n.popover-primary{\r\n  .popover{\r\n    @include popover-color($primary-color, $white-color);\r\n    .arrow:after {\r\n      border-left-color: $primary-color;\r\n    }\r\n  }\r\n}\r\n\r\n.popover-info{\r\n  .popover{\r\n    @include popover-color($info-color, $white-color);\r\n    .arrow:after {\r\n      border-left-color: $info-color;\r\n    }\r\n  }\r\n}\r\n\r\n.popover-warning{\r\n  .popover{\r\n    @include popover-color($warning-color, $white-color);\r\n    .arrow:after {\r\n      border-left-color: $warning-color;\r\n    }\r\n  }\r\n}\r\n\r\n.popover-danger{\r\n  .popover{\r\n    @include popover-color($danger-color, $white-color);\r\n    .arrow:after {\r\n      border-left-color: $danger-color;\r\n    }\r\n  }\r\n}\r\n\r\n.popover-success{\r\n  .popover{\r\n    @include popover-color($success-color, $white-color);\r\n    .arrow:after {\r\n      border-left-color: $success-color;\r\n    }\r\n  }\r\n}\r\n",".bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before{\r\n  border-left-color: $white-bg;\r\n}\r\n.bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before{\r\n  border-right-color: $white-bg;\r\n}\r\n.bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before{\r\n  border-top-color: $white-bg;\r\n}\r\n.bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before{\r\n  border-bottom-color: $white-bg;\r\n}\r\n",".clear-filter[filter-color=\"blue\"] {\r\n  @include linear-gradient(rgba($black-color,.20), rgba(3, 161, 224, 0.6));\r\n}\r\n[data-background-color=\"blue\"]{\r\n    background-color: $info-color;\r\n}\r\n.section-nucleo-icons .icons-container i:nth-child(6) {\r\n  color: $info-color;\r\n}\r\n.page-header{\r\n  &.page-header-small{\r\n    min-height: 60vh;\r\n    max-height: 640px;\r\n  }\r\n}\r\n","@media screen and (max-width: 991px){\r\n  .sidebar-collapse .navbar-collapse:before {\r\n    background: $info-color;\r\n    background: linear-gradient($info-color,$black-color 80%);\r\n  }\r\n  .navbar-nav .dropdown-menu {\r\n    position: static !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px){\r\n  .nav-tabs {\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
